webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var shared = __webpack_require__(51);
var has = __webpack_require__(5);
var uid = __webpack_require__(55);
var NATIVE_SYMBOL = __webpack_require__(56);
var USE_SYMBOL_AS_UID = __webpack_require__(98);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PubSub = function () {
  var events = {};

  var subscribe = function subscribe(eventName, callback) {
    if (!events[eventName]) {
      events[eventName] = [];
    }

    events[eventName].push(callback);
  };

  var once = function once(eventName, args) {
    if (events[eventName]) {
      return;
    }

    subscribe(eventName, args);
  };

  var unsubscribe = function unsubscribe(eventName, callbackToUnsubscribe) {
    for (var i = 0; i < events[eventName].length; i++) {
      if (events[eventName][i] === callbackToUnsubscribe) {
        events[eventName].splice(i, 1);
        break;
      }
    }
  };

  var publish = function publish(eventName, args) {
    return events[eventName] && events[eventName].forEach(function (callback) {
      return callback(args);
    });
  };

  return {
    subscribe: subscribe,
    once: once,
    unsubscribe: unsubscribe,
    publish: publish
  };
}();

exports.default = PubSub;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MARKET = exports.MARKET = {
  CODE: 5
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(10);
var definePropertyModule = __webpack_require__(11);
var createPropertyDescriptor = __webpack_require__(35);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(7);

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(10);
var IE8_DOM_DEFINE = __webpack_require__(53);
var anObject = __webpack_require__(4);
var toPrimitive = __webpack_require__(54);

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var createNonEnumerableProperty = __webpack_require__(8);
var has = __webpack_require__(5);
var setGlobal = __webpack_require__(33);
var inspectSource = __webpack_require__(36);
var InternalStateModule = __webpack_require__(21);

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(59);
var global = __webpack_require__(1);

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pubSub = __webpack_require__(3);

var _pubSub2 = _interopRequireDefault(_pubSub);

var _breakpoint = __webpack_require__(145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BreakpointDispatcher = {
  start: start,
  getState: getState,
  breakpoint: _breakpoint.BREAKPOINT.NAME
};

var BreakpointHandler = {
  mobile: { handleChange: handleMobileContext },
  tablet: { handleChange: handleTabletContext },
  desktop: { handleChange: handleDesktopContext }
};

var state = null;
var isStarted = false;

function start() {
  if (isStarted) {
    return;
  }
  isStarted = true;

  setCurrentState();
  window.addEventListener('resize', handleResize);
};

function handleContext(context) {
  BreakpointHandler[context].handleChange();
}

function setCurrentState() {
  if (getViewportWidth() <= _breakpoint.BREAKPOINT.WIDTH.MOBILE) {
    state = _breakpoint.BREAKPOINT.NAME.MOBILE;
  } else if (getViewportWidth() <= _breakpoint.BREAKPOINT.WIDTH.TABLET) {
    state = _breakpoint.BREAKPOINT.NAME.TABLET;
  } else if (getViewportWidth() > _breakpoint.BREAKPOINT.WIDTH.TABLET) {
    state = _breakpoint.BREAKPOINT.NAME.DESKTOP;
  }
}

function getViewportWidth() {
  return window.innerWidth;
}

function handleMobileContext() {
  if (getViewportWidth() > _breakpoint.BREAKPOINT.WIDTH.MOBILE) {
    state = _breakpoint.BREAKPOINT.NAME.TABLET;
    _pubSub2.default.publish('resize:tablet');
    console.log("Mode : Tablet");
  }
};

function handleTabletContext() {
  var winSize = getViewportWidth();

  if (winSize > _breakpoint.BREAKPOINT.WIDTH.TABLET) {
    state = _breakpoint.BREAKPOINT.NAME.DESKTOP;
    _pubSub2.default.publish('resize:desktop');
    console.log("Mode : Desktop");
  } else if (winSize <= _breakpoint.BREAKPOINT.WIDTH.MOBILE) {
    state = _breakpoint.BREAKPOINT.NAME.MOBILE;
    _pubSub2.default.publish('resize:mobile');
    console.log("Mode : Mobile");
  }
};

function handleDesktopContext() {
  if (getViewportWidth() <= _breakpoint.BREAKPOINT.WIDTH.TABLET) {
    state = _breakpoint.BREAKPOINT.NAME.TABLET;
    _pubSub2.default.publish('resize:tablet');
    console.log("Mode : Tablet");
  }
};

function handleResize() {
  handleContext(state);

  _pubSub2.default.publish('resize');
}

function getState() {
  return state;
};

exports.default = BreakpointDispatcher;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SessionStoragePop = function () {
    function SessionStoragePop(key, intervalTime) {
        _classCallCheck(this, SessionStoragePop);

        var _self = this;

        // init default values
        _self.sessionKey = key;
        _self.intervalTime = intervalTime;
    }

    /**
     * Update interval Time of current object session
     */


    _createClass(SessionStoragePop, [{
        key: "setIntervalTime",
        value: function setIntervalTime(intervalTime) {
            this.intervalTime = intervalTime;
        }

        /**
         *   get Expiration Date
         */

    }, {
        key: "getExpirationDate",
        value: function getExpirationDate(intervalTime) {
            return new Date(new Date().getTime() + 60000 * intervalTime - 10000);
        }

        /**
         *   get current session object
         */

    }, {
        key: "getJsonObjectFromSession",
        value: function getJsonObjectFromSession() {
            var jsonObj = JSON.parse(window.sessionStorage.getItem(this.sessionKey));
            return jsonObj;
        }

        /**
         *   get current session object
         */

    }, {
        key: "removeKey",
        value: function removeKey() {
            var _self = this;
            window.sessionStorage.removeItem(_self.sessionKey);
        }
        /**
         * Add Simple Boolean in Session Storage
         */

    }, {
        key: "addSimpleBooleanInSessionStorage",
        value: function addSimpleBooleanInSessionStorage() {
            var _self = this;
            window.sessionStorage.setItem(_self.sessionKey, true);
        }

        /**
         * Update Session Storage
         */

    }, {
        key: "updateSessionStorage",
        value: function updateSessionStorage(data) {
            var _self = this;
            window.sessionStorage.setItem(_self.sessionKey, JSON.stringify({
                counterVal: data.counterVal,
                expirationDate: _self.getExpirationDate(_self.intervalTime),
                dateMessage: data.dateMessage,
                message: data.message,
                idAlerte: data.idAlerte,
                closed: data.closed
            }));
        }

        /**
         * Update Counter alone
         */

    }, {
        key: "updateCounterAlone",
        value: function updateCounterAlone(val, closed) {
            var _self = this;
            window.sessionStorage.setItem(_self.sessionKey, JSON.stringify({
                counterVal: val,
                expirationDate: _self.getExpirationDate(_self.intervalTime),
                dateMessage: null,
                message: null,
                idAlerte: null,
                closed: closed
            }));
        }

        /**
         * Update Session Storage
         */

    }, {
        key: "resetCounterInSession",
        value: function resetCounterInSession() {
            var _self = this;
            window.sessionStorage.setItem(_self.sessionKey, JSON.stringify({
                counterVal: 0,
                expirationDate: _self.getExpirationDate(_self.intervalTime).toISOString(),
                dateMessage: null,
                message: null,
                idAlerte: null,
                closed: false
            }));
        }
    }]);

    return SessionStoragePop;
}();

exports.default = SessionStoragePop;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MAX_NOTIFICATION_NUMBER_TO_SHOW = 99;

var MethodUtils = function () {
    function MethodUtils() {
        _classCallCheck(this, MethodUtils);
    }

    _createClass(MethodUtils, [{
        key: 'updateApplicationNotificationEvery',
        value: function updateApplicationNotificationEvery(appliFunction, time) {
            return window.setInterval(appliFunction, time);
        }
    }, {
        key: 'getNotificationCounterToShow',
        value: function getNotificationCounterToShow(actualCounterValue) {
            // If data cannot be cast to number, do not continue
            if (Number.isNaN(actualCounterValue)) {
                return actualCounterValue;
            }

            return actualCounterValue > MAX_NOTIFICATION_NUMBER_TO_SHOW ? MAX_NOTIFICATION_NUMBER_TO_SHOW : actualCounterValue;
        }
    }, {
        key: 'getCookie',
        value: function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
    }]);

    return MethodUtils;
}();

exports.default = MethodUtils;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(99);
var global = __webpack_require__(1);
var isObject = __webpack_require__(9);
var createNonEnumerableProperty = __webpack_require__(8);
var objectHas = __webpack_require__(5);
var sharedKey = __webpack_require__(37);
var hiddenKeys = __webpack_require__(38);

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var getOwnPropertyDescriptor = __webpack_require__(41).f;
var createNonEnumerableProperty = __webpack_require__(8);
var redefine = __webpack_require__(12);
var setGlobal = __webpack_require__(33);
var copyConstructorProperties = __webpack_require__(105);
var isForced = __webpack_require__(62);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(104);
var requireObjectCoercible = __webpack_require__(40);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmoothScroll = function () {
  var scrollTo = function scrollTo(offset, callback) {
    (0, _jquery2.default)('html, body').animate({
      scrollTop: offset
    }, 500, callback || null);
  };

  return {
    scrollTo: scrollTo
  };
}();

exports.default = SmoothScroll;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    // Function to check if any cookie in the parameter is present on the browser cookies
    // It receives a list of cookies as parameter (ex: ["cookie1=value1,value2","cookie2=value3",...])
    // Returns a boolean saying if the cookie is present or not (in other words, if the content should be visible or not)
    analyze: function analyze(cookies) {
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var indexOfEqual = cookie.indexOf("=");
            var cookieName = cookie.substring(0, indexOfEqual);
            var cookieValues = cookie.substring(indexOfEqual + 1, cookie.length).split(",");

            for (var j = 0; j < cookieValues.length; j++) {
                if (this.getByName(cookieName).indexOf(cookieValues[j]) >= 0) {
                    return true;
                }
            }
        }

        return false;
    },


    // Function to check the result of the cookies hide.
    // It receives a list of cookies as parameter (ex: ["cookie1=value1,value2","cookie2=value3",...])
    // Returns a boolean saying if the content should be visible or not
    analyzeHide: function analyzeHide(cookiesToHide) {
        return !this.analyze(cookiesToHide);
    },


    // Function to check the result of the cookies to show and cookies to hide. If there are both cookies to show and
    // cookies to hide present in the browser, then we assume we don't want to display the content, so returns false.
    // Both parameters it receives are lists of cookies (ex: ["cookie1=value1,value2","cookie2=value3",...])
    // Returns a boolean saying if the content should be visible or not
    analyzeShowAndHide: function analyzeShowAndHide(cookiesToShow, cookiesToHide) {
        var resultToShow = this.analyze(cookiesToShow);
        var resultToHide = this.analyze(cookiesToHide);

        if (resultToShow && resultToHide || !resultToShow && !resultToHide) {
            return false;
        } else {
            // In this case, one of them is true and the other is false. If:
            // * resultToShow is true and resultToHide is false, we show the content, so return true;
            // * resultToShow is false and resultToHide is true, we hide the content, so return false.
            // So basically, we return the value of resultToShow!
            return resultToShow;
        }
    },
    getByName: function getByName(cookieName) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + cookieName + "=");
        if (parts.length === 2) {
            return parts.pop().split(";").shift();
        }
        return "";
    }
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SELECTOR = {
    SPAN_COUNTER: '.js-nav-user-counter'
};

var CLASS = {
    IS_ACTIVE: 'is-active'
};

var Counter = function () {
    function Counter(selectorCounter) {
        _classCallCheck(this, Counter);

        var _self = this;
        _self.$counter = (0, _jquery2.default)(selectorCounter);
        _self.counterVal = "0";

        var $notifSpan = _self.$counter.find(SELECTOR.SPAN_COUNTER);
        if ($notifSpan.length > 0) {
            _self.$notifSpan = $notifSpan;
        } else {
            _self.$notifSpan = (0, _jquery2.default)(document.createElement('span'));
            _self.$notifSpan.addClass('js-nav-user-counter rsp_counter');
            _self.$counter.append(_self.$notifSpan);
        }

        _self.notifHidden = true;
    }

    /**
     * Update the html of mobile and desktop alert notification
     * Need Id alert-dekstop and alert-mobile to work properly
     */


    _createClass(Counter, [{
        key: 'updateHtml',
        value: function updateHtml(counterVal) {
            var _self = this;

            /*
                We kept here the initial behavior even if counter is not present in the HTML
             */
            if (counterVal == "0" || counterVal == 0) {
                window.EventBusCMS.dispatchEvent('toggleBurgerMobileNotif', { state: 'unactive' });

                // check if element exist
                if (!_self.notifHidden && _self.$notifSpan !== null) {
                    // hide notification span
                    _self.$notifSpan.removeClass(CLASS.IS_ACTIVE);
                    _self.notifHidden = true;
                }
            } else {
                window.EventBusCMS.dispatchEvent('toggleBurgerMobileNotif', { state: 'active' });

                // check if element exist
                if (_self.$notifSpan === null) {
                    return;
                }

                if (_self.notifHidden) {
                    // hide notification span
                    _self.$notifSpan.addClass(CLASS.IS_ACTIVE);
                    _self.notifHidden = false;
                }
                _self.$notifSpan.text(counterVal);
            }
        }
    }]);

    return Counter;
}();

exports.default = Counter;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateLoginBoxNamesLhs = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _market = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS = {
    LOGIN_NAMES: '.js-login-names'
};

var updateLoginBoxNamesLhs = function updateLoginBoxNamesLhs() {
    var scriptTag = document.getElementById("sas_user_info");
    if (scriptTag) {
        var userInfos = getUserInfos(scriptTag);
        if (userInfos !== null) {
            if ((0, _jquery2.default)(CLASS.LOGIN_NAMES).text() === "" && _market.MARKET.CODE != 1) {
                (0, _jquery2.default)(CLASS.LOGIN_NAMES).append(getFormatedNames(userInfos));
            }
            return getFormatedNamesForSnackBar(userInfos);
        }
    } else {
        return "";
    }
};

function getUserInfos(scriptTag) {
    try {
        var userInfos = JSON.parse(scriptTag.innerHTML.trim());
        if (userInfos && userInfos["user-info-firstname"] && userInfos["user-info-lastname"]) {
            return {
                lastName: camelCase(userInfos["user-info-lastname"].toLowerCase()),
                firstName: userInfos["user-info-firstname"].substring(0, 1),
                fullFirstName: camelCase(userInfos["user-info-firstname"].toLowerCase()),
                lastConnectionDate: new Date(getCookie("lastDate") * 1000)
            };
        } else {
            console.error("Impossible de récupérer les informations utilisateur");
            return null;
        }
    } catch (e) {
        console.error("Impossible de récupérer les informations utilisateur");
        return null;
    }
}

function getFormatedNames(userInfos) {
    return (userInfos && userInfos.firstName ? userInfos.firstName : "") + '. ' + (userInfos && userInfos.lastName ? userInfos.lastName : "");
}

function getFormatedNamesForSnackBar(userInfos) {
    return (userInfos && userInfos.fullFirstName ? userInfos.fullFirstName : "") + ' ' + (userInfos && userInfos.lastName ? userInfos.lastName : "");
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

// add/remove class polyfill
function addClass(element, className) {
    element.className += " " + className;
}

function removeClass(element, className) {
    element.className = element.className.replace(className, "");
}

function camelCase(str) {
    return str.toLowerCase().replace(/(^|[':.,; -])./g, function (e) {
        return e.toUpperCase();
    });
}

exports.updateLoginBoxNamesLhs = updateLoginBoxNamesLhs;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(2);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 32 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var createNonEnumerableProperty = __webpack_require__(8);

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var isObject = __webpack_require__(9);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(52);

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(51);
var uid = __webpack_require__(55);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(10);
var propertyIsEnumerableModule = __webpack_require__(103);
var createPropertyDescriptor = __webpack_require__(35);
var toIndexedObject = __webpack_require__(23);
var toPrimitive = __webpack_require__(54);
var has = __webpack_require__(5);
var IE8_DOM_DEFINE = __webpack_require__(53);

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(11).f;
var has = __webpack_require__(5);
var wellKnownSymbol = __webpack_require__(2);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(19);

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    isReady: isDomReady,
    execMethodsOnReady: execMethodsOnReady,
    addToQueueIfNotReady: addToQueueIfNotReady,
    unwrap: unwrap,
    appendHtml: appendHtml,
    closestParent: closestParent
};


function isDomReady() {
    return document.readyState === "complete";
}

function execMethodsOnReady(domReadyCallbacks) {
    document.onreadystatechange = function () {
        if (document.readyState == "complete") {
            domReadyCallbacks.forEach(function (callback) {
                return callback();
            });
        }
    };
}

function addToQueueIfNotReady(method, queue) {
    return function (args, success, error) {
        if (isDomReady()) {
            method(args, success, error);
        } else {
            queue.addMethod(method, args, success, error);
        }
    };
}

// Function to unwrap client side elements
function unwrap(element) {
    var fragment = document.createDocumentFragment();
    while (element.firstChild) {
        var child = element.removeChild(element.firstChild);
        fragment.appendChild(child);
    }

    element.parentNode.replaceChild(fragment, element);
}

// Function to append HTML to an element
function appendHtml(element, html) {
    var div = document.createElement("div");
    div.innerHTML = html;

    while (div.children.length > 0) {
        element.appendChild(div.children[0]);
    }
}

// Function to get the closest parent that matches a selector
function closestParent(element, selector, stopSelector) {
    var result = null;
    while (element) {
        if (element.matches(selector)) {
            result = element;
            break;
        } else if (stopSelector && element.matches(stopSelector)) {
            break;
        }

        element = element.parentNode;
    }

    return result;
}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainSearchUnAuth = exports.MainSearchAuth = exports.SearchBox = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _pubSub = __webpack_require__(3);

var _pubSub2 = _interopRequireDefault(_pubSub);

var _helpers = __webpack_require__(47);

var _smoothScroll = __webpack_require__(24);

var _smoothScroll2 = _interopRequireDefault(_smoothScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// mock ajax call getting json list
var searchList;

var KEY = {
  UP: 38,
  DOWN: 40,
  ESC: 27,
  ENTER: 13,
  SPACE: 27
};

var MIN_SEARCH_CHARS = 3;

var SearchBox = exports.SearchBox = function () {
  function SearchBox(_ref) {
    var $el = _ref.$el,
        itemIdPrefix = _ref.itemIdPrefix;

    _classCallCheck(this, SearchBox);

    this.root = $el instanceof _jquery2.default ? $el : (0, _jquery2.default)($el);
    this.itemIdPrefix = itemIdPrefix;
    this.searchField = this.root.find('.js-main-search_field');
    this.searchLabel = this.root.find('.js-main-search_label');
    this.searchEraseBtn = this.root.find('.js-main-search_erase');
    this.searchResultList = this.root.find('.js-main-search_list');
    this.goResultsBtn = (0, _jquery2.default)('.JS--resultbutton');
    this.isAlwaysOpen = this.root.hasClass('is-open');
    this.isResultListOpen = false;
    this.currentItemFocus = null;
    this.resultListLen = 0;
    this.focusIndex = -1;

    this.loadList();
    this.handleEvents();
  }

  _createClass(SearchBox, [{
    key: '_destroy',
    value: function _destroy() {
      console.log('destroy in SearchBox');
      this.root.off();
    }
  }, {
    key: 'loadList',
    value: function loadList() {
      var url = (0, _jquery2.default)("#hidden-autocompletion-file").html();
      if (url) {
        _jquery2.default.ajax({
          url: url.trim(),
          method: "GET",
          dataType: "json",
          success: function success(response) {
            searchList = response.filterList;
          },
          error: function error() {
            console.log('Erreur du chargement de la liste');
          }
        });
      }
    }
  }, {
    key: 'handleEvents',
    value: function handleEvents() {
      var _this = this;

      this.root.submit(function (e) {
        if (_this.isEmpty(_this.searchField.val()) || _this.focusIndex !== -1) {
          e.preventDefault();
        }
      });

      this.searchEraseBtn.mousedown(function (e) {
        e.preventDefault();
        _this.hideEraseBtn();
        _this.searchField.val('');
        _this.searchResultList.html('');
        _this.searchField.focus();
      });

      this.searchField.focus(function (e) {
        _this.root.addClass('is-active');
      });

      this.searchField.click(function (e) {
        e.stopPropagation();
      });

      // bind on click JS--resultbutton
      this.goResultsBtn.click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (_this.searchField.val() !== "" && _this.searchField.val() !== null) {
          _this.submitMainSearchField(_this.searchField);
        }
      });

      // Bind on key down and perform search with "enter"
      this.searchField.keydown(function (e) {
        e.stopPropagation();
        _this.handleKeyDown(e);
      });

      // bind on click on autocomplete element
      this.searchResultList.mousedown(function (e) {
        if (e.target.tagName === 'LI') {
          _this.searchField.val(_this.trimSpaces(e.target.textContent));

          // Perform the search
          _this.submitMainSearchField(_this.searchField);
        }
      });

      // Css animation of text research when user leave search box
      this.searchField.blur(function (e) {
        if (_this.isEmpty(e.target.value)) {
          _this.root.removeClass('is-active');
        }

        _this.emptyList();
      });

      this.searchField.keyup(function (e) {
        switch (_this.shouldStartAutoCompletion()) {
          case true:
            if (_this.shouldStartAutoCompletion()) {
              _this.focusIndex = -1;
              _this.emptyList();
            };
            break;
          case false:
            if (e.keyCode === KEY.DOWN || e.keyCode === KEY.UP || e.keyCode === KEY.ENTER || e.keyCode === KEY.SPACE) return;

            _this.focusIndex = -1;
            _this.openList();
            _this.buildResultList(e);
            break;
        }

        if (_this.searchField.val() !== "") {
          _this.showEraseBtn();
        } else {
          _this.hideEraseBtn();
        }
      });
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      e.stopPropagation();
      var index = void 0;

      switch (e.keyCode) {
        case KEY.ENTER:
          e.preventDefault();
          if (this.focusIndex > -1) {
            this.searchField.val(this.getItemValueByIndex(this.focusIndex));
            this.focusIndex = -1;
            this.emptyList();
            this.updateActiveDescendantByIndex(this.focusIndex);
          }
          if (this.searchField.val() !== "" && this.searchField.val() !== null) {
            this.submitMainSearchField(this.searchField);
          }
          break;
        case KEY.ESC:
          this.searchField.val('');
          this.focusIndex = -1;
          this.emptyList();
          this.hideEraseBtn();
          break;
        case KEY.DOWN:
          e.preventDefault();
          index = this.getNextIndex(this.focusIndex);

          if (index === this.focusIndex) {
            return;
          }

          this.removePseudoFocus(this.focusIndex);
          this.addPseudoFocus(index);
          this.updateActiveDescendantByIndex(index);
          this.focusIndex = index;
          break;
        case KEY.UP:
          e.preventDefault();
          index = this.getPrevIndex(this.focusIndex);

          if (index === this.focusIndex) {
            return;
          }

          this.removePseudoFocus(this.focusIndex);
          this.addPseudoFocus(index);
          this.focusIndex = index;
          break;
      }
    }
  }, {
    key: 'addPseudoFocus',
    value: function addPseudoFocus(index) {
      this.searchResultList.find('li').eq(index).addClass('is-focus');
      this.searchResultList.find('li').eq(index).attr("aria-selected", "true");
    }
  }, {
    key: 'removePseudoFocus',
    value: function removePseudoFocus(index) {
      this.searchResultList.find('li').eq(index).removeClass('is-focus');
      this.searchResultList.find('li').eq(index).attr("aria-selected", "false");
    }
  }, {
    key: 'updateActiveDescendantByIndex',
    value: function updateActiveDescendantByIndex(index) {
      this.searchField.attr('aria-activedescendant', this.getItemIdByIndex(index));
    }
  }, {
    key: 'submitMainSearchField',
    value: function submitMainSearchField(element) {
      // element = searchfield
      //element.prop('disabled', true); 
      var actualpage = window.location.href;
      var action = element.closest('form').attr('action');
      // 2788 + 2741
      var keywordValue = btoa(element.val() + "p").replace(/=/g, '');
      window.location.href = action + "#keyword=" + keywordValue;
      // If previous page was already searchpage: force reload
      if (actualpage.indexOf("resultats-recherche") >= 0) window.location.reload(true);
      //window.location.assign(action+"#keyword=" + keywordValue);
    }
  }, {
    key: 'getItemIdByIndex',
    value: function getItemIdByIndex(index) {
      if (index === -1) return null;
      return this.itemIdPrefix + '-' + index;
    }
  }, {
    key: 'trimSpaces',
    value: function trimSpaces(str) {
      return str.replace(/^\s+|\s+$/g, "");
    }
  }, {
    key: 'getItemValueByIndex',
    value: function getItemValueByIndex(index) {
      return this.trimSpaces(this.searchResultList.find('li').eq(index).text());
    }
  }, {
    key: 'getNextIndex',
    value: function getNextIndex(index) {
      return Math.min(index + 1, this.resultListLen - 1);
    }
  }, {
    key: 'getPrevIndex',
    value: function getPrevIndex(index) {
      return Math.max(index - 1, 0);
    }
  }, {
    key: 'showEraseBtn',
    value: function showEraseBtn() {
      this.searchEraseBtn.addClass('is-active');
    }
  }, {
    key: 'hideEraseBtn',
    value: function hideEraseBtn() {
      this.searchEraseBtn.removeClass('is-active');
    }
  }, {
    key: 'emptyList',
    value: function emptyList() {
      this.searchResultList.html('');
      this.searchField.attr("aria-expanded", "false");
    }
  }, {
    key: 'buildResultList',
    value: function buildResultList(e) {
      var _this2 = this;

      var searchEntry = this.escapeRegexpChars(this.searchField.val());
      var resultList = "";

      this.resultListLen = 0;
      this.searchField.html('');

      if (this.isSearchListDefined()) {
        searchList.filter(function (listEntry) {
          return _this2.hasItem(listEntry, searchEntry);
        }).forEach(function (item, index) {
          var itemWithHighlight = _this2.highlight(item, searchEntry);

          resultList += '<li\n                            id=\'' + _this2.itemIdPrefix + '-' + index + '\'\n                            class=\'dcw_main-search_item\' role=\'option\' aria-selected=\'false\'>\n                            ' + itemWithHighlight + '\n                           </li>';

          _this2.resultListLen++;
        });
      }

      this.searchResultList.html(resultList);
    }
  }, {
    key: 'escapeRegexpChars',
    value: function escapeRegexpChars(chars) {
      return chars.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }
  }, {
    key: 'highlight',
    value: function highlight(listEntry, searchEntry) {
      return listEntry.replace(searchEntry, '<span>' + searchEntry + '</span>');
    }
  }, {
    key: 'shouldStartAutoCompletion',
    value: function shouldStartAutoCompletion() {
      return this.searchField.val().length < MIN_SEARCH_CHARS && this.isSearchListDefined();
    }
  }, {
    key: 'isSearchListDefined',
    value: function isSearchListDefined() {
      return searchList !== undefined && searchList !== null;
    }
  }, {
    key: 'hasItem',
    value: function hasItem(listEntry, searchEntry) {
      if (searchEntry === '') return;

      var regexp = new RegExp(searchEntry);

      return regexp.test(listEntry);
    }
  }, {
    key: 'openList',
    value: function openList() {
      if (!this.isResultListOpen) {
        this.isResultListOpen = true;
        this.searchResultList.css('display', 'block');
      }
      this.searchField.attr("aria-expanded", "true");
    }
  }, {
    key: 'resetSearch',
    value: function resetSearch() {
      this.searchField.val('');
      this.searchResultList.html('');
      this.root.removeClass('is-active');
      this.hideEraseBtn();
      this.currentItemFocus = null;
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty(value) {
      return value === "";
    }
  }]);

  return SearchBox;
}();

var MainSearch = function (_SearchBox) {
  _inherits(MainSearch, _SearchBox);

  function MainSearch(opts) {
    _classCallCheck(this, MainSearch);

    var _this3 = _possibleConstructorReturn(this, (MainSearch.__proto__ || Object.getPrototypeOf(MainSearch)).call(this, opts));

    _this3.searchWrapper = (0, _jquery2.default)('.js-main-search_wrapper');
    _this3.searchContainer = (0, _jquery2.default)('.js-main-search_container');
    _this3.searchToggle = (0, _jquery2.default)('.js-main-search_toggle');
    _this3.searchCloseBtn = (0, _jquery2.default)('.js-main-search_close');

    _this3.handleSpecificEvents();
    return _this3;
  }

  _createClass(MainSearch, [{
    key: '_destroy',
    value: function _destroy() {
      SearchBox.prototype._destroy.call(this);
      this.searchCloseBtn.off('click', this._onCloseBtnClick);
      this.searchToggle.off('click', this._onSearchToggleClick);
    }
  }, {
    key: 'handleSpecificEvents',
    value: function handleSpecificEvents() {
      var _this4 = this;

      this._onSearchToggleClick = function (e) {
        _this4.resetSearch();
        _this4.handleClick(e);
        setTimeout(function () {
          return _this4.searchField.focus();
        });
      };

      this._onCloseBtnClick = function (e) {
        _this4.handleClick(e);
      };

      this.searchToggle.click(this._onSearchToggleClick);
      this.searchCloseBtn.click(this._onCloseBtnClick);
    }
  }]);

  return MainSearch;
}(SearchBox);

var MainSearchAuth = exports.MainSearchAuth = function (_MainSearch) {
  _inherits(MainSearchAuth, _MainSearch);

  function MainSearchAuth(opts) {
    _classCallCheck(this, MainSearchAuth);

    var _this5 = _possibleConstructorReturn(this, (MainSearchAuth.__proto__ || Object.getPrototypeOf(MainSearchAuth)).call(this, opts));

    _this5.activeItem = (0, _jquery2.default)('.js-menu_item.is-active');
    _this5.navContainer = _this5.activeItem.find('.dcw_submenu-auth');
    _this5.activeNav = null;
    _this5.isOpen = false;
    _this5.searchWrapper.removeClass('dcw_submenu-auth_search-wrapper--fill');

    if (_this5.activeItem.length) {
      _this5.activeNav = _this5.navContainer;

      if (_this5.activeNav.length == 0) {
        _this5.activeNav = (0, _jquery2.default)('.dcw_submenu-auth--persistent');
      }
    } else {
      _this5.activeNav = (0, _jquery2.default)('.dcw_submenu-auth--persistent');
    }

    _this5._stopSearchPropagation = function (e) {
      return e.stopPropagation;
    };
    _this5.searchWrapper.click(_this5._stopSearchPropagation);
    return _this5;
  }

  _createClass(MainSearchAuth, [{
    key: 'destroy',
    value: function destroy() {
      this._destroy();
      this.unbindOutEvents();
      this.searchWrapper.off('click', this._stopSearchPropagation);
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();
      this.toggleSearchPane();
    }
  }, {
    key: 'toggleNavigations',
    value: function toggleNavigations() {
      this.activeNav.toggleClass('is-search-open');
    }
  }, {
    key: 'toggleSearchPane',
    value: function toggleSearchPane() {
      var _this6 = this;

      var isSticky = (0, _jquery2.default)('.dcw_header').hasClass('is-sticky');
      this.handleExtEvents();
      this.toggleNavigations();
      (0, _helpers.toggleAttribute)(this.searchToggle, 'aria-expanded');

      if (isSticky && !this.isOpen) {
        this.expandNavContainer();
      } else if (isSticky && this.isOpen) {
        this.navContainer.css('height', '');
      }

      this.searchWrapper.toggleClass('is-open-add');

      setTimeout(function () {
        _this6.searchWrapper.toggleClass('is-open');
        _this6.isOpen = !_this6.isOpen;
      }, 30);

      this.searchCloseBtn.css('display', 'block');
    }
  }, {
    key: 'expandNavContainer',
    value: function expandNavContainer() {
      this.navContainer.css('height', '160px');
    }
  }, {
    key: 'handleExtEvents',
    value: function handleExtEvents() {
      var _this7 = this;

      if (!this.isOpen) {
        setTimeout(function () {
          _this7.bindOutsideClick();
          _this7.bindOutsideScroll();
        });
      } else {
        this.unbindOutEvents();
      }
    }
  }, {
    key: 'onOutsideClickCallback',
    value: function onOutsideClickCallback(self) {
      return function (e) {
        self.toggleSearchPane();
        self.unbindOutEvents();
      };
    }
  }, {
    key: 'onOutsideScrollCallback',
    value: function onOutsideScrollCallback(self) {
      return function () {
        self.toggleSearchPane();
        self.unbindOutEvents();
      };
    }
  }, {
    key: 'bindOutsideScroll',
    value: function bindOutsideScroll() {
      this.onOutsideScroll = this.onOutsideScrollCallback(this);
      (0, _jquery2.default)(window).scroll(this.onOutsideScroll);
    }
  }, {
    key: 'bindOutsideClick',
    value: function bindOutsideClick() {
      this.onOutsideClick = this.onOutsideClickCallback(this);
      (0, _jquery2.default)(window).click(this.onOutsideClick);
    }
  }, {
    key: 'unbindOutEvents',
    value: function unbindOutEvents() {
      (0, _jquery2.default)(window).off('click', this.onOutsideClick);
      (0, _jquery2.default)(window).off('scroll', this.onOutsideScroll);
    }
  }]);

  return MainSearchAuth;
}(MainSearch);

var MainSearchUnAuth = exports.MainSearchUnAuth = function (_MainSearch2) {
  _inherits(MainSearchUnAuth, _MainSearch2);

  function MainSearchUnAuth($el) {
    _classCallCheck(this, MainSearchUnAuth);

    var _this8 = _possibleConstructorReturn(this, (MainSearchUnAuth.__proto__ || Object.getPrototypeOf(MainSearchUnAuth)).call(this, $el));

    _this8.isOpen = false;
    _this8.isCalled = false;
    _this8.main = (0, _jquery2.default)('.dcw_main');
    _this8.searchWrapper = (0, _jquery2.default)('.dcw_main-nav_search').find('.js-mega-menu');

    _this8._onSearchClose = function () {
      return _this8.closeSearch();
    };
    _pubSub2.default.subscribe('search:close', _this8._onSearchClose);
    return _this8;
  }

  _createClass(MainSearchUnAuth, [{
    key: 'destroy',
    value: function destroy() {
      this._destroy();
      this.unbindOutEvents();
      _pubSub2.default.unsubscribe('search:close', this._onSearchClose);
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      var _this9 = this;

      e.stopPropagation();
      e.preventDefault();

      var scrollPos = (0, _jquery2.default)(window).scrollTop();

      if (!this.isOpen && scrollPos > 272) {
        this.isCalled = false;
        _smoothScroll2.default.scrollTo(0, function () {
          if (_this9.isCalled) return;
          _this9.isCalled = true;
          _this9.toggleSearchPane(e);
        });
      } else {
        this.toggleSearchPane(e);
      }
    }
  }, {
    key: 'closeSearch',
    value: function closeSearch() {
      this.unbindOutEvents();
      this.closeSearchPane();
    }
  }, {
    key: 'toggleSearchPane',
    value: function toggleSearchPane(e) {
      var self = this;

      this.isAnimating = true;

      if (!this.isOpen) {

        (0, _jquery2.default)('.js-menu_item.is-active').find('.is-open.is-open-add .js-mega-menu_btn-close').click();

        this.openSearchPane(e);
      } else {
        this.unbindOutEvents();

        this.closeSearchPane();
      }

      (0, _helpers.toggleAttribute)(this.searchToggle, 'aria-expanded');
    }
  }, {
    key: 'toggleLastMenuOpen',
    value: function toggleLastMenuOpen() {
      this.lastActiveMenu.toggleClass('is-open');
      this.lastActiveMenu.toggleClass('is-open-add');
    }
  }, {
    key: 'openSearchPane',
    value: function openSearchPane(e) {
      var _this10 = this;

      this.searchWrapper.addClass('is-open-add');
      setTimeout(function () {
        _this10.searchWrapper.addClass('is-open');
      }, 30);
      setTimeout(function () {
        _this10.searchCloseBtn.css('display', 'block');
        _this10.isOpen = true;

        setTimeout(function () {
          _this10.bindOutsideClick();
          _this10.bindOutsideScroll();
        });
      }, 300);
    }
  }, {
    key: 'closeSearchPane',
    value: function closeSearchPane() {
      var _this11 = this;

      this.searchWrapper.removeClass('is-open');
      this.searchCloseBtn.css('display', '');
      setTimeout(function () {
        _this11.searchWrapper.removeClass('is-open-add');
        _this11.isOpen = false;
      }, 300);
    }
  }, {
    key: 'getLastActiveMenu',
    value: function getLastActiveMenu() {
      var lastActiveItem = (0, _jquery2.default)('.js-menu_item.is-active');
      var lastActiveMenu = void 0;

      if (lastActiveItem.length) {
        lastActiveMenu = lastActiveItem.find('.is-open.is-open-add');
      }

      return lastActiveMenu.length && lastActiveMenu || null;
    }
  }, {
    key: 'onOutsideClickCallback',
    value: function onOutsideClickCallback(self) {
      return function () {
        self.toggleSearchPane();
        self.unbindOutEvents();
      };
    }
  }, {
    key: 'onOutsideScrollCallback',
    value: function onOutsideScrollCallback(self) {
      return function () {
        var windowWidth = window.innerWidth;
        if (windowWidth < 768 || windowWidth > 1024) {
          self.toggleSearchPane();
          self.unbindOutEvents();
        }
      };
    }
  }, {
    key: 'bindOutsideScroll',
    value: function bindOutsideScroll() {
      this.onOutsideScroll = this.onOutsideScrollCallback(this);
      (0, _jquery2.default)(window).scroll(this.onOutsideScroll);
    }
  }, {
    key: 'bindOutsideClick',
    value: function bindOutsideClick() {
      this.onOutsideClick = this.onOutsideClickCallback(this);
      (0, _jquery2.default)(window).click(this.onOutsideClick);
    }
  }, {
    key: 'unbindOutEvents',
    value: function unbindOutEvents() {
      (0, _jquery2.default)(window).off('click', this.onOutsideClick);
      (0, _jquery2.default)(window).off('scroll', this.onOutsideScroll);
    }
  }]);

  return MainSearchUnAuth;
}(MainSearch);

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toggleAttribute = toggleAttribute;
exports.request = request;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toggleAttribute(el, attribute) {
    if (el.attr(attribute) === 'true') {
        el.attr(attribute, 'false');
    } else {
        el.attr(attribute, 'true');
    }
}

function request(url, callback, error) {
    var xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status == 200) {
                callback(xhr.responseText);
            } else {
                return error && error(xhr);
            }
        }
    };

    xhr.open("GET", url, true);
    xhr.send(null);
}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LOGIN_BOX_POPIN = {
    SELECTOR_PARENT: '.js-container-popin',
    SELECTOR_POPIN: '.js-notif-box',
    CLASS_POPIN: 'js-notif-box',
    SELECTOR_HEADLINE: '.js-notif-box-title',
    SELECTOR_DESCRIPTION: '.js-notif-box-description',
    SELECTOR_LINK: ".js-notif-box-link",
    SELECTOR_BTN_CLOSE: ".js-notif-box-close"
};

var POPIN_DEFAULT_VALUES = {
    MOBILE_BREAKPOINT: 768,
    MOBILE_ID_AFTER_CONTAINER: "#go-content"
};

var Popin = function () {
    function Popin(selectorContainer, currentApp, priorityMobile) {
        var multipleStage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        _classCallCheck(this, Popin);

        var _self = this;
        _self.currentApp = currentApp;
        _self.isActive = false;
        _self.isOpen = false;

        // HTML DOM
        _self.$elt = (0, _jquery2.default)(LOGIN_BOX_POPIN.SELECTOR_POPIN);
        _self.$popin = _self.$elt.clone();
        _self.$popin.removeClass(LOGIN_BOX_POPIN.CLASS_POPIN);

        // Init priority property for mobile
        _self.priorityMobile = priorityMobile;

        // MultiStage context
        _self.multipleStage = multipleStage;
        _self.firstLvlClosed = false;

        // Init Mobile context
        _self.onMobile = false;
        if ((0, _jquery2.default)(window).width() < POPIN_DEFAULT_VALUES.MOBILE_BREAKPOINT) {
            _self.onMobile = true;
        }

        // Init popin with generic structure - Hide by default
        _self.$container = (0, _jquery2.default)(LOGIN_BOX_POPIN.SELECTOR_PARENT);
        _self.$container.append(_self.$popin);
        _self.hide();

        // Init Each HMTL Element
        _self.$headLine = _self.$popin.find(LOGIN_BOX_POPIN.SELECTOR_HEADLINE);
        _self.$description = _self.$popin.find(LOGIN_BOX_POPIN.SELECTOR_DESCRIPTION);
        _self.$link = _self.$popin.find(LOGIN_BOX_POPIN.SELECTOR_LINK);
        _self.$btnClose = _self.$popin.find(LOGIN_BOX_POPIN.SELECTOR_BTN_CLOSE);
        _self.$moreWithLink = _self.$popin.find(LOGIN_BOX_POPIN.SELECTOR_MORE_WITH_LINK);

        window.EventBusCMS.addEventListener('nextPopinToShow', function (event) {
            if (event.detail.priorityToDisplay === _self.priorityMobile && _self.isActive) {
                _self.show();
            }
        });

        // bind btn close
        _self.$btnClose.bind("click", function () {
            _self.hide();

            // specific popin with multiple stage
            if (_self.multipleStage && !_self.firstLvlClosed) {
                window.EventBusCMS.dispatchEvent('popinEvent', { firstLvlClosed: true, currentApp: _self.currentApp });
                _self.firstLvlClosed = true;
            }

            // specific popin with multiple stage
            window.EventBusCMS.dispatchEvent('popinGenericEventOnClose', { currentApp: _self.currentApp });

            // generate event to display other popin by priority on mobile
            if (_self.onMobile) {
                _self.displayNextPopin();
            }
        });
    }

    _createClass(Popin, [{
        key: 'displayNextPopin',
        value: function displayNextPopin() {
            var priorityToDisplay = this.priorityMobile + 1;
            // specific popin with multiple stage
            window.EventBusCMS.dispatchEvent('nextPopinToShow', { priorityToDisplay: priorityToDisplay });
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.isActive = false;
            this.isOpen = false;
            this.$popin.removeClass('is-open');
        }
    }, {
        key: 'activate',
        value: function activate() {
            this.isActive = true;
        }
    }, {
        key: 'show',
        value: function show() {
            this.isActive = true;
            this.isOpen = true;
            this.$popin.addClass('is-open');
            this.$container.addClass('is-open');
        }
    }, {
        key: 'updatePopinData',
        value: function updatePopinData(data) {
            var _self = this;

            _self.updateHeadLine(data.headLine);
            _self.updateDescription(data.description);
            if (data.hideLink) {
                _self.hideLink();
            } else {
                _self.updateLink(data.href);
                _self.updateTextLink(data.textLink);
            }
        }
    }, {
        key: 'hideLink',
        value: function hideLink() {
            if (this.$moreWithLink.length) {
                this.$moreWithLink.hide();
            }
        }
    }, {
        key: 'updateHeadLine',
        value: function updateHeadLine(txt) {
            if (this.$headLine.length) {
                this.$headLine.text(txt);
            }
        }
    }, {
        key: 'updateDescription',
        value: function updateDescription(txt) {
            if (this.$description.length) {
                this.$description.html(txt);
            }
        }
    }, {
        key: 'updateLink',
        value: function updateLink(href) {
            if (this.$link.length) {
                this.$link.attr("href", href);
            }
        }
    }, {
        key: 'updateTextLink',
        value: function updateTextLink(txt) {
            if (this.$link.length) {
                this.$link.text(txt);
            }
        }
    }]);

    return Popin;
}();

exports.default = Popin;

/***/ }),
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
exports.subscribe = subscribe;
exports.publish = publish;
var events = {};

function init() {
  window.cmsEventBus = {
    publish: publish
  };
}

function subscribe(eventName, eventHandler) {
  console.info("[info][cmsEventBus] - subscribe to " + eventName + " event");
  if (typeof events[eventName] === 'undefined') {
    events[eventName] = [];
  }

  events[eventName].push({
    eventHandler: eventHandler
  });
}

function publish(eventName) {
  var eventParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var success = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;


  if (!events[eventName] || events[eventName].length === 0) {
    console.error("[error][" + eventName + "] - \xE9v\xE8nement non souscrit");
    return false;
  }

  events[eventName].forEach(function (eventObj) {
    var eventHandler = eventObj.eventHandler;


    eventHandler(eventParameters, error, success);
  });
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(16);
var store = __webpack_require__(52);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.5',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var setGlobal = __webpack_require__(33);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(10);
var fails = __webpack_require__(7);
var createElement = __webpack_require__(34);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(7);

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(31);
var classofRaw = __webpack_require__(17);
var wellKnownSymbol = __webpack_require__(2);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(22);
var createIteratorConstructor = __webpack_require__(111);
var getPrototypeOf = __webpack_require__(64);
var setPrototypeOf = __webpack_require__(116);
var setToStringTag = __webpack_require__(43);
var createNonEnumerableProperty = __webpack_require__(8);
var redefine = __webpack_require__(12);
var wellKnownSymbol = __webpack_require__(2);
var IS_PURE = __webpack_require__(16);
var Iterators = __webpack_require__(18);
var IteratorsCore = __webpack_require__(63);

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);

module.exports = global;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(5);
var toIndexedObject = __webpack_require__(23);
var indexOf = __webpack_require__(108).indexOf;
var hiddenKeys = __webpack_require__(38);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(39);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(7);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__(64);
var createNonEnumerableProperty = __webpack_require__(8);
var has = __webpack_require__(5);
var wellKnownSymbol = __webpack_require__(2);
var IS_PURE = __webpack_require__(16);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(5);
var toObject = __webpack_require__(112);
var sharedKey = __webpack_require__(37);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(113);

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var defineProperties = __webpack_require__(114);
var enumBugKeys = __webpack_require__(42);
var hiddenKeys = __webpack_require__(38);
var html = __webpack_require__(66);
var documentCreateElement = __webpack_require__(34);
var sharedKey = __webpack_require__(37);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(13);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);

module.exports = global.Promise;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var isArrayIteratorMethod = __webpack_require__(126);
var toLength = __webpack_require__(61);
var bind = __webpack_require__(69);
var getIteratorMethod = __webpack_require__(127);
var callWithSafeIterationClosing = __webpack_require__(128);

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = bind(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, next, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

iterate.stop = function (result) {
  return new Result(true, result);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(19);

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var aFunction = __webpack_require__(19);
var wellKnownSymbol = __webpack_require__(2);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var fails = __webpack_require__(7);
var classof = __webpack_require__(17);
var bind = __webpack_require__(69);
var html = __webpack_require__(66);
var createElement = __webpack_require__(34);
var IS_IOS = __webpack_require__(72);

var location = global.location;
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (classof(process) == 'process') {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    typeof postMessage == 'function' &&
    !global.importScripts &&
    !fails(post) &&
    location.protocol !== 'file:'
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__(73);

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(13);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var isObject = __webpack_require__(9);
var newPromiseCapability = __webpack_require__(44);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stickyModule = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _smoothScroll = __webpack_require__(24);

var _smoothScroll2 = _interopRequireDefault(_smoothScroll);

var _pubSub = __webpack_require__(3);

var _pubSub2 = _interopRequireDefault(_pubSub);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stickyModule = exports.stickyModule = function stickyModule(_ref) {
  var $el = _ref.$el,
      stickyLimit = _ref.stickyLimit,
      _ref$enterSticky = _ref.enterSticky,
      enterSticky = _ref$enterSticky === undefined ? null : _ref$enterSticky,
      _ref$leaveSticky = _ref.leaveSticky,
      leaveSticky = _ref$leaveSticky === undefined ? null : _ref$leaveSticky;

  var el = (0, _jquery2.default)($el);
  var isSticky = false;
  var isCbTriggered = false;
  var isDebounced = false;
  var shouldUpdate = true;
  var _scrollHandler;

  var bindScrollEvent = function bindScrollEvent() {
    _scrollHandler = function _scrollHandler(e) {
      if (!isDebounced) {
        handleScrollCb(e);
      }
    };

    window.addEventListener('scroll', _scrollHandler, { passive: true });
  };

  var unbindScrollEvent = function unbindScrollEvent() {
    window.removeEventListener('scroll', _scrollHandler);
  };

  var destroy = function destroy() {
    unbindScrollEvent();
    el.removeClass('is-sticky');
  };

  var scrollTop = function scrollTop(callback) {
    isCbTriggered = false;

    _smoothScroll2.default.scrollTo(0, function () {
      isSticky = !isSticky;

      if (isCbTriggered) return;

      isCbTriggered = true;
      callback();
    });
  };

  var getState = function getState() {
    return isSticky;
  };

  function handleScrollCb(e) {
    if (!shouldUpdate) return;

    var scrollPos = (0, _jquery2.default)(window).scrollTop();

    switch (isSticky) {
      case true:
        if (scrollPos < stickyLimit) {
          shouldUpdate = false;
          el.removeClass('is-sticky');
          isSticky = !isSticky;

          _pubSub2.default.publish('sticky:leave');
          shouldUpdate = true;
          return leaveSticky && leaveSticky();
        }
        break;

      case false:
        if (scrollPos > stickyLimit) {
          shouldUpdate = false;
          el.addClass('is-sticky');
          isSticky = !isSticky;

          _pubSub2.default.publish('sticky:enter');
          shouldUpdate = true;
          return enterSticky && enterSticky();
        }
        break;
    }

    shouldUpdate = true;
  };

  bindScrollEvent();

  return {
    getState: getState,
    scrollTop: scrollTop,
    destroy: destroy
  };
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marker = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var marker = exports.marker = function marker(type, $el, targetElements) {
  var minPos = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var markerEl = (0, _jquery2.default)($el);
  var HORIZONTAL = 'HORIZONTAL';
  var VERTICAL = 'VERTICAL';
  var HORIZ_Y = 'HORIZ_Y';
  var ANIM_DURATION = 300;

  var offsetType = 'offsetLeft';
  if (type !== 'HORIZONTAL') {
    offsetType = 'offsetTop';
  }

  var minPosition = minPos;
  var lastElementMarked = null;
  var lastPos = null;

  var updateLastElementMarked = function updateLastElementMarked(element) {
    lastElementMarked = element;
  };

  var getLastElementMarked = function getLastElementMarked() {
    return lastElementMarked;
  };

  var translateX = function translateX(value, shouldScaleToZero) {

    var translateStr = shouldScaleToZero ? 'translateX(' + value + 'px) scaleX(0)' : 'translateX(' + value + 'px) scaleX(1)';

    markerEl.css({
      'transform': translateStr,
      '-webkit-transform': translateStr,
      '-moz-transform': translateStr,
      '-ms-transform': translateStr
    });
  };

  var translateY = function translateY(value) {
    var translateStr = 'translateY(' + value + 'px)';

    markerEl.css({
      'transform': translateStr,
      '-webkit-transform': translateStr,
      '-moz-transform': translateStr,
      '-ms-transform': translateStr
    });
  };

  var translate = type === HORIZONTAL ? translateX : translateY;

  var translateAndHide = function translateAndHide(pos) {
    updateLastElementMarked(null);
    translate(pos, true);
  };

  var translateTo = function translateTo(element, shouldNotAnimate) {
    var pad = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    var _element = void 0;

    if (element instanceof _jquery2.default) {
      _element = element[0];
    } else {
      _element = element;
    }

    updateLastElementMarked(_element);
    var offsetValue = _element[offsetType];

    if (type === HORIZ_Y) {
      offsetValue = offsetValue + _element.offsetHeight - 4;
    }

    var transitionStr = void 0;

    if (shouldNotAnimate) {
      transitionStr = markerEl.css('transition');
      markerEl.css('transition', 'none');
    }

    translate(Math.max(offsetValue, minPosition) + pad);

    if (transitionStr) {
      setTimeout(function () {
        markerEl.css('transition', transitionStr);
      }, 100);
    }
  };

  var onTargetHoverCb = function onTargetHoverCb(e) {
    translateTo(e.currentTarget);
  };

  var setLasPos = function setLasPos(x, y) {
    lastPos = { x: x, y: y };
  };

  var onMouseMove = function onMouseMove(e) {
    setLasPos(e.clientX, e.clientY);
  };

  var unbind = function unbind() {
    (0, _jquery2.default)(targetElements).off('mouseover', onTargetHoverCb);
    $container.off('mouseout', onMouseLeaveCb);
  };

  var bind = function bind() {
    (0, _jquery2.default)(targetElements).hover(onTargetHoverCb);
  };

  var changePadTo = function changePadTo(value) {
    return minPosition = value;
  };

  var replayTranslate = function replayTranslate(shouldNotAnimate) {
    var pad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (!lastElementMarked) return;
    translateTo(lastElementMarked, shouldNotAnimate, pad);
  };

  bind();

  return {
    changePadTo: changePadTo,
    replayTranslate: replayTranslate,
    translateTo: translateTo,
    translate: translate,
    translateAndHide: translateAndHide,
    updateLastElementMarked: updateLastElementMarked
  };
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var handleMouseMove = null;
var elementBounds = null;
var hasLeftBounds = true;

var onElementBoundsOut = exports.onElementBoundsOut = function onElementBoundsOut(element, outerElement, handler) {
  if (!element) return;

  elementBounds = element.getBoundingClientRect();
  handleMouseMove = onLeaveBounds(handler);

  outerElement.addEventListener('mousemove', function (e) {
    handleMouseMove(e.clientX, e.clientY);
  });

  element.addEventListener('mouseleave', function (e) {
    handler();
  });
};

var getState = exports.getState = function getState() {
  return hasLeftBounds;
};

function onEnterBounds(handler) {
  return function (x, y) {
    if (isOutsideBounds(x, y)) {
      hasLeftBounds = true;
      handleMouseMove = onLeaveBounds(handler);
      handler();
    }
  };
}

function onLeaveBounds(handler) {
  return function (x, y) {
    if (!isOutsideBounds(x, y)) {
      hasLeftBounds = false;
      handleMouseMove = onEnterBounds(handler);
    }
  };
}

function isOutsideBounds(x, y) {
  return x < elementBounds.left || x > elementBounds.right || y < elementBounds.top || y > elementBounds.bottom;
}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CLASS = {
    IS_OPEN: 'is-open',
    BURGER_CONTENT: '.js-burger-content',
    MENU_BURGER: '.js-header-burger'
};

var key = {
    'ESCAPE': 27
};

var BurgerBtn = function () {
    function BurgerBtn(selectorBurger, selectorBurgerContent) {
        var selectorCloseBtn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        _classCallCheck(this, BurgerBtn);

        var _self = this;

        // Burger Btn is used to open / close element
        // by himself if no selector to close
        if (!selectorCloseBtn) {
            _self.isToggleBtn = true;
        } else {
            _self.isToggleBtn = false;
            _self.$btnClose = (0, _jquery2.default)(selectorCloseBtn);
        }

        // get Btn Element
        _self.$burgerBtn = (0, _jquery2.default)(selectorBurger);

        // get related Menu
        _self.$containerBurgerContent = (0, _jquery2.default)(selectorBurgerContent);

        // initial state
        _self.isOpen = _self.$containerBurgerContent.hasClass(CLASS.IS_OPEN) ? true : false;

        // burger content
        _self.$burgerContent = (0, _jquery2.default)(CLASS.BURGER_CONTENT);

        _self.$document = (0, _jquery2.default)(document);

        _self.initEventListeners();
    }

    /**
     * Init App
     */


    _createClass(BurgerBtn, [{
        key: 'init',
        value: function init() {
            var _self = this;
            _self.bindEvents();
        }

        /**
         * Bind required events
         */

    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            var _self = this;
            if (_self.isToggleBtn) {
                _self.$burgerBtn.off("click");
                _self.$burgerBtn.on("click", function (e) {
                    if (_self.isOpen) {
                        _self.closeMenu();
                    } else {
                        _self.openMenu();
                    }
                    e.stopPropagation();
                });
            } else {
                // bind btn burger
                _self.$burgerBtn.off("click");
                _self.$burgerBtn.on("click", function (e) {
                    _self.openMenu();
                    e.stopPropagation();
                });
                // bind btn close
                _self.$btnClose.off("click");
                _self.$btnClose.on("click", function (e) {
                    _self.closeMenu();
                    e.stopPropagation();
                });
            }

            _self.$burgerContent.off("click");
            _self.$burgerContent.on("click", function (e) {
                e.stopPropagation();
            });

            // bind close menu clicking everywhere
            _self.$document.on("click", function () {
                if (_self.isOpen) {
                    _self.closeMenu();
                }
            });
        }

        /**
         * Gestion de la touche échap
         */

    }, {
        key: 'initEventListeners',
        value: function initEventListeners() {
            var _this = this;

            document.addEventListener('keyup', function (e) {
                if (e.keyCode === key.ESCAPE) {
                    var isMenuOpen = (0, _jquery2.default)(CLASS.MENU_BURGER).attr('aria-expanded') === 'true';
                    if (isMenuOpen) {
                        _this.closeMenu();
                        // ▼ afin de remettre le focus sur le bouton
                        setTimeout(function () {
                            (0, _jquery2.default)(CLASS.MENU_BURGER).focus();
                        }, 100);
                    }
                }
            });
        }

        /**
         * Open Mobile Menu
         */

    }, {
        key: 'openMenu',
        value: function openMenu() {
            this.$containerBurgerContent.addClass(CLASS.IS_OPEN);
            this.$burgerBtn.attr("aria-expanded", "true");
            this.isOpen = true;
        }

        /**
         * Close Mobile Menu
         */

    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            this.$containerBurgerContent.removeClass(CLASS.IS_OPEN);
            this.$burgerBtn.attr("aria-expanded", "false");
            this.isOpen = false;
        }
    }]);

    return BurgerBtn;
}();

exports.default = BurgerBtn;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SELECTOR = {
	SEARCH_CONTAINER: '.js-search-wrapper',
	SEARCH_BTN: '.js-search-menu',
	SEARCH_FIELD: '.js-main-search_field',
	SEARCH_FIELD_MOBILE: '.js-main-search_field-mobile',
	SEARCH_RESULT_LIST: '.js-main-search_list',
	SEARCH_BTN_FORM: '.js-search-form-btn'
};

var KEY = {
	UP: 38,
	DOWN: 40,
	ESC: 27,
	ENTER: 13,
	SPACE: 27,
	TAB: 9
};

var MIN_SEARCH_CHARS = 3;

// mock ajax call getting json list
var searchList;

var CLASS = {
	IS_OPEN: 'is-open',
	IS_ACTIVE: 'is-active'
};

var SearchPanel = function () {
	function SearchPanel(selectorPanel, itemIdPrefix, isMobile) {
		_classCallCheck(this, SearchPanel);

		var _self = this;
		_self.itemIdPrefix = itemIdPrefix;
		_self.isMobile = isMobile;

		_self.$el = (0, _jquery2.default)(selectorPanel);
		_self.$btn = _self.$el.find(SELECTOR.SEARCH_BTN);
		_self.$container = (0, _jquery2.default)(SELECTOR.SEARCH_CONTAINER);
		// _self.$el / selectorPanel (conteneur) est valable seulement pour mobile,
		// pour desktop le conteneur correspond au '.js-search-wrapper'
		_self.$searchField = isMobile ? _self.$el.find(SELECTOR.SEARCH_FIELD_MOBILE) : _self.$container.find(SELECTOR.SEARCH_FIELD);
		_self.$searchResultList = _self.$container.find(SELECTOR.SEARCH_RESULT_LIST);
		_self.$searchForm = _self.$container.find('form');
		_self.$searchBtnForm = _self.$container.find(SELECTOR.SEARCH_BTN_FORM);
		_self.$document = (0, _jquery2.default)(document);
		_self.$searchEraseBtn = _self.$container.find('.js-main-search_erase2');

		_self.isOpen = false;
		_self.focusIndex = -1;

		_self.loadList();
		_self.handleEventsGlobal();
		_self.handleEventsInSearchField();

		_self.$btn.attr("aria-expanded", "false");
		_self.$searchResultList.css('display', 'none');
	}

	/**
  * Ajax call to initialize context
  */


	_createClass(SearchPanel, [{
		key: 'loadList',
		value: function loadList() {
			var url = (0, _jquery2.default)("#hidden-autocompletion-file").html();
			if (url) {
				_jquery2.default.ajax({
					url: url.trim(),
					method: "GET",
					dataType: "json",
					success: function success(response) {
						searchList = response.filterList;
					},
					error: function error() {
						console.log('Erreur du chargement de la liste');
					}
				});
			}
		}
	}, {
		key: 'escapeRegexpChars',
		value: function escapeRegexpChars(chars) {
			return chars.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
		}
	}, {
		key: 'searchFldFocus',
		value: function searchFldFocus() {
			//_self.$container = $('.js-search-wrapper'); _self.$container.find('.js-main-search_field');		
			(0, _jquery2.default)('.js-search-wrapper').find('.js-main-search_field').focus();
		}

		/**
   * buildResultList
   */

	}, {
		key: 'buildResultList',
		value: function buildResultList(e) {
			var _this = this;

			var _self = this;
			var searchEntry = _self.escapeRegexpChars(_self.$searchField.val());
			var resultList = "";

			_self.resultListLen = 0;
			_self.$searchField.html('');

			if (_self.isSearchListDefined()) {
				searchList.filter(function (listEntry) {
					return _self.hasItem(listEntry, searchEntry);
				}).forEach(function (item, index) {
					var itemWithHighlight = _self.highlight(item, searchEntry);

					resultList += '<li\n\t\t\t\t\t\t\t\tid=\'' + _this.itemIdPrefix + '-' + index + '\'\n\t\t\t\t\t\t\t\tclass=\'rsp_search-box__item\' role=\'option\' tabindex=\'-1\' >' + itemWithHighlight + '</li>';
					_self.resultListLen++;
				});
			}

			_self.$searchResultList.html(resultList);
		}

		/**
   * Handle all needed events
   */

	}, {
		key: 'handleEventsGlobal',
		value: function handleEventsGlobal() {
			var _self = this;

			// Event use to open / close the search field
			_self.$btn.bind("click", function (e) {

				if (_self.isOpen) {
					_self.closeSearch(false);
				} else {
					_self.openSearch();
					document.querySelector("#searchBox").addEventListener("transitionend", _self.searchFldFocus);
					// Close search clicking outside of the research bar
					_self.$document.on('click', function (e) {
						if (_self.isOpen) {
							e.stopPropagation();
							_self.closeSearch(false);
						}
					});
				}
				e.stopPropagation();
			});

			// Event that prevent submit of form if searchField is empty
			// TODO : why focusIndex here ?
			// $el is not a form but the container <li ?!
			_self.$el.submit(function (e) {
				//if (this.isEmpty(this.$searchField.val()) || this.focusIndex !== -1) 
				e.preventDefault();
			});

			// bind on click on autocomplete element
			_self.$searchResultList.mousedown(function (e) {
				if (e.target.tagName === 'LI') {
					_self.$searchField.val(_self.trimSpaces(e.target.textContent));

					// Perform the search
					_self.submitMainSearchField(_self.$searchField);
				}
			});

			// bind click btn form
			_self.$searchBtnForm.bind('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				_self.submitMainSearchField(_self.$searchField);
			});

			// Close form when user leaves form with tab
			// Tab sur dernière bouton, on quitte le formulaire : fermer
			_self.$searchBtnForm.keydown(function (e) {
				if (!e.shiftKey && e.keyCode === KEY.TAB) e.stopPropagation();
				e.preventDefault();
				_self.closeSearch(true);
			});

			// Erase button (on click or enter : clear search field
			if (_self.$searchEraseBtn !== undefined) {

				_self.$searchEraseBtn.mousedown(function (e) {
					e.preventDefault();
					e.stopPropagation();

					_self.clearSearchField();
				});

				_self.$searchEraseBtn.keyup(function (e) {
					if (e.keyCode === KEY.ENTER) {
						e.preventDefault();
						e.stopPropagation();
						_self.clearSearchField();
					}
				});
			}

			if (!_self.isMobile && _self.$container !== undefined) {

				_self.$container.keyup(function (e) {
					switch (e.keyCode) {
						case KEY.ESC:
							_self.closeSearch(true);
							break;
					}
				});

				// Ca ne fonctionne pas (ni pour container) ?
				_self.$searchForm.blur(function (e) {
					_self.closeSearch(true);
				});
			}

			// Do not close search bar clicking on it
			_self.$container.bind('click', function (e) {
				e.stopPropagation();
			});
		}

		/** Open Search */

	}, {
		key: 'openSearch',
		value: function openSearch() {
			this.$container.addClass(CLASS.IS_OPEN);
			this.$btn.attr("aria-expanded", "true");
			this.isOpen = true;
		}

		/** Close Search */

	}, {
		key: 'closeSearch',
		value: function closeSearch(searchbtnfocus) {
			var _self = this;

			this.$container.removeClass(CLASS.IS_OPEN);
			this.$btn.attr("aria-expanded", "false");
			this.isOpen = false;

			_self.emptyList();

			if (searchbtnfocus) this.$btn.focus();

			_self.$document.off('click');
		}

		/** Clear search field */

	}, {
		key: 'clearSearchField',
		value: function clearSearchField() {
			var _self = this;

			_self.$searchField.val('');
			_self.$searchField.focus();

			if (!_self.isMobile) {
				_self.emptyList();
				if (_self.$searchEraseBtn !== undefined) _self.$searchEraseBtn.addClass('dcw_hidden');
			}
		}

		/** Clear search list */

	}, {
		key: 'emptyList',
		value: function emptyList() {
			var _self = this;
			_self.$searchResultList.html(''); // Comment this line out to keep list for tests
			_self.$searchResultList.css('display', 'none');
			_self.focusIndex = -1;
			_self.$searchField.attr("aria-expanded", "false");
		}

		/**
   * Handle event linked to Search Field
   */

	}, {
		key: 'handleEventsInSearchField',
		value: function handleEventsInSearchField(e) {
			var _self = this;

			var index = void 0;

			// On focus on search field, put active class on parent
			_self.$searchField.focus(function (e) {
				// 1x focus annuler le setfocus à la fin de transitioned
				// comme activé par le clic sur bouton recherche :
				// document.querySelector("#searchBox").addEventListener("transitionend", _self.searchFldFocus);
				document.querySelector("#searchBox").removeEventListener("transitionend", _self.searchFldFocus);

				_self.$el.addClass(CLASS.IS_ACTIVE);
			});

			// Blur : Css animation of text research when user leave search box
			_self.$searchField.blur(function (e) {
				if (_self.isEmpty(e.target.value)) _self.$el.removeClass('is-active');

				if (!_self.isMobile) _self.emptyList();
			});

			// On click on search field block propagation
			_self.$searchField.click(function (e) {
				e.stopPropagation();
			});

			/**
    * On press key down, stop propagation
    * Navigate in list, perform search if key is "enter"
    */
			_self.$searchField.keydown(function (e) {

				// Close form when user leaves form with tab
				if (e.shiftKey && e.keyCode === KEY.TAB) {
					e.stopPropagation();
					e.preventDefault();
					_self.closeSearch(true);
				} else {
					switch (e.keyCode) {

						case KEY.ENTER:

							e.stopPropagation();
							e.preventDefault();

							// Recherche sur la ligne sélectionnée indexée avec focusIndex
							// A noter que focusIndex est seulement > -1 après sélection avec les flèches
							// Comme devient -1 au blur (donc focus) du champ de saisie est à chaque changement du champ
							if (_self.focusIndex > -1) {
								_self.$searchField.val(_self.getItemValueByIndex(_self.focusIndex));
								_self.emptyList();
								_self.updateActiveDescendantByIndex(_self.focusIndex);
							}

							if (_self.$searchField.val() !== "" && _self.$searchField.val() !== null) _self.submitMainSearchField(_self.$searchField);

							break;

						case KEY.ESC:

							e.stopPropagation();
							_self.clearSearchField();
							break;

						case KEY.DOWN:

							if (!_self.isMobile) {

								e.stopPropagation();
								e.preventDefault();
								index = _self.getNextIndex(_self.focusIndex);
								if (index === _self.focusIndex) return;
								_self.removePseudoFocus(_self.focusIndex);
								_self.addPseudoFocus(index);
								_self.updateActiveDescendantByIndex(index);
								_self.focusIndex = index;
							}
							break;

						case KEY.UP:

							if (!_self.isMobile) {
								e.stopPropagation();
								e.preventDefault();

								index = _self.getPrevIndex(_self.focusIndex);
								if (index === _self.focusIndex) return;
								_self.removePseudoFocus(_self.focusIndex);
								_self.addPseudoFocus(index);
								_self.focusIndex = index;
							}
							break;
					}
				}
			});

			// keyup
			_self.$searchField.keyup(function (e) {

				if (!_self.isMobile) {

					// start list from 3 characters entered
					switch (_self.shouldStartAutoCompletion()) {
						case true:
							_self.emptyList();
							break;

						case false:
							if (e.keyCode === KEY.DOWN || e.keyCode === KEY.UP || e.keyCode === KEY.ENTER || e.keyCode === KEY.SPACE) return;

							// Reset index liste
							_self.focusIndex = -1;

							// Create liste
							_self.$searchResultList.css('display', 'block');
							_self.buildResultList(e);

							if (_self.resultListLen > 0) {
								_self.$searchField.attr("aria-expanded", "true");
							} else _self.emptyList();

							break;
					}

					// Show erasebutton as soon as user types something
					if (_self.$searchEraseBtn !== undefined) {
						if (_self.$searchField.val() !== "") _self.$searchEraseBtn.removeClass('dcw_hidden');else _self.$searchEraseBtn.addClass('dcw_hidden');
					}
				}
			});
		}
	}, {
		key: 'addPseudoFocus',
		value: function addPseudoFocus(index) {
			this.$searchResultList.find('li').eq(index).addClass('is-focus');
			this.$searchResultList.find('li').eq(index).attr("aria-selected", "true");
		}
	}, {
		key: 'removePseudoFocus',
		value: function removePseudoFocus(index) {
			this.$searchResultList.find('li').eq(index).removeClass('is-focus');
			this.$searchResultList.find('li').eq(index).attr("aria-selected", "false");
		}
	}, {
		key: 'getNextIndex',
		value: function getNextIndex(index) {
			return Math.min(index + 1, this.resultListLen - 1);
		}
	}, {
		key: 'getPrevIndex',
		value: function getPrevIndex(index) {
			return Math.max(index - 1, 0);
		}
	}, {
		key: 'isEmpty',
		value: function isEmpty(value) {
			return value === "";
		}
	}, {
		key: 'updateActiveDescendantByIndex',
		value: function updateActiveDescendantByIndex(index) {
			this.$searchField.attr('aria-activedescendant', this.getItemIdByIndex(index));
		}
	}, {
		key: 'getItemIdByIndex',
		value: function getItemIdByIndex(index) {
			if (index === -1) return null;
			return this.itemIdPrefix + '-' + index;
		}
	}, {
		key: 'getItemValueByIndex',
		value: function getItemValueByIndex(index) {
			return this.trimSpaces(this.$searchResultList.find('li').eq(index).text());
		}
	}, {
		key: 'shouldStartAutoCompletion',
		value: function shouldStartAutoCompletion() {
			return this.$searchField.val().length < MIN_SEARCH_CHARS && this.isSearchListDefined();
		}
	}, {
		key: 'submitMainSearchField',
		value: function submitMainSearchField(element) {
			// Searchvalue added to url // element.prop('disabled', true); 
			var actualpage = window.location.href;
			var action = element.closest('form').attr('action');
			var keywordValue = btoa(element.val() + "b").replace(/=/g, '');
			window.location.href = action + "#keyword=" + keywordValue;
			// If previous page was already searchpage: force reload
			if (actualpage.indexOf("resultats-recherche") >= 0) window.location.reload(true);
			//window.location.assign(action+"#keyword=" + keywordValue);
		}
	}, {
		key: 'trimSpaces',
		value: function trimSpaces(str) {
			return str.replace(/^\s+|\s+$/g, "");
		}
	}, {
		key: 'isSearchListDefined',
		value: function isSearchListDefined() {
			return searchList !== undefined && searchList !== null;
		}
	}, {
		key: 'hasItem',
		value: function hasItem(listEntry, searchEntry) {
			if (searchEntry === '') return;
			var regexp = new RegExp(searchEntry);
			return regexp.test(listEntry);
		}
	}, {
		key: 'highlight',
		value: function highlight(listEntry, searchEntry) {
			return listEntry.replace(searchEntry, '<strong>' + searchEntry + '</strong>');
		}
	}]);

	return SearchPanel;
}();

exports.default = SearchPanel;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CLASS = {
    IS_OPEN: 'is-open',
    IS_ACTIVE: 'is-active',
    LEFT_MENU: "js-leftnav",
    FIRST_LVL: "js-mainnav-link"
};

var SELECTOR = {
    BREADCRUMB_CHANNEL_IDS_SELECTOR: "#breadcrumb-channel-ids",
    DATA_CHANNEL_ID_ATTR: "data-channelid",
    FIRST_LVL: ".js-mainnav-link",
    CONTAINER_MENU_DESKTOP: '.js-nav-desktop',
    SECOND_LVL: ".js-secondlvl-link",
    PARENT_SUBLEVEL: '.js-sub-level',
    CONTAINER_SUBLEVEL: '.js-container-sublevel',
    SELECTOR_DROPDOWN: ".js-dropdown",
    SELECTOR_DROPDOWN_CONTENT: ".js-dropdown-content",
    SELECTOR_DROPDOWN_BTN: ".js-dropdown-btn",
    SELECTOR_DROPDOWN_ITEMS: ".js-submenu_elt-in-dropdown",
    TABLET_FIFTH_ELEMENT: ".js-dropdown-item-only-tablet",
    DESKTOP_FIFTH_ELEMENT: ".js-item-only-desktop"
};

var breakPointMobile = 768;
var breakPointTablet = 1024;

var NavPanelDesktop = function () {
    function NavPanelDesktop() {
        _classCallCheck(this, NavPanelDesktop);

        var _self = this;

        _self.$firstLinkActive = null;
        _self.$panel = (0, _jquery2.default)(SELECTOR.CONTAINER_MENU_DESKTOP);
        _self.$subLvlContainer = (0, _jquery2.default)(SELECTOR.CONTAINER_SUBLEVEL);

        // Only hide if doesn't contain a submenu yet (view moves from desktop to mobile and back)
        if (_self.$subLvlContainer.find(SELECTOR.SECOND_LVL).length == 0) _self.$subLvlContainer.hide();

        // get channel Ids from dom
        _self.currentChannelBreadcrumb = (0, _jquery2.default)(SELECTOR.BREADCRUMB_CHANNEL_IDS_SELECTOR).val();

        // get first list of links
        _self.$firstLvlLinks = _self.$panel.children("li");

        // perform anchors context
        _self.$linksWithAnchors = (0, _jquery2.default)('*[data-cm="1"]');
        if (_self.$linksWithAnchors.length > 0) {
            _self.generateFriendlyUrlWithAnchors();
        }
    }

    /**
     * Init App
     */


    _createClass(NavPanelDesktop, [{
        key: 'init',
        value: function init() {
            var _self = this;

            _self.bindLinkSecondLevel();
            _self.setActiveLink();
            if (_self.hasDropDown) _self.bindEventDropDown();
        }

        /*
           BIND CLICK FOR SECOND LEVEL LINKS
        */

    }, {
        key: 'bindLinkSecondLevel',
        value: function bindLinkSecondLevel() {
            var _self = this;
            function updateHighlight() {
                if (_self && typeof _self.$secondLvlLinks !== 'undefined') {
                    //_self.$secondLvlLinks.removeClass(CLASS.IS_ACTIVE);
                    _self.setActiveLink();
                }
            }
            window.addEventListener('hashchange', updateHighlight, false);
        }

        /*
           Perform menu
        */

    }, {
        key: 'setActiveLink',
        value: function setActiveLink() {
            var _self = this;

            if (_self.currentChannelBreadcrumb != undefined) {
                /* Activate highlight to the link for first lvl  */
                _self.$firstLvlLinks.each(function (index, element) {
                    var currentChannelId = (0, _jquery2.default)(element).attr(SELECTOR.DATA_CHANNEL_ID_ATTR);
                    if (currentChannelId !== "" && _self.currentChannelBreadcrumb.indexOf(currentChannelId) >= 0) {
                        _self.$firstLinkActive = (0, _jquery2.default)(element);
                        _self.activateElt(_self.$firstLinkActive);

                        // Perform 2nd level of first level link
                        if (_self.$firstLinkActive.hasClass(CLASS.FIRST_LVL)) //"js-mainnav-link"
                            _self.initSecondLvl(_self.$firstLinkActive);
                    }
                });
            }
        }

        /*
            GENERATE URL WITH ANCHOR
        */

    }, {
        key: 'generateFriendlyUrlWithAnchors',
        value: function generateFriendlyUrlWithAnchors() {
            var _self = this;

            _self.$linksWithAnchors.each(function () {
                var $this = (0, _jquery2.default)(this);
                if ($this.data('anchor')) {
                    var newHref = $this.attr("href") + $this.data('anchor');
                    $this.attr("href", newHref);
                }
            });
        }

        /*
            BIND CLICK FOR DROPDOWN
        */

    }, {
        key: 'bindEventDropDown',
        value: function bindEventDropDown() {
            var _self = this;

            _self.$dropDownBtn.off("click");
            _self.$dropDownBtn.on("click", function () {
                //_self.$dropDown.toggleClass(CLASS.IS_ACTIVE);
                if (_self.$dropDownBtn.attr("aria-expanded") == "true") {
                    _self.$dropDownBtn.attr("aria-expanded", "false");
                    _self.$dropDown.removeClass(CLASS.IS_ACTIVE);
                } else {
                    _self.$dropDownBtn.attr("aria-expanded", "true");
                    _self.$dropDown.addClass(CLASS.IS_ACTIVE);
                }
            });
        }

        /*
          GET CURRENT CONTEXT OF WINDOWS
        */

    }, {
        key: 'initFormatContext',
        value: function initFormatContext() {
            var _self = this;
            if (breakPointMobile < (0, _jquery2.default)(window).width() && (0, _jquery2.default)(window).width() <= breakPointTablet) {
                _self.contextTablet = true;
                _self.contextDesktop = false;
            } else {
                _self.contextTablet = false;
                _self.contextDesktop = true;
            }
        }

        /*
            REMOVE EXTRA ENTRY IN MENU
        */

    }, {
        key: 'removeExtraItem',
        value: function removeExtraItem() {
            var _self = this;
            if (_self.contextTablet) {
                var $desktopFifthLi = (0, _jquery2.default)(SELECTOR.DESKTOP_FIFTH_ELEMENT);
                if ($desktopFifthLi.length > 0) {
                    $desktopFifthLi.remove();
                }
            } else if (_self.contextDesktop) {
                var $tabletFifthLi = (0, _jquery2.default)(SELECTOR.TABLET_FIFTH_ELEMENT);
                if ($tabletFifthLi.length > 0) {
                    $tabletFifthLi.remove();
                }
            }
        }

        /**
         * Init Second Lvl
        * Moves secondlevel menu to subLvlContainer
         */

    }, {
        key: 'initSecondLvl',
        value: function initSecondLvl($mainLink) {
            var _self = this;

            _self.$secondLvlLinks = $mainLink.find(SELECTOR.SECOND_LVL);
            if (_self.$secondLvlLinks.length > 0) {
                var $secondLvl = _self.$firstLinkActive.find(SELECTOR.PARENT_SUBLEVEL);

                // generate context on left part
                if ($secondLvl.hasClass(CLASS.LEFT_MENU)) {
                    _self.performLeftMenu();
                } else {
                    _self.activateSecondLvlWithChannelId();
                }
                _self.$subLvlContainer.prepend($secondLvl);
                _self.$subLvlContainer.show();
                _self.initDropDown();
            }
        }

        // Activates 2nd level link if in breadcrumb

    }, {
        key: 'activateSecondLvlWithChannelId',
        value: function activateSecondLvlWithChannelId() {
            var _self = this;

            _self.$secondLvlLinks.each(function (index, element) {
                var currentChannelId = (0, _jquery2.default)(element).attr(SELECTOR.DATA_CHANNEL_ID_ATTR);
                if (currentChannelId !== "" && _self.currentChannelBreadcrumb.indexOf(currentChannelId) >= 0) _self.activateElt((0, _jquery2.default)(element));
            });

            /*  Remove active class in single page context (multi link related to same channel ID)
                TODO : REFACTO FOR THIS SPECIFIC CONTEXT       
            var nbSecondLinkActivated = 0;
            if (nbSecondLinkActivated > 1){
                $listLinks.each(function(index, element){
                    _self.deactivateElt($(element));
                });
            } */
        }

        /*
            PRO & ENT MARKET CONTEXT
        - Activates link of current page (first item in breadcrumb),
        - then opens left menu bottom up
        */

    }, {
        key: 'performLeftMenu',
        value: function performLeftMenu() {
            var _self = this;

            var currentChannelIdsArray = _self.currentChannelBreadcrumb.split(/[\s,]+/);
            var $activeLink = _self.$firstLinkActive.find("li[data-channelid=" + currentChannelIdsArray[0] + "]");
            if ($activeLink.length > 0) {
                _self.activateElt($activeLink);
                _self.processLeftParent($activeLink);
            }
            // Si page pas dans le menu, activer qd même lien niv. 2 dont la page est un sousrubrique
            else {
                    _self.activateSecondLvlWithChannelId();
                }
        }
    }, {
        key: 'processLeftParent',
        value: function processLeftParent($currentElement) {
            var _self = this;
            var $parentsLi = $currentElement.parents('.js-leftnav-link');

            if ($parentsLi.length > 0) {
                var $parentLi = $parentsLi.eq(0);
                var $btn = $parentLi.find('.js-menu-left_toggle').eq(0);
                $btn.addClass("is-active is-open");
                $btn.next().stop(true).slideDown();
                $btn.children("svg").removeClass("is-up");
                $btn.children("svg").addClass("is-up");

                _self.processLeftParent($parentLi);
            } else {
                $currentElement.addClass("parent-active");
            }
        }

        /**
         * Init DropDown & clean it if empty
         */

    }, {
        key: 'initDropDown',
        value: function initDropDown() {
            var _self = this;

            _self.$dropDown = _self.$subLvlContainer.find(SELECTOR.SELECTOR_DROPDOWN);

            if (_self.$dropDown.length > 0) {
                // CHECK IF ITEMS ARE STILL HERE IN DROPDOWN
                _self.$dropDownItems = _self.$dropDown.find(SELECTOR.SELECTOR_DROPDOWN_ITEMS);

                if (_self.$dropDownItems.length > 0) {
                    _self.$dropDownBtn = _self.$dropDown.find(SELECTOR.SELECTOR_DROPDOWN_BTN);
                    _self.$dropDownContent = _self.$dropDown.find(SELECTOR.SELECTOR_DROPDOWN_CONTENT);
                    _self.hasDropDown = true;
                } else {
                    _self.$dropDown.remove();
                    _self.hasDropDown = false;
                }
            } else {
                _self.hasDropDown = false;
            }
        }

        /*
            GENERIC FUNCTIONS
         */

    }, {
        key: 'deactivateElt',
        value: function deactivateElt($element) {
            $element.removeClass(CLASS.IS_ACTIVE);
        }
    }, {
        key: 'activateElt',
        value: function activateElt($element) {
            $element.addClass(CLASS.IS_ACTIVE);
            $element.children("a").attr("aria-current", "page");
        }

        /* TODO : CHECK IF DEPRECATED  */

    }, {
        key: 'activeLinkWithAnchor',
        value: function activeLinkWithAnchor($elements) {
            $elements.each(function () {
                if (window.location.href.indexOf((0, _jquery2.default)(this).data('anchor')) !== -1) {
                    (0, _jquery2.default)(this).parent().addClass(CLASS.IS_ACTIVE);
                }
            });
        }

        /*  DEPRECATED
        performLeftSecondLvl(currentPageId, $listLinksSecondLvl) {
            var _self = this;
            $listLinksSecondLvl.each(function(index, element){
                var currentChannelId = $(element).attr(SELECTOR.DATA_CHANNEL_ID_ATTR);
                if (currentPageId.indexOf(currentChannelId) >= 0) {
                    var $currentElement = $(element);
                    $currentElement.addClass(CLASS.IS_ACTIVE);
                    _self.activateLeftLink($currentElement);
                }
            });
        } */

    }]);

    return NavPanelDesktop;
}();

exports.default = NavPanelDesktop;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SELECTOR = {
    CONTAINER_SUBLEVEL: '.rsp_nav__list',
    BREADCRUMB_CHANNEL_IDS_SELECTOR: '#breadcrumb-channel-ids',
    DATA_CHANNEL_ID_ATTR: "data-channelid"
};

var CLASS = {
    IS_ACTIVE: 'is-active'
};

var NavPanelMobile = function () {
    function NavPanelMobile() {
        _classCallCheck(this, NavPanelMobile);

        var _self = this;
        _self.$panel = (0, _jquery2.default)(SELECTOR.CONTAINER_SUBLEVEL);
        _self.$lvlLinks = _self.$panel.find("li.rsp_nav__item[data-channelid]");
        _self.currentChannelBreadcrumb = (0, _jquery2.default)(SELECTOR.BREADCRUMB_CHANNEL_IDS_SELECTOR).val();
    }
    /**
     * Init App
     */


    _createClass(NavPanelMobile, [{
        key: 'init',
        value: function init() {
            var _self = this;
            _self.bindEvents();
            _self.setActiveLink();
        }

        /**
         * Bind required events
         */

    }, {
        key: 'bindEvents',
        value: function bindEvents() {

            // On cache tous les menus
            (0, _jquery2.default)('.rsp_nav__item ul').hide();

            // On cache le menu à gauche (pro & ent) qd on clique sur btn burger, utilité ?
            // Pas faire ....off("click") comme clics déjà gérés en burgerBtn
            (0, _jquery2.default)('.rsp_btn.rsp_btn--burger.js-header-burger').on("click", function () {
                //$('.rsp_nav__item ul').slideUp();
                (0, _jquery2.default)('.rsp_nav__item ul').each(function () {
                    if ((0, _jquery2.default)(this).hasClass("rsp_menu-left_list")) {
                        (0, _jquery2.default)(this).slideUp();
                    }
                });
            });

            // Boutons menu - event click
            var allMenuBtns = (0, _jquery2.default)(".rsp_nav__item button.rsp_btn.rsp_btn--toggle.js-nav-mobile-first-lvl-btn");
            allMenuBtns.off("click");
            allMenuBtns.on("click", function (e) {
                e.stopPropagation();

                // Toggle menu on click
                var $myListe = (0, _jquery2.default)(this).next('ul.rsp_nav__list');
                (0, _jquery2.default)(this).attr('aria-expanded', $myListe.css('display') == 'none' ? 'true' : 'false');
                $myListe.slideToggle();

                // If first level : close other first level
                if (!(0, _jquery2.default)(this).hasClass("rsp_btn--sub-level")) {
                    var $mainLI = (0, _jquery2.default)(this).closest("li");

                    // Les autres menus niv1 frères
                    var $allMainLI = $mainLI.siblings();

                    // Fermer les autres uls niv.1
                    $allMainLI.find("ul.rsp_nav__list.js-nav-mobile-second-lvl-container").slideUp("100");
                    // Fermer les autres boutons niv.1
                    $allMainLI.find("button.rsp_btn.js-nav-mobile-first-lvl-btn").each(function () {
                        if (!(0, _jquery2.default)(this).hasClass("rsp_btn--sub-level")) {
                            (0, _jquery2.default)(this).attr('aria-expanded', 'false'); //rsp_btn--toggle. & rsp_btn--emergency
                        }
                    });
                }
            });

            // Combo Autres sites
            var otherSite = (0, _jquery2.default)("button.rsp_btn.rsp_btn--emergency.js-nav-mobile-first-lvl-btn");
            // Par défaut fermé
            otherSite.attr('aria-expanded', 'false');
            otherSite.off("click");
            otherSite.on("click", function (e) {
                var attrSwitch = (0, _jquery2.default)(this).attr('aria-expanded');
                (0, _jquery2.default)(this).attr('aria-expanded', attrSwitch === 'false' ? 'true' : 'false');
                (0, _jquery2.default)(this).next('#sub-list-otherSite_metiers, #sub-list-otherSite_regions').slideToggle();
            });
        }

        // Find active link between links with a page reference (data-channelid)

    }, {
        key: 'setActiveLink',
        value: function setActiveLink() {
            var _self = this;
            if (_self.currentChannelBreadcrumb != undefined) {
                if (_self.$lvlLinks.length > 0) {
                    _self.activateLinkWithChannelId(_self.$lvlLinks);
                }
            }
        }
    }, {
        key: 'activateLinkWithChannelId',
        value: function activateLinkWithChannelId($listLinks) {
            var _self = this;
            var currentChannelIds = _self.currentChannelBreadcrumb;

            $listLinks.each(function (index, element) {
                var currentChannelId = (0, _jquery2.default)(element).attr(SELECTOR.DATA_CHANNEL_ID_ATTR);
                // If line is current page
                if (currentChannelId !== "" && currentChannelIds.indexOf(currentChannelId) >= 0) {

                    // Indicate actif line
                    _self.$firstLinkActive = (0, _jquery2.default)(element);
                    _self.$firstLinkActive.addClass(CLASS.IS_ACTIVE);

                    // Open menu bottum-up
                    _self.$firstLinkActive.parents("ul.rsp_nav__list").each(function () {
                        (0, _jquery2.default)(this).show();
                        (0, _jquery2.default)(this).prev("button").attr('aria-expanded', 'true');
                    });

                    // Indicate actif a link
                    _self.$firstLinkActive.children("a").attr('aria-current', 'page');
                }
            });
        }
    }]);

    return NavPanelMobile;
}();

exports.default = NavPanelMobile;

/***/ }),
/* 83 */,
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var classes = {
	CLOSE_BTN: "dcw_popin_modal_close-btn",
	POPIN_OVERLAY: "dcw_popin_modal_overlay",
	POPIN_CLOSE: "dcw_popin_close"
};

function PopinView(root, titleElement, descriptionElement) {
	var self = this;

	this.root = root;
	this.titleElement = titleElement;
	this.descriptionElement = descriptionElement;
	this.callingElement = null;
	this.readonly = false;

	// Handle mouse & keyboard events

	// - Mouse closeBtn
	this.onCloseButtonClick();

	//- Keydown (any key (esp. TAB (9))) : stopPropagation()
	this.root.addEventListener("keydown", function (e) {
		if (e.keyCode === 9) {
			e.stopPropagation();e.preventDefault();

			// Go next/previous tabable element in modal
			// ! Pas testé
			var focusableElements = self.root.querySelectorAll('[tabindex]');
			if (focusableElements.length > 1) {
				var newIndex = 0;
				var currentIndex = focusableElements.indexOf(document.activeElement);
				if (currentIndex >= 0) {
					if (e.shiftKey) newIndex = currentIndex - 1 + focusableElements.length;else newIndex = currentIndex + 1;
					newIndex = newIndex % focusableElements.length;
				}
				focusableElements[newIndex].focus();
			}
		}
	});

	//- Keyup : stopPropagation(), 
	// - 'ESC' : hide()
	this.root.addEventListener("keyup", function (event) {
		if (event.keyCode === 27) self.hide();
	});
}

PopinView.prototype.onCloseButtonClick = function () {
	var self = this;

	this.root.addEventListener("click", function (event) {
		if (event.target.classList.contains(classes.CLOSE_BTN) || event.target.classList.contains(classes.POPIN_OVERLAY) || event.target.classList.contains(classes.POPIN_CLOSE)) {
			self.hide();
		}
	});
};

PopinView.prototype.setTitleElement = function (titleElement) {
	this.titleElement = titleElement;
};

PopinView.prototype.setDescriptionElement = function (descriptionElement) {
	this.descriptionElement = descriptionElement;
};

PopinView.prototype.show = function () {
	this.root.style.display = "block";
	this.root.firstElementChild.style.display = "block";

	// Set focus on first button
	var closebtn = this.root.getElementsByTagName("button")[0];
	if (closebtn) closebtn.focus();
};

PopinView.prototype.hide = function () {
	this.root.style.display = "none";

	if (this.callingElement) this.callingElement.focus();
};

PopinView.prototype.render = function (model) {

	if (this.titleElement) this.titleElement.innerHTML = model.keyword;
	if (this.descriptionElement) this.descriptionElement.innerHTML = model.definition;

	this.readonly = this.callingElement && this.callingElement.getAttribute("readonly") == "true";
};

exports.default = PopinView;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _Cookie = __webpack_require__(25);

var _Cookie2 = _interopRequireDefault(_Cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Const
var SELECTOR_BTN = ".js-sobot-btn";
var COOKIE_PROFILE = "profilTiers";

// Classs can be intiated by search.js passing keyword

var Sobot = function () {
	function Sobot(keyword) {
		_classCallCheck(this, Sobot);

		this.keyword = keyword === undefined ? "" : keyword;
		this.$btn = (0, _jquery2.default)(SELECTOR_BTN);
	}

	// Same as checkProfil() in search.js
	// Returns if profil is ok


	_createClass(Sobot, [{
		key: "checkProfil",
		value: function checkProfil() {

			// return ok if no profils desactivated
			var profilsToDeactivate = window.cmsGlobals.chatbotConfig.profilToDeactivate;
			if (profilsToDeactivate && profilsToDeactivate != "") {} else return true;

			// return ok if not connected (no profile)
			var profilT = _Cookie2.default.getByName(COOKIE_PROFILE);
			if (profilT === "") return true;

			// Profile desactived ?
			var listOfProfiles = profilsToDeactivate.split(',');
			var profileOk = true;
			listOfProfiles.forEach(function (profilToDeactivate) {
				if (profilT.includes(profilToDeactivate)) profileOk = false;
			});
			return profileOk;
		}
	}, {
		key: "initSobot",
		value: function initSobot() {
			var _self = this;

			// Check conditions :	
			// - Globally disabled ?
			if (window.cmsGlobals.chatbotConfig.disabled) return true;
			// - Interact api loaded ?
			if (typeof sdcInteract == "undefined" || typeof sdcInteract.api == "undefined") return true;
			// - Interact checkbox activated ?
			if (!document.getElementById('sticky_showContact')) return true;
			// - Chatbot checkbox activated ?
			if (document.getElementById('chatbot_activated') == null) return true;
			// - Profil ?
			if (!_self.checkProfil()) return true;

			// Load Sobot Api (déplacé en interact.js)
			//$.getScript("/icd/static/pch-front/public/pch-lanceur.js", function(data, textStatus, jqxhr){ var result = jqxhr.status; }); 
			// -> charge : /icd/static/pch-front-js/3.0.11-V3-RC3/awtPchBuilder.js

			// Sobot panel, il semblerait que ce script est initié justement par .js-sobot
			var $container = (0, _jquery2.default)(".js-sobot");if ($container) {} else return true;

			// Button sobot
			// - Click
			_self.$btn.on('click', function () {
				// sdcInteract.api.openFeatureStickyPanel({feature: sdcInteract.api.constants.FEATURES.CHATBOT, keyWord: _self.keyword } );
				window.pchApi.startChat({ keyword: _self.keyword });
			});
			// - Label 
			if (window.cmsGlobals.chatbotConfig.ctaSearchLabel) _self.$btn.html(window.cmsGlobals.chatbotConfig.ctaSearchLabel.replaceAll(" ", "&nbsp;"));
			//_self.$btn.text(window.cmsGlobals.chatbotConfig.ctaSearchLabel);

			// Show Sobot panel
			$container.removeClass("dcw_visually-hidden");

			// Interact chatbot feature, encore utile ?
			sdcInteract.api.getFeatureDisplayStatus(sdcInteract.api.constants.FEATURES.CHATBOT, _self.displaySobot);
		}

		// displayStatus.ngim : état de désactivation, encore utile, maintenant que le profile est géré ici ?

	}, {
		key: "displaySobot",
		value: function displaySobot(displayStatus) {
			if (displayStatus !== null && !displayStatus.ngim) {}
		}
	}]);

	return Sobot;
}();

exports.default = Sobot;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.POPIN_PROFILE_DEFAULT_VALUES = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _popin = __webpack_require__(48);

var _popin2 = _interopRequireDefault(_popin);

var _SessionStoragePop = __webpack_require__(15);

var _SessionStoragePop2 = _interopRequireDefault(_SessionStoragePop);

var _name = __webpack_require__(27);

var _market = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var POPIN_PROFILE_DEFAULT_VALUES = exports.POPIN_PROFILE_DEFAULT_VALUES = {
    MOBILE_BREAKPOINT: 768,
    TEXT_HEADLINE: "Sécurité",
    //TEXT_DESCRIPTION_1: "Bienvenue ",
    //TEXT_DESCRIPTION_2: ", Vous naviguez désormais sur votre espace ",
    //TEXT_DESCRIPTION_3: ". Attention à vos identifiants utilisés.",
    TEXT_DESCRIPTION_1: "<p>Bienvenue sur votre espace client ",
    TEXT_DESCRIPTION_2: ".</p><p>Attention : veillez à bien utiliser ",
    TEXT_DESCRIPTION_3: "votre code secret  ",
    TEXT_DESCRIPTION_4: " pour toute opération les nécessitant.</p>",
    SESSION_STORAGE_POPIN_ACTIVATED: "popin_activate_nav_pro_pri",
    APP: "NavProPri",
    PRIORITY_MOBILE: 1
};

var PopinNavProPriApp = function () {
    function PopinNavProPriApp() {
        _classCallCheck(this, PopinNavProPriApp);

        var _self = this;

        // init default values
        _self.sessionKey = POPIN_PROFILE_DEFAULT_VALUES.SESSION_STORAGE_POPIN_ACTIVATED;
        _self.initMobileContext();

        // Init session storage with custom key
        _self.sessionStoragePop = new _SessionStoragePop2.default(_self.sessionKey);
        // Do not display popin if yet closed during session
        // So do not check the cookie in this context

        _self.needToDisplayPopin = false;
        _self.clientName = (0, _name.updateLoginBoxNamesLhs)();
        _self.currentApp = POPIN_PROFILE_DEFAULT_VALUES.APP;

        _self.market = "Particuliers";
        if (_market.MARKET.CODE === 2) {
            _self.market = "Professionnels";
        }

        //Si on a le flag true dans le local storage ça signifie que la popin a déjà été affiché au cours de la session donc on n'affiche pas la popin
        //Si on ne l'a pas on vérifie que l'on est dans le cas du parcours nav pro pri et si oui on affiche la popin
        if (_self.sessionStoragePop.getJsonObjectFromSession()) {
            _self.needToDisplayPopin = false;
        } else if (sasJs !== undefined && sasJs["user-auth-origin"] !== undefined && (sasJs["user-auth-origin"] === "PRI" || sasJs["user-auth-origin"] === "PRO")) {
            _self.needToDisplayPopin = true;
        }

        _self.popin = new _popin2.default(null, _self.currentApp, _self.priorityMobile, false);

        // Event when first element closed
        window.EventBusCMS.addEventListener('popinGenericEventOnClose', function (event) {
            if (event.detail.currentApp === _self.currentApp) {
                _self.sessionStoragePop.addSimpleBooleanInSessionStorage();
            }
        });
    }

    _createClass(PopinNavProPriApp, [{
        key: 'initMobileContext',
        value: function initMobileContext() {
            // Init Mobile context
            this.onMobile = false;
            if ((0, _jquery2.default)(window).width() < POPIN_PROFILE_DEFAULT_VALUES.MOBILE_BREAKPOINT) {
                this.onMobile = true;
            }
        }

        /**
         * init activation tel
         */

    }, {
        key: 'initPopinNavProPri',
        value: function initPopinNavProPri() {
            if (this.needToDisplayPopin) {
                this.initPopin();
                //this.sessionStoragePop.addSimpleBooleanInSessionStorage();
            } else if ((0, _jquery2.default)(window).width() < POPIN_PROFILE_DEFAULT_VALUES.MOBILE_BREAKPOINT) {
                // if no popin - display following popin on mobile
                this.popin.displayNextPopin();
            }
        }

        /**
         * init activation tel
         */

    }, {
        key: 'initPopin',
        value: function initPopin() {
            var data = {};
            var _self = this;
            _self.popin.hide();

            data.headLine = POPIN_PROFILE_DEFAULT_VALUES.TEXT_HEADLINE;
            //data.description = POPIN_PROFILE_DEFAULT_VALUES.TEXT_DESCRIPTION_1 + _self.clientName + POPIN_PROFILE_DEFAULT_VALUES.TEXT_DESCRIPTION_2 + _self.market + POPIN_PROFILE_DEFAULT_VALUES.TEXT_DESCRIPTION_3;
            data.description = POPIN_PROFILE_DEFAULT_VALUES.TEXT_DESCRIPTION_1 + _self.market + POPIN_PROFILE_DEFAULT_VALUES.TEXT_DESCRIPTION_2 + "<strong>" + POPIN_PROFILE_DEFAULT_VALUES.TEXT_DESCRIPTION_3 + _self.market + "</strong>" + POPIN_PROFILE_DEFAULT_VALUES.TEXT_DESCRIPTION_4;
            data.hideLink = true;

            _self.popin.updatePopinData(data);
            _self.popin.show();
        }
    }]);

    return PopinNavProPriApp;
}();

exports.default = PopinNavProPriApp;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _svg4everybody = __webpack_require__(49);

var _svg4everybody2 = _interopRequireDefault(_svg4everybody);

var _initAPI = __webpack_require__(88);

var _polyfills = __webpack_require__(141);

var _loadComponents = __webpack_require__(143);

var _loadCMS = __webpack_require__(170);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// load exposed methods before dom ready
try {
  (0, _initAPI.initAPI)();
} catch (error) {
  console.error('Failed to load API:', error);
}

(0, _jquery2.default)(document).ready(function ($) {

  // load polyfills
  try {
    (0, _polyfills.loadPolyfills)();
  } catch (error) {
    console.error(error);
  }

  // load CMS modules
  try {
    (0, _loadCMS.loadCMS)();
  } catch (error) {
    console.error(error);
  }

  // SVG fallback for IE
  (0, _svg4everybody2.default)();

  // load front components
  try {
    (0, _loadComponents.loadComponents)($);
  } catch (error) {
    console.error(error);
  }
});

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initAPI = initAPI;

var _eventBus = __webpack_require__(50);

var _globalAPI = __webpack_require__(89);

var _CmsLogger = __webpack_require__(90);

var _ngimBreakpointApi = __webpack_require__(137);

var _ngimFabApi = __webpack_require__(138);

var _headerMethods = __webpack_require__(139);

var API_NAME = {
  BREAKPOINT: 'breakpoint',
  FAB: 'fab',
  HEADER: 'header',
  LOGGER: 'logger'
};

function initAPI() {
  (0, _eventBus.init)();

  try {
    _globalAPI.globalAPI.add(API_NAME.LOGGER, (0, _CmsLogger.getCmsLogger)());
  } catch (error) {
    console.error('failed to initialize the Init Logger API:', error);
  }

  try {
    _globalAPI.globalAPI.add(API_NAME.BREAKPOINT, _ngimBreakpointApi.BreakpointAPI);
  } catch (error) {
    console.error("failed to initialize the Breakpoint API:", error);
  }

  try {
    _globalAPI.globalAPI.add(API_NAME.FAB, _ngimFabApi.FabAPI);
  } catch (error) {
    console.error("failed to initialize the Fab API:", error);
  }

  try {
    _globalAPI.globalAPI.add(API_NAME.HEADER, _headerMethods.apiMethods);
  } catch (error) {
    console.error("failed to initialize the Header API:", error);
  }
}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var API_NAMESPACE = 'cmsAPI';

var globalAPI = exports.globalAPI = {
  add: add
};

function add(apiName, apiModule) {
  if (!isAttachedToWindow()) {
    window[API_NAMESPACE] = {};
  }

  window[API_NAMESPACE][apiName] = apiModule;
}

function isAttachedToWindow() {
  return !!window[API_NAMESPACE];
}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCmsLogger = getCmsLogger;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _common = __webpack_require__(91);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCmsLogger() {
    if (window.cmsConstants) {
        var logServiceEndpoint = window.cmsConstants.LOGGER_SERVICE_END_POINT || window.cmsConstants.LOGGER_SERVICE_END_POINT_DEFAULT;
        var logLevelMinServer = window.cmsConstants.LOGGER_LEVEL_MIN_SERVER || window.cmsConstants.LOGGER_LEVEL_MIN_SERVER_DEFAULT;
        var logLevelMinClient = window.cmsConstants.LOGGER_LEVEL_MIN_CLIENT || window.cmsConstants.LOGGER_LEVEL_MIN_CLIENT_DEFAULT;
    } else {
        var logServiceEndpoint = "/extrestcontent/logBigData";
        var logLevelMinServer = "error";
        var logLevelMinClient = "error";
    }
    var log = new _common2.default({
        logServicesUrls: {
            defaut: logServiceEndpoint
        },
        niveauMinimalLogSurServeur: logLevelMinServer,
        niveauMinimalLogSurClient: logLevelMinClient
    });

    return {
        log: log,
        generateLogIfEmpty: generateLogIfEmpty,
        generateLogValue: generateLogValue,
        generateDebugMsg: generateDebugMsg,
        generateErrorMsg: generateErrorMsg
    };
}

/*
    Generate Log if no value,
    if goReturn is "true" stop the log process because this variable is required
 */
function generateLogIfEmpty(debugInfo, params) {
    var isRequired = debugInfo.isRequired;

    // default isRequired to false
    isRequired = typeof isRequired !== 'undefined' ? isRequired : false;

    if (!debugInfo.valueToCheck || 0 === debugInfo.valueToCheck.length) {
        this.log[debugInfo.logLevel](debugInfo.category + " - " + debugInfo.message + debugInfo.param, params);

        if (isRequired) {
            return;
        }
    }
}

function generateLogValue(debugInfo, params) {
    if (debugInfo.valueToCheck) {
        this.log.info(debugInfo.category + " - " + debugInfo.message + '"' + debugInfo.param + '" : ' + debugInfo.valueToCheck, params);
    }
}

// Generate Debug Msg
function generateDebugMsg(debugInfo, params) {
    this.log.info(debugInfo.category + " - " + debugInfo.message, params);
}

function generateErrorMsg(cat, msg) {
    var variable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

    this.log.error(cat + " - " + msg + variable);
}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(28);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(92));

var _typeof2 = _interopRequireDefault(__webpack_require__(94));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(95));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(29));

var _createClass2 = _interopRequireDefault(__webpack_require__(30));

__webpack_require__(96);

var _TraceEvent = _interopRequireDefault(__webpack_require__(135));

var _RequestCounter = _interopRequireDefault(__webpack_require__(136));

var w = typeof window !== 'undefined' ? window : {};

var CommonLog = /*#__PURE__*/function () {
  /**
   * Constructor
   * @param {object} params
   */
  function CommonLog(params) {
    (0, _classCallCheck2["default"])(this, CommonLog);
    this.updateConfiguration(params);
    this.RequestCounter = new _RequestCounter["default"]({
      nbMaxRequestPerPeriod: Math.min(params.nbMaxRequestPerMinute || 100, 100),
      periodDurationInMs: params.periodDurationInMs || 60 * 1000
    });
    this.requestInterceptors = [];
  }
  /**
   * Update Configuration
   * @param {object} params
   */


  (0, _createClass2["default"])(CommonLog, [{
    key: "updateConfiguration",
    value: function updateConfiguration() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.contextName = params.contextName || '';
      this.niveauMinimalLogSurServeur = params.niveauMinimalLogSurServeur || 'ERROR';
      this.niveauMinimalLogSurClient = params.niveauMinimalLogSurClient || this.niveauMinimalLogSurServeur; // Référentiel des URLs de services de logs par contexte (socle, awt commun et sdc)

      this.logServicesUrls = params.logServicesUrls || {
        defaut: false
      }; // URL du service de logs utilisé dans le contexte d'exécution actuel

      this.logServiceUrl = this.logServicesUrls.defaut;
      this.logMaxSizeMessage = params.logMaxSizeMessage ? Math.min(params.logMaxSizeMessage * 1, 4000) : 200; // Un message est divisé en plusieurs sous messages pour faciliter la lecture dans les logs
      // Cette variable correspond au nombre max de sous message.

      this.nbMaxSsMessage = params.nbMaxSsMessage ? Math.min(params.nbMaxSsMessage, 10) : 10; // Si "nbFailedCallService" de traces envoyées au serveur sont tombées en erreur réseau, alors
      // aucune des traces suivantes ne sera envoyée au serveur.

      this.nbFailedCallService = params.nbFailedCallService ? Math.min(params.nbFailedCallService * 1, 20) : 2;
      this.countFailedRequest = this.countFailedRequest || 0; // Permet de déclarer les patterns (regex) de messages à ne pas tracer sur le serveur.

      this.filterMessagePatterns = params.filterMessagePatterns || [];
      this.cesure = params.cesure || "...";
      this.withCredentials = params.withCredentials;
      this.addUserAgent = params.addUserAgent;
      this.httpMethod = params.httpMethod || "POST";
      this.niveauParamName = params.niveauParamName || "an200_niveau";
      this.messageParamName = params.messageParamName || "cl200_message";
      this.addUserAgentParamName = params.addUserAgentParamName || "an200_add_useragent";
      this._params = params;
    }
    /**
     * Set Context
     * @param {string} name
     */

  }, {
    key: "setContext",
    value: function setContext(name) {
      var defaultUrl;
      name = name || this.contextName;

      switch (name) {
        case "socle":
        case "commun":
          defaultUrl = this.logServicesUrls.defaut;
          break;

        default:
          defaultUrl = this.logServicesUrls[this.logServicesUrls.sdc ? 'sdc' : 'defaut'];
          break;
      }

      this.logServiceUrl = this.logServicesUrls[name] || defaultUrl;
    }
  }, {
    key: "setRequestInterceptor",
    value: function setRequestInterceptor(interceptor) {
      this.requestInterceptors = [interceptor];
    }
  }, {
    key: "processRequestInterceptors",
    value: function () {
      var _processRequestInterceptors = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(xmlHttpRequest) {
        var i;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                i = 0;

              case 1:
                if (!(i < this.requestInterceptors.length)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return Promise.resolve(this.requestInterceptors[i](xmlHttpRequest));

              case 4:
                i++;
                _context.next = 1;
                break;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function processRequestInterceptors(_x) {
        return _processRequestInterceptors.apply(this, arguments);
      }

      return processRequestInterceptors;
    }()
  }, {
    key: "removeInterceptors",
    value: function removeInterceptors() {
      this.requestInterceptors = [];
    }
    /**
     * Log Level
     * @param niveau
     * @param logs
     */

  }, {
    key: "log",
    value: function log(niveau, logs) {
      this.updateConfiguration(this._params);
      var traceEvent = null;

      if (typeof logs === 'string') {
        logs = [logs];
      } // Si le premier paramètre est un TraceEvent, on récupère le message et les méta données


      if (logs[0] instanceof _TraceEvent["default"]) {
        traceEvent = logs[0];
        logs[0] = traceEvent.getMessage();
      }

      if (this.countFailedRequest < this.nbFailedCallService) {
        // Log level
        if (this.logServiceUrl && this.getLevelIndex(this.niveauMinimalLogSurServeur) !== -1 && this.getLevelIndex(niveau) >= this.getLevelIndex(this.niveauMinimalLogSurServeur)) {
          // Check if we reached the limit, then we should not
          // send the log, otherwise we should add the timestamp
          // to the log counter queue
          if (this.RequestCounter.isMaxRequestsThresholdReached()) {
            return;
          }

          this.remoteCallback(niveau, logs, traceEvent);
        }
      }

      Array.prototype.unshift.call(logs, "[".concat(niveau, "]"));

      if (this.getLevelIndex(this.niveauMinimalLogSurClient) === -1 || this.getLevelIndex(niveau) < this.getLevelIndex(this.niveauMinimalLogSurClient)) {
        return; // no log client
      } // On ajoute les métaDonnées à la fin du message


      if (traceEvent) {
        Array.prototype.push.call(logs, traceEvent.getAllMetaDataAsString());
      }

      switch (niveau) {
        case this.NIVEAU.DEBUG:
          Function.prototype.apply.call(console.log, console, logs);
          break;

        case this.NIVEAU.INFO:
        case this.NIVEAU.NOTICE:
        case this.NIVEAU.AUDIT:
          Function.prototype.apply.call(console.info, console, logs);
          break;

        case this.NIVEAU.WARNING:
          Function.prototype.apply.call(console.warn, console, logs);
          break;

        case this.NIVEAU.ERROR:
          Function.prototype.apply.call(console.error, console, logs);
          break;
      }
    }
    /**
     *
     * @param niveau
     * @returns {number}
     */

  }, {
    key: "getLevelIndex",
    value: function getLevelIndex(niveau) {
      var i = 0;

      for (var niv in this.NIVEAU) {
        if (niveau && niv.toLowerCase() === niveau.toLowerCase()) {
          return i;
        }

        i++;
      }

      return -1;
    }
    /**
     * Trace type debug
     * @function debug
     */

  }, {
    key: "debug",
    value: function debug() {
      this.log(this.NIVEAU.DEBUG, arguments);
    }
    /**
     * Trace type info
     * @function info
     */

  }, {
    key: "info",
    value: function info() {
      this.log(this.NIVEAU.INFO, arguments);
    }
    /**
     * Trace type notice
     * @function notice
     */

  }, {
    key: "notice",
    value: function notice() {
      this.log(this.NIVEAU.NOTICE, arguments);
    }
    /**
     * Trace type warning
     * @function warning
     */

  }, {
    key: "warning",
    value: function warning() {
      this.log(this.NIVEAU.WARNING, arguments);
    }
    /**
     * Trace type error
     * @function error
     */

  }, {
    key: "error",
    value: function error() {
      this.log(this.NIVEAU.ERROR, arguments);
    }
    /**
     * Trace type audit
     * @function audit
     */

  }, {
    key: "audit",
    value: function audit() {
      this.log(this.NIVEAU.AUDIT, arguments);
    }
  }, {
    key: "parseJSON",
    value: function parseJSON(json) {
      var jsonResp;

      try {
        try {
          jsonResp = JSON.parse(json);
        } catch (e) {
          // Fallback IE, on mise tout sur le fait que jQuery traîne dans la page
          jsonResp = w.jQuery.parseJSON(json);
        }
      } catch (e) {
        jsonResp = {
          'commun': {
            'statut': "KO",
            'raison': "err_tech",
            "origine": "common.log"
          }
        };
      }

      return jsonResp;
    }
    /**
     *
     * @param niveau
     * @param logs
     * @param metaDonnees
     */

  }, {
    key: "remoteCallback",
    value: function remoteCallback(niveau, logs, traceEvent) {
      var encodedMessages;
      var encodeMessage;
      var message;
      var metaDonneesRequestParameters = traceEvent ? traceEvent.getAllMetaDataAsRequestParametersString() : "";
      var addUserAgent = typeof this.addUserAgent !== 'undefined' ? addUserAgent : traceEvent ? false : true;
      message = this._formatLogs(logs); // Filter message

      if (this._filterMessage(this.filterMessagePatterns, message)) {
        return; // no log server
      }

      message = this._convertToF5CompliantMessage(message);
      encodeMessage = encodeURIComponent(message); // splitText message into multiple message

      encodedMessages = this._splitMessage(encodeMessage, !!traceEvent);

      for (var index = 0, length = encodedMessages.length; index < length; index++) {
        this._sendMessage(niveau, encodedMessages[index], metaDonneesRequestParameters, addUserAgent, this._callbackAjaxSuccess, this._callbackAjaxError, this.logServiceUrl, this);
      }
    }
    /**
     *
     * @param response
     */

  }, {
    key: "_callbackAjaxError",
    value: function _callbackAjaxError(response) {
      this.countFailedRequest++;

      if (this.countFailedRequest >= this.nbFailedCallService) {
        console.error("".concat(this.nbFailedCallService, " log service requests on error reached, log requested disabled"));
      }
    }
    /**
     *
     * @param response
     */

  }, {
    key: "_callbackAjaxSuccess",
    value: function _callbackAjaxSuccess(response) {
      this.countFailedRequest = 0;
    }
    /**
     *
     * @param encodedMessage
     * @returns {Array}
     */

  }, {
    key: "_splitMessage",
    value: function _splitMessage(encodedMessage, hideSubMessageId) {
      var messageList = [];
      var messageOffset = 0;
      var nbSentMessages = 0; // Génération d'un identifiant commun à tous les sous messages envoyés

      var idCharacters = ['_', '+', '.', '/', '!'];
      var messageId = idCharacters[Math.floor(Math.random() * idCharacters.length)] + idCharacters[Math.floor(Math.random() * idCharacters.length)]; // Découper le message en plusieurs (max=this.nbMaxSsMessage) sous messages d'une taille inférieure à this.logMaxSizeMessage

      while (messageOffset < encodedMessage.length && nbSentMessages < this.nbMaxSsMessage) {
        // Génération d'un identifiant spécifique à chaque sous messages envoyés
        var subMessageIdPrefix = hideSubMessageId ? '' : "".concat(messageId + _pad_left('.00', nbSentMessages), " "); // Création du sous message

        var nextMessageOffset = messageOffset + (this.logMaxSizeMessage - subMessageIdPrefix.length);
        var subMessage = subMessageIdPrefix + encodedMessage.substring(messageOffset, nextMessageOffset);

        if (nextMessageOffset < encodedMessage.length) {
          // Tant que le message n'est pas complet, faire attention aux caractères encodés qui peuvent être
          // séparés dans 2 subMessages différents.
          if (subMessage.lastIndexOf('%') >= this.logMaxSizeMessage - 2) {
            // le caractère encodé est coupé entre le subMessage courant et le suivant. Reculer avant le % pour partir d'une
            // base saine
            nextMessageOffset -= this.logMaxSizeMessage - subMessage.lastIndexOf('%');
            subMessage = subMessage.substring(0, subMessage.lastIndexOf('%'));
          }

          var lastCharacterEncodedMatches = subMessage.match(/%([0-9a-zA-Z]{2})$/); // Le dernier caractère est-il encodé ?

          var needRewind = lastCharacterEncodedMatches;

          while (needRewind) {
            // On boucle jusqu'à ce que l'ensemble des membres représentant le caractère encodé se trouvent dans le subMessage
            // suivant. On ne sépare pas les membres d'une même famille.
            var lastCharacterHexaCode = lastCharacterEncodedMatches[1]; // %12 => 12

            var lastCharacterHexaCodeAsInt = parseInt(lastCharacterHexaCode, 16); // Convertir l'hexadécimal %12 en int

            if (lastCharacterHexaCodeAsInt >= 0x80
            /* binaire 1000 0000 */
            && lastCharacterHexaCodeAsInt <= 0xBF
            /* binaire 1011 1111 */
            ) {
                // Si le code numérique commençe en binaire par '10' c'est qu'il est l'un des membres représentant le caractère encodé
                // Il doit rester dans le même submessage que les autres membres
                nextMessageOffset -= 3;
                subMessage = subMessage.substring(0, subMessage.length - 3);
                lastCharacterEncodedMatches = subMessage.match(/%([0-9a-zA-Z]{2})$/) || (needRewind = false);
              } else {
              // Le code numérique correspond au premier membre représentant le caractère encodé
              nextMessageOffset -= 3;
              subMessage = subMessage.substring(0, subMessage.length - 3);
              needRewind = false;
            }
          }
        }

        messageOffset = nextMessageOffset;
        messageList.push(subMessage);
        nbSentMessages += 1;
      }

      return messageList;
    }
    /**
     *
     * @param patterns
     * @param message
     * @returns {boolean}
     */

  }, {
    key: "_filterMessage",
    value: function _filterMessage(patterns, message) {
      var regex;

      for (var index = 0, length = patterns.length; index < length; index++) {
        regex = new RegExp(patterns[index]);

        if (regex.test(message)) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "_formatLogs",
    value: function _formatLogs(logs) {
      var message = [];
      var str = [];
      var msg;

      for (var index = 0, length = logs.length; index < length; index++) {
        msg = logs[index];

        switch ((0, _typeof2["default"])(msg)) {
          case "undefined":
            message.push("undefined");
            break;

          case "string":
            message.push(msg);
            break;

          case "object":
            if (msg instanceof Array) {
              message.push(msg.toString());
            } else {
              try {
                message.push(JSON.stringify(msg));
              } catch (e) {
                str = [];

                for (var attr in msg) {
                  str.push("".concat(attr, ":").concat(msg[attr]));
                }

                message.push("{".concat(str.join(','), "}"));
              }
            }

            break;

          default:
            message.push(msg.toString());
        }
      }

      return message.join('|');
    }
    /**
     * Le composant F5 bloque les messages dont le contenu peut être une menace telle qu'une injection XSS.
     * Cf. OWASP.
     *
     * @param message
     * @returns {*} message qui respecte les règles de filtrage du composant F5.
     * @private
     */

  }, {
    key: "_convertToF5CompliantMessage",
    value: function _convertToF5CompliantMessage(message) {
      var forbiddenRegexAndReplacement = [{
        regex: /script/gi,
        replacement: "s*ript"
      }, {
        regex: /settimeout/gi,
        replacement: "s*ttimeout"
      }, {
        regex: /#/gi,
        replacement: " "
      }, {
        regex: /location/gi,
        replacement: "l*cation"
      }, {
        regex: /[\u0000-\u001F\u007F]/g,
        replacement: " "
      }, // Filtrer les caractères de contrôles
      {
        regex: /<{"param/gi,
        replacement: "<*\"param"
      }, {
        regex: /<param/gi,
        replacement: "<*aram"
      }];

      for (var i = 0; i < forbiddenRegexAndReplacement.length; i++) {
        try {
          message = message.replace(forbiddenRegexAndReplacement[i].regex, forbiddenRegexAndReplacement[i].replacement);
        } catch (e) {} // Exception silencieuse pour ne pas provoquer une erreur applicative à cause d'un problème sur le logger

      }

      return message;
    }
  }, {
    key: "_sendMessage",
    value: function () {
      var _sendMessage2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(niveau, encodedMessage, metaDonneesRequestParameters, addUserAgent, callbackSuccess, callbackError, url, ctx) {
        var async, xmlHttpRequest, queryString;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                async = true;
                this.RequestCounter.incrementRequestCount(); // code for IE7+, Firefox, Chrome, Opera, Safari

                xmlHttpRequest = new XMLHttpRequest();

                xmlHttpRequest.onreadystatechange = function () {
                  if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {
                    var jsonResp = ctx.parseJSON(xmlHttpRequest.responseText);

                    if (jsonResp && jsonResp.commun && jsonResp.commun.statut && jsonResp.commun.statut.toLowerCase() === "ok") {
                      callbackSuccess.call(ctx, xmlHttpRequest.responseText);
                    } else {
                      callbackError.call(ctx, xmlHttpRequest.responseText);
                    }
                  }

                  if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status !== 200) {
                    callbackError.call(ctx, xmlHttpRequest.responseText);
                  }
                };

                if (this.withCredentials) {
                  xmlHttpRequest.withCredentials = true;
                }

                queryString = "".concat(encodeURIComponent(this.niveauParamName), "=").concat(encodeURIComponent(niveau), "&").concat(encodeURIComponent(this.messageParamName), "=").concat(encodedMessage).concat(addUserAgent ? "&".concat(this.addUserAgentParamName, "=").concat(addUserAgent) : "").concat(metaDonneesRequestParameters ? "&".concat(metaDonneesRequestParameters) : "");

                if (!(this.httpMethod === 'POST')) {
                  _context2.next = 18;
                  break;
                }

                xmlHttpRequest.open('POST', url, async);
                xmlHttpRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=utf-8");
                xmlHttpRequest.setRequestHeader("x-no-auth", "true"); // Pour des raisons d'optimisation, le header x-no-auth est ajouté à la requête pour désactiver certains contrôles SAS.

                _context2.prev = 10;
                _context2.next = 13;
                return ctx.processRequestInterceptors(xmlHttpRequest);

              case 13:
                _context2.prev = 13;
                xmlHttpRequest.send(queryString);
                return _context2.finish(13);

              case 16:
                _context2.next = 27;
                break;

              case 18:
                xmlHttpRequest.open('GET', "".concat(url, "?").concat(queryString), async);
                xmlHttpRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=utf-8");
                xmlHttpRequest.setRequestHeader("x-no-auth", "true"); // Pour des raisons d'optimisation, le header x-no-auth est ajouté à la requête pour désactiver certains contrôles SAS.

                _context2.prev = 21;
                _context2.next = 24;
                return ctx.processRequestInterceptors(xmlHttpRequest);

              case 24:
                _context2.prev = 24;
                xmlHttpRequest.send();
                return _context2.finish(24);

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[10,, 13, 16], [21,, 24, 27]]);
      }));

      function _sendMessage(_x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9) {
        return _sendMessage2.apply(this, arguments);
      }

      return _sendMessage;
    }()
  }]);
  return CommonLog;
}();

CommonLog.prototype.TraceEvent = _TraceEvent["default"];
/**
 * Log Levels
 * @type {{AUDIT: string, NOTICE: string, ERROR: string, INFO: string, DEBUG: string, WARNING: string}}
 */

CommonLog.prototype.NIVEAU = {
  DEBUG: 'debug',
  INFO: 'info',
  NOTICE: 'notice',
  WARNING: 'warning',
  ERROR: 'error',
  AUDIT: 'audit'
};
/**
 *
 * @param pattern
 * @param str
 * @returns {string}
 * @private
 */

function _pad_left(pad, str) {
  str = "".concat(str);
  return pad.substring(0, pad.length - str.length) + str;
}
/**
 * @typedef {object} CommonLog
 * @class
 */


var _default = CommonLog;
exports["default"] = _default;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(93);


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next mehtod, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),
/* 94 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 95 */
/***/ (function(module, exports) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(97);
__webpack_require__(101);
__webpack_require__(118);
__webpack_require__(122);
__webpack_require__(133);
__webpack_require__(134);
var path = __webpack_require__(59);

module.exports = path.Promise;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(31);
var redefine = __webpack_require__(12);
var toString = __webpack_require__(100);

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__(56);

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var inspectSource = __webpack_require__(36);

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(31);
var classof = __webpack_require__(57);

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(102).charAt;
var InternalStateModule = __webpack_require__(21);
var defineIterator = __webpack_require__(58);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(39);
var requireObjectCoercible = __webpack_require__(40);

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(7);
var classof = __webpack_require__(17);

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(5);
var ownKeys = __webpack_require__(106);
var getOwnPropertyDescriptorModule = __webpack_require__(41);
var definePropertyModule = __webpack_require__(11);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(13);
var getOwnPropertyNamesModule = __webpack_require__(107);
var getOwnPropertySymbolsModule = __webpack_require__(110);
var anObject = __webpack_require__(4);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(60);
var enumBugKeys = __webpack_require__(42);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(23);
var toLength = __webpack_require__(61);
var toAbsoluteIndex = __webpack_require__(109);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(39);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 110 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(63).IteratorPrototype;
var create = __webpack_require__(65);
var createPropertyDescriptor = __webpack_require__(35);
var setToStringTag = __webpack_require__(43);
var Iterators = __webpack_require__(18);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(40);

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(7);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(10);
var definePropertyModule = __webpack_require__(11);
var anObject = __webpack_require__(4);
var objectKeys = __webpack_require__(115);

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(60);
var enumBugKeys = __webpack_require__(42);

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var aPossiblePrototype = __webpack_require__(117);

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var DOMIterables = __webpack_require__(119);
var ArrayIteratorMethods = __webpack_require__(120);
var createNonEnumerableProperty = __webpack_require__(8);
var wellKnownSymbol = __webpack_require__(2);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),
/* 119 */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(23);
var addToUnscopables = __webpack_require__(121);
var Iterators = __webpack_require__(18);
var InternalStateModule = __webpack_require__(21);
var defineIterator = __webpack_require__(58);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(2);
var create = __webpack_require__(65);
var definePropertyModule = __webpack_require__(11);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(22);
var IS_PURE = __webpack_require__(16);
var global = __webpack_require__(1);
var getBuiltIn = __webpack_require__(13);
var NativePromise = __webpack_require__(67);
var redefine = __webpack_require__(12);
var redefineAll = __webpack_require__(123);
var setToStringTag = __webpack_require__(43);
var setSpecies = __webpack_require__(124);
var isObject = __webpack_require__(9);
var aFunction = __webpack_require__(19);
var anInstance = __webpack_require__(125);
var classof = __webpack_require__(17);
var inspectSource = __webpack_require__(36);
var iterate = __webpack_require__(68);
var checkCorrectnessOfIteration = __webpack_require__(129);
var speciesConstructor = __webpack_require__(70);
var task = __webpack_require__(71).set;
var microtask = __webpack_require__(130);
var promiseResolve = __webpack_require__(74);
var hostReportErrors = __webpack_require__(131);
var newPromiseCapabilityModule = __webpack_require__(44);
var perform = __webpack_require__(75);
var InternalStateModule = __webpack_require__(21);
var isForced = __webpack_require__(62);
var wellKnownSymbol = __webpack_require__(2);
var V8_VERSION = __webpack_require__(132);

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var PromiseConstructor = NativePromise;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var IS_NODE = classof(process) == 'process';
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (V8_VERSION === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE && typeof PromiseRejectionEvent != 'function') return true;
  }
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromiseConstructor.prototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(promise, state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (handler = global['on' + name]) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (promise, state) {
  task.call(global, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (promise, state) {
  task.call(global, function () {
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(promise, state, true);
};

var internalResolve = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, promise, wrapper, state),
            bind(internalReject, promise, wrapper, state)
          );
        } catch (error) {
          internalReject(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(promise, state, false);
    }
  } catch (error) {
    internalReject(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
    } catch (error) {
      internalReject(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, promise, state);
    this.reject = bind(internalReject, promise, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && typeof NativePromise == 'function') {
    nativeThen = NativePromise.prototype.then;

    // wrap native Promise#then for native async functions
    redefine(NativePromise.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected);
    // https://github.com/zloirock/core-js/issues/640
    }, { unsafe: true });

    // wrap fetch result
    if (typeof $fetch == 'function') $({ global: true, enumerable: true, forced: true }, {
      // eslint-disable-next-line no-unused-vars
      fetch: function fetch(input /* , init */) {
        return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
      }
    });
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(12);

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(13);
var definePropertyModule = __webpack_require__(11);
var wellKnownSymbol = __webpack_require__(2);
var DESCRIPTORS = __webpack_require__(10);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(2);
var Iterators = __webpack_require__(18);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(57);
var Iterators = __webpack_require__(18);
var wellKnownSymbol = __webpack_require__(2);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(2);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var getOwnPropertyDescriptor = __webpack_require__(41).f;
var classof = __webpack_require__(17);
var macrotask = __webpack_require__(71).set;
var IS_IOS = __webpack_require__(72);

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var IS_NODE = classof(process) == 'process';
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver && !IS_IOS) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(1);
var userAgent = __webpack_require__(73);

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(22);
var aFunction = __webpack_require__(19);
var newPromiseCapabilityModule = __webpack_require__(44);
var perform = __webpack_require__(75);
var iterate = __webpack_require__(68);

// `Promise.allSettled` method
// https://github.com/tc39/proposal-promise-allSettled
$({ target: 'Promise', stat: true }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (e) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: e };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(22);
var IS_PURE = __webpack_require__(16);
var NativePromise = __webpack_require__(67);
var fails = __webpack_require__(7);
var getBuiltIn = __webpack_require__(13);
var speciesConstructor = __webpack_require__(70);
var promiseResolve = __webpack_require__(74);
var redefine = __webpack_require__(12);

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromise && fails(function () {
  NativePromise.prototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.github.io/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = typeof onFinally == 'function';
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// patch native Promise.prototype for native async functions
if (!IS_PURE && typeof NativePromise == 'function' && !NativePromise.prototype['finally']) {
  redefine(NativePromise.prototype, 'finally', getBuiltIn('Promise').prototype['finally']);
}


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(28);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(29));

var _createClass2 = _interopRequireDefault(__webpack_require__(30));

var TraceEvent = /*#__PURE__*/function () {
  function TraceEvent(message) {
    (0, _classCallCheck2["default"])(this, TraceEvent);

    if (message) {
      this.setMessage(message);
    }
  }

  (0, _createClass2["default"])(TraceEvent, [{
    key: "setMessage",
    value: function setMessage(message) {
      this._message = this._checkAndFormatString("message", message, this.MESSAGE_MAX_LENGTH);
    }
  }, {
    key: "getMessage",
    value: function getMessage() {
      return this._message;
    }
  }, {
    key: "_logInvalidValue",
    value: function _logInvalidValue(expectedType, key, value) {
      console.warn("TraceEvent : la valeur ".concat(value, " du param\xE8tre ").concat(key, " est incorrecte/vide (type attendu : ").concat(expectedType, ")"));
    }
  }, {
    key: "_checkAndFormatString",
    value: function _checkAndFormatString(key, stringValue, maxLength) {
      if (typeof stringValue === "string" && stringValue.length > 0) {
        if (stringValue.length > maxLength) {
          console.warn("TraceEvent : la longueur du param\xE8tre ".concat(key, " est sup\xE9rieure \xE0 ").concat(maxLength, " caract\xE8res => tronqu\xE9e"));
          return stringValue.substring(0, maxLength);
        }

        return stringValue;
      } else {
        this._logInvalidValue("string", key, stringValue);

        return null;
      }
    }
  }, {
    key: "_addMetaData",
    value: function _addMetaData(type, key, value) {
      if (key) {
        this._metaDonnees = this._metaDonnees || {};
        this._metaDonnees[key] = {
          "type": type,
          "value": value
        };
      } else {
        console.warn("TraceEvent : le nom du param\xE8tre ".concat(key, " est incorrect/vide"));
      }

      return this;
    }
  }, {
    key: "addDate",
    value: function addDate(key, dateValue) {
      var convertDateToString = function convertDateToString(date) {
        var month = (date.getMonth() + 1 <= 9 ? "0" : "") + (date.getMonth() + 1);
        var day = (date.getDate() <= 9 ? "0" : "") + date.getDate();
        return "".concat(day, "/").concat(month, "/").concat(date.getFullYear());
      };

      if (dateValue instanceof Date) {
        dateValue = convertDateToString(dateValue);

        this._addMetaData(this._METADONNEES_TYPES.DATE, key, dateValue);
      } else {
        this._logInvalidValue("Date", key, dateValue);
      }

      return this;
    }
  }, {
    key: "addBoolean",
    value: function addBoolean(key, booleanValue) {
      if (typeof booleanValue === "boolean") {
        this._addMetaData(this._METADONNEES_TYPES.BOOLEAN, key, booleanValue);
      } else {
        this._logInvalidValue("boolean", key, booleanValue);
      }

      return this;
    }
  }, {
    key: "addString",
    value: function addString(key, stringValue) {
      stringValue = this._checkAndFormatString(key, stringValue, this.STRING_MAX_LENGTH);

      if (stringValue) {
        this._addMetaData(this._METADONNEES_TYPES.STRING, key, stringValue);
      }

      return this;
    }
  }, {
    key: "addFloat",
    value: function addFloat(key, floatValue) {
      if (typeof floatValue === "number" && !isNaN(floatValue) && floatValue !== Infinity) {
        var floatAsString = "".concat(floatValue); // Si écriture exposant ou longueur trop longue : on convertit

        if (floatAsString.includes("e") || floatAsString.length > this.FLOAT_MAX_LENGTH) {
          var roundedValue = Math.round(floatValue);

          if (roundedValue > Math.pow(10, this.FLOAT_MAX_LENGTH) - 1 || roundedValue < -Math.pow(10, this.FLOAT_MAX_LENGTH - 1)) {
            // Si valeur entière en écriture non exponentielle est supérieure à taille max => impossible de tronquer (ex: supérieur à 999999999999999 ou inférieur à -99999999999999 si la taille max FLOAT_MAX_LENGTH est 15)
            console.warn("TraceEvent : la longueur du param\xE8tre ".concat(key, " convertie en string est sup\xE9rieure \xE0 ").concat(this.FLOAT_MAX_LENGTH, " caract\xE8res (").concat(floatAsString, ") et ne peut pas \xEAtre tronqu\xE9e => ignor\xE9e"));
            return this;
          } else {
            // On réduit la précision au nombre de chiffres significatifs disponibles :
            // - taille max -2 pour le "-." si floatValue < -1
            // - taille max -3 pour le "-0." si -1 < floatValue < 0
            // - taille max -2 pour le "0." si 0 < floatValue < 1
            // - taille max -1 pour le "." si floatValue > 1
            var precision;

            if (floatValue < -1) {
              precision = this.FLOAT_MAX_LENGTH - 2;
            } else if (floatValue < 0) {
              precision = this.FLOAT_MAX_LENGTH - 3;
            } else if (floatValue < 1) {
              precision = this.FLOAT_MAX_LENGTH - 2;
            } else {
              precision = this.FLOAT_MAX_LENGTH - 1;
            }

            floatValue = Number(floatValue.toPrecision(precision)); // On convertit en chaîne de caractères avec écriture non exponentielle

            var convertedFloatAsString = floatValue.toFixed(this.FLOAT_MAX_LENGTH); // On tronque la chaîne obtenue à la taille max

            convertedFloatAsString = convertedFloatAsString.substring(0, this.FLOAT_MAX_LENGTH); // On logue si la chaîne de caractères obtenue est différente de l'initiale

            if (convertedFloatAsString !== floatAsString) {
              console.warn("TraceEvent : la valeur du param\xE8tre ".concat(key, " convertie en string est sup\xE9rieure \xE0 la taille max ").concat(this.FLOAT_MAX_LENGTH, " (").concat(floatAsString, ") => arrondi en ").concat(convertedFloatAsString));
              floatAsString = convertedFloatAsString;
            }
          }
        }

        this._addMetaData(this._METADONNEES_TYPES.FLOAT, key, floatAsString);
      } else {
        this._logInvalidValue("number (Float)", key, floatValue);
      }

      return this;
    }
  }, {
    key: "addDouble",
    value: function addDouble(key, doubleValue) {
      if (typeof doubleValue === "number" && doubleValue % 1 === 0) {
        if (doubleValue > Math.pow(10, this.FLOAT_MAX_LENGTH) - 1 || doubleValue < -Math.pow(10, this.FLOAT_MAX_LENGTH - 1)) {
          // Si valeur entière en écriture non exponentielle est supérieure à taille max => impossible de tronquer (ex: supérieur à 999999999999999 ou inférieur à -99999999999999 si la taille max FLOAT_MAX_LENGTH est 15)
          console.warn("TraceEvent : la longueur du param\xE8tre ".concat(key, " convertie en string est sup\xE9rieure \xE0 ").concat(this.DOUBLE_MAX_LENGTH, " caract\xE8res (").concat(doubleValue, ") et ne peut pas \xEAtre tronqu\xE9e => ignor\xE9e"));
          return this;
        }

        this._addMetaData(this._METADONNEES_TYPES.DOUBLE, key, doubleValue.toFixed());
      } else {
        this._logInvalidValue("number (Double)", key, doubleValue);
      }

      return this;
    }
  }, {
    key: "getAllMetaDataAsString",
    value: function getAllMetaDataAsString() {
      var str = [];

      for (var key in this._metaDonnees) {
        if (this._metaDonnees.hasOwnProperty(key)) {
          var metaDonnee = this._metaDonnees[key];
          str.push("[".concat(key, "=").concat(metaDonnee.value, "]"));
        }
      }

      return str.join(",");
    }
  }, {
    key: "getAllMetaDataAsRequestParametersString",
    value: function getAllMetaDataAsRequestParametersString() {
      var str = [];
      var paramValue;
      var paramName;

      for (var key in this._metaDonnees) {
        if (this._metaDonnees.hasOwnProperty(key)) {
          var metaDonnee = this._metaDonnees[key];
          paramName = metaDonnee.type.prefix + key;

          if (metaDonnee.type === this._METADONNEES_TYPES.BOOLEAN) {
            paramValue = metaDonnee.value ? 1 : 0;
          } else {
            paramValue = metaDonnee.value;
          }

          str.push("".concat(encodeURIComponent(paramName), "=").concat(encodeURIComponent(paramValue)));
        }
      }

      return str.join("&");
    }
  }]);
  return TraceEvent;
}();

TraceEvent.prototype._message = null;
TraceEvent.prototype._metaDonnees = null;
TraceEvent.prototype._METADONNEES_TYPES = {
  DATE: {
    prefix: "dt10_md_"
  },
  BOOLEAN: {
    prefix: "n10_b_md_"
  },
  STRING: {
    prefix: "f2000_md_"
  },
  DOUBLE: {
    prefix: "n15_md_"
  },
  FLOAT: {
    prefix: "n15_md_"
  }
};
TraceEvent.prototype.MESSAGE_MAX_LENGTH = 200;
TraceEvent.prototype.STRING_MAX_LENGTH = 2000;
TraceEvent.prototype.DOUBLE_MAX_LENGTH = 15;
TraceEvent.prototype.FLOAT_MAX_LENGTH = 15;
var _default = TraceEvent;
exports["default"] = _default;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(28);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(29));

var _createClass2 = _interopRequireDefault(__webpack_require__(30));

var w = typeof window !== 'undefined' ? window : {};
var ONE_MINUTE = 60 * 1000;
var SESSION_STORAGE_KEY = 'commonLog';

var RequestCounter = /*#__PURE__*/function () {
  function RequestCounter(_ref) {
    var nbMaxRequestPerPeriod = _ref.nbMaxRequestPerPeriod,
        periodDurationInMs = _ref.periodDurationInMs;
    (0, _classCallCheck2["default"])(this, RequestCounter);
    this.nbMaxRequestPerPeriod = nbMaxRequestPerPeriod;
    this.periodDurationInMs = periodDurationInMs || ONE_MINUTE;
  }

  (0, _createClass2["default"])(RequestCounter, [{
    key: "isMaxRequestsThresholdReached",
    value: function isMaxRequestsThresholdReached() {
      var requestsCount = this.getUnexpiredRequestCount();
      return requestsCount >= this.nbMaxRequestPerPeriod;
    }
  }, {
    key: "incrementRequestCount",
    value: function incrementRequestCount() {
      var commonLogRequestCount = this._getSessionStorageData();

      var contextCommonLogRequestCount = commonLogRequestCount;

      if (!contextCommonLogRequestCount) {
        // Create it if it does not exist.
        contextCommonLogRequestCount = commonLogRequestCount = {};
      } // If we divide it by 1000 we will have a double instead of integer, which is why we used toFixed


      var currentSecond = (new Date().getTime() / 1000).toFixed();

      for (var prop in contextCommonLogRequestCount) {
        if (!contextCommonLogRequestCount.hasOwnProperty(prop)) break; // We should use 'prop' that contains the timestamp not its value

        if (isNaN(prop) || Math.abs(new Date().getTime() - prop * 1000) > this.periodDurationInMs) {
          try {
            delete contextCommonLogRequestCount[prop];
          } catch (e) {
            contextCommonLogRequestCount[prop] = undefined;
          }
        }
      }

      contextCommonLogRequestCount[currentSecond] = (contextCommonLogRequestCount[currentSecond] || 0) + 1;

      this._updateSessionStorageData(commonLogRequestCount);
    }
  }, {
    key: "getUnexpiredRequestCount",
    value: function getUnexpiredRequestCount() {
      var requestCounter = 0;

      var commonLogRequestCount = this._getSessionStorageData();

      var contextCommonLogRequestCount = commonLogRequestCount;

      for (var prop in contextCommonLogRequestCount) {
        if (!contextCommonLogRequestCount.hasOwnProperty(prop)) break;
        if (!contextCommonLogRequestCount[prop]) break;
        if (isNaN(prop)) break; // We should use 'prop' that contains the timestamp not its value

        if (new Date().getTime() - prop * 1000 > this.periodDurationInMs) break;
        requestCounter += isNaN(contextCommonLogRequestCount[prop]) ? 0 : contextCommonLogRequestCount[prop] * 1;
      }

      return requestCounter;
    } // L'utilisation du sessionStorage est normalement prohibée (https://dev.to/rdegges/please-stop-using-local-storage-1i04).
    // Ici, on est obligé d'utiliser le session storage pour éviter les appels aux backend.
    // Plus de détails : https://sgithub.fr.world.socgen/SocleDigitalClient/sg_npm_dgt_awt-common-log/pull/7
    // La règle sonar (javascript:S3271) est désactivée sur ce fichier (cf. sonar-project.properties)

  }, {
    key: "_getSessionStorageData",
    value: function _getSessionStorageData() {
      if (w.sessionStorage) {
        try {
          var sessionStorageData = w.sessionStorage.getItem(SESSION_STORAGE_KEY);
          return sessionStorageData ? JSON.parse(sessionStorageData) : {};
        } catch (e) {}
      }

      return {};
    }
  }, {
    key: "_updateSessionStorageData",
    value: function _updateSessionStorageData(data) {
      if (w.sessionStorage) {
        try {
          w.sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(data));
        } catch (e) {}
      }
    }
  }]);
  return RequestCounter;
}();

var _default = RequestCounter;
exports["default"] = _default;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

!function(n,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports["ngim-breakpoint-api"]=e():n["ngim-breakpoint-api"]=e()}("undefined"!=typeof self?self:this,function(){return function(n){function e(i){if(t[i])return t[i].exports;var a=t[i]={i:i,l:!1,exports:{}};return n[i].call(a.exports,a,a.exports,e),a.l=!0,a.exports}var t={};return e.m=n,e.c=t,e.d=function(n,t,i){e.o(n,t)||Object.defineProperty(n,t,{configurable:!1,enumerable:!0,get:i})},e.n=function(n){var t=n&&n.__esModule?function(){return n.default}:function(){return n};return e.d(t,"a",t),t},e.o=function(n,e){return Object.prototype.hasOwnProperty.call(n,e)},e.p="",e(e.s=2)}([/*!************************!*\
  !*** ./lib/pub-sub.js ***!
  \************************/
/*! dynamic exports provided */
/*! all exports used */
function(module,exports,__webpack_require__){"use strict";eval('\n\nObject.defineProperty(exports, "__esModule", {\n  value: true\n});\nvar PubSub = function () {\n  var events = {};\n\n  var subscribe = function subscribe(eventName, callback) {\n    if (!events[eventName]) {\n      events[eventName] = [];\n    }\n\n    events[eventName].push(callback);\n  };\n\n  var once = function once(eventName, args) {\n    if (events[eventName]) {\n      return;\n    }\n\n    subscribe(eventName, args);\n  };\n\n  var unsubscribe = function unsubscribe(eventName, callbackToUnsubscribe) {\n    for (var i = 0; i < events[eventName].length; i++) {\n      if (events[eventName][i] === callbackToUnsubscribe) {\n        events[eventName].splice(i, 1);\n        break;\n      }\n    }\n  };\n\n  var publish = function publish(eventName, args) {\n    return events[eventName] && events[eventName].forEach(function (callback) {\n      return callback(args);\n    });\n  };\n\n  return {\n    subscribe: subscribe,\n    once: once,\n    unsubscribe: unsubscribe,\n    publish: publish\n  };\n}();\n\nexports.default = PubSub;//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMC5qcyIsInNvdXJjZXMiOlsid2VicGFjazovLy9saWIvcHViLXN1Yi5qcz9kZTk5Il0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFB1YlN1YiA9IChmdW5jdGlvbigpIHtcbiAgbGV0IGV2ZW50cyA9IHt9O1xuXG4gIGxldCBzdWJzY3JpYmUgPSBmdW5jdGlvbihldmVudE5hbWUsIGNhbGxiYWNrKSB7XG4gICAgaWYgKCFldmVudHNbZXZlbnROYW1lXSkge1xuICAgICAgZXZlbnRzW2V2ZW50TmFtZV0gPSBbXTtcbiAgICB9XG5cbiAgICBldmVudHNbZXZlbnROYW1lXS5wdXNoKGNhbGxiYWNrKTtcbiAgfTtcblxuICBsZXQgb25jZSA9IGZ1bmN0aW9uKGV2ZW50TmFtZSwgYXJncykge1xuICAgIGlmIChldmVudHNbZXZlbnROYW1lXSkge1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIHN1YnNjcmliZShldmVudE5hbWUsIGFyZ3MpO1xuICB9O1xuXG4gIGxldCB1bnN1YnNjcmliZSA9IGZ1bmN0aW9uKGV2ZW50TmFtZSwgY2FsbGJhY2tUb1Vuc3Vic2NyaWJlKSB7XG4gICAgZm9yICh2YXIgaSA9IDA7IGkgPCBldmVudHNbZXZlbnROYW1lXS5sZW5ndGg7IGkrKykge1xuICAgICAgaWYgKGV2ZW50c1tldmVudE5hbWVdW2ldID09PSBjYWxsYmFja1RvVW5zdWJzY3JpYmUpIHtcbiAgICAgICAgZXZlbnRzW2V2ZW50TmFtZV0uc3BsaWNlKGksIDEpO1xuICAgICAgICBicmVhaztcbiAgICAgIH1cbiAgICB9XG4gIH07XG5cbiAgbGV0IHB1Ymxpc2ggPSBmdW5jdGlvbihldmVudE5hbWUsIGFyZ3MpIHtcbiAgICByZXR1cm4gKFxuICAgICAgZXZlbnRzW2V2ZW50TmFtZV0gJiYgZXZlbnRzW2V2ZW50TmFtZV0uZm9yRWFjaChjYWxsYmFjayA9PiBjYWxsYmFjayhhcmdzKSlcbiAgICApO1xuICB9O1xuXG4gIHJldHVybiB7XG4gICAgc3Vic2NyaWJlLFxuICAgIG9uY2UsXG4gICAgdW5zdWJzY3JpYmUsXG4gICAgcHVibGlzaFxuICB9O1xufSkoKTtcblxuZXhwb3J0IGRlZmF1bHQgUHViU3ViO1xuXG5cblxuLy8gV0VCUEFDSyBGT09URVIgLy9cbi8vIGxpYi9wdWItc3ViLmpzIl0sIm1hcHBpbmdzIjoiOzs7OztBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQUE7QUFFQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUpBO0FBTUE7QUFDQTtBQUNBIiwic291cmNlUm9vdCI6IiJ9\n//# sourceURL=webpack-internal:///0\n')},/*!***********************************************************!*\
  !*** ./src/breakpoint-dispatcher/breakpoint.constants.js ***!
  \***********************************************************/
/*! dynamic exports provided */
/*! all exports used */
function(module,exports,__webpack_require__){"use strict";eval('\n\nObject.defineProperty(exports, "__esModule", {\n  value: true\n});\nvar BREAKPOINT = exports.BREAKPOINT = {\n  NAME: {\n    MOBILE: "mobile",\n    TABLET: "tablet",\n    DESKTOP: "desktop"\n  },\n  WIDTH: {\n    MOBILE: 768,\n    TABLET: 1024\n  }\n};//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5qcyIsInNvdXJjZXMiOlsid2VicGFjazovLy9zcmMvYnJlYWtwb2ludC1kaXNwYXRjaGVyL2JyZWFrcG9pbnQuY29uc3RhbnRzLmpzP2M3MjIiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IEJSRUFLUE9JTlQgPSB7XG4gIE5BTUU6IHtcbiAgICBNT0JJTEU6IFwibW9iaWxlXCIsXG4gICAgVEFCTEVUOiBcInRhYmxldFwiLFxuICAgIERFU0tUT1A6IFwiZGVza3RvcFwiXG4gIH0sXG4gIFdJRFRIOiB7XG4gICAgTU9CSUxFOiA3NjgsXG4gICAgVEFCTEVUOiAxMDI0XG4gIH1cbn07XG5cblxuXG4vLyBXRUJQQUNLIEZPT1RFUiAvL1xuLy8gc3JjL2JyZWFrcG9pbnQtZGlzcGF0Y2hlci9icmVha3BvaW50LmNvbnN0YW50cy5qcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBSEE7QUFLQTtBQUNBO0FBQ0E7QUFGQTtBQU5BIiwic291cmNlUm9vdCI6IiJ9\n//# sourceURL=webpack-internal:///1\n')},/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! dynamic exports provided */
/*! all exports used */
function(module,exports,__webpack_require__){"use strict";eval('\n\nObject.defineProperty(exports, "__esModule", {\n  value: true\n});\nexports.BreakpointAPI = undefined;\n\nvar _pubSub = __webpack_require__(/*! ../lib/pub-sub */ 0);\n\nvar _pubSub2 = _interopRequireDefault(_pubSub);\n\nvar _breakpointDispatcher = __webpack_require__(/*! ./breakpoint-dispatcher/breakpoint-dispatcher */ 3);\n\nvar _breakpointDispatcher2 = _interopRequireDefault(_breakpointDispatcher);\n\nvar _breakpoint = __webpack_require__(/*! ./breakpoint-dispatcher/breakpoint.constants */ 1);\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nvar resizeHandlers = {};\n\nvar BreakpointAPI = exports.BreakpointAPI = function initialize() {\n  _breakpointDispatcher2.default.start();\n\n  [].forEach.call(Object.keys(_breakpoint.BREAKPOINT.NAME), function (name) {\n    var breakPointName = _breakpoint.BREAKPOINT.NAME[name];\n    var eventName = getEventNameFromBreakpoint(breakPointName);\n\n    resizeHandlers[breakPointName] = new Array();\n    _pubSub2.default.subscribe(eventName, function () {\n      return handleResize(breakPointName);\n    });\n  });\n\n  return {\n    getCurrentContext: getCurrentContext,\n    on: on\n  };\n}();\n\nfunction getCurrentContext() {\n  return _breakpointDispatcher2.default.getState();\n}\n\nfunction on(breakPointName, breakpointHandler) {\n  resizeHandlers[breakPointName].push(breakpointHandler);\n}\n\nfunction handleResize(breakPointName) {\n  resizeHandlers[breakPointName].forEach(function (handler) {\n    return handler();\n  });\n}\n\nfunction getEventNameFromBreakpoint(name) {\n  return "resize:" + name;\n}//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMi5qcyIsInNvdXJjZXMiOlsid2VicGFjazovLy9zcmMvaW5kZXguanM/MWZkZiJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUHViU3ViIGZyb20gJy4uL2xpYi9wdWItc3ViJztcbmltcG9ydCBCcmVha1BvaW50IGZyb20gXCIuL2JyZWFrcG9pbnQtZGlzcGF0Y2hlci9icmVha3BvaW50LWRpc3BhdGNoZXJcIjtcbmltcG9ydCB7IEJSRUFLUE9JTlQgfSBmcm9tIFwiLi9icmVha3BvaW50LWRpc3BhdGNoZXIvYnJlYWtwb2ludC5jb25zdGFudHNcIjtcblxudmFyIHJlc2l6ZUhhbmRsZXJzID0ge307XG5cbmV4cG9ydCBjb25zdCBCcmVha3BvaW50QVBJID0gKGZ1bmN0aW9uIGluaXRpYWxpemUoKSB7XG4gIEJyZWFrUG9pbnQuc3RhcnQoKTtcblxuICBbXS5mb3JFYWNoLmNhbGwoT2JqZWN0LmtleXMoQlJFQUtQT0lOVC5OQU1FKSwgbmFtZSA9PiB7XG4gICAgbGV0IGJyZWFrUG9pbnROYW1lID0gQlJFQUtQT0lOVC5OQU1FW25hbWVdO1xuICAgIGxldCBldmVudE5hbWUgPSBnZXRFdmVudE5hbWVGcm9tQnJlYWtwb2ludChicmVha1BvaW50TmFtZSk7XG5cbiAgICByZXNpemVIYW5kbGVyc1ticmVha1BvaW50TmFtZV0gPSBuZXcgQXJyYXkoKTtcbiAgICBQdWJTdWIuc3Vic2NyaWJlKGV2ZW50TmFtZSwgKCkgPT4gaGFuZGxlUmVzaXplKGJyZWFrUG9pbnROYW1lKSk7XG4gIH0pO1xuXG4gIHJldHVybiB7XG4gICAgZ2V0Q3VycmVudENvbnRleHQsXG4gICAgb25cbiAgfTtcbn0pKCk7XG5cbmZ1bmN0aW9uIGdldEN1cnJlbnRDb250ZXh0KCkge1xuICByZXR1cm4gQnJlYWtQb2ludC5nZXRTdGF0ZSgpO1xufVxuXG5mdW5jdGlvbiBvbihicmVha1BvaW50TmFtZSwgYnJlYWtwb2ludEhhbmRsZXIpIHtcbiAgcmVzaXplSGFuZGxlcnNbYnJlYWtQb2ludE5hbWVdLnB1c2goYnJlYWtwb2ludEhhbmRsZXIpO1xufVxuXG5mdW5jdGlvbiBoYW5kbGVSZXNpemUoYnJlYWtQb2ludE5hbWUpIHtcbiAgcmVzaXplSGFuZGxlcnNbYnJlYWtQb2ludE5hbWVdLmZvckVhY2goaGFuZGxlciA9PiBoYW5kbGVyKCkpO1xufVxuXG5mdW5jdGlvbiBnZXRFdmVudE5hbWVGcm9tQnJlYWtwb2ludChuYW1lKSB7XG4gIHJldHVybiBgcmVzaXplOiR7bmFtZX1gO1xufVxuXG5cbi8vIFdFQlBBQ0sgRk9PVEVSIC8vXG4vLyBzcmMvaW5kZXguanMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTtBQUNBOzs7QUFBQTtBQUNBOzs7QUFBQTtBQUNBOzs7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQUE7QUFBQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFGQTtBQUlBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUFBO0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwic291cmNlUm9vdCI6IiJ9\n//# sourceURL=webpack-internal:///2\n')},/*!************************************************************!*\
  !*** ./src/breakpoint-dispatcher/breakpoint-dispatcher.js ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
function(module,exports,__webpack_require__){"use strict";eval('\n\nObject.defineProperty(exports, "__esModule", {\n  value: true\n});\n\nvar _pubSub = __webpack_require__(/*! ../../lib/pub-sub */ 0);\n\nvar _pubSub2 = _interopRequireDefault(_pubSub);\n\nvar _breakpoint = __webpack_require__(/*! ./breakpoint.constants */ 1);\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nvar BreakpointDispatcher = {\n  start: start,\n  getState: getState,\n  breakpoint: _breakpoint.BREAKPOINT.NAME\n};\n\nvar BreakpointHandler = {\n  mobile: { handleChange: handleMobileContext },\n  tablet: { handleChange: handleTabletContext },\n  desktop: { handleChange: handleDesktopContext }\n};\n\nvar state = null;\nvar isStarted = false;\n\nfunction start() {\n  if (isStarted) {\n    return;\n  }\n  isStarted = true;\n\n  setCurrentState();\n  window.addEventListener("resize", handleResize);\n}\n\nfunction handleContext(context) {\n  BreakpointHandler[context].handleChange();\n}\n\nfunction setCurrentState() {\n  if (getViewportWidth() <= _breakpoint.BREAKPOINT.WIDTH.MOBILE) {\n    state = _breakpoint.BREAKPOINT.NAME.MOBILE;\n  } else if (getViewportWidth() <= _breakpoint.BREAKPOINT.WIDTH.TABLET) {\n    state = _breakpoint.BREAKPOINT.NAME.TABLET;\n  } else if (getViewportWidth() > _breakpoint.BREAKPOINT.WIDTH.TABLET) {\n    state = _breakpoint.BREAKPOINT.NAME.DESKTOP;\n  }\n}\n\nfunction getViewportWidth() {\n  return window.innerWidth;\n}\n\nfunction handleMobileContext() {\n  if (getViewportWidth() > _breakpoint.BREAKPOINT.WIDTH.MOBILE) {\n    state = _breakpoint.BREAKPOINT.NAME.TABLET;\n    _pubSub2.default.publish("resize:tablet");\n  }\n}\n\nfunction handleTabletContext() {\n  var winSize = getViewportWidth();\n\n  if (winSize > _breakpoint.BREAKPOINT.WIDTH.TABLET) {\n    state = _breakpoint.BREAKPOINT.NAME.DESKTOP;\n    _pubSub2.default.publish("resize:desktop");\n  } else if (winSize <= _breakpoint.BREAKPOINT.WIDTH.MOBILE) {\n    state = _breakpoint.BREAKPOINT.NAME.MOBILE;\n    _pubSub2.default.publish("resize:mobile");\n  }\n}\n\nfunction handleDesktopContext() {\n  if (getViewportWidth() <= _breakpoint.BREAKPOINT.WIDTH.TABLET) {\n    state = _breakpoint.BREAKPOINT.NAME.TABLET;\n    _pubSub2.default.publish("resize:tablet");\n  }\n}\n\nfunction handleResize() {\n  handleContext(state);\n\n  _pubSub2.default.publish("resize");\n}\n\nfunction getState() {\n  return state;\n}\n\nexports.default = BreakpointDispatcher;//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMy5qcyIsInNvdXJjZXMiOlsid2VicGFjazovLy9zcmMvYnJlYWtwb2ludC1kaXNwYXRjaGVyL2JyZWFrcG9pbnQtZGlzcGF0Y2hlci5qcz82MzJlIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQdWJTdWIgZnJvbSBcIi4uLy4uL2xpYi9wdWItc3ViXCI7XG5pbXBvcnQgeyBCUkVBS1BPSU5UIH0gZnJvbSBcIi4vYnJlYWtwb2ludC5jb25zdGFudHNcIjtcblxuY29uc3QgQnJlYWtwb2ludERpc3BhdGNoZXIgPSB7XG4gIHN0YXJ0LFxuICBnZXRTdGF0ZSxcbiAgYnJlYWtwb2ludDogQlJFQUtQT0lOVC5OQU1FXG59O1xuXG5jb25zdCBCcmVha3BvaW50SGFuZGxlciA9IHtcbiAgbW9iaWxlOiB7IGhhbmRsZUNoYW5nZTogaGFuZGxlTW9iaWxlQ29udGV4dCB9LFxuICB0YWJsZXQ6IHsgaGFuZGxlQ2hhbmdlOiBoYW5kbGVUYWJsZXRDb250ZXh0IH0sXG4gIGRlc2t0b3A6IHsgaGFuZGxlQ2hhbmdlOiBoYW5kbGVEZXNrdG9wQ29udGV4dCB9XG59O1xuXG52YXIgc3RhdGUgPSBudWxsO1xudmFyIGlzU3RhcnRlZCA9IGZhbHNlO1xuXG5mdW5jdGlvbiBzdGFydCgpIHtcbiAgaWYgKGlzU3RhcnRlZCkge1xuICAgIHJldHVybjtcbiAgfVxuICBpc1N0YXJ0ZWQgPSB0cnVlO1xuXG4gIHNldEN1cnJlbnRTdGF0ZSgpO1xuICB3aW5kb3cuYWRkRXZlbnRMaXN0ZW5lcihcInJlc2l6ZVwiLCBoYW5kbGVSZXNpemUpO1xufVxuXG5mdW5jdGlvbiBoYW5kbGVDb250ZXh0KGNvbnRleHQpIHtcbiAgQnJlYWtwb2ludEhhbmRsZXJbY29udGV4dF0uaGFuZGxlQ2hhbmdlKCk7XG59XG5cbmZ1bmN0aW9uIHNldEN1cnJlbnRTdGF0ZSgpIHtcbiAgaWYgKGdldFZpZXdwb3J0V2lkdGgoKSA8PSBCUkVBS1BPSU5ULldJRFRILk1PQklMRSkge1xuICAgIHN0YXRlID0gQlJFQUtQT0lOVC5OQU1FLk1PQklMRTtcbiAgfSBlbHNlIGlmIChnZXRWaWV3cG9ydFdpZHRoKCkgPD0gQlJFQUtQT0lOVC5XSURUSC5UQUJMRVQpIHtcbiAgICBzdGF0ZSA9IEJSRUFLUE9JTlQuTkFNRS5UQUJMRVQ7XG4gIH0gZWxzZSBpZiAoZ2V0Vmlld3BvcnRXaWR0aCgpID4gQlJFQUtQT0lOVC5XSURUSC5UQUJMRVQpIHtcbiAgICBzdGF0ZSA9IEJSRUFLUE9JTlQuTkFNRS5ERVNLVE9QO1xuICB9XG59XG5cbmZ1bmN0aW9uIGdldFZpZXdwb3J0V2lkdGgoKSB7XG4gIHJldHVybiB3aW5kb3cuaW5uZXJXaWR0aDtcbn1cblxuZnVuY3Rpb24gaGFuZGxlTW9iaWxlQ29udGV4dCgpIHtcbiAgaWYgKGdldFZpZXdwb3J0V2lkdGgoKSA+IEJSRUFLUE9JTlQuV0lEVEguTU9CSUxFKSB7XG4gICAgc3RhdGUgPSBCUkVBS1BPSU5ULk5BTUUuVEFCTEVUO1xuICAgIFB1YlN1Yi5wdWJsaXNoKFwicmVzaXplOnRhYmxldFwiKTtcbiAgfVxufVxuXG5mdW5jdGlvbiBoYW5kbGVUYWJsZXRDb250ZXh0KCkge1xuICBsZXQgd2luU2l6ZSA9IGdldFZpZXdwb3J0V2lkdGgoKTtcblxuICBpZiAod2luU2l6ZSA+IEJSRUFLUE9JTlQuV0lEVEguVEFCTEVUKSB7XG4gICAgc3RhdGUgPSBCUkVBS1BPSU5ULk5BTUUuREVTS1RPUDtcbiAgICBQdWJTdWIucHVibGlzaChcInJlc2l6ZTpkZXNrdG9wXCIpO1xuICB9IGVsc2UgaWYgKHdpblNpemUgPD0gQlJFQUtQT0lOVC5XSURUSC5NT0JJTEUpIHtcbiAgICBzdGF0ZSA9IEJSRUFLUE9JTlQuTkFNRS5NT0JJTEU7XG4gICAgUHViU3ViLnB1Ymxpc2goXCJyZXNpemU6bW9iaWxlXCIpO1xuICB9XG59XG5cbmZ1bmN0aW9uIGhhbmRsZURlc2t0b3BDb250ZXh0KCkge1xuICBpZiAoZ2V0Vmlld3BvcnRXaWR0aCgpIDw9IEJSRUFLUE9JTlQuV0lEVEguVEFCTEVUKSB7XG4gICAgc3RhdGUgPSBCUkVBS1BPSU5ULk5BTUUuVEFCTEVUO1xuICAgIFB1YlN1Yi5wdWJsaXNoKFwicmVzaXplOnRhYmxldFwiKTtcbiAgfVxufVxuXG5mdW5jdGlvbiBoYW5kbGVSZXNpemUoKSB7XG4gIGhhbmRsZUNvbnRleHQoc3RhdGUpO1xuXG4gIFB1YlN1Yi5wdWJsaXNoKFwicmVzaXplXCIpO1xufVxuXG5mdW5jdGlvbiBnZXRTdGF0ZSgpIHtcbiAgcmV0dXJuIHN0YXRlO1xufVxuXG5leHBvcnQgZGVmYXVsdCBCcmVha3BvaW50RGlzcGF0Y2hlcjtcblxuXG5cbi8vIFdFQlBBQ0sgRk9PVEVSIC8vXG4vLyBzcmMvYnJlYWtwb2ludC1kaXNwYXRjaGVyL2JyZWFrcG9pbnQtZGlzcGF0Y2hlci5qcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7QUFDQTs7O0FBQUE7QUFDQTs7O0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFIQTtBQUNBO0FBS0E7QUFDQTtBQUNBO0FBQ0E7QUFIQTtBQUNBO0FBS0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsInNvdXJjZVJvb3QiOiIifQ==\n//# sourceURL=webpack-internal:///3\n')}])});

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

!function(n,I){ true?module.exports=I():"function"==typeof define&&define.amd?define([],I):"object"==typeof exports?exports["ngim-fab-api"]=I():n["ngim-fab-api"]=I()}("undefined"!=typeof self?self:this,function(){return function(n){function I(t){if(g[t])return g[t].exports;var e=g[t]={i:t,l:!1,exports:{}};return n[t].call(e.exports,e,e.exports,I),e.l=!0,e.exports}var g={};return I.m=n,I.c=g,I.d=function(n,g,t){I.o(n,g)||Object.defineProperty(n,g,{configurable:!1,enumerable:!0,get:t})},I.n=function(n){var g=n&&n.__esModule?function(){return n.default}:function(){return n};return I.d(g,"a",g),g},I.o=function(n,I){return Object.prototype.hasOwnProperty.call(n,I)},I.p="",I(I.s=0)}([/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! dynamic exports provided */
/*! all exports used */
function(module,exports,__webpack_require__){"use strict";eval("\n\nObject.defineProperty(exports, \"__esModule\", {\n  value: true\n});\nexports.FabAPI = exports.API_NAME = undefined;\n\nvar _config = __webpack_require__(/*! ./config */ 1);\n\nvar _safeAreaInsets = __webpack_require__(/*! safe-area-insets */ 2);\n\nvar _safeAreaInsets2 = _interopRequireDefault(_safeAreaInsets);\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nvar CMS_GLOBAL_NAMESPACE = 'cmsGlobals';\n\nvar fabList = null;\nvar isConfigLoaded = false;\nvar configLoadStatus;\n\nvar API_NAME = exports.API_NAME = _config.FAB.API_NAME;\n\nvar FabAPI = exports.FabAPI = {\n  register: handleRegistration,\n  unregister: handleUnregistration\n};\n\nfunction handleRegistration(data, success, error) {\n  try {\n    loadConfig();\n    checkRegistrationParams(data);\n    registerFab(data);\n    applyFabPositions();\n  } catch (errorMessage) {\n    return error && error(errorMessage);\n  }\n\n  return success && success(_config.FAB.SUCCESS.REGISTER);\n}\n\nfunction loadConfig() {\n  if (isConfigLoaded) return;\n\n  if (!isFabConfigDefined()) {\n    throw new Error(_config.FAB.ERROR.UNABLE_LOAD_CONFIG);\n  }\n\n  fabList = buildFabListFrom(getFabOrderList());\n  isConfigLoaded = true;\n}\n\nfunction checkRegistrationParams(data) {\n  if (!data || !data['name'] || data['name'] === \"\" || !data['domId']) {\n    throw new Error(_config.FAB.ERROR.MISSED_PARAMS);\n  }\n}\n\nfunction checkUnregistrationParams(data, error) {\n  if (!data['name'] || data['name'] === \"\") {\n    throw new Error(_config.FAB.ERROR.UNDEFINED_PARAM_NAME);\n  }\n}\n\nfunction handleUnregistration(data, success, error) {\n  var element = void 0;\n\n  try {\n    checkRegistrationParams(data);\n  } catch (errorMessage) {\n    error(errorMessage);\n  }\n\n  if (element = unregisterFab(data.name)) {\n    hideElement(element);\n  } else {\n    return error && error(_config.FAB.ERROR.UNABLE_UNREGISTER);\n  }\n\n  try {\n    applyFabPositions();\n  } catch (errorMessage) {\n    error(errorMessage);\n  }\n\n  return success && success(_config.FAB.SUCCESS.UNREGISTER);\n}\n\nfunction registerFab(data) {\n  var fabObj = getFabConfByName(data.name, fabList);\n\n  if (!fabObj || !!fabObj.details) {\n    throw new Error(_config.FAB.ERROR.UNABLE_REGISTER);\n  }\n\n  fabObj.details = data;\n\n  return fabObj.details;\n}\n\nfunction unregisterFab(name) {\n  var fabObj = getFabConfByName(name, fabList);\n  var element = void 0;\n\n  if (!fabObj) {\n    return false;\n  } else if (!fabObj.details) {\n    return false;\n  }\n\n  element = document.getElementById(fabObj.details.domId);\n  fabObj.details = false;\n\n  return element;\n}\n\nfunction applyFabPositions() {\n  var value = true;\n\n  fabList.filter(function (fabObj) {\n    return fabObj.details !== false;\n  }).forEach(function (fabObj, index) {\n    var element = document.getElementById(fabObj.details.domId);\n\n    if (!element) {\n      fabObj.details = false;\n      throw new Error(_config.FAB.ERROR.UNDEFINED_DOM_EL);\n    } else {\n      setElementPosition(element, index);\n      showElement(element);\n    }\n  });\n}\n\nfunction setElementPosition(element, index) {\n  element.style.zIndex = getZPosition();\n  element.style.bottom = getBottomPositionFromIndex(index);\n  element.style.right = getRightPosition();\n}\n\nfunction getZPosition() {\n  return _config.FAB.Z_POS;\n}\n\nfunction getBottomPositionFromIndex(index) {\n  var bottomValue = void 0;\n\n  if (!isSafeAreaSupported()) {\n    bottomValue = _config.FAB.INITIAL_POS;\n  } else {\n    bottomValue = Math.max(getSafeAreaBottom() !== 0 ? _config.FAB.SAFE_AREA_POS : 0, _config.FAB.INITIAL_POS);\n  }\n\n  return bottomValue + index * _config.FAB.SIZE + index * _config.FAB.INBETWEEN_SPACE + 'px';\n}\n\nfunction isSafeAreaSupported() {\n  return _safeAreaInsets2.default.support;\n}\n\nfunction getSafeAreaBottom() {\n  return _safeAreaInsets2.default.bottom;\n}\n\nfunction getRightPosition() {\n  return _config.FAB.RIGHT_POS + 'px';\n}\n\nfunction showElement(element) {\n  element.style.display = 'block';\n}\n\nfunction hideElement(element) {\n  element.style.display = 'none';\n}\n\nfunction isFabConfigDefined() {\n  return !!window[CMS_GLOBAL_NAMESPACE] && !!window[CMS_GLOBAL_NAMESPACE].fabConfig && !!window[CMS_GLOBAL_NAMESPACE].fabConfig.fabOrder;\n}\n\nfunction getFabOrderList() {\n  return window[CMS_GLOBAL_NAMESPACE].fabConfig.fabOrder;\n}\n\nfunction buildFabListFrom(fabConfig) {\n  return fabConfig.map(function (fabObj) {\n    return { name: fabObj.name, details: false };\n  });\n}\n\nfunction getFabConfByName(name, fabList) {\n  for (var i = 0; i < fabList.length; i++) {\n    if (fabList[i].name === name) {\n      return fabList[i];\n    }\n  }\n\n  return null;\n}//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///0\n")},/*!***********************!*\
  !*** ./src/config.js ***!
  \***********************/
/*! dynamic exports provided */
/*! all exports used */
function(module,exports,__webpack_require__){"use strict";eval('\n\nObject.defineProperty(exports, "__esModule", {\n  value: true\n});\nvar FAB = exports.FAB = {\n  API_NAME: \'fab\',\n  CONFIG_KEY_NAME: \'fabOrder\',\n  INITIAL_POS: 15,\n  SAFE_AREA_POS: 49,\n  RIGHT_POS: 15,\n  Z_POS: 500,\n  SIZE: 50,\n  INBETWEEN_SPACE: 16,\n  ERROR: {\n    UNABLE_LOAD_CONFIG: "[error] - echec du chargement de la configuration",\n    UNDEFINED_DOM_EL: "[error] - undefined element",\n    UNABLE_REGISTER: "[error][fab:register] - unable to register",\n    UNABLE_UNREGISTER: "[error][fab:register] - unable to unregister",\n    UNDEFINED_NAME: "[error][fab:register] - Le nom de la pastille n\'est pas référencé pas dans le fichier de configuration.",\n    REGISTERED_NAME: "[error][fab:register] - Ce nom de pastille est déjà enregistré.",\n    UNREGISTERED_NAME: "[error][fab:unregister] - Ce nom de pastille n\'a pas été enregistré.",\n    MISSED_PARAMS: "[error][fabMediator] - vous devez renseigner en paramètre un nom de pastille et l\'id de l\'élément",\n    UNDEFINED_PARAM_NAME: \'[error][fabMediator] - vous devez renseigner en paramètre le nom de la pastille à désinscire.\'\n  },\n  SUCCESS: {\n    REGISTER: "[info] - la pastille a été enregistré avec succès",\n    UNREGISTER: "[info] - la pastille a été désenregistré avec succès"\n  }\n};//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///1\n')},/*!****************************************************!*\
  !*** ./node_modules/safe-area-insets/out/index.js ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
function(module,exports,__webpack_require__){"use strict";eval("\nvar attrs = ['top', 'left', 'right', 'bottom'];\nvar inited;\nvar elementComputedStyle = {};\nvar support;\nfunction getSupport() {\n    if (!('CSS' in window) || typeof CSS.supports != 'function') {\n        support = '';\n    }\n    else if (CSS.supports('top: env(safe-area-inset-top)')) {\n        support = 'env';\n    }\n    else if (CSS.supports('top: constant(safe-area-inset-top)')) {\n        support = 'constant';\n    }\n    else {\n        support = '';\n    }\n    return support;\n}\nfunction init() {\n    support = typeof support === 'string' ? support : getSupport();\n    if (!support) {\n        attrs.forEach(function (attr) {\n            elementComputedStyle[attr] = 0;\n        });\n        return;\n    }\n    function setStyle(el, style) {\n        var elStyle = el.style;\n        Object.keys(style).forEach(function (key) {\n            var val = style[key];\n            elStyle[key] = val;\n        });\n    }\n    var cbs = [];\n    function parentReady(callback) {\n        if (callback) {\n            cbs.push(callback);\n        }\n        else {\n            cbs.forEach(function (cb) {\n                cb();\n            });\n        }\n    }\n    var passiveEvents = false;\n    try {\n        var opts = Object.defineProperty({}, 'passive', {\n            get: function () {\n                passiveEvents = { passive: true };\n            }\n        });\n        window.addEventListener('test', null, opts);\n    }\n    catch (e) {\n    }\n    function addChild(parent, attr) {\n        var a1 = document.createElement('div');\n        var a2 = document.createElement('div');\n        var a1Children = document.createElement('div');\n        var a2Children = document.createElement('div');\n        var W = 100;\n        var MAX = 10000;\n        var aStyle = {\n            position: 'absolute',\n            width: W + 'px',\n            height: '200px',\n            boxSizing: 'border-box',\n            overflow: 'hidden',\n            paddingBottom: support + \"(safe-area-inset-\" + attr + \")\"\n        };\n        setStyle(a1, aStyle);\n        setStyle(a2, aStyle);\n        setStyle(a1Children, {\n            transition: '0s',\n            animation: 'none',\n            width: '400px',\n            height: '400px'\n        });\n        setStyle(a2Children, {\n            transition: '0s',\n            animation: 'none',\n            width: '250%',\n            height: '250%'\n        });\n        a1.appendChild(a1Children);\n        a2.appendChild(a2Children);\n        parent.appendChild(a1);\n        parent.appendChild(a2);\n        parentReady(function () {\n            a1.scrollTop = a2.scrollTop = MAX;\n            var a1LastScrollTop = a1.scrollTop;\n            var a2LastScrollTop = a2.scrollTop;\n            function onScroll() {\n                if (this.scrollTop === (this === a1 ? a1LastScrollTop : a2LastScrollTop)) {\n                    return;\n                }\n                a1.scrollTop = a2.scrollTop = MAX;\n                a1LastScrollTop = a1.scrollTop;\n                a2LastScrollTop = a2.scrollTop;\n                attrChange(attr);\n            }\n            a1.addEventListener('scroll', onScroll, passiveEvents);\n            a2.addEventListener('scroll', onScroll, passiveEvents);\n        });\n        var computedStyle = getComputedStyle(a1);\n        Object.defineProperty(elementComputedStyle, attr, {\n            get: function () {\n                return parseFloat(computedStyle.paddingBottom);\n            }\n        });\n    }\n    var parentDiv = document.createElement('div');\n    setStyle(parentDiv, {\n        position: 'absolute',\n        left: '0',\n        top: '0',\n        width: '0',\n        height: '0',\n        zIndex: '-1',\n        overflow: 'hidden',\n        visibility: 'hidden',\n    });\n    attrs.forEach(function (key) {\n        addChild(parentDiv, key);\n    });\n    document.body.appendChild(parentDiv);\n    parentReady();\n    inited = true;\n}\nfunction getAttr(attr) {\n    if (!inited) {\n        init();\n    }\n    return elementComputedStyle[attr];\n}\nvar changeAttrs = [];\nfunction attrChange(attr) {\n    if (!changeAttrs.length) {\n        setTimeout(function () {\n            var style = {};\n            changeAttrs.forEach(function (attr) {\n                style[attr] = elementComputedStyle[attr];\n            });\n            changeAttrs.length = 0;\n            callbacks.forEach(function (callback) {\n                callback(style);\n            });\n        }, 0);\n    }\n    changeAttrs.push(attr);\n}\nvar callbacks = [];\nfunction onChange(callback) {\n    if (!getSupport()) {\n        return;\n    }\n    if (!inited) {\n        init();\n    }\n    if (typeof callback === 'function') {\n        callbacks.push(callback);\n    }\n}\nvar safeAreaInsets = {\n    get support() {\n        return (typeof support === 'string' ? support : getSupport()).length != 0;\n    },\n    get top() {\n        return getAttr('top');\n    },\n    get left() {\n        return getAttr('left');\n    },\n    get right() {\n        return getAttr('right');\n    },\n    get bottom() {\n        return getAttr('bottom');\n    },\n    onChange: onChange\n};\nmodule.exports = safeAreaInsets;\n//# sourceMappingURL=index.js.map//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///2\n")}])});

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.apiMethods = undefined;

var _headerUICache = __webpack_require__(140);

var _DomHelper = __webpack_require__(45);

var _DomHelper2 = _interopRequireDefault(_DomHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _HeaderUICache = _headerUICache.HeaderUICache;

var apiMethods = exports.apiMethods = {
    setParameters: setParametersOnDomReady,
    title: function title() {
        var newTitle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        if (_isParamMissing(newTitle)) return false;
        setTitle(newTitle);
    },
    pageTitle: function pageTitle() {
        var newPageTitle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        if (_isParamMissing(newPageTitle)) return false;
        setPageTitle(newPageTitle);
    }
};

function setParametersOnDomReady(params) {
    if (_DomHelper2.default.isReady()) {
        setParameters(params);
    } else {
        _DomHelper2.default.execMethodsOnReady([function () {
            return setParameters(params);
        }]);
    }
}

function setParameters() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        title = _ref.title,
        pageTitle = _ref.pageTitle;

    execMethodIfParamDefined(pageTitle, apiMethods.pageTitle);
    execMethodIfParamDefined(title, apiMethods.title);
}

function execMethodIfParamDefined(param, method) {
    if (param !== undefined) {
        method(param);
    }
}

function setTitle(newTitle) {
    var title = _HeaderUICache.title,
        titleDesktop = _HeaderUICache.titleDesktop;

    _setTextContent(title, newTitle);
    _setTextContent(titleDesktop, newTitle);
}

function setPageTitle(newPageTitle) {
    document.title = newPageTitle;
}

function _setTextContent(element, text) {
    if (element != null && typeof element != "undefined") {
        element.textContent = text;
    } else {
        console.log("unable to find element");
    }
}

function _isParamMissing(param) {
    return param === null;
}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DOM_SELECTOR = {
    TITLE: "js-mobile-title",
    TITLE_DESKTOP: ".dcw_submenu-auth_title",
    SUBTITLE: "js-mobile-subtitle",
    BACK_BUTTON: "js-back-btn",
    BACK_BUTTON_DESKTOP: ".dcw_submenu-auth_back-btn",
    HELP_LINK: "js-help-link"
};

var cachedElements = {};

var HeaderUICache = exports.HeaderUICache = {
    get title() {
        return getElementByNameOrQuery("title", function () {
            return document.getElementById(DOM_SELECTOR.TITLE);
        });
    },
    set titleDesktop(value) {
        cachedElements.titleDesktop = value;
    },
    get titleDesktop() {
        var element = getElementByNameOrQuery("titleDesktop", function () {
            return document.querySelector(DOM_SELECTOR.TITLE_DESKTOP);
        });

        if (!element) {
            console.log("Unable to find a title desktop DOM element");
        }

        this.titleDesktop = element;
        return element;
    },
    get subtitle() {
        return getElementByNameOrQuery("subtitle", function () {
            return document.getElementById(DOM_SELECTOR.SUBTITLE);
        });
    },
    get backBtn() {
        return getElementByNameOrQuery("backBtn", function () {
            return document.getElementById(DOM_SELECTOR.BACK_BUTTON);
        });
    },
    set backBtnDesktop(value) {
        cachedElements.backBtnDesktop = value;
    },
    get backBtnDesktop() {
        var element = getElementByNameOrQuery("backBtnDesktop", function () {
            return document.querySelector(DOM_SELECTOR.BACK_BUTTON_DESKTOP);
        });

        if (!element) {
            console.log("Unable to find a desktop back button DOM element");
        }

        this.backBtnDesktop = element;
        return element;
    },
    get helpLink() {
        return getElementByNameOrQuery("helpLink", function () {
            return document.getElementById(DOM_SELECTOR.HELP_LINK);
        });
    }
};

function getElementByNameOrQuery(name, query) {
    if (!cachedElements[name]) {
        cachedElements[name] = query();
    }

    return cachedElements[name];
}

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadPolyfills = undefined;

__webpack_require__(142);

var rafPolyfill = function rafPolyfill() {
    if (typeof window['requestAnimationFrame'] === 'undefined') {
        window.requestAnimationFrame = setTimeout;
    }

    // closest() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }

    if (!Element.prototype.closest) {
        Element.prototype.closest = function (selector) {
            var element = this;

            if (!document.documentElement.contains(element)) {
                return null;
            }

            do {
                if (element.matches(selector)) {
                    return element;
                }

                element = element.parentElement || element.parentNode;
            } while (element !== null && element.nodeType === 1);

            return null;
        };
    }

    // Number.isNaN() polyfill
    Number.isNaN = Number.isNaN || function (value) {
        return value !== value;
    };
};

var loadPolyEventForIE = function loadPolyEventForIE() {
    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
};

var loadPolyfills = exports.loadPolyfills = function loadPolyfills() {
    rafPolyfill();
    loadPolyEventForIE();
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * classList.js: Cross-browser full element.classList implementation.
 * 1.2.20171210
 *
 * By Eli Grey, http://eligrey.com
 * License: Dedicated to the public domain.
 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
 */

/*global self, document, DOMException */

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */

if ("document" in self) {

	// Full polyfill for browsers with no classList support
	// Including IE < Edge missing SVGElement.classList
	if (!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) {

		(function (view) {

			"use strict";

			if (!('Element' in view)) return;

			var classListProp = "classList",
			    protoProp = "prototype",
			    elemCtrProto = view.Element[protoProp],
			    objCtr = Object,
			    strTrim = String[protoProp].trim || function () {
				return this.replace(/^\s+|\s+$/g, "");
			},
			    arrIndexOf = Array[protoProp].indexOf || function (item) {
				var i = 0,
				    len = this.length;
				for (; i < len; i++) {
					if (i in this && this[i] === item) {
						return i;
					}
				}
				return -1;
			}
			// Vendors: please allow content code to instantiate DOMExceptions
			,
			    DOMEx = function DOMEx(type, message) {
				this.name = type;
				this.code = DOMException[type];
				this.message = message;
			},
			    checkTokenAndGetIndex = function checkTokenAndGetIndex(classList, token) {
				if (token === "") {
					throw new DOMEx("SYNTAX_ERR", "The token must not be empty.");
				}
				if (/\s/.test(token)) {
					throw new DOMEx("INVALID_CHARACTER_ERR", "The token must not contain space characters.");
				}
				return arrIndexOf.call(classList, token);
			},
			    ClassList = function ClassList(elem) {
				var trimmedClasses = strTrim.call(elem.getAttribute("class") || ""),
				    classes = trimmedClasses ? trimmedClasses.split(/\s+/) : [],
				    i = 0,
				    len = classes.length;
				for (; i < len; i++) {
					this.push(classes[i]);
				}
				this._updateClassName = function () {
					elem.setAttribute("class", this.toString());
				};
			},
			    classListProto = ClassList[protoProp] = [],
			    classListGetter = function classListGetter() {
				return new ClassList(this);
			};
			// Most DOMException implementations don't allow calling DOMException's toString()
			// on non-DOMExceptions. Error's toString() is sufficient here.
			DOMEx[protoProp] = Error[protoProp];
			classListProto.item = function (i) {
				return this[i] || null;
			};
			classListProto.contains = function (token) {
				return ~checkTokenAndGetIndex(this, token + "");
			};
			classListProto.add = function () {
				var tokens = arguments,
				    i = 0,
				    l = tokens.length,
				    token,
				    updated = false;
				do {
					token = tokens[i] + "";
					if (!~checkTokenAndGetIndex(this, token)) {
						this.push(token);
						updated = true;
					}
				} while (++i < l);

				if (updated) {
					this._updateClassName();
				}
			};
			classListProto.remove = function () {
				var tokens = arguments,
				    i = 0,
				    l = tokens.length,
				    token,
				    updated = false,
				    index;
				do {
					token = tokens[i] + "";
					index = checkTokenAndGetIndex(this, token);
					while (~index) {
						this.splice(index, 1);
						updated = true;
						index = checkTokenAndGetIndex(this, token);
					}
				} while (++i < l);

				if (updated) {
					this._updateClassName();
				}
			};
			classListProto.toggle = function (token, force) {
				var result = this.contains(token),
				    method = result ? force !== true && "remove" : force !== false && "add";

				if (method) {
					this[method](token);
				}

				if (force === true || force === false) {
					return force;
				} else {
					return !result;
				}
			};
			classListProto.replace = function (token, replacement_token) {
				var index = checkTokenAndGetIndex(token + "");
				if (~index) {
					this.splice(index, 1, replacement_token);
					this._updateClassName();
				}
			};
			classListProto.toString = function () {
				return this.join(" ");
			};

			if (objCtr.defineProperty) {
				var classListPropDesc = {
					get: classListGetter,
					enumerable: true,
					configurable: true
				};
				try {
					objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
				} catch (ex) {
					// IE 8 doesn't support enumerable:true
					// adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
					// modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
					if (ex.number === undefined || ex.number === -0x7FF5EC54) {
						classListPropDesc.enumerable = false;
						objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
					}
				}
			} else if (objCtr[protoProp].__defineGetter__) {
				elemCtrProto.__defineGetter__(classListProp, classListGetter);
			}
		})(self);
	}

	// There is full or partial native classList support, so just check if we need
	// to normalize the add/remove and toggle APIs.

	(function () {
		"use strict";

		var testElement = document.createElement("_");

		testElement.classList.add("c1", "c2");

		// Polyfill for IE 10/11 and Firefox <26, where classList.add and
		// classList.remove exist but support only one argument at a time.
		if (!testElement.classList.contains("c2")) {
			var createMethod = function createMethod(method) {
				var original = DOMTokenList.prototype[method];

				DOMTokenList.prototype[method] = function (token) {
					var i,
					    len = arguments.length;

					for (i = 0; i < len; i++) {
						token = arguments[i];
						original.call(this, token);
					}
				};
			};
			createMethod('add');
			createMethod('remove');
		}

		testElement.classList.toggle("c3", false);

		// Polyfill for IE 10 and Firefox <24, where classList.toggle does not
		// support the second argument.
		if (testElement.classList.contains("c3")) {
			var _toggle = DOMTokenList.prototype.toggle;

			DOMTokenList.prototype.toggle = function (token, force) {
				if (1 in arguments && !this.contains(token) === !force) {
					return force;
				} else {
					return _toggle.call(this, token);
				}
			};
		}

		// replace() polyfill
		if (!("replace" in document.createElement("_").classList)) {
			DOMTokenList.prototype.replace = function (token, replacement_token) {
				var tokens = this.toString().split(" "),
				    index = tokens.indexOf(token + "");
				if (~index) {
					tokens = tokens.slice(index);
					this.remove.apply(this, tokens);
					this.add(replacement_token);
					this.add.apply(this, tokens.slice(1));
				}
			};
		}

		testElement = null;
	})();
}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadComponents = undefined;

var _index = __webpack_require__(144);

var _index2 = _interopRequireDefault(_index);

var _tabBar = __webpack_require__(153);

var _tabBar2 = _interopRequireDefault(_tabBar);

var _slider = __webpack_require__(154);

var _slider2 = _interopRequireDefault(_slider);

var _index3 = __webpack_require__(155);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(156);

var _index6 = _interopRequireDefault(_index5);

var _scrollSlider = __webpack_require__(157);

var _scrollSlider2 = _interopRequireDefault(_scrollSlider);

var _filterList = __webpack_require__(158);

var _filterList2 = _interopRequireDefault(_filterList);

var _lightbox = __webpack_require__(159);

var _lightbox2 = _interopRequireDefault(_lightbox);

var _tableOfContent = __webpack_require__(160);

var _tableOfContent2 = _interopRequireDefault(_tableOfContent);

var _articleTemplate = __webpack_require__(161);

var _articleTemplate2 = _interopRequireDefault(_articleTemplate);

var _seeMore = __webpack_require__(162);

var _seeMore2 = _interopRequireDefault(_seeMore);

var _accordion = __webpack_require__(163);

var _accordion2 = _interopRequireDefault(_accordion);

var _productList = __webpack_require__(164);

var _productList2 = _interopRequireDefault(_productList);

var _dropdown = __webpack_require__(165);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _dropdownlight = __webpack_require__(166);

var _dropdownlight2 = _interopRequireDefault(_dropdownlight);

var _search = __webpack_require__(167);

var _search2 = _interopRequireDefault(_search);

var _mainSearch = __webpack_require__(46);

var _menuBrs = __webpack_require__(168);

var _menuToggle = __webpack_require__(169);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadComponents = exports.loadComponents = function loadComponents($) {

  if ($('.js-menu-brs').length) {
    (0, _menuBrs.initMenuBrs)();
  }

  if ($('.js-menu-left_toggle').length) {
    (0, _menuToggle.initToggles)();
  }

  $('.js-slider').each(function (i, el) {
    new _slider2.default($(el));
  });

  $('.js-tablist').each(function (i, el) {
    new _index4.default($(el));
  });

  $('.js-accordion-card').each(function (i, el) {
    new _index6.default($(el));
  });

  $('.js-filter-list').each(function (i, el) {
    new _filterList2.default($(el));
  });

  new _lightbox2.default($('.js-lightbox'));

  $('.js-see-more').each(function (i, el) {
    new _seeMore2.default($(el));
  });

  if ($('.js-toc').length > 0 && $('.js-article').length > 0) {
    new _tableOfContent2.default($('.js-toc'));
    new _articleTemplate2.default();
  }

  if ($('.js-scroll-slider').length > 0) {
    new _scrollSlider2.default($('.js-scroll-slider'));
  }

  if ($('.js-accordion_head').length > 0) {
    $('.js-accordion_head').each(function (i, el) {
      return new _accordion2.default($(el));
    });
  }

  if ($('.js-product-list').length > 0) {
    $('.js-product-list').each(function (i, el) {
      return new _productList2.default($(el));
    });
  }

  if ($('.js-dropdown-old').length > 0) {
    $('.js-dropdown-old').each(function (i, el) {
      return new _dropdown2.default($(el));
    });
  }

  if ($('.js-dropdown-light').length > 0) {
    $('.js-dropdown-light').each(function (i, el) {
      return new _dropdownlight2.default($(el));
    });
  }

  if ($('.js-search').length > 0) {
    $('.js-search').each(function (i, el) {
      return new _search2.default($(el));
    });
  }

  if ($('.js-search-gsa').length) {
    new _mainSearch.SearchBox({
      $el: $('.js-search-gsa'),
      itemIdPrefix: 'search-gsa'
    });
  }

  if ($('.js-tab-bar').length) {
    new _tabBar2.default($('.js-tab-bar'));
  };

  // bind btn print
  $('.js-btn-print').click(function () {
    window.print();
  });

  _index2.default.init();
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _breakpointDispatcher = __webpack_require__(14);

var _breakpointDispatcher2 = _interopRequireDefault(_breakpointDispatcher);

var _pubSub = __webpack_require__(3);

var _pubSub2 = _interopRequireDefault(_pubSub);

var _header = __webpack_require__(146);

var _headerLhsUnauth = __webpack_require__(149);

var _headerLhsAuth = __webpack_require__(150);

var _HeaderAuth = __webpack_require__(151);

var _HeaderAuth2 = _interopRequireDefault(_HeaderAuth);

var _sidedrawer = __webpack_require__(152);

var _sidedrawer2 = _interopRequireDefault(_sidedrawer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BREAKPOINT_DESKTOP = _breakpointDispatcher2.default.breakpoint.DESKTOP;
var BREAKPOINT_TABLET = _breakpointDispatcher2.default.breakpoint.TABLET;
var BREAKPOINT_MOBILE = _breakpointDispatcher2.default.breakpoint.MOBILE;

var AUTH_STATE = {
  AUTH: 'AUTH',
  NO_AUTH: 'NO_AUTH'
};

var HEADER_SELECTOR = {
  SIDEDRAWER_AUTH: '.js-header-auth',
  HEADER_LHS_AUTH: '.js-header-lhs-auth',
  HEADER_LHS_UNAUTH: '.js-header-lhs-no-auth',
  SIDEDRAWER_NO_AUTH: '.js-header',
  AUTH: '.js-menu-auth',
  NO_AUTH: null
};

var headerInstance = null;
var headerInstanceLhs = null;
var isMobile;
var viewState = "";

var HeaderFactory = function () {

  return {
    init: function init() {
      _breakpointDispatcher2.default.start();
      setInitialContext();
    }
  };
}();

function setInitialContext() {
  var isContextLHS = false;

  if ((0, _jquery2.default)(HEADER_SELECTOR.HEADER_LHS_UNAUTH).length > 0 || (0, _jquery2.default)(HEADER_SELECTOR.HEADER_LHS_AUTH).length > 0) {
    isContextLHS = true;
  }

  if (isContextLHS) {
    (0, _jquery2.default)("body").append("<span id='viewState' style='display:none'></span>");
    performLHSContext();
    _pubSub2.default.subscribe('resize:mobile', performLHSContext);
    _pubSub2.default.subscribe('resize:tablet', performLHSContext);
    _pubSub2.default.subscribe('resize:desktop', performLHSContext);
  } else {
    performOldNav();
  }
}

function performLHSContext() {
  viewState = _breakpointDispatcher2.default.getState();
  (0, _jquery2.default)('#viewState').text(viewState);
  switch (viewState) {
    case BREAKPOINT_MOBILE:
    case BREAKPOINT_TABLET:

      if ((0, _jquery2.default)(HEADER_SELECTOR.HEADER_LHS_AUTH).length > 0) {
        (0, _headerLhsAuth.initHeaderLhsAuthMobile)();
        break;
      }

      if ((0, _jquery2.default)(HEADER_SELECTOR.HEADER_LHS_UNAUTH).length > 0) {
        (0, _headerLhsUnauth.initHeaderLhsUnauthMobile)(HEADER_SELECTOR.HEADER_LHS_UNAUTH);
        break;
      }

    case BREAKPOINT_DESKTOP:
      if ((0, _jquery2.default)(HEADER_SELECTOR.HEADER_LHS_AUTH).length > 0) {
        (0, _headerLhsAuth.initHeaderLhsAuthDesktop)();
        break;
      }

      if ((0, _jquery2.default)(HEADER_SELECTOR.HEADER_LHS_UNAUTH).length > 0) {
        (0, _headerLhsUnauth.initHeaderLhsUnauthDesktop)(HEADER_SELECTOR.HEADER_LHS_UNAUTH);
        break;
      }
  }
}

function performOldNav() {
  switch (_breakpointDispatcher2.default.getState()) {
    case BREAKPOINT_MOBILE:
      isMobile = true;

      if ((0, _jquery2.default)('.js-menu').length > 0) {
        headerInstance = new _sidedrawer2.default(HEADER_SELECTOR.SIDEDRAWER_NO_AUTH);
      } else {
        headerInstance = new _sidedrawer2.default(HEADER_SELECTOR.SIDEDRAWER_AUTH);
      }

      break;

    case BREAKPOINT_DESKTOP:
    case BREAKPOINT_TABLET:
      isMobile = false;

      if ((0, _jquery2.default)('.js-menu').length > 0) {
        headerInstance = (0, _header.initMenu)();
      } else {
        headerInstance = new _HeaderAuth2.default((0, _jquery2.default)(HEADER_SELECTOR.AUTH));
      }
      break;
  }
  handleBreakPointChange();
}

function handleBreakPointChange() {
  _pubSub2.default.subscribe('resize:mobile', handleMobileBreakPoint);
  _pubSub2.default.subscribe('resize:tablet', handleTabletBreakPoint);
  _pubSub2.default.subscribe('resize:desktop', handleTabletBreakPoint);
}

function handleMobileBreakPoint() {
  isMobile = true;
  headerInstance.destroy();

  if (headerInstance.authState === AUTH_STATE.AUTH) {
    headerInstance = new _sidedrawer2.default(HEADER_SELECTOR.SIDEDRAWER_AUTH);
  } else {
    headerInstance = new _sidedrawer2.default(HEADER_SELECTOR.SIDEDRAWER_NO_AUTH);
  }
}

function handleTabletBreakPoint() {
  if (!isMobile) return;
  isMobile = false;

  headerInstance.destroy();

  if (headerInstance.authState === AUTH_STATE.AUTH) {
    headerInstance = new _HeaderAuth2.default((0, _jquery2.default)(HEADER_SELECTOR.AUTH));
  } else {
    headerInstance = (0, _header.initMenu)(HEADER_SELECTOR.NO_AUTH);
  }
}

exports.default = HeaderFactory;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BREAKPOINT = exports.BREAKPOINT = {
  NAME: {
    MOBILE: 'mobile',
    TABLET: 'tablet',
    DESKTOP: 'desktop'
  },
  WIDTH: {
    MOBILE: 768,
    TABLET: 1279
  }
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.initMenu = initMenu;

var _lodash = __webpack_require__(147);

var _lodash2 = _interopRequireDefault(_lodash);

var _stickyModule = __webpack_require__(76);

var _marker = __webpack_require__(77);

var _onElementOut = __webpack_require__(78);

var _mainSearch = __webpack_require__(46);

var _pubSub = __webpack_require__(3);

var _pubSub2 = _interopRequireDefault(_pubSub);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = void 0;

var KEY = {
  ESC: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};

var DO_ANIM = true;
var NO_ANIM = false;

var MENU_OPEN = true;
var MENU_CLOSE = false;

var DO_FOCUS_BACK = true;
var NO_FOCUS_BACK = false;

var LEVEL_1 = 0;
var LEVEL_2 = 1;
var LEVEL_3 = 2;

var ACTIVE_CLASS = "is-active";
var SCROLL_STICKY_BASE = 10;
var MARKER_INITIAL_POS = 16;
var MARKER_STICKY_POS = 82;

var state = {
  active: null,
  activeLevel: LEVEL_1,
  isMegaMenuOpen: false,
  openMegaMenu: null,
  expandedButtons: []
};

var dom = {
  headerRoot: ".js-header",
  menuRoot: ".js-menu",
  mainContent: ".dcw_main",
  mainNav: ".dcw_main-nav_list",
  firstLevel: ".js-menu_item",
  secondLevel: ".js-mega-menu_item",
  secondLevelShown: ".js-mega-menu_item:not(.hide-on-desktop)",
  thirdLevel: ".js-mega-menu_subitem",
  thirdLevelShown: ".js-mega-menu_subitem:not(.hide-on-desktop)",
  marker: ".js-marker",
  megaMenuContainer: ".js-mega-menu",
  menuLink: ".dcw_mega-menu_link",
  activeClass: ".is-active",
  closeBtn: ".js-mega-menu_btn-close"
};

var eventHandlers = {
  preventMenuPropagation: _preventMenuClickPropagation,
  firstLevel: _handleFirstLevel
};

var domCache = void 0;
var firstLevelMarker = void 0;
var thirdLevelMarker;
var sticky = void 0;
var mainSearch = void 0;

function initMenu() {
  domCache = getDomCache();
  setInitialState();
  bindEvents();
  sticky = setSticky();
  initMarkers();
  padContent();
  mainSearch = createMainSearch();

  return {
    destroy: destroy,
    authState: "NO_AUTH"
  };
}

function destroy() {
  unbindAllEvents();
  sticky.destroy();
  mainSearch.destroy();
}

function createMainSearch() {
  return new _mainSearch.MainSearchUnAuth({
    $el: document.querySelector(".js-main-search"),
    itemIdPrefix: "main-search"
  });
}

function unbindAllEvents() {
  unbindCloseEvents();
  removeListeners(domCache.root);
}

function getDomCache() {
  return {
    root: document.querySelector(".dcw_main-nav"),
    menuRoot: document.querySelector(dom.menuRoot),
    headerRoot: document.querySelector(dom.headerRoot),
    firstMarker: document.querySelector(dom.marker)
  };
}

function setInitialState() {
  state.active = getActiveItems();
  initialState = (0, _lodash2.default)(state);
}

function resetInitialState() {
  state = (0, _lodash2.default)(initialState);
}

function setActiveLevel(level) {
  state.activeLevel = level;
}

function resetSubLevelsState() {
  state.active.slice(1).forEach(function (element) {
    var btn = element.querySelector("button");
    element.classList.remove(ACTIVE_CLASS);
  });
  unsetAllAriaExpanded();
}

function applyLevelsState(menuItem) {
  var secondLevel = void 0;
  var thirdLevel = void 0;
  var shouldTranslateMarker = false;
  var menuItemBtn = menuItem.querySelector("button");

  if (isCurrent(menuItem)) {
    var _initialState$active$ = initialState.active.slice(1);

    var _initialState$active$2 = _slicedToArray(_initialState$active$, 2);

    secondLevel = _initialState$active$2[0];
    thirdLevel = _initialState$active$2[1];

    shouldTranslateMarker = true;
  } else {
    secondLevel = menuItem.querySelector(dom.secondLevelShown);
    thirdLevel = secondLevel && secondLevel.querySelector(dom.thirdLevelShown);
  }

  requestAnimationFrame(function () {
    menuItem.classList.add(ACTIVE_CLASS);
    setAriaExpanded(menuItemBtn);

    if (secondLevel) {
      secondLevel.classList.add(ACTIVE_CLASS);
      setAriaExpanded(secondLevel.querySelector("button"));

      if (thirdLevel) {
        thirdLevel.classList.add(ACTIVE_CLASS);
        thirdLevelMarker = getSecondMarker(secondLevel);

        if (shouldTranslateMarker) {
          setTimeout(function () {
            return thirdLevelMarker.translateTo(thirdLevel, NO_ANIM);
          }, 30);
        }
      }
    }

    updateSubLevelState(secondLevel, thirdLevel);
  });
}

function unsetLastActive(level) {
  return state.active && state.active[level] && state.active[level].classList.remove(ACTIVE_CLASS);
}

function setActive(level, element) {
  if (!state.active) {
    state.active = [];
  }

  if (state.active.length - 1 < level) {
    return state.active.push(element);
  }

  state.active[level] = element;
}

function updateSubLevelState(second, third) {
  if (second) setActive(LEVEL_2, second);
  if (third) setActive(LEVEL_3, third);
}

// marker

function initMarkers() {
  firstLevelMarker = getFirstMarker();

  if (initialState.active) {
    firstLevelMarker.translateTo(initialState.active[LEVEL_1]);
  }

  (0, _onElementOut.onElementBoundsOut)(document.querySelector(".dcw_main-nav_list"), domCache.headerRoot, function () {
    setMarkerToLastActive();
  });
}

function getFirstMarker() {
  return (0, _marker.marker)("HORIZONTAL", domCache.firstMarker, dom.firstLevel, MARKER_INITIAL_POS);
}

function getSecondMarker(menuItem) {
  return (0, _marker.marker)("VERTICAL", menuItem.querySelector(dom.marker), menuItem.querySelectorAll(dom.thirdLevel));
}

function resetMarkerBackToInitial() {
  return initialState.active && firstLevelMarker.translateTo(initialState.active[LEVEL_1]);
}

function setMarkerToLastActive() {
  if (state.active) {
    return firstLevelMarker.translateTo(state.active[LEVEL_1]);
  }
  firstLevelMarker.translateAndHide(MARKER_INITIAL_POS);
}

function resetSecondMarker() {
  if (!thirdLevelMarker) return;

  thirdLevelMarker.translate(-24);
  thirdLevelMarker = null;
}

// sticky

function setSticky() {
  return (0, _stickyModule.stickyModule)({
    $el: domCache.headerRoot,
    stickyLimit: SCROLL_STICKY_BASE,

    enterSticky: function enterSticky() {
      firstLevelMarker.changePadTo(MARKER_STICKY_POS);
      return firstLevelMarker.replayTranslate(true);
    },
    leaveSticky: function leaveSticky() {
      firstLevelMarker.changePadTo(MARKER_INITIAL_POS);
      return firstLevelMarker.replayTranslate(true);
    }
  });
}

// handling content below menu

function padContent() {
  document.querySelector(dom.mainContent).style.marginTop = domCache.headerRoot.clientHeight + "px";
}
// events

function bindEvents() {
  preventMenuPropagation();
  bindFirstLevel();
  bindSecondLevel();
  bindKeys();
}

function preventMenuPropagation() {
  domCache.menuRoot.addEventListener("click", eventHandlers.preventMenuPropagation);
}

function _preventMenuClickPropagation(e) {
  e.stopPropagation();

  if (isCloseBtn(e)) {
    closeMegaMenu(DO_ANIM);
  }
}

function isCloseBtn(e) {
  var target = e.target;
  var closeBtnClass = dom.closeBtn.slice(1);

  return target.classList.contains(closeBtnClass) || target.parentNode.classList.contains(closeBtnClass);
}

function removeListeners(el) {
  var newEl = el.cloneNode(true);
  el.parentNode.replaceChild(newEl, el);
}

function bindFirstLevel() {
  document.querySelector(dom.mainNav).addEventListener("click", function (e) {
    var element = e.target;
    var menuItem = void 0;

    if (element.classList.contains(dom.firstLevel.slice(1))) {
      menuItem = element;
    } else if (element.classList.contains("dcw_main-nav_link")) {
      menuItem = element.parentNode;
    }

    if (!menuItem) return;

    onEnterFirstLevel(menuItem);
  });

  document.querySelector(dom.mainNav).addEventListener("focusin", function (e) {
    var element = e.target;

    if (element.classList.contains("dcw_main-nav_link")) {
      firstLevelMarker.translateTo(element);
    }
  });
}

function _handleFirstLevel() {}

function bindSecondLevel() {
  [].forEach.call(document.querySelectorAll(".dcw_mega-menu_list"), function (secondMenu) {
    secondMenu.addEventListener("click", function (e) {
      var element = e.target;
      var menuItem = void 0;

      if (element.classList.contains("dcw_mega-menu_item")) {
        menuItem = element;
      } else if (element.classList.contains("dcw_mega-menu_link")) {
        menuItem = element.parentNode;
      }

      if (!menuItem || isThirdLevelItem(menuItem)) return;

      onEnterSecondLevel(menuItem);
    });
  });
}

function isThirdLevelItem(item) {
  return item.classList.contains("dcw_mega-menu_subitem") || typeof item.getAttribute("href") === "string";
}

function onEnterFirstLevel(menuItem) {
  resetSecondMarker();

  switch (state.isMegaMenuOpen) {
    case MENU_OPEN:
      handleMenuOpen(menuItem);
      break;
    case MENU_CLOSE:
      handleMenuClose(menuItem);
      break;
  }
}

function onEnterSecondLevel(menuItem) {
  var menuItemBtn = void 0;

  if (hasActiveClass(menuItem)) return;
  resetSecondMarker();

  unsetLastActive(LEVEL_2);
  unsetLastAriaExpanded();

  setActive(LEVEL_2, menuItem);
  state.active[LEVEL_3] = state.active[LEVEL_2].querySelector(dom.thirdLevel);
  thirdLevelMarker = getSecondMarker(menuItem);
  menuItemBtn = menuItem.querySelector("button");
  focusThirdLevel();
  setActiveLevel(LEVEL_3);
  menuItem.classList.add(ACTIVE_CLASS);
  setAriaExpanded(menuItemBtn);
}

function handleMenuOpen(menuItem) {
  if (isActive(LEVEL_1, menuItem)) {
    return;
  }

  closeMegaMenu(NO_ANIM, NO_FOCUS_BACK);
  applyLevelsState(menuItem);
  unsetLastActive(LEVEL_1);
  setActive(LEVEL_1, menuItem);
  openMegaMenu(menuItem, NO_ANIM);
  bindCloseEvents();
}

function handleMenuClose(menuItem) {
  _pubSub2.default.publish("search:close");

  unsetLastActive(LEVEL_1);
  setActive(LEVEL_1, menuItem);
  applyLevelsState(menuItem);
  openMegaMenu(menuItem, DO_ANIM);
  bindCloseEvents();
}

function bindCloseEvents() {
  window.addEventListener("click", handleCloseEvents);
  window.addEventListener("scroll", handleCloseEvents);
}

function unbindCloseEvents() {
  window.removeEventListener("click", handleCloseEvents);
  window.removeEventListener("scroll", handleCloseEvents);
}

function handleCloseEvents() {
  closeMegaMenu(DO_ANIM, DO_FOCUS_BACK);
}

function focusBackToLastActive(state) {}

// actions

function openMegaMenu(menuItem, shouldAnimate) {
  var megaMenu = getMegaMenuFrom(menuItem);
  var megaMenuItem = megaMenu.querySelector(dom.secondLevel);

  state.isMegaMenuOpen = true;
  state.openMegaMenu = megaMenu;

  if (shouldAnimate) {
    requestAnimationFrame(function () {
      animOpenMenu(megaMenu);
    });
  } else {
    megaMenu.classList.add("is-open", "is-open-add");
    showCloseBtn(megaMenu);
  }
}

function closeMegaMenu(shouldAnimate, shouldFocusBack) {
  unbindCloseEvents();

  if (shouldAnimate) {
    requestAnimationFrame(function () {
      animCloseMenu(state.openMegaMenu);
      resetSubLevelsState();
      resetInitialState();
    });
  } else {
    state.openMegaMenu.classList.remove("is-open", "is-open-add");

    unsetAllAriaExpanded();
    resetSubLevelsState();
    resetInitialState();
  }

  if (shouldFocusBack) {
    focusBackToLastActive();
    resetMarkerBackToInitial();
  }
}

function showCloseBtn(megaMenuRoot) {
  megaMenuRoot.querySelector(dom.closeBtn).style.display = "inline-block";
}

function hideCloseBtn(megaMenuRoot) {
  megaMenuRoot.querySelector(dom.closeBtn).style.display = "";
}

function setAriaExpanded(element) {
  element.setAttribute("aria-expanded", true);
  state.expandedButtons.push(element);
}

function unsetLastAriaExpanded() {
  var element = state.expandedButtons.pop();
  return element && unsetAriaExpanded(element);
}

function unsetAriaExpanded(element) {
  element.setAttribute("aria-expanded", false);
}

function unsetAllAriaExpanded() {
  state.expandedButtons.forEach(function (btn) {
    unsetAriaExpanded(btn);
  });
  state.expandedButtons = [];
}

// getters

function getActiveItems() {
  var firstActive = getFirstActive();
  var subLevels = void 0;

  if (!firstActive) return null;

  return [firstActive].concat(_toConsumableArray(getActiveSubLevelsFrom(firstActive)));
}

function getFirstActive() {
  return document.querySelector(dom.firstLevel + dom.activeClass);
}

function getParentElementOf(element) {
  return element.parentNode;
}

function getActiveFromInitialState(level) {
  return initialState.active[level] || null;
}

function getActiveSubLevelsFrom(element) {
  var entry = element.querySelector(dom.activeClass);

  if (entry) {
    return [entry].concat(getActiveSubLevelsFrom(entry));
  }

  return [];
}

function getMegaMenuFrom(menuItem) {
  return menuItem.querySelector(dom.megaMenuContainer);
}

// booleans

function hasActiveClass(element) {
  return element.classList.contains(ACTIVE_CLASS);
}

function isActive(level, menuItem) {
  return state.active[level] === menuItem;
}

function isCurrent(menuItem) {
  return initialState.active && initialState.active[LEVEL_1] === menuItem;
}

// anim
function animOpenMenu(menuItem) {
  menuItem.classList.add("is-open-add");

  requestAnimationFrame(function () {
    menuItem.classList.add("is-open");
  });
  setTimeout(function () {
    return showCloseBtn(menuItem);
  }, 400);
}

function animCloseMenu(menuItem) {
  menuItem.classList.remove("is-open");
  hideCloseBtn(menuItem);

  setTimeout(function () {
    menuItem.classList.remove("is-open-add");
  }, 300);
}

// KEY nav

function bindKeys() {
  domCache.menuRoot.addEventListener("keydown", handleKeyDown);
}

function handleKeyDown(e) {
  switch (state.activeLevel) {
    case LEVEL_1:
      handleLevelOneKey(e);
      break;
    case LEVEL_2:
      handleLevelTwoKey(e);
      break;
    case LEVEL_3:
      handleLevelThreeKey(e);
      break;
  }
}

function handleLevelOneKey(e) {
  switch (e.keyCode) {
    case KEY.ESC:
      closeMegaMenu(true);
      break;
    case KEY.DOWN:
      e.preventDefault();

      if (state.isMegaMenuOpen) {
        focusThirdLevel();
      }

      onEnterFirstLevel(getParentElementOf(e.target));
      break;
  }
}

function handleLevelTwoKey(e) {
  switch (e.keyCode) {
    case KEY.ESC:
      closeMegaMenu(true);
      break;
    case KEY.UP:
      e.preventDefault();
      focusPreviousItem();
      break;
    case KEY.DOWN:
      e.preventDefault();
      focusNextItem();
      break;
    case KEY.LEFT:
      setActiveLevel(LEVEL_2);
      break;
    case KEY.RIGHT:
      onEnterSecondLevel(getParentElementOf(e.target));
      break;
  }
}

function handleLevelThreeKey(e) {
  switch (e.keyCode) {
    case KEY.ESC:
      closeMegaMenu(true);
      break;
    case KEY.UP:
      e.preventDefault();
      focusPreviousItem();
      break;
    case KEY.DOWN:
      e.preventDefault();
      focusNextItem();
      break;
    case KEY.LEFT:
      setActiveLevel(LEVEL_2);
      getFocusableElementOf(state.active[LEVEL_2]).focus();
      break;
  }
}

function focusPreviousItem() {
  var parent = getParentElementOf(document.activeElement);
  var sibling = getPrevSiblingOfType(parent, "LI");
  var newFocus = void 0;

  if (!sibling) return;

  if (newFocus = getFocusableElementOf(sibling)) {
    newFocus.focus();
  }
}

function focusNextItem() {
  var parent = getParentElementOf(document.activeElement);
  var sibling = getNextSiblingOfType(parent, "LI");
  var newFocus = void 0;

  if (!sibling) return;

  if (newFocus = getFocusableElementOf(sibling)) {
    newFocus.focus();
  }
}

function focusThirdLevel() {
  setTimeout(function () {
    return getFocusableElementOf(state.active[LEVEL_3]).focus();
  });
  setActiveLevel(LEVEL_3);
}

function getFocusableElementOf(element) {
  return element.querySelector(dom.menuLink);
}

function getNextSiblingOfType(element, type) {
  var sibling = element.nextSibling;

  while (sibling.tagName !== type) {
    sibling = sibling.nextSibling;
    if (!sibling) return null;
  }

  return sibling;
}

function getPrevSiblingOfType(element, type) {
  var sibling = element.previousSibling;

  while (sibling.tagName !== type) {
    sibling = sibling.previousSibling;
    if (!sibling) return null;
  }

  return sibling;
}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(148)(module)))

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initHeaderLhsUnauthDesktop = initHeaderLhsUnauthDesktop;
exports.initHeaderLhsUnauthMobile = initHeaderLhsUnauthMobile;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _burgerBtn = __webpack_require__(79);

var _burgerBtn2 = _interopRequireDefault(_burgerBtn);

var _searchPanel = __webpack_require__(80);

var _searchPanel2 = _interopRequireDefault(_searchPanel);

var _navPanelDesktop = __webpack_require__(81);

var _navPanelDesktop2 = _interopRequireDefault(_navPanelDesktop);

var _navPanelMobile = __webpack_require__(82);

var _navPanelMobile2 = _interopRequireDefault(_navPanelMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = {
    MAIN_CONTENT: '.dcw_main',
    MOBILE_BURGER: '.js-header-burger',
    MOBILE_BURGER_CONTENT: '.js-burger-content',
    PANEL_SEACH: '.js-nav-search',
    NAV_MOBILE_AUTHENTICATED: '.js-mobile-nav-codeco',
    NAV_MOBILE_AUTHENTICATED_AREA: '.js-mobile-menu-codeco'
};

var PREFIX = {
    GSA: 'search-gsa'
};

var domCache = void 0;

// COMPONENTS
var burgerBtn,
    navPanelMobile,
    panelSearch,
    navPanelDesktop = null;

function initHeaderLhsUnauthDesktop(SelectorHeaderRoot) {
    panelSearch = new _searchPanel2.default(SELECTOR.PANEL_SEACH, PREFIX.GSA, false);

    navPanelDesktop = new _navPanelDesktop2.default();
    navPanelDesktop.init();

    domCache = getDomCache(SelectorHeaderRoot);
}

function initHeaderLhsUnauthMobile(SelectorHeaderRoot) {
    panelSearch = new _searchPanel2.default(SELECTOR.PANEL_SEACH, PREFIX.GSA, true);
    burgerBtn = new _burgerBtn2.default(SELECTOR.MOBILE_BURGER, SELECTOR.MOBILE_BURGER_CONTENT);
    burgerBtn.init();
    /*if (isAuthenticated()) {
        initAuthenticatedNavigationMobile();
    }*/

    navPanelMobile = new _navPanelMobile2.default();
    navPanelMobile.init();

    domCache = getDomCache(SelectorHeaderRoot);
    marginContent();
}

function getDomCache(SelectorHeaderRoot) {
    return {
        headerRoot: document.querySelector(SelectorHeaderRoot)
    };
}

/*
    [TODO] Check if deprecated
 */
function initAuthenticatedNavigationMobile() {
    (0, _jquery2.default)(SELECTOR.NAV_MOBILE_AUTHENTICATED_AREA).append((0, _jquery2.default)(SELECTOR.NAV_MOBILE_AUTHENTICATED).children());
}

/*
    [TODO] Check if deprecated
 */
function isAuthenticated() {
    var sasInf = document.getElementById('sas_user_info');
    if (sasInf) {
        var sasHtml = sasInf.innerHTML;
        try {
            var sasJs = JSON.parse(sasHtml.trim());
            if (sasJs && sasJs.IdStat) {
                return true;
            }
        } catch (e) {
            return false;
        }
    }
    return false;
}

function marginContent() {
    var marginHead = domCache.headerRoot.clientHeight + 24;
    document.querySelector(SELECTOR.MAIN_CONTENT).style.marginTop = marginHead + "px";
}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initHeaderLhsAuthDesktop = initHeaderLhsAuthDesktop;
exports.initHeaderLhsAuthMobile = initHeaderLhsAuthMobile;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _burgerBtn = __webpack_require__(79);

var _burgerBtn2 = _interopRequireDefault(_burgerBtn);

var _searchPanel = __webpack_require__(80);

var _searchPanel2 = _interopRequireDefault(_searchPanel);

var _navPanelDesktop = __webpack_require__(81);

var _navPanelDesktop2 = _interopRequireDefault(_navPanelDesktop);

var _navPanelMobile = __webpack_require__(82);

var _navPanelMobile2 = _interopRequireDefault(_navPanelMobile);

var _market = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR = {
    HEADER_ROOT: '.js-header-lhs-auth',
    MAIN_CONTENT: '.dcw_main',
    MAIN_CONTENT_RSP: '.rsp_main',
    BURGER_BTN: '.js-header-burger',
    GLOBAL_BURGER: '.js-burger-content',
    DESKTOP_PANEL_SEACH: '.js-desktop-panel-search',
    MOBILE_PANEL_SEACRH: '.js-nav-search',
    CLOSE_BTN: '.js-mobile-close-menu',
    BURGER_CONTENT: '.js-login-box'
};

var PREFIX = {
    GSA: 'search-gsa'

    // COMPONENTS
};var burgerBtn,
    navPanelDesktop,
    navPanelMobile,
    panelSearch = null;
var domCache = void 0;

/*
    This function is used to initialized Desktop context for the navigation LHS
 */
function initHeaderLhsAuthDesktop() {
    panelSearch = new _searchPanel2.default(SELECTOR.DESKTOP_PANEL_SEACH, PREFIX.GSA, false);
    burgerBtn = new _burgerBtn2.default(SELECTOR.BURGER_BTN, SELECTOR.GLOBAL_BURGER, SELECTOR.CLOSE_BTN);
    burgerBtn.init();

    navPanelDesktop = new _navPanelDesktop2.default();
    navPanelDesktop.init();

    domCache = getDomCache(SELECTOR.HEADER_ROOT);
}

/*
    This function is used to initialized Mobile context for the navigation LHS
 */
function initHeaderLhsAuthMobile() {
    panelSearch = new _searchPanel2.default(SELECTOR.MOBILE_PANEL_SEACRH, PREFIX.GSA, true);
    burgerBtn = new _burgerBtn2.default(SELECTOR.BURGER_BTN, SELECTOR.GLOBAL_BURGER);
    burgerBtn.init();

    navPanelMobile = new _navPanelMobile2.default();
    navPanelMobile.init();

    domCache = getDomCache(SELECTOR.HEADER_ROOT);

    if (_market.MARKET.CODE === 1) {
        marginContent();
    }
}

function getDomCache(SelectorHeaderRoot) {
    return {
        headerRoot: document.querySelector(SelectorHeaderRoot)
    };
}

function marginContent() {
    var marginHead = domCache.headerRoot.clientHeight + 24;

    // Case with new classes rsp main
    var mainContent = document.querySelector(SELECTOR.MAIN_CONTENT);
    if (!mainContent) {
        mainContent = document.querySelector(SELECTOR.MAIN_CONTENT_RSP);
    }

    mainContent.style.marginTop = marginHead + "px";
}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _breakpointDispatcher = __webpack_require__(14);

var _breakpointDispatcher2 = _interopRequireDefault(_breakpointDispatcher);

var _marker = __webpack_require__(77);

var _onElementOut = __webpack_require__(78);

var _mainSearch = __webpack_require__(46);

var _stickyModule = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HeaderAuth = function () {
  function HeaderAuth($el) {
    var _this = this;

    _classCallCheck(this, HeaderAuth);

    this.root = $el;
    this.authState = "AUTH";
    this.header = (0, _jquery2.default)(".js-header-auth");
    this.menuBarItems = this.root.find(".js-menu_item");
    this.subMenuBarItems = this.root.find(".js-submenu_item.js-outside-dropdown");

    //this.subMenuBarSubItems = this.subMenuBarItems.find(".js-submenu_elt-not-in-dropdown");
    this.subMenuBarInDropItems = this.root.find(".js-submenu_item.js-submenu_elt-in-dropdown");

    this.SCROLL_STICKY_BASE = 230;
    this.INITIAL_MARKER_POS = 2000;
    this.INITIAL_2NDMARKER_POS = 0;
    this.INITIAL_3RDMARKER_POS = 0;
    this.INITIAL_3RDMARKER_POS_HIDE = 2000;

    this.initialActiveEntry = this.getInitialEntry();
    this.secondActive = this.getSecondEntry();
    this.thirdActive = this.getThirdEntry();

    this.lastActive = this.initialActiveEntry;

    var _createMarkers = this.createMarkers();

    var _createMarkers2 = _slicedToArray(_createMarkers, 3);

    this.marker = _createMarkers2[0];
    this.secondMarker = _createMarkers2[1];
    this.thirdMarker = _createMarkers2[2];


    if (this.initialActiveEntry) {
      this.marker.updateLastElementMarked(this.initialActiveEntry);

      this.marker.replayTranslate();
    }

    this.queryActiveSubList = this.root.find(".is-active .dcw_submenu-auth_list");
    this.queryActiveDropDownList = this.root.find(".is-active .dcw_dropdown_list");
    this.queryActiveSubMenu = this.root.find(".is-active .dcw_submenu-auth");

    if (this.queryActiveSubList.length > 0) {
      if (this.queryActiveSubList instanceof _jquery2.default) {
        this.activeSubList = this.queryActiveSubList[0];
      } else {
        this.activeSubList = this.queryActiveSubList;
      }
    }

    if (this.queryActiveDropDownList.length > 0) {
      if (this.queryActiveDropDownList instanceof _jquery2.default) {
        this.activeDropDownList = this.queryActiveDropDownList[0];
      } else {
        this.activeDropDownList = this.queryActiveDropDownList;
      }
    }

    if (this.queryActiveSubMenu.length > 0) {
      if (this.queryActiveSubMenu instanceof _jquery2.default) {
        this.activeSubMenu = this.queryActiveSubMenu[0];
      } else {
        this.activeSubMenu = this.queryActiveSubMenu;
      }
    }

    if (this.secondActive) {
      this.secondMarker.updateLastElementMarked(this.secondActive);

      setTimeout(function () {
        _this.secondMarker.replayTranslate(true, _this.INITIAL_2NDMARKER_POS);
      }, 300);
    }

    if (this.thirdActive) {
      this.thirdMarker.updateLastElementMarked(this.thirdActive);

      setTimeout(function () {
        _this.thirdMarker.replayTranslate(true, _this.INITIAL_3RDMARKER_POS);
      }, 300);
    }

    this.handleEvents();
    this.sticky = this.initStickyModule();
    this.mainSearch = this.createMainSearch();

    this.padContent();
  }

  _createClass(HeaderAuth, [{
    key: "destroy",
    value: function destroy() {
      this.sticky.destroy();
      this.mainSearch.destroy();
    }
  }, {
    key: "createMainSearch",
    value: function createMainSearch() {
      console.log("createMainSearch");
      return new _mainSearch.MainSearchAuth({
        $el: (0, _jquery2.default)(".js-main-search"),
        itemIdPrefix: "main-search"
      });
    }
  }, {
    key: "handleEvents",
    value: function handleEvents() {
      this.bindMarkerBoundsOut();
    }
  }, {
    key: "initStickyModule",
    value: function initStickyModule() {
      var _this2 = this;

      return (0, _stickyModule.stickyModule)({
        $el: null,
        stickyLimit: this.SCROLL_STICKY_BASE,
        enterSticky: function enterSticky() {
          requestAnimationFrame(function () {
            if (!_this2.initialActiveEntry) return;
          });
        },
        leaveSticky: function leaveSticky() {
          if (!_this2.initialActiveEntry) return;
        }
      });
    }
  }, {
    key: "bindMarkerBoundsOut",
    value: function bindMarkerBoundsOut() {
      var _this3 = this;

      (0, _onElementOut.onElementBoundsOut)(document.querySelector(".dcw_main-nav_list"), this.header[0], function () {
        if (_this3.lastActive) {
          return _this3.marker.translateTo(_this3.lastActive);
        }

        _this3.marker.translateAndHide(_this3.INITIAL_MARKER_POS);
      });

      if (this.secondMarker) {
        (0, _onElementOut.onElementBoundsOut)(this.activeSubList, this.activeSubMenu, function () {
          if (_this3.secondActive) {
            return _this3.secondMarker.translateTo(_this3.secondActive, false, _this3.INITIAL_2NDMARKER_POS);
          }

          _this3.secondMarker.translateAndHide(_this3.INITIAL_2NDMARKER_POS);
        });
      }

      if (this.thirdMarker) {
        (0, _onElementOut.onElementBoundsOut)(this.activeDropDownList, this.activeSubMenu, function () {
          if (_this3.thirdActive) {
            return _this3.thirdMarker.translateTo(_this3.thirdActive, false, _this3.INITIAL_3RDMARKER_POS);
          }

          _this3.thirdMarker.translateAndHide(_this3.INITIAL_3RDMARKER_POS_HIDE);
        });
      }
    }
  }, {
    key: "getInitialEntry",
    value: function getInitialEntry() {
      var initialActiveEntry = this.root.find(".js-menu_item.is-active").eq(0);

      if (!initialActiveEntry.length) {
        var menuItem = this.root.find('a[aria-current="true"]');
        initialActiveEntry = menuItem.length ? menuItem.parent() : null;
      }

      if (initialActiveEntry && initialActiveEntry.length > 0) {
        initialActiveEntry.addClass("is-active");
        return initialActiveEntry;
      }

      return null;
    }
  }, {
    key: "getSecondEntry",
    value: function getSecondEntry() {
      var secondEntry = void 0;

      if (!this.initialActiveEntry) return null;

      secondEntry = this.initialActiveEntry.find(".js-submenu_item.is-active");

      if (secondEntry && secondEntry.length > 0) {
        return secondEntry;
      } else {
        return null;
      }
    }
  }, {
    key: "getThirdEntry",
    value: function getThirdEntry() {
      var thirdEntry = void 0;

      if (!this.initialActiveEntry) return null;

      thirdEntry = this.initialActiveEntry.find(".js-submenu_elt-in-dropdown .is-active-in-dropdown");
      thirdEntry = thirdEntry.parent();

      if (thirdEntry && thirdEntry.length > 0) {
        return thirdEntry;
      } else {
        return null;
      }
    }
  }, {
    key: "padContent",
    value: function padContent() {
      var activeSubmenu = this.header.find(".js-menu_item.is-active > .dcw_submenu-auth");

      if (!activeSubmenu.length && this.shouldHaveVisibleTitle()) {
        activeSubmenu = this.header.find(".dcw_submenu-auth--persistent");
      }

      this.padContentBy(this.header.outerHeight() + activeSubmenu.outerHeight());
    }
  }, {
    key: "padContentBy",
    value: function padContentBy(value) {
      if (this.isUserTablet()) {
        (0, _jquery2.default)(".dcw_main").css("margin-top", value + "px");
      }
    }
  }, {
    key: "createMarkers",
    value: function createMarkers() {
      return [(0, _marker.marker)("VERTICAL", (0, _jquery2.default)(".js-marker").eq(0), this.menuBarItems, 96), (0, _marker.marker)("HORIZONTAL", (0, _jquery2.default)(".js-menu_item.is-active .js-submenu_item").eq(0).find(".js-marker"), this.subMenuBarItems), (0, _marker.marker)("HORIZ_Y", (0, _jquery2.default)(".js-menu_item.is-active .js-dropdown").eq(0).find(".js-marker"), this.subMenuBarInDropItems, 16)];
    }
  }, {
    key: "shouldHaveVisibleTitle",
    value: function shouldHaveVisibleTitle() {
      return (0, _jquery2.default)(".dcw_header--no-nav").length || (0, _jquery2.default)(".dcw_submenu-auth--persistent").length;
    }
  }, {
    key: "isUserTablet",
    value: function isUserTablet() {
      return (0, _jquery2.default)(window).width() < _breakpointDispatcher2.default.breakpoint.TABLET;
    }
  }]);

  return HeaderAuth;
}();

exports.default = HeaderAuth;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _pubSub = __webpack_require__(3);

var _pubSub2 = _interopRequireDefault(_pubSub);

var _eventBus = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Sidedrawer = function () {
  function Sidedrawer(headerSelector) {
    var _this = this;

    _classCallCheck(this, Sidedrawer);

    this.header = (0, _jquery2.default)(headerSelector);
    this.toggleBtn = (0, _jquery2.default)('.js-drawer-toggle');
    this.closeBtn = (0, _jquery2.default)('.js-drawer-close');
    this.sideDrawer = (0, _jquery2.default)('.js-sidedrawer');
    this.paneContainer = (0, _jquery2.default)('.js-sidedrawer_pane-container');
    this.paneItem = (0, _jquery2.default)('.js-sidedrawer_item');
    this.paneBackItem = (0, _jquery2.default)('.js-sidedrawer_back-item');
    this.mainContent = (0, _jquery2.default)('.dcw_main');
    this.loginBox = this.header.find('.dcw_login_wrapper-auth');
    this.handleScroll = this.handleTitleSticky;
    this.lastScroll = this.getScrollPos();
    this.headerTitleMask = (0, _jquery2.default)('.dcw_header-title_mask');
    this.headerTitle = (0, _jquery2.default)('.dcw_header-title').length > 0 ? (0, _jquery2.default)('.dcw_header-title') : null;

    this.paneIndex = (0, _jquery2.default)('.js-sidedrawer_item.has-popup.is-active').length;
    this.isSliding = false;
    this.lastActive = [];
    this.isMobile = false;
    this.hideTimeoutId = null;

    this.subHeaderAuth = this.getSubHeader(headerSelector);
    this.authState = this.subHeaderAuth ? 'AUTH' : 'NO_AUTH';

    this.classIsActive = "is-active";
    this.classIsOpen = "is-open";
    this.classIsBlured = "is-blurred";
    this.classIsSticky = "is-sticky";
    this.classIsStickyTitleHeader = ".js--stickyTitleHeader";
    this.classHasPopup = "has-popup";
    this.classJsNoSCroll = "js-no-scroll";

    this.applyDrawerContext();

    this.padContent(this.mainContent);

    if ((0, _jquery2.default)(window).width() <= 768) {
      this.slidePane();
    }

    if (this.subHeaderAuth) {
      this.sideDrawer.find('.js-sidedrawer_item').filter(function (index, el) {
        return (0, _jquery2.default)(el).hasClass(_this.classHasPopup);
      }).find('.dcw_main-nav_link').click(function (e) {
        return e.preventDefault();
      });
    }

    this.handleEvents();
    this.handleDrawerToggle();

    (0, _eventBus.subscribe)("cms:change-title", function (params) {
      _this.changeTitle(params.title);
    });
  }

  _createClass(Sidedrawer, [{
    key: 'destroy',
    value: function destroy() {
      this.resetPanePosition();
      this.unbindEvents();
      this.toggleBtn.off('click', this._toggleDrawerCallBack);
      this.closeBtn.off('click', this._toggleDrawerCallBack);
      _pubSub2.default.unsubscribe('login-search:toggle', this._loginSearchToggleCb);
    }
  }, {
    key: 'resetPanePosition',
    value: function resetPanePosition() {
      this.paneIndex = 0;
      this.slidePane();
    }
  }, {
    key: 'changeTitle',
    value: function changeTitle(newTitle) {
      this.headerTitle.text(newTitle);
    }
  }, {
    key: 'padContent',
    value: function padContent(contentContainer) {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.subHeaderAuth && contentContainer.css('margin-top', _this2.header.outerHeight() + _this2.subHeaderAuth.outerHeight() + 'px') || contentContainer.css('margin-top', _this2.header.outerHeight() + 'px');
      });
    }
  }, {
    key: 'getSubHeader',
    value: function getSubHeader(headerSelector) {
      return headerSelector === '.js-header-auth' ? this.header.find('.dcw_header-title') : null;
    }
  }, {
    key: 'applyDrawerContext',
    value: function applyDrawerContext() {
      var self = this;

      (0, _jquery2.default)('.js-sidedrawer_item.has-popup.is-active').each(function (i, item) {
        self.lastActive.push((0, _jquery2.default)(item));
      });
    }
  }, {
    key: 'handleEvents',
    value: function handleEvents() {
      var _this3 = this;

      this.paneItem.click(function (e) {
        return _this3.handleItemClick(e);
      });
      this.paneBackItem.click(function (e) {
        return _this3.handleBackItemClick(e);
      });
      this._loginSearchToggleCb = function () {
        return _this3.loginBox.toggleClass('is-expanded');
      };

      _pubSub2.default.subscribe('login-search:toggle', this._loginSearchToggleCb);

      return this.headerTitle && (0, _jquery2.default)(window).scroll(function (e) {
        _this3.handleScroll(e);
      });
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      this.paneItem.off('click', this.paneItemClick);
      this.paneBackItem.off('click', this.paneBackItemClick);
    }
  }, {
    key: 'handleDrawerToggle',
    value: function handleDrawerToggle() {
      var _this4 = this;

      this._toggleDrawerCallBack = function () {
        return _this4.toggleDrawer();
      };
      this.toggleBtn.click(function () {
        try {
          _this4.toggleFabVisibility();
        } catch (e) {
          console.error("Error while calling cmsAPI.fab", e);
        }
        _this4._toggleDrawerCallBack();
      });
      this.closeBtn.click(function () {
        _this4._toggleDrawerCallBack();
        try {
          _this4.showFab();
        } catch (e) {
          console.error("Error while calling cmsAPI.fab", e);
        }
      });
    }
  }, {
    key: 'toggleFabVisibility',
    value: function toggleFabVisibility() {
      if (this.sideDrawer.hasClass(this.classIsActive)) {
        this.showFab();
      } else {
        window.cmsAPI.fab.hide();
      }
    }
  }, {
    key: 'showFab',
    value: function showFab() {
      window.cmsAPI.fab.show();
    }
  }, {
    key: 'handleTitleSticky',
    value: function handleTitleSticky(e) {
      var _this5 = this;

      if (this.isScrollingDown()) {
        if (this.getScrollPos() < 74) return;

        requestAnimationFrame(function () {
          _this5.headerTitle.removeClass(_this5.classIsSticky);
          _this5.handleScroll = _this5.handleTitleHidden;
          _this5.hideTimeoutId = setTimeout(function () {
            _this5.headerTitleMask.css("display", "none");
          }, 200);
        });
      }

      this.lastScroll = this.getScrollPos();
    }
  }, {
    key: 'handleTitleHidden',
    value: function handleTitleHidden(e) {
      var _this6 = this;

      if (!this.isScrollingDown()) {
        this.cancelTimeout();
        this.headerTitleMask.css("display", "");
        var $titleHeaderArticle = (0, _jquery2.default)(this.classIsStickyTitleHeader);

        if ($titleHeaderArticle.length > 0) {
          if ((0, _jquery2.default)(window).scrollTop() < $titleHeaderArticle.offset().top - 100) {
            requestAnimationFrame(function () {
              _this6.headerTitle.addClass(_this6.classIsSticky);
              _this6.handleScroll = _this6.handleTitleSticky;
            });
          }
        } else {
          requestAnimationFrame(function () {
            _this6.headerTitle.addClass(_this6.classIsSticky);
            _this6.handleScroll = _this6.handleTitleSticky;
          });
        }
      }

      this.lastScroll = this.getScrollPos();
    }
  }, {
    key: 'cancelTimeout',
    value: function cancelTimeout() {
      if (!this.hideTimeoutId) return;
      clearTimeout(this.hideTimeoutId);
      this.hideTimeoutId = null;
    }
  }, {
    key: 'getScrollPos',
    value: function getScrollPos() {
      return (0, _jquery2.default)(window).scrollTop();
    }
  }, {
    key: 'isScrollingDown',
    value: function isScrollingDown() {
      return this.getScrollPos() > this.lastScroll;
    }
  }, {
    key: 'handleItemClick',
    value: function handleItemClick(e) {
      var target = (0, _jquery2.default)(e.currentTarget);
      e.stopPropagation();

      if (this.hasPopup(target) && !this.isActive(target) && !this.isSliding) {
        this.setLastActive(target);
        this.paneIndex++;
        this.slidePane();
      }
    }
  }, {
    key: 'handleBackItemClick',
    value: function handleBackItemClick(e) {
      e.stopPropagation();

      if (!this.isSliding) {
        this.paneIndex--;
        this.slideBack(this.removeLastActive);
      }
    }
  }, {
    key: 'handleResize',
    value: function handleResize() {
      var self = this;

      return function () {

        switch (self.isMobile) {

          case true:
            if ((0, _jquery2.default)(window).width() >= 768) {
              self.unbindEvents();
              self.isMobile = false;
              self.paneContainer.css('transform', 'translateX(0)');
            }
            break;

          case false:
            if ((0, _jquery2.default)(window).width() <= 768) {
              self.isMobile = true;
              self.handleEvents();
              self.slidePane();
            }
            break;
        }
      };
    }
  }, {
    key: 'toggleDrawer',
    value: function toggleDrawer() {
      this.isMobile = true;
      this.toggleBodyLock();
      this.sideDrawer.toggleClass(this.classIsActive);
      this.toggleBtn.toggleClass(this.classIsOpen);

      if (this.sideDrawer.hasClass(this.classIsActive)) {
        this.toggleBtn.attr("aria-label", window.cmsConstantsLabel.MOBILE_CLOSE_THE_MENU);
      } else {
        this.toggleBtn.attr("aria-label", window.cmsConstantsLabel.MOBILE_OPEN_THE_MENU);
      }
    }
  }, {
    key: 'toggleBodyLock',
    value: function toggleBodyLock() {
      (0, _jquery2.default)(document.body).toggleClass(this.classJsNoSCroll);
      (0, _jquery2.default)(document.documentElement).toggleClass(this.classJsNoSCroll);
      this.mainContent.toggleClass(this.classIsBlured);
    }
  }, {
    key: 'slidePane',
    value: function slidePane() {
      var transformValue = this.buildTransformValue();
      this.isSliding = true;

      this.resetOnAnimEnd();
      this.paneContainer.css('transform', transformValue);
    }
  }, {
    key: 'slideBack',
    value: function slideBack() {
      var _this7 = this;

      var transformValue = this.buildTransformValue();
      this.isSliding = true;

      this.resetOnAnimEnd(function () {
        return _this7.removeLastActive();
      });
      this.paneContainer.css('transform', transformValue);
    }
  }, {
    key: 'resetOnAnimEnd',
    value: function resetOnAnimEnd(callback) {
      var self = this;

      this.paneContainer.on('transitionend', function endCb() {
        self.paneContainer.off('transitionend', endCb);
        self.isSliding = false;

        return callback && callback();
      });
    }
  }, {
    key: 'hasPopup',
    value: function hasPopup(el) {
      return el.hasClass(this.classHasPopup);
    }
  }, {
    key: 'isActive',
    value: function isActive(el) {
      return el.hasClass(this.classIsActive);
    }
  }, {
    key: 'setLastActive',
    value: function setLastActive(el) {
      el.addClass(this.classIsActive);
      this.lastActive.push(el);
    }
  }, {
    key: 'removeLastActive',
    value: function removeLastActive() {
      var lastActive = this.lastActive.pop();
      lastActive.removeClass(this.classIsActive);
    }
  }, {
    key: 'buildTransformValue',
    value: function buildTransformValue() {
      return 'translateX(' + this.paneIndex * -100 + '%)';
    }
  }]);

  return Sidedrawer;
}();

exports.default = Sidedrawer;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TabBar = function () {
  function TabBar($el) {
    _classCallCheck(this, TabBar);

    this.tabBarBtn = $el.find('.js-tab-bar_btn');
    this.tabPaneCloseBtn = (0, _jquery2.default)('.js-tab-bar-pane_close');
    this.tabPanes = (0, _jquery2.default)('.js-tab-bar-pane');
    this.lastOpenPane = null;

    this.handleEvents();
  }

  _createClass(TabBar, [{
    key: 'handleEvents',
    value: function handleEvents() {
      var _this = this;

      this.tabBarBtn.click(function (e) {
        var targetPane = _this.getPane(e.currentTarget);

        if (_this.lastOpenPane && _this.lastOpenPane[0] === targetPane[0]) return;

        if (_this.lastOpenPane && _this.lastOpenPane[0] !== targetPane[0]) {
          _this.unsetActiveTab();
          _this.setActiveTab(e.currentTarget);
          _this.hidePane();
          setTimeout(function () {
            _this.showPane(targetPane);
            _this.lastOpenPane = targetPane;
          }, 300);
        }

        if (!_this.lastOpenPane) {
          _this.setActiveTab(e.currentTarget);
          _this.showPane(targetPane);
          _this.lastOpenPane = targetPane;
        }
      });

      this.tabPaneCloseBtn.click(function (e) {
        _this.hidePane();
        _this.unsetActiveTab();
        _this.lastOpenPane = null;
      });
    }
  }, {
    key: 'showPane',
    value: function showPane(targetPane) {
      targetPane.addClass('is-open');
    }
  }, {
    key: 'hidePane',
    value: function hidePane() {
      return this.lastOpenPane && this.lastOpenPane.removeClass('is-open');
    }
  }, {
    key: 'setActiveTab',
    value: function setActiveTab(tabActive) {
      (0, _jquery2.default)(tabActive).addClass('is-active');
    }
  }, {
    key: 'unsetActiveTab',
    value: function unsetActiveTab() {
      this.tabBarBtn.filter('.is-active').removeClass('is-active');
    }
  }, {
    key: 'getPane',
    value: function getPane(tabActive) {
      return this.tabPanes.filter(this.getPaneIdFrom(tabActive));
    }
  }, {
    key: 'getPaneIdFrom',
    value: function getPaneIdFrom(tabActive) {
      return '#' + tabActive.getAttribute('aria-controls');
    }
  }]);

  return TabBar;
}();

exports.default = TabBar;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _hammerjs = __webpack_require__(83);

var _hammerjs2 = _interopRequireDefault(_hammerjs);

var _pubSub = __webpack_require__(3);

var _pubSub2 = _interopRequireDefault(_pubSub);

var _breakpointDispatcher = __webpack_require__(14);

var _breakpointDispatcher2 = _interopRequireDefault(_breakpointDispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Slider = function () {
  function Slider(el) {
    _classCallCheck(this, Slider);

    _breakpointDispatcher2.default.start();
    var self = this;

    this.slider = el;
    this.pane = el.find('.js-slider-pane');
    this.paneItems = el.find('.js-slider-item');
    this.prevBtn = el.find('.js-slider-prev');
    this.nextBtn = el.find('.js-slider-next');
    this.dots = el.find('.js-slider-dot');
    this.hammerEvent = new _hammerjs2.default(el[0]);

    this.dir = {
      LEFT: 1,
      RIGHT: -1
    };

    this.MOBILE_ITEMS = 1;
    this.DESKTOP_ITEMS = this.getNumOfItems();

    this.index = 0;
    this.prevItems = 0;
    this.nextItems = this.paneItems.length - this.getNumOfVisibleItems();

    this.init();
  }

  _createClass(Slider, [{
    key: 'init',
    value: function init() {
      var self = this;

      _pubSub2.default.subscribe('resize:desktop', function () {
        self.resetPositions();
      });

      _pubSub2.default.subscribe('resize:tablet', function () {
        self.resetPositions();
      });

      _pubSub2.default.subscribe('resize:mobile', function () {
        self.resetPositions();
      });

      this.setArrowState();
      this.handleArrowClick(self);
      this.handleSwipe(self);
    }
  }, {
    key: 'getNumOfItems',
    value: function getNumOfItems() {
      var numOfItems = this.slider.attr('data-slider-items');

      if (numOfItems) {
        return Number(numOfItems);
      }

      return 3;
    }
  }, {
    key: 'resetPositions',
    value: function resetPositions() {
      this.index = 0;
      this.prevItems = 0;
      this.nextItems = this.paneItems.length - this.getNumOfVisibleItems();
      this.applyTransformation(0);
      this.setArrowState();
      this.updateDot();
    }
  }, {
    key: 'handleArrowClick',
    value: function handleArrowClick(self) {
      this.nextBtn.click(function () {
        self.slidePane(self.getNextItems(), self.dir.LEFT);
      });

      this.prevBtn.click(function () {
        self.slidePane(self.getPrevItems(), self.dir.RIGHT);
      });
    }
  }, {
    key: 'handleSwipe',
    value: function handleSwipe(self) {
      this.hammerEvent.on('swipe', function (e) {
        if (e.deltaX < 0) {
          self.slidePane(self.getNextItems(), self.dir.LEFT);
        } else {
          self.slidePane(self.getPrevItems(), self.dir.RIGHT);
        }
      });
    }
  }, {
    key: 'slidePane',
    value: function slidePane(value, direction) {
      this.update(value, direction);

      this.applyTransformation(this.getTranslationValue());

      this.setArrowState();
      this.updateDot();
    }
  }, {
    key: 'setArrowState',
    value: function setArrowState() {
      if (this.nextItems === 0) {
        this.nextBtn.addClass('is-hidden');
      } else {
        this.nextBtn.removeClass('is-hidden');
      }

      if (this.prevItems === 0) {
        this.prevBtn.addClass('is-hidden');
      } else {
        this.prevBtn.removeClass('is-hidden');
      }
    }
  }, {
    key: 'applyTransformation',
    value: function applyTransformation(value) {
      this.pane.css('transform', 'translate3d(' + value + '%, 0, 0)');
    }
  }, {
    key: 'update',
    value: function update(value, direction) {
      this.nextItems -= value * direction;
      this.prevItems += value * direction;
      this.index += value * direction;
    }
  }, {
    key: 'updateDot',
    value: function updateDot() {
      this.dots.filter('.is-active').removeClass('is-active');
      this.dots.eq(this.index).addClass('is-active');
    }
  }, {
    key: 'getNextItems',
    value: function getNextItems() {
      return this.clamp(this.nextItems, 0, this.getNumOfVisibleItems());
    }
  }, {
    key: 'getPrevItems',
    value: function getPrevItems() {
      return this.clamp(this.prevItems, 0, this.getNumOfVisibleItems());
    }
  }, {
    key: 'getNumOfVisibleItems',
    value: function getNumOfVisibleItems() {
      var windowSize = (0, _jquery2.default)(window).width();

      if (windowSize < 768) {
        return this.MOBILE_ITEMS;
      } else if (windowSize <= 1024) {
        return this.DESKTOP_ITEMS - 1;
      } else if (windowSize > 1024) {
        return this.DESKTOP_ITEMS;
      }
    }
  }, {
    key: 'getTranslationValue',
    value: function getTranslationValue() {
      var windowSize = (0, _jquery2.default)(window).width();

      if (windowSize < 768) {
        return this.index * -90 / this.MOBILE_ITEMS;
      } else if (windowSize <= 1024) {
        return this.index * -(46 * (this.DESKTOP_ITEMS - 1)) / (this.DESKTOP_ITEMS - 1);
      } else if (windowSize > 1024) {
        return this.index * -100 / this.DESKTOP_ITEMS;
      }
    }
  }, {
    key: 'clamp',
    value: function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }
  }]);

  return Slider;
}();

exports.default = Slider;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tablist = function () {
    function Tablist(el) {
        _classCallCheck(this, Tablist);

        this.tablist = el;
        this.tabs = this.tablist.find('.js-tab');
        this.panes = this.tablist.find('.js-pane');
        this.setActiveTab();
        this.activePane = this.panes.filter('.is-active');
        this.activeTab = this.tabs.filter('.is-active');

        this.handleEvents();

        // quick fix - to handle in the handlebars template cms side
        this.removeEmptyLegals(el);
    }

    _createClass(Tablist, [{
        key: 'removeEmptyLegals',
        value: function removeEmptyLegals(el) {
            this.panes.each(function (i, pane) {
                var legals = (0, _jquery2.default)(pane).find('.dcw_legals');

                if (legals && legals.find('.dcw_legals_text').length < 1) {
                    legals.remove();
                }
            });
        }
    }, {
        key: 'setActiveTab',
        value: function setActiveTab() {
            this.setActiveTabFromId(this.buildIdFromHash(window.location.hash));
        }
    }, {
        key: 'setScrollTop',
        value: function setScrollTop() {
            (0, _jquery2.default)(window).on('beforeunload', function () {
                (0, _jquery2.default)(window).scrollTop((0, _jquery2.default)('.dcw_banner-heading_desc').offset().top);
            });
        }
    }, {
        key: 'setActiveTabFromId',
        value: function setActiveTabFromId(tabId) {
            var tab = [];
            var tabId = tabId === '' ? this.tabs.eq(0) : tabId;

            var format = /[ !@$%^&*()+=\[\]{};':"\\|,.<>\/?]/;

            if (!format.test(tabId)) {
                tab = this.tablist.find(tabId);
            }

            if (tab.length === 0) {
                tab = this.tabs.eq(0);
            } else {
                this.setScrollTop();
            }

            tab.addClass('is-active');
            tab.find('button').attr('aria-expanded', 'true');

            (0, _jquery2.default)('#' + tab.find('button').attr('aria-controls')).addClass('is-active');
        }
    }, {
        key: 'handleEvents',
        value: function handleEvents() {
            var self = this;
            this.tabs.click(this.showPane(self));
        }
    }, {
        key: 'showPane',
        value: function showPane(self) {
            return function (e) {
                var newTab = (0, _jquery2.default)(this),
                    newHash = newTab.attr('id');

                self.changeActiveTab(self, newTab);
                self.updateUrlHash(newHash);
            };
        }
    }, {
        key: 'updateUrlHash',
        value: function updateUrlHash(tabId) {
            window.location.hash = this.buildHashName(tabId);
        }
    }, {
        key: 'buildHashName',
        value: function buildHashName(id) {
            return '#' + id.split('-').slice(2).join('-');
        }
    }, {
        key: 'buildIdFromHash',
        value: function buildIdFromHash(hash) {
            return hash != '' ? '#' + 'dcw-tab-' + hash.slice(1) || null : '';
        }
    }, {
        key: 'changeActiveTab',
        value: function changeActiveTab(self, newTab) {
            var tabBtn = newTab.find('button');
            var pane = self.getControlPane(tabBtn);

            newTab.addClass('is-active');
            tabBtn.attr('aria-expanded', 'true');
            self.activeTab.removeClass('is-active');
            self.activeTab.find('button').attr('aria-expanded', 'false');

            self.onTransitionEnd(self.activePane, function () {
                self.activePane.removeClass('is-active-remove');
                self.activePane.removeClass('is-active');

                pane.addClass('is-active-add');
                setTimeout(function () {
                    pane.addClass('is-active');
                    pane.removeClass('is-active-add');
                }, 30);

                self.activePane = pane;
                self.activeTab = newTab;
            });

            self.activePane.addClass('is-active-remove');
        }
    }, {
        key: 'getControlPane',
        value: function getControlPane(tab) {
            return this.tablist.find('#' + tab.attr('aria-controls'));
        }
    }, {
        key: 'onTransitionEnd',
        value: function onTransitionEnd(element, onTransitionEndCallBack) {
            element.on('transitionend', function () {
                element.off('transitionend');
                onTransitionEndCallBack();
            });
        }
    }]);

    return Tablist;
}();

exports.default = Tablist;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AccordionCard = function () {
  function AccordionCard(el) {
    _classCallCheck(this, AccordionCard);

    this.accordion = el;
    this.toggleLink = this.accordion.find('.js-toggle');
    this.isOpen = false;

    this.handleEvents();
  }

  _createClass(AccordionCard, [{
    key: 'handleEvents',
    value: function handleEvents() {
      var self = this;

      this.toggleLink.click(this.toggleCard(self));
    }
  }, {
    key: 'toggleCard',
    value: function toggleCard(self) {
      return function (e) {
        e.preventDefault();
        self.accordion.toggleClass('is-open');
        self.switchLinkContent();
      };
    }
  }, {
    key: 'switchLinkContent',
    value: function switchLinkContent() {
      switch (this.isOpen) {
        case false:
          this.toggleLink.html('Fermer la formule');
          this.isOpen = true;
          break;
        case true:
          this.toggleLink.html('Voir la formule');
          this.isOpen = false;
          break;
      }
    }
  }]);

  return AccordionCard;
}();

exports.default = AccordionCard;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _pubSub = __webpack_require__(3);

var _pubSub2 = _interopRequireDefault(_pubSub);

var _breakpointDispatcher = __webpack_require__(14);

var _breakpointDispatcher2 = _interopRequireDefault(_breakpointDispatcher);

var _smoothScroll = __webpack_require__(24);

var _smoothScroll2 = _interopRequireDefault(_smoothScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScrollSlider = function () {
  function ScrollSlider(el) {
    _classCallCheck(this, ScrollSlider);

    this.el = el;
    this.sliderItem = (0, _jquery2.default)('.js-scroll-slider_item');
    this.sliderPanes = (0, _jquery2.default)('.js-scroll-slider_pane');

    this.imgUrls = this.getImagesUrl();
    this.lastScrollPos = 0;
    this.currentPaneIndex = 0;
    this.isFading = false;
    this.NUM_OF_IMAGES = this.imgUrls.length - 1;
    this.START_POSITION = 0;

    this.createSliderDots(this.sliderPanes.length);
    this.sliderDots = (0, _jquery2.default)('.js-scroll-slider_dot');

    this.handleScroll = this.handleScrollOffer;

    this.init();
  }

  _createClass(ScrollSlider, [{
    key: 'init',
    value: function init() {
      var self = this;

      _breakpointDispatcher2.default.start();

      _pubSub2.default.subscribe('resize', function () {
        if ((0, _jquery2.default)(window).width() < 768) return;

        self.imagesCoords = self.buildImgCoords(self.imgUrls);
        self.setInitialPosition(false);
      });

      _pubSub2.default.subscribe('resize:mobile', function () {
        self.unBindScrollEvent();
      });

      _pubSub2.default.subscribe('resize:desktop', function () {
        self.imagesCoords = self.buildImgCoords(self.imgUrls);
        self.setInitialPosition(true);
        self.handleEvents();
      });

      if (_breakpointDispatcher2.default.getState() === _breakpointDispatcher2.default.breakpoint.DESKTOP) {
        setTimeout(function () {
          self.imagesCoords = self.buildImgCoords(self.imgUrls);
          self.setInitialPosition(true);
          self.handleEvents();
        }, 300);
      }
    }
  }, {
    key: 'createSliderDots',
    value: function createSliderDots(numOfDots) {
      var dotHTML = '';

      for (var i = 0; i < numOfDots; i++) {
        if (i === 0) {
          dotHTML += '<li class="js-scroll-slider_dot is-active"></li>';
        } else {
          dotHTML += '<li class="js-scroll-slider_dot"></li>';
        }
      }

      (0, _jquery2.default)('.js-scroll-slider_dots').html(dotHTML);
    }
  }, {
    key: 'getImagesUrl',
    value: function getImagesUrl() {
      return [].slice.call((0, _jquery2.default)('.js-scroll-slider_image')).map(function (img) {
        return img.getAttribute('data-src');
      });
    }
  }, {
    key: 'setInitialPosition',
    value: function setInitialPosition(hasToChangePane) {
      this.START_POSITION = this.imagesCoords[0].start;

      var currentPos = (0, _jquery2.default)(window).scrollTop() + this.START_POSITION,
          imagesCoords = this.imagesCoords,
          lastIndex = this.currentPaneIndex;

      for (var i = 0; i < imagesCoords.length; i++) {
        if (currentPos > imagesCoords[i].start && currentPos < imagesCoords[i].end) {

          if (i === 0) return;

          this.currentPaneIndex = i;
          this.updateActiveDot(lastIndex, i);
          this.updateSliderPosition();

          return hasToChangePane && this.changePane();
        }
      }
    }
  }, {
    key: 'unBindScrollEvent',
    value: function unBindScrollEvent() {
      (0, _jquery2.default)(document).off('scroll', this.handleScrollCallBack);
    }
  }, {
    key: 'handleEvents',
    value: function handleEvents() {
      var _this = this;

      var self = this;

      this.handleScrollCallBack = handleScrollCallBack;

      (0, _jquery2.default)(document).scroll(handleScrollCallBack);

      this.sliderDots.click(function (e) {
        return _this.handleDotsClick(e);
      });

      function handleScrollCallBack(scrollEvent) {
        self.handleScroll(scrollEvent);
      }
    }
  }, {
    key: 'handleDotsClick',
    value: function handleDotsClick(e) {
      var offset = this.imagesCoords[this.sliderDots.index(e.target)].start;

      _smoothScroll2.default.scrollTo(offset);
    }
  }, {
    key: 'handleScrollOffer',
    value: function handleScrollOffer() {
      var currentPos = (0, _jquery2.default)(window).scrollTop() + this.START_POSITION;

      switch (this.isScrollDown()) {
        case true:
          if (this.hasToGetNextPane(currentPos)) {
            this.updateActiveDot(this.currentPaneIndex, this.incrementIndex());

            this.currentPaneIndex = this.incrementIndex();
            this.changePane();
            this.updateSliderPosition();
          }
          break;

        case false:
          if (this.hasToGetPrevPane(currentPos)) {
            this.updateActiveDot(this.currentPaneIndex, this.decrementIndex());
            this.currentPaneIndex = this.decrementIndex();
            this.changePane();
            this.updateSliderPosition();
          }
          break;
      }
    }
  }, {
    key: 'changePane',
    value: function changePane() {
      this.applyTransition(this.updateBackgroundImage);
    }
  }, {
    key: 'updateSliderPosition',
    value: function updateSliderPosition() {
      var topPos = this.getCurrentPane().start - 150;

      this.el.css('transform', 'translate3d(-50%,' + topPos + 'px, 0)');
    }
  }, {
    key: 'applyTransition',
    value: function applyTransition(callback) {
      var self = this;

      if (this.isFading) return;
      this.isFading = true;

      this.sliderItem.on('transitionend', function transitionEndCb() {
        self.isFading = false;
        self.sliderItem.off('transitionend', transitionEndCb);

        callback.call(self);
        self.sliderItem.addClass('is-active');
      });

      this.sliderItem.removeClass('is-active');
    }
  }, {
    key: 'updateBackgroundImage',
    value: function updateBackgroundImage() {
      this.sliderItem.attr('src', this.getCurrentPane().imgUrl);
    }
  }, {
    key: 'updateActiveDot',
    value: function updateActiveDot(oldIndex, newIndex) {
      if (oldIndex === newIndex) return;

      this.sliderDots.eq(newIndex).addClass('is-active');
      this.sliderDots.eq(oldIndex).removeClass('is-active');
    }
  }, {
    key: 'hasToGetNextPane',
    value: function hasToGetNextPane(currentPos) {
      return this.currentPaneIndex < this.NUM_OF_IMAGES && currentPos > this.getCurrentPane().end;
    }
  }, {
    key: 'hasToGetPrevPane',
    value: function hasToGetPrevPane(currentPos) {
      return this.currentPaneIndex !== 0 && currentPos < this.getPrevPane().end;
    }
  }, {
    key: 'getCurrentPane',
    value: function getCurrentPane() {
      return this.imagesCoords[this.currentPaneIndex];
    }
  }, {
    key: 'getPrevPane',
    value: function getPrevPane() {
      return this.imagesCoords[Math.max(0, this.currentPaneIndex - 1)];
    }
  }, {
    key: 'buildImgCoords',
    value: function buildImgCoords(urls) {
      return [].map.call(this.sliderPanes, function (pane, i) {
        return {
          start: (0, _jquery2.default)(pane).offset().top,
          end: (0, _jquery2.default)(pane).offset().top + (0, _jquery2.default)(pane).outerHeight(),
          imgUrl: urls[i]
        };
      });
    }
  }, {
    key: 'isScrollDown',
    value: function isScrollDown() {
      var isScrollingDown = (0, _jquery2.default)(window).scrollTop() > this.lastScrollPos ? true : false;

      this.lastScrollPos = (0, _jquery2.default)(window).scrollTop();

      return isScrollingDown;
    }
  }, {
    key: 'incrementIndex',
    value: function incrementIndex() {
      return Math.min(this.NUM_OF_IMAGES, this.currentPaneIndex + 1);
    }
  }, {
    key: 'decrementIndex',
    value: function decrementIndex() {
      return Math.max(0, this.currentPaneIndex - 1);
    }
  }, {
    key: 'getWindowTopPosition',
    value: function getWindowTopPosition() {
      return (0, _jquery2.default)(window).scrollTop();
    }
  }]);

  return ScrollSlider;
}();

exports.default = ScrollSlider;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _helpers = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ATTR_ARIA_EXPANDED = 'aria-expanded';
var ARIA_EXPANDED_TRUE = 'true';
var ARIA_EXPANDED_FALSE = 'false';

var FilterList = function () {
  function FilterList(el) {
    _classCallCheck(this, FilterList);

    this.filterList = el;
    this.allActiveBtn = el.find('.js-filter-list-btn-all');
    this.filterBtn = el.find('.js-filter-list-btn');
    this.filterCard = el.find('.js-filter-list-card');
    this.showMoreLink = el.find('.js-filter-list-more');
    this.numOfActive = 0;
    this.CARDS_BY_STEP = 5;
    this.hiddenCardIndex = this.CARDS_BY_STEP;
    this.visibleFilter = null;
    this.lastActiveFilterBtn = null;
    this.lastActiveCategory = null;

    //this.setCategories(this.filterBtn);
    var categories = this.getCategories(this.filterBtn);
    //this.applyRandCategories(this.filterCard);
    this.categoryMap = this.buildCategoryMap(categories);
    this.setNumOfElementsByCategory(this.categoryMap);

    this.handleEvents();

    if (this.allActiveBtn.hasClass("is-active")) {
      this.lastActiveFilterBtn = this.allActiveBtn;
    }

    if (this.isMobile()) {
      this.handleMaxOfCardsShown(true);
    }
  }

  _createClass(FilterList, [{
    key: 'isMobile',
    value: function isMobile() {
      return (0, _jquery2.default)(window).width() <= 768;
    }
  }, {
    key: 'buildCategoryMap',
    value: function buildCategoryMap(categories) {
      var _this = this;

      var categoryMap = {};

      categories.forEach(function (categoryName) {
        categoryMap[categoryName] = {
          elements: _this.getElementsOfCategory(categoryName),
          active: false
        };
      });

      return categoryMap;
    }
  }, {
    key: 'setNumOfElementsByCategory',
    value: function setNumOfElementsByCategory(categoryMap) {
      var total = 0;
      for (var category in categoryMap) {
        var len = categoryMap[category].elements.length;
        total += len;

        if (len === 0) {
          this.filterBtn.filter('[data-category=' + category + ']').css('display', 'none');
        } else {
          this.filterBtn.filter('[data-category=' + category + ']').find('span').html('(' + len + ')');
        }
      }

      this.allActiveBtn.find('span').html('(' + this.filterCard.length + ')');
    }
  }, {
    key: 'getElementsOfCategory',
    value: function getElementsOfCategory(categoryName) {
      var cards = this.filterList.find('.js-filter-list-card'),
          categoryCards = [];

      cards.each(function (i, card) {
        var regexp = new RegExp(categoryName + "(?=\\s+|$)");

        if (regexp.test((0, _jquery2.default)(card).attr('data-category'))) {
          categoryCards.push(card);
        }
      });

      return categoryCards;
    }
  }, {
    key: 'handleEvents',
    value: function handleEvents() {
      var self = this;

      if ((0, _jquery2.default)(window).width() >= 768) {
        this.filterBtn.click(this.filterCards(self));
      } else {
        this.filterBtn.click(this.filterMobileCards(self));

        this.showMoreLink.click(this.showMoreCards(self));

        this.handleMaxOfCardsShown();
      }

      this.allActiveBtn.click(this.handleAllActiveBtn(self));
    }
  }, {
    key: 'handleAllActiveBtn',
    value: function handleAllActiveBtn(self) {
      return function () {
        (0, _jquery2.default)(this).addClass('is-active');
        (0, _jquery2.default)(this).attr(ATTR_ARIA_EXPANDED, ARIA_EXPANDED_TRUE);
        self.unsetActiveCategory();
        self.setAllActiveFilter();
        self.resetHiddenIndex();
        self.handleMaxOfCardsShown(true);
        self.lastActiveFilterBtn = self.allActiveBtn;
        self.lastActiveCategory = null;
      };
    }
  }, {
    key: 'filterCards',
    value: function filterCards(self) {
      return function () {
        self.toggleActiveState((0, _jquery2.default)(this));
        self.toggleCategory((0, _jquery2.default)(this).attr('data-category'));
      };
    }
  }, {
    key: 'filterMobileCards',
    value: function filterMobileCards(self) {
      return function () {
        self.toggleActiveState((0, _jquery2.default)(this));
        self.toggleCategory((0, _jquery2.default)(this).attr('data-category'));
        self.handleMaxOfCardsShown();
      };
    }
  }, {
    key: 'toggleActiveState',
    value: function toggleActiveState(filterBtn) {
      if (this.lastActiveFilterBtn) {
        this.lastActiveFilterBtn.attr(ATTR_ARIA_EXPANDED, ARIA_EXPANDED_FALSE);
        this.lastActiveFilterBtn.removeClass('is-active');
        if (this.lastActiveFilterBtn === this.allActiveBtn) {
          this.filterList.removeClass('all-visible');
        }
      }
      filterBtn.attr(ATTR_ARIA_EXPANDED, ARIA_EXPANDED_TRUE);
      filterBtn.toggleClass('is-active');
      this.lastActiveFilterBtn = filterBtn;
    }
  }, {
    key: 'toggleCategory',
    value: function toggleCategory(categoryName) {
      if (this.allActiveBtn.hasClass('is-active')) {
        this.unsetAllActiveFilter();
      }

      this.resetHiddenIndex();
      this.hideCardsOfLastActiveCategory();
      this.showCardsOfCategory(categoryName);
      this.lastActiveCategory = categoryName;
    }
  }, {
    key: 'showCardsOfCategory',
    value: function showCardsOfCategory(categoryName) {
      this.categoryMap[categoryName].elements.sort(function (a, b) {
        var categoryIndex = categoryName.replace('category-', '');

        var indexA = a.dataset["category_order_" + categoryIndex];
        var indexB = b.dataset["category_order_" + categoryIndex];
        return indexB - indexA;
      });

      this.categoryMap[categoryName].elements.forEach(function (filterCard) {
        (0, _jquery2.default)(filterCard).prependTo('.js-filter-list .dcw_grid');
        (0, _jquery2.default)(filterCard).addClass('is-visible');
      });
    }
  }, {
    key: 'hideCardsOfLastActiveCategory',
    value: function hideCardsOfLastActiveCategory() {
      return this.lastActiveCategory && this.categoryMap[this.lastActiveCategory].elements.forEach(function (filterCard) {
        (0, _jquery2.default)(filterCard).removeClass('is-visible');
      });
    }
  }, {
    key: 'handleMaxOfCardsShown',
    value: function handleMaxOfCardsShown(isAllFilter) {
      var cardsVisible = isAllFilter ? this.filterCard : this.filterCard.filter('.is-visible');

      if (this.hasMoreThanMaxOfCards(cardsVisible)) {
        this.showShowMoreLink();
        this.hideRemainingCards(cardsVisible);
      } else {
        this.resetHiddenIndex();
        this.hideShowMoreLink();
      }
    }
  }, {
    key: 'hasMoreThanMaxOfCards',
    value: function hasMoreThanMaxOfCards(cardsVisible) {
      return cardsVisible.length - this.hiddenCardIndex > 0;
    }
  }, {
    key: 'allCardsShownForCategory',
    value: function allCardsShownForCategory() {
      if (this.lastActiveCategory) {
        return this.categoryMap[this.lastActiveCategory].elements.length === this.hiddenCardIndex;
      }

      return this.filterCard.length === this.hiddenCardIndex;
    }
  }, {
    key: 'hideRemainingCards',
    value: function hideRemainingCards(cards) {
      (0, _jquery2.default)(cards).eq(this.hiddenCardIndex - 1).addClass('is-last-visible');
    }
  }, {
    key: 'showMoreCards',
    value: function showMoreCards(self) {
      return function (e) {
        e.preventDefault();

        var cardsVisible = self.filterCard.filter('.is-visible').length === 0 ? self.filterCard : self.filterCard.filter('.is-visible'),
            hiddenCardIndex = self.hiddenCardIndex + Math.min(self.CARDS_BY_STEP, cardsVisible.length - self.hiddenCardIndex);

        cardsVisible.eq(self.hiddenCardIndex - 1).removeClass('is-last-visible');
        cardsVisible.eq(hiddenCardIndex - 1).addClass('is-last-visible');

        self.hiddenCardIndex = hiddenCardIndex;

        if (self.allCardsShownForCategory()) {
          self.hideShowMoreLink();
        }
      };
    }
  }, {
    key: 'resetHiddenIndex',
    value: function resetHiddenIndex() {
      this.filterCard.filter('.is-last-visible').removeClass('is-last-visible');
      this.hiddenCardIndex = this.CARDS_BY_STEP;
    }
  }, {
    key: 'showShowMoreLink',
    value: function showShowMoreLink() {
      this.showMoreLink.removeClass('is-hidden');
    }
  }, {
    key: 'hideShowMoreLink',
    value: function hideShowMoreLink() {
      this.showMoreLink.addClass('is-hidden');
    }
  }, {
    key: 'updateNumOfActive',
    value: function updateNumOfActive(isActive) {
      return isActive ? ++this.numOfActive : --this.numOfActive;
    }
  }, {
    key: 'getCategories',
    value: function getCategories() {
      return [].map.call(this.filterBtn, function (btn) {
        return (0, _jquery2.default)(btn).attr('data-category');
      });
    }
  }, {
    key: 'setAllActiveFilter',
    value: function setAllActiveFilter() {
      this.allActiveBtn.addClass('is-active');
      this.filterList.addClass('all-visible');
    }
  }, {
    key: 'unsetAllActiveFilter',
    value: function unsetAllActiveFilter() {
      this.allActiveBtn.removeClass('is-active');
      this.filterList.removeClass('all-visible');
    }
  }, {
    key: 'unsetActiveCategory',
    value: function unsetActiveCategory() {
      this.filterBtn.filter('.is-active').attr(ATTR_ARIA_EXPANDED, ARIA_EXPANDED_FALSE).removeClass('is-active');

      this.categoryMap[this.lastActiveCategory].elements.forEach(function (categoryElement) {
        (0, _jquery2.default)(categoryElement).removeClass('is-visible');
      });
    }
  }]);

  return FilterList;
}();

exports.default = FilterList;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Lightbox = function () {
  function Lightbox(el) {
    _classCallCheck(this, Lightbox);

    this.el = el;
    this.lightBoxSrc = (0, _jquery2.default)('.js-lightbox_src');
    this.lightBoxVideoContainer = (0, _jquery2.default)('.js-lightbox_video-container');
    this.lightBoxVideoSrc = (0, _jquery2.default)('.js-lightbox_video-src');
    this.lightBoxDest = el.find('.js-lightbox_img');

    this.handleEvents();
  }

  _createClass(Lightbox, [{
    key: 'handleEvents',
    value: function handleEvents() {
      var _this = this;

      var self = this;

      this.lightBoxDest.click(function (e) {
        return e.stopPropagation();
      });
      this.lightBoxSrc.click(this.openLightBoxWithImage(self));
      this.lightBoxVideoSrc.click(this.openLightBoxWithVideo(self));
      this.el.click(function () {
        _this.toggleLightbox();
        _this.removeVideo();
      });
    }
  }, {
    key: 'openLightBoxWithImage',
    value: function openLightBoxWithImage(self) {
      return function (e) {
        self.insertImageFrom(e.target);
        self.insertAltDescription(e.target);
        self.toggleLightbox();
      };
    }
  }, {
    key: 'openLightBoxWithVideo',
    value: function openLightBoxWithVideo(self) {
      return function (e) {
        self.insertVideoFrom(e.target);
        self.toggleLightbox();
      };
    }
  }, {
    key: 'insertImageFrom',
    value: function insertImageFrom(imgClicked) {
      this.lightBoxDest.attr('src', (0, _jquery2.default)(imgClicked).attr('data-src')).show();

      this.lightBoxVideoContainer.hide();
    }
  }, {
    key: 'insertVideoFrom',
    value: function insertVideoFrom(imgClicked) {
      this.lightBoxVideoContainer.html(this.getIframeFragment(imgClicked));

      this.lightBoxDest.hide();
      this.lightBoxVideoContainer.show();
    }
  }, {
    key: 'getIframeFragment',
    value: function getIframeFragment(element) {
      var iFrameRef = (0, _jquery2.default)(element).attr('data-video-ref');

      return (0, _jquery2.default)('[data-ref=' + iFrameRef + ']').html();
    }
  }, {
    key: 'removeVideo',
    value: function removeVideo() {
      this.lightBoxVideoContainer.html('');
    }
  }, {
    key: 'insertAltDescription',
    value: function insertAltDescription(imgClicked) {
      this.lightBoxDest.attr('alt', (0, _jquery2.default)(imgClicked).attr('data-src-alt'));
    }
  }, {
    key: 'toggleLightbox',
    value: function toggleLightbox() {
      this.el.toggleClass('is-opened');
    }
  }]);

  return Lightbox;
}();

exports.default = Lightbox;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _pubSub = __webpack_require__(3);

var _pubSub2 = _interopRequireDefault(_pubSub);

var _breakpointDispatcher = __webpack_require__(14);

var _breakpointDispatcher2 = _interopRequireDefault(_breakpointDispatcher);

var _smoothScroll = __webpack_require__(24);

var _smoothScroll2 = _interopRequireDefault(_smoothScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MOBILE_HEADER_HEIGHT = 50;
var MOBILE_TOC_PAD = 0;

var SELECTORS = {
    TOC_WRAPPER: ".js-toc_links-wrapper",
    TOC_LIST: ".js-toc_list",
    TOC_ITEM: ".js-toc_item",
    TOC_ARTICLE: ".js-toc_ref",
    TOC_SUMMARY: ".dcw_article-template_wrapper"
};

var CLASS = {
    IS_ACTIVE: ".is-active"
};

var TableOfContent = function () {
    function TableOfContent(el) {
        var _this = this;

        _classCallCheck(this, TableOfContent);

        _breakpointDispatcher2.default.start();

        this.el = el;
        this.list = el.find(SELECTORS.TOC_LIST);
        this.linksNode = el.find(SELECTORS.TOC_WRAPPER);
        this.$articles = (0, _jquery2.default)(SELECTORS.TOC_ARTICLE);

        this.buildListFromArticles(this.$articles);

        this.$summaryWrapper = (0, _jquery2.default)(SELECTORS.TOC_SUMMARY);
        this.$items = el.find(SELECTORS.TOC_ITEM);

        this.setActiveItemFromHash();
        this.$lastActive = this.$items.filter(CLASS.IS_ACTIVE);
        this.isListOpen = false;
        this.handleClick = null;

        window.addEventListener("load", function () {
            _this.originalScroll = window.scrollY;
            _this.offsets = _this.getOffsetTopOf(_this.$articles);
        });

        this.init();
    }

    _createClass(TableOfContent, [{
        key: "init",
        value: function init() {
            switch (_breakpointDispatcher2.default.getState()) {
                case _breakpointDispatcher2.default.breakpoint.DESKTOP:
                    this.handleDesktop();
                    break;
                case _breakpointDispatcher2.default.breakpoint.MOBILE:
                    this.handleMobile();
                    break;
            }
        }
    }, {
        key: "buildListFromArticles",
        value: function buildListFromArticles(articles) {
            var _this2 = this;

            var htmlListItems = "";

            [].forEach.call(articles, function (article, i) {
                htmlListItems = htmlListItems + _this2.renderListItem(article);
            });

            this.linksNode.html(htmlListItems);
        }
    }, {
        key: "renderListItem",
        value: function renderListItem(article) {
            var articleId = article.id,
                articleTitle = (0, _jquery2.default)(article).find(".js-toc_ref-title").text();

            return "<li class='dcw_table-of-content_item js-toc_item'>\n              <a class='dcw_table-of-content_anchor js-toc_link' href='#" + articleId + "'>" + articleTitle + "</a>\n            </li>";
        }
    }, {
        key: "getOffsetTopOf",
        value: function getOffsetTopOf($items) {
            var offsets = [];
            $items.each(function (i, item) {
                offsets.push(item.getBoundingClientRect().top - MOBILE_HEADER_HEIGHT - MOBILE_TOC_PAD);
            });
            return offsets;
        }
    }, {
        key: "setActiveItemFromHash",
        value: function setActiveItemFromHash() {
            var urlHash = window.location.hash;
            if (urlHash === "" || urlHash === "#") {
                this.$items.eq(0).addClass("is-active").find("a").attr("aria-current", true);
            } else {
                this.$items.find("a").filter('[href="' + urlHash.replace(/^#_/, "#") + '"]').parent().addClass("is-active").find("a").attr("aria-current", true);
            }
        }
    }, {
        key: "handleDesktop",
        value: function handleDesktop() {
            var _this3 = this;

            var self = this;

            this.bindResizes(self);

            this.handleClick = this.handleDesktopClick;
            this.$items.click(function (event) {
                return _this3.handleClick(event);
            });
        }
    }, {
        key: "handleMobile",
        value: function handleMobile() {
            var _this4 = this;

            var self = this;

            this.bindResizes(self);

            this.handleClick = this.handleMobileClick;
            this.$items.click(function (event) {
                return _this4.handleClick(event);
            });
        }
    }, {
        key: "bindResizes",
        value: function bindResizes(self) {
            _pubSub2.default.subscribe("resize:mobile", function () {
                self.handleClick = self.handleMobileClick;
            });

            _pubSub2.default.subscribe("resize:desktop", function () {
                self.handleClick = self.handleDesktopClick;
            });
        }
    }, {
        key: "handleDesktopClick",
        value: function handleDesktopClick(event) {
            var _this5 = this;

            var element = this.getListItem(event.originalEvent.target);
            var offset = this.$articles.eq(this.$items.index(element)).offset().top;

            _smoothScroll2.default.scrollTo(offset, function () {
                _this5.updateAnchor(element);
            });

            this.updateActiveItem(element);
        }
    }, {
        key: "handleMobileClick",
        value: function handleMobileClick(event) {
            var _this6 = this;

            var $element = (0, _jquery2.default)(event.originalEvent.currentTarget);
            this.toggleList();
            this.updateActiveItem($element);

            var offset = this.getComputedOffsetOf(this.offsets[this.$items.index($element)]);

            if (this.isListOpen) {
                _smoothScroll2.default.scrollTo(offset, function () {
                    return _this6.updateAnchor($element);
                });
            }

            this.isListOpen = !this.isListOpen;
        }
    }, {
        key: "getComputedOffsetOf",
        value: function getComputedOffsetOf(value) {
            return this.originalScroll > 10 ? value + this.originalScroll - this.$summaryWrapper.outerHeight() : value - this.$summaryWrapper.outerHeight() * 2;
        }
    }, {
        key: "toggleList",
        value: function toggleList() {
            this.list.toggleClass("is-opened");
        }
    }, {
        key: "updateActiveItem",
        value: function updateActiveItem(element) {
            var $lastActiveLink = this.$lastActive.find("a");
            var newActiveLink = element.find("a");

            this.$lastActive.removeClass("is-active");
            $lastActiveLink.attr("aria-current", false);
            element.addClass("is-active");
            newActiveLink.attr("aria-current", true);

            this.$lastActive = (0, _jquery2.default)(element);
        }
    }, {
        key: "getListItem",
        value: function getListItem(element) {
            return element.tagName !== "A" ? (0, _jquery2.default)(element) : (0, _jquery2.default)(element).parent();
        }
    }, {
        key: "getIndexOf",
        value: function getIndexOf(element, list) {
            return list.indexOf(element);
        }
    }, {
        key: "updateAnchor",
        value: function updateAnchor(element) {
            window.location.hash = "_" + element.find("a").attr("href").slice(1);
        }
    }, {
        key: "getHeaderHeight",
        value: function getHeaderHeight() {
            return (0, _jquery2.default)(".dcw_header").outerHeight() + this.getSubMenuNavHeight() + 32;
        }
    }, {
        key: "getSubMenuNavHeight",
        value: function getSubMenuNavHeight() {
            var subMenuHeight = 0;

            if ((0, _jquery2.default)(".dcw_submenu-auth").length) {
                subMenuHeight = (0, _jquery2.default)(".dcw_submenu-auth").outerHeight();
            } else if ((0, _jquery2.default)(".dcw_submenu").length) {
                subMenuHeight = (0, _jquery2.default)(".dcw_submenu").outerHeight();
            }

            return subMenuHeight;
        }
    }]);

    return TableOfContent;
}();

exports.default = TableOfContent;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _pubSub = __webpack_require__(3);

var _pubSub2 = _interopRequireDefault(_pubSub);

var _breakpointDispatcher = __webpack_require__(14);

var _breakpointDispatcher2 = _interopRequireDefault(_breakpointDispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ArticleTemplate = function () {
  function ArticleTemplate() {
    _classCallCheck(this, ArticleTemplate);

    _breakpointDispatcher2.default.start();
    var self = this;

    this.el = (0, _jquery2.default)('.js-article');
    this.aside = this.el.find('.js-article_aside');
    this.mobileInitialPos = this.getAsidePosition();
    this.isSticky = false;
    this.stickyClass = (0, _jquery2.default)('.js-header-auth').length ? 'is-sticky-co' : 'is-sticky';

    this.setInitialState();
    this.handleEvents();
  }

  _createClass(ArticleTemplate, [{
    key: 'setInitialState',
    value: function setInitialState() {
      this.templateWidth = (0, _jquery2.default)('.dcw_article-template').width();
      this.lastScrollPos = (0, _jquery2.default)(window).scrollTop();
      this.initialPos = (0, _jquery2.default)('.js-article_main').offset().top;
    }
  }, {
    key: 'handleEvents',
    value: function handleEvents() {
      var _this = this;

      this.handleResizeCallback = this.handleResize(this);

      if (!this.isMobileWidth()) {
        _pubSub2.default.subscribe('resize', this.handleResizeCallback);

        _pubSub2.default.subscribe('sticky:enter', function () {
          if (_this.isMobileWidth()) return;

          _this.aside.addClass(_this.stickyClass);
          _this.setAsideWidth();
        });

        _pubSub2.default.subscribe('sticky:leave', function () {
          _this.aside.removeClass(_this.stickyClass);
        });

        _pubSub2.default.subscribe('resize:mobile', this.handleMobile(this));
      } else {
        this.handleMobileScroll();
      }

      this.handleBreakpointChange();
    }
  }, {
    key: 'isMobileWidth',
    value: function isMobileWidth() {
      return _breakpointDispatcher2.default.getState() === _breakpointDispatcher2.default.breakpoint.MOBILE;
    }
  }, {
    key: 'isAsideAlreadySticky',
    value: function isAsideAlreadySticky() {
      if (!this.isMobileWidth()) {
        return false;
      } else {
        return (0, _jquery2.default)(window).scrollTop() >= this.mobileInitialPos;
      }
    }
  }, {
    key: 'handleResize',
    value: function handleResize(self) {
      return function handleResize() {
        if (self.isMobileWidth()) return;

        self.setInitialState();
        self.setAsideWidth();
      };
    }
  }, {
    key: 'handleMobileScroll',
    value: function handleMobileScroll() {
      var _this2 = this;

      window.addEventListener('scroll', function (e) {
        switch (_this2.isSticky) {
          case false:
            if ((0, _jquery2.default)(window).scrollTop() > _this2.mobileInitialPos) {
              _this2.isSticky = true;
              _this2.aside.addClass(_this2.stickyClass);
            }
            break;
          case true:
            if ((0, _jquery2.default)(window).scrollTop() <= _this2.mobileInitialPos) {
              _this2.isSticky = false;
              _this2.aside.removeClass(_this2.stickyClass);
            }
            break;
        }
      });
    }
  }, {
    key: 'handleMobile',
    value: function handleMobile(self) {
      return function handleMobile() {
        _pubSub2.default.unsubscribe('resize', self.handleResizeCallback);
        self.aside.css('width', '100%');
      };
    }
  }, {
    key: 'handleBreakpointChange',
    value: function handleBreakpointChange() {
      var _this3 = this;

      _pubSub2.default.subscribe('resize:tablet', function () {
        _this3.setInitialState();
        _this3.setAsideWidth();
        _pubSub2.default.subscribe('resize', _this3.handleResizeCallback);
      });
    }
  }, {
    key: 'getAsidePosition',
    value: function getAsidePosition() {
      return this.el.find('.dcw_article-header').offset().top;
    }
  }, {
    key: 'setAsideWidth',
    value: function setAsideWidth() {
      this.aside.css('width', 1 / 3 * this.templateWidth + 'px');
    }
  }]);

  return ArticleTemplate;
}();

exports.default = ArticleTemplate;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SeeMore = function () {
  function SeeMore(el) {
    _classCallCheck(this, SeeMore);

    this.el = el;
    this.link = el.find('.js-see-more_link');
    this.text = el.find('.js-see-more_text');

    this.handleEvents();
  }

  _createClass(SeeMore, [{
    key: 'handleEvents',
    value: function handleEvents() {
      var _this = this;

      this.link.click(function (e) {
        _this.text.show();
        _this.link.hide();
      });
    }
  }]);

  return SeeMore;
}();

exports.default = SeeMore;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _helpers = __webpack_require__(47);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Accordion = function () {
  function Accordion($el) {
    _classCallCheck(this, Accordion);

    this.accordionHead = $el;
    this.accordionToggle = $el.find('.js-accordion_toggle').eq(0);
    this.accordionPanel = $el.next();

    this.handleEvents();
  }

  _createClass(Accordion, [{
    key: 'handleEvents',
    value: function handleEvents() {
      var _this = this;

      this.accordionToggle.click(function (e) {
        return _this.toggleAccordion(e);
      });
    }
  }, {
    key: 'toggleAccordion',
    value: function toggleAccordion() {
      this.accordionPanel.slideToggle('fast');

      (0, _helpers.toggleAttribute)(this.accordionToggle, 'aria-expanded');
    }
  }]);

  return Accordion;
}();

exports.default = Accordion;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductList = function () {
  function ProductList($el) {
    var _this = this;

    _classCallCheck(this, ProductList);

    if (window.innerWidth > 768) return;

    this.root = $el;
    this.list = $el.find('.js-product-list_list');
    this.seeMore = $el.find('.js-product-list_see-more');

    this.lastItemVisible = $el.find('.is-last-visible');
    this.lastItemTop = this.getLastItemPos();
    this.listTop = this.getItemPos(this.list);

    setTimeout(function () {
      _this.listOriginalHeight = _this.list.outerHeight();
      _this.lastItemVisible.addClass('is-active');
      _this.listHiddenHeight = _this.list.outerHeight();

      _this.prepareTransition();
    }, 100);

    this.seeMore.click(function (e) {
      e.preventDefault();

      requestAnimationFrame(function () {
        _this.list.css('height', _this.listOriginalHeight);

        _this.lastItemVisible.removeClass('is-active');

        setTimeout(function () {
          _this.lastItemVisible.addClass('is-fade-in');
          _this.seeMore.addClass('is-fade-out');
        });
      });
    });
  }

  _createClass(ProductList, [{
    key: 'prepareTransition',
    value: function prepareTransition() {
      this.list.css('height', this.listHiddenHeight);
    }
  }, {
    key: 'getLastItemPos',
    value: function getLastItemPos() {
      return this.root.find('li').last().offsetTop;
    }
  }, {
    key: 'getItemPos',
    value: function getItemPos($item) {
      return $item.offsetTop;
    }
  }]);

  return ProductList;
}();

exports.default = ProductList;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var key = {
  'TAB': 9,
  'ENTER': 13,
  'ESCAPE': 27,
  'SPACE': 32,
  'UP': 38,
  'DOWN': 40
};

var Dropdown = function () {
  function Dropdown($el) {
    _classCallCheck(this, Dropdown);

    this.root = $el;
    this.button = $el.find(".js-dropdown_btn");
    this.links = this.root.find('.js-dropdown_link');
    this.focusIndex = 0;
    this.numOfLinks = this.links.length;
    this.isOpen = false;

    this.handleEvents();
  }

  _createClass(Dropdown, [{
    key: 'handleEvents',
    value: function handleEvents() {
      var _this = this;

      this.root.click(function () {
        _this.isOpen = !_this.isOpen;
        _this.toggleList();
      });

      (0, _jquery2.default)(document.body).click(function () {
        if (_this.isOpen && _this.root.hasClass('is-open-add')) {
          _this.isOpen = !_this.isOpen;
          _this.toggleList();
        }
      });

      this.root.focusout(function (e) {
        if (_this.isOpen && !(0, _jquery2.default)(e.relatedTarget).hasClass('js-dropdown_link')) {
          _this.focusIndex = 0;
          _this.isOpen = !_this.isOpen;
          _this.toggleList();
        }
      });

      // keyboard
      this.root.keydown(function (e) {
        switch (_this.isOpen) {
          case true:
            if (key.DOWN === e.keyCode || key.TAB === e.keyCode) {
              _this.focusNextItem();
            }

            if (key.UP === e.keyCode) {
              _this.focusPrevItem();
            }

            if (key.ESCAPE === e.keyCode) {
              _this.focusIndex = 0;
              _this.isOpen = !_this.isOpen;
              _this.toggleList();
              setTimeout(function () {
                return _this.focusItem(_this.root);
              });
            }
            break;

          case false:
            if (key.DOWN === e.keyCode || key.SPACE === e.keyCode || key.ENTER === e.keyCode) {
              _this.isOpen = !_this.isOpen;
              _this.toggleList();
              _this.focusItem(_this.links.eq(_this.focusIndex));
            }
            break;
        }
      });
    }
  }, {
    key: 'focusNextItem',
    value: function focusNextItem() {
      this.focusItem(this.getNextItem());
    }
  }, {
    key: 'focusPrevItem',
    value: function focusPrevItem() {
      this.focusItem(this.getPrevItem());
    }
  }, {
    key: 'focusItem',
    value: function focusItem($item) {
      $item.focus();
    }
  }, {
    key: 'getNextItem',
    value: function getNextItem() {
      this.focusIndex = Math.min(++this.focusIndex, this.numOfLinks - 1);
      return this.links.eq(this.focusIndex);
    }
  }, {
    key: 'getPrevItem',
    value: function getPrevItem() {
      this.focusIndex = Math.max(--this.focusIndex, 0);
      return this.links.eq(this.focusIndex);
    }
  }, {
    key: 'toggleList',
    value: function toggleList() {
      var _this2 = this;

      if (this.shouldPlaceAbove()) {
        this.root.addClass('dcw_dropdown--up');
      } else {
        this.root.removeClass('dcw_dropdown--up');
      }

      this.root.toggleClass('is-open');
      setTimeout(function () {
        _this2.root.toggleClass('is-open-add');
      });

      this.button.attr('aria-expanded', this.isOpen);
    }
  }, {
    key: 'shouldPlaceAbove',
    value: function shouldPlaceAbove() {
      return window.innerHeight - this.root[0].getBoundingClientRect().bottom < 128;
    }
  }]);

  return Dropdown;
}();

exports.default = Dropdown;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var key = {
  'TAB': 9,
  'ENTER': 13,
  'ESCAPE': 27,
  'SPACE': 32,
  'UP': 38,
  'DOWN': 40
};

var DropdownLight = function () {
  function DropdownLight($el) {
    _classCallCheck(this, DropdownLight);

    this.root = $el;
    this.button = $el.find(".js-dropdown_btn");
    this.links = this.root.find('.js-dropdown_link');
    this.focusIndex = 0;
    this.numOfLinks = this.links.length;
    this.isOpen = false;

    this.handleEvents();
  }

  _createClass(DropdownLight, [{
    key: 'handleEvents',
    value: function handleEvents() {
      var _this = this;

      this.root.click(function () {
        _this.toggleList();
        if (_this.isOpen === true) {
          _this.focusIndex = -1;
        }
      });

      (0, _jquery2.default)(document.body).click(function () {
        if (_this.isOpen && _this.root.hasClass('is-open-add')) {
          _this.toggleList();
        }
      });

      this.root.focusout(function (e) {
        if (_this.isOpen && !(0, _jquery2.default)(e.relatedTarget).hasClass('js-dropdown_link')) {
          _this.focusIndex = 0;
          _this.toggleList();
        }
      });

      // keyboard
      this.root.keydown(function (e) {
        switch (_this.isOpen) {
          case true:

            if (key.ENTER !== e.keyCode) {
              e.preventDefault();
              e.stopPropagation();
            }

            if (key.DOWN === e.keyCode || key.TAB === e.keyCode) {
              _this.focusNextItem();
            }

            if (key.UP === e.keyCode) {
              _this.focusPrevItem();
            }

            if (key.ESCAPE === e.keyCode) {
              _this.focusIndex = 0;
              _this.toggleList();
              setTimeout(function () {
                return _this.focusItem(_this.root);
              });
            }
            break;

          case false:
            if (key.DOWN === e.keyCode || key.SPACE === e.keyCode || key.ENTER === e.keyCode) {
              _this.toggleList();
              _this.focusItem(_this.links.eq(_this.focusIndex));
            }
            break;
        }
      });
    }
  }, {
    key: 'focusNextItem',
    value: function focusNextItem() {

      if (this.focusIndex === this.numOfLinks - 1) {
        this.focusItem(this.button).next();
      } else {
        this.focusItem(this.getNextItem());
      }
    }
  }, {
    key: 'focusPrevItem',
    value: function focusPrevItem() {
      this.focusItem(this.getPrevItem());
    }
  }, {
    key: 'focusItem',
    value: function focusItem($item) {
      $item.focus();
    }
  }, {
    key: 'getNextItem',
    value: function getNextItem() {
      this.focusIndex = Math.min(++this.focusIndex, this.numOfLinks - 1);
      return this.links.eq(this.focusIndex);
    }
  }, {
    key: 'getPrevItem',
    value: function getPrevItem() {
      this.focusIndex = Math.max(--this.focusIndex, 0);
      return this.links.eq(this.focusIndex);
    }
  }, {
    key: 'toggleList',
    value: function toggleList() {
      var _this2 = this;

      this.isOpen = !this.isOpen;

      if (this.shouldPlaceAbove()) {
        this.root.addClass('dcw_dropdown--up');
      } else {
        this.root.removeClass('dcw_dropdown--up');
      }

      this.root.toggleClass('is-open');
      setTimeout(function () {
        _this2.root.toggleClass('is-open-add');
      });

      this.button.attr('aria-expanded', this.isOpen);

      if (this.isOpen === true) {
        this.button.next().removeClass('dcw_hidden');
      } else {
        this.button.next().addClass('dcw_hidden');
      }

      if (this.isOpen === true) {
        if (this.button.attr('aria-controls') === 'id_menu_deroulant_regions') {
          this.button.attr('aria-label', 'Fermer la liste des régions');
        } else {
          this.button.attr('aria-label', 'Fermer la liste des autres sites SG');
        }
      } else {
        if (this.button.attr('aria-controls') === 'id_menu_deroulant_regions') {
          this.button.attr('aria-label', 'Ouvrir la liste des régions');
        } else {
          this.button.attr('aria-label', 'Ouvrir la liste des autres sites SG');
        }
      }
    }
  }, {
    key: 'shouldPlaceAbove',
    value: function shouldPlaceAbove() {
      return window.innerHeight - this.root[0].getBoundingClientRect().bottom < 128;
    }
  }]);

  return DropdownLight;
}();

exports.default = DropdownLight;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _pubSub = __webpack_require__(3);

var _pubSub2 = _interopRequireDefault(_pubSub);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KEY = {
  ENTER: 13
};

var Search = function () {
  function Search($el) {
    _classCallCheck(this, Search);

    this.root = $el;
    this.searchToggle = $el.find('.js-search_toggle');
    this.searchField = $el.find('.js-search_field');
    this.searchLabel = $el.find('.js-search_label');
    this.isAlwaysOpen = this.root.hasClass('is-open');

    //
    this.handleEvents();
  }

  _createClass(Search, [{
    key: 'handleEvents',
    value: function handleEvents() {
      var _this = this;

      this.searchField.click(function (e) {
        return e.stopPropagation();
      });

      this.searchField.keydown(function (e) {
        e.stopPropagation();
        _this.handleKeyDown(e);
      });

      this.searchToggle.click(function (e) {
        e.preventDefault();

        if (_this.isAlwaysOpen) {
          if (_this.searchField.val() !== "" && _this.searchField.val() !== null) {
            _this.submitMainSearchField(_this.searchField);
          }
          return;
        }

        if (_this.searchField.val() !== "" && _this.searchField.val() !== null) {
          _this.submitMainSearchField(_this.searchField);
        }

        _this.root.toggleClass('is-open');
        _pubSub2.default.publish('login-search:toggle');

        setTimeout(function () {
          window.addEventListener('click', _this.onOutsideClick(_this));
        });
      });
    }
  }, {
    key: 'submitMainSearchField',
    value: function submitMainSearchField(element) {
      var keywordField = (0, _jquery2.default)('<input type="hidden" name="keyword">');
      var value = element.val();
      keywordField.val(btoa(value).replace(/=/g, ''));
      element.prop('disabled', true);
      element.closest('form').append(keywordField).submit();
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      e.stopPropagation();

      if (e.keyCode == KEY.ENTER) {
        e.preventDefault();
        if (this.searchField.val() !== "" && this.searchField.val() !== null) {
          this.submitMainSearchField(this.searchField);
        }
      }
    }
  }, {
    key: 'onOutsideClick',
    value: function onOutsideClick(self) {
      return function unBindOutsideClick() {
        self.root.toggleClass('is-open');

        _pubSub2.default.publish('login-search:toggle');

        window.removeEventListener('click', unBindOutsideClick);
      };
    }
  }, {
    key: 'isSearchFieldEmpty',
    value: function isSearchFieldEmpty(value) {
      return value === "";
    }
  }]);

  return Search;
}();

exports.default = Search;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initMenuBrs = initMenuBrs;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SLIDE_TIME = "fast";

function initMenuBrs() {
  (0, _jquery2.default)('.js-menu-brs_toggle').click(function () {
    toggleBtn(this);

    return false;
  });
}

function toggleBtn(button) {
  (0, _jquery2.default)(button).next().stop(true).slideToggle(SLIDE_TIME);

  (0, _jquery2.default)(button).children("svg").toggleClass("is-up");
}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initToggles = initToggles;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SLIDE_TIME = "fast";

// for Alerting & GMS
var SELECTOR = {
    CLASS_MENU_LEFT_TOGGLE: ".js-menu-left_toggle",
    CLASS_BTN_ACTIVE: ".is-open",
    CLASS_PARENT_ACTIVE: ".parent-active",
    CLASS_FIRST_LI: ".js-secondlvl-link",
    CLASS_NAV_LEFT: ".js-container-sublevel",
    CLASS_CONTAINER_MAIN: ".rsp_main"
};

var CLASS = {
    PARENT_ACTIVE: "parent-active",
    FIRST_LI: "js-secondlvl-link"
};

function initToggles() {
    processHeightMain();
    (0, _jquery2.default)(document).on('click', SELECTOR.CLASS_MENU_LEFT_TOGGLE, function (event) {
        event.stopPropagation();
        toggleBtn(this);

        return false;
    });
}

function toggleBtn(button) {
    var $btn = (0, _jquery2.default)(button);

    closeOthers($btn);
    processBtn($btn);
}

function closeOthers($btn) {
    var $parent = $btn.parents(SELECTOR.CLASS_FIRST_LI);
    var needToKeepParent = true;
    var $btnActive = (0, _jquery2.default)(SELECTOR.CLASS_BTN_ACTIVE);

    if (!$parent.hasClass(CLASS.PARENT_ACTIVE)) {
        needToKeepParent = false;
        (0, _jquery2.default)(SELECTOR.CLASS_FIRST_LI).removeClass(CLASS.PARENT_ACTIVE);
        $parent.addClass(CLASS.PARENT_ACTIVE);
    }

    $btnActive.each(function () {
        var $btnCurrent = (0, _jquery2.default)(this);

        // escape to close parent if lvl 3
        if (needToKeepParent && $btnCurrent.parent().hasClass(CLASS.FIRST_LI)) {
            return;
        }

        if ($btnCurrent.is($btn)) {
            return;
        }

        closeAccordian($btnCurrent);
    });
}

function closeAccordian($btnCurrent) {
    $btnCurrent.removeClass("is-open");
    $btnCurrent.next().stop(true).slideUp(SLIDE_TIME);
    $btnCurrent.children("svg").toggleClass("is-up");
}

function processBtn($btn) {
    $btn.next().stop(true).slideToggle(SLIDE_TIME, processHeightMain());
    $btn.children("svg").toggleClass("is-up");
    $btn.toggleClass("is-open");
}

function processHeightMain() {
    setTimeout(processAfterTime, 250);

    function processAfterTime() {
        var heightNav = (0, _jquery2.default)(SELECTOR.CLASS_NAV_LEFT).outerHeight();
        var containerMain = document.querySelector(SELECTOR.CLASS_CONTAINER_MAIN);
        if (typeof containerMain != 'undefined' && containerMain != null) {
            containerMain.style.minHeight = heightNav + "px";
        }
    }
}

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadCMS = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _market = __webpack_require__(6);

var _eventBusCustom = __webpack_require__(171);

var _eventBusCustom2 = _interopRequireDefault(_eventBusCustom);

var _ClientCustomizer = __webpack_require__(172);

var _ClientCustomizer2 = _interopRequireDefault(_ClientCustomizer);

var _initCmsUtil = __webpack_require__(179);

var _queue = __webpack_require__(180);

var _cookieDisclaimer = __webpack_require__(181);

var _search = __webpack_require__(182);

var _sobot = __webpack_require__(85);

var _sobot2 = _interopRequireDefault(_sobot);

var _initPopinModal = __webpack_require__(184);

var _filterListWem = __webpack_require__(185);

var _brsShortcut = __webpack_require__(186);

var _serviceMessages = __webpack_require__(187);

var _eventsHandler = __webpack_require__(188);

var _counters = __webpack_require__(189);

var _menu = __webpack_require__(196);

var _name = __webpack_require__(27);

var _lastConnectionMessage = __webpack_require__(197);

var _firstLevelConnectedMenu = __webpack_require__(198);

var _updateDescription = __webpack_require__(199);

var _setHtmlAccessibility = __webpack_require__(200);

var _interact = __webpack_require__(201);

var _initJauge = __webpack_require__(202);

var _bourseLeftMenu = __webpack_require__(203);

var _initSimulator = __webpack_require__(204);

var _contextualMenuCleanups = __webpack_require__(205);

var _initCardSubscription = __webpack_require__(206);

var _initSupervision = __webpack_require__(207);

var _initPopinLogin = __webpack_require__(208);

var _navpropri = __webpack_require__(209);

var _checkCookieYoga = __webpack_require__(210);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import {cookieCAID} from './commons/cookieCAID';

__webpack_require__(211);

var loadCMS = function loadCMS() {

    _ClientCustomizer2.default.initialize();
    (0, _initCmsUtil.initCmsUtil)();

    // Init Event But
    window.EventBusCMS = new _eventBusCustom2.default();

    // commons components
    (0, _filterListWem.filterListWem)();

    // PRI/PRO CONTEXT
    if (_market.MARKET.CODE === 1 || _market.MARKET.CODE === 2) {
        (0, _interact.initInteract)();
    }

    (0, _search.initSearchContext)();
    (0, _cookieDisclaimer.initCookieDisclaimer)();
    (0, _lastConnectionMessage.initLastConnectionMessage)();
    (0, _initPopinModal.initPopinModal)();
    (0, _updateDescription.updateDescription)();
    (0, _initSupervision.initSupervision)();

    // commons Services Messages
    (0, _serviceMessages.bindCloseMessageEvent)();
    (0, _serviceMessages.showFirstEligibleMessage)();

    // Deprecated ?
    (0, _setHtmlAccessibility.setHtmlAccessibility)();

    // Cut into Event Customs - Events PRI
    (0, _eventsHandler.eventsHandler)();

    // util commons
    (0, _queue.executeQueuedFunctions)();

    // PRI CONTEXT
    if (_market.MARKET.CODE === 1) {
        (0, _bourseLeftMenu.bourseLeftMenuActiveItems)();
        (0, _initSimulator.initSimulator)();
        (0, _initCardSubscription.initCardSubscription)();
    }

    // PRI or PRO CONTEXT
    if (_market.MARKET.CODE === 1 || _market.MARKET.CODE === 2) {
        if ((0, _jquery2.default)('#sobot-l').length > 0 && (0, _jquery2.default)('.js-sobot').length == 1) {
            var sobotApp = new _sobot2.default();
            sobotApp.initSobot();
        }
    }

    // ASSO CONTEXT
    if (_market.MARKET.CODE === 4) {
        (0, _initPopinLogin.initPopinLogin)();
    }

    // launch script only used in connected part
    // IMPORTANT NOTE: if window.cmsUtil.isProspect is false, it doesn't mean that we are in the connected area of the
    // site!!!! It means that the user is either connected or identified!! If the user is connected or identified and
    // we are in the disconnected area, this variable will still be false!!
    if (!window.cmsUtil.isProspect) {
        (0, _counters.processLhsNotifications)();
        (0, _name.updateLoginBoxNamesLhs)();
        (0, _brsShortcut.updateBrsShortcuts)();

        // Need update for PRO
        (0, _menu.processLoginBoxMenu)();

        // Deprecated ?
        (0, _firstLevelConnectedMenu.processFirstLevelConnected)();

        // PRI CONTEXT
        if (_market.MARKET.CODE === 1) {
            (0, _initJauge.initJauge)();
        }
    }

    // PRO AND PRI CONTEXT
    if (_market.MARKET.CODE === 1 || _market.MARKET.CODE === 2) {
        (0, _navpropri.initNavpropri)(_market.MARKET.CODE);
    }

    // PRI CONTEXT
    if (_market.MARKET.CODE === 1) {
        (0, _contextualMenuCleanups.contextualMenuCleanup)();
    }

    if (_market.MARKET.CODE === 1 || _market.MARKET.CODE === 2 || _market.MARKET.CODE === 3) {
        if (!window.cmsGlobals.checkCookieYogaConfig.disabled || !window.cmsGlobals.checkCookieCMSTechConfig.disabled) {
            if (!window.cmsGlobals.checkCookieYogaConfig.disabled) {
                (0, _checkCookieYoga.checkCookieICDSwitch)("YOGA");
            }

            if (!window.cmsGlobals.checkCookieCMSTechConfig.disabled) {
                (0, _checkCookieYoga.checkCookieICDSwitch)("CMS_TECH");
            }
        }
    }

    // Cookie CAID
    //cookieCAID();
};

exports.loadCMS = loadCMS;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventBusCustom = function () {
    /**
     * Initialize a new event bus instance.
     */
    function EventBusCustom() {
        _classCallCheck(this, EventBusCustom);

        this.bus = document.createElement('customCmsEvent');
    }

    /**
     * Add an event listener.
     */


    _createClass(EventBusCustom, [{
        key: 'addEventListener',
        value: function addEventListener(event, callback) {
            this.bus.addEventListener(event, callback);
        }

        /**
         * Dispatch an event.
         */

    }, {
        key: 'dispatchEvent',
        value: function dispatchEvent(event) {
            var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            this.bus.dispatchEvent(new CustomEvent(event, { detail: detail }));
        }
    }]);

    return EventBusCustom;
}();

exports.default = EventBusCustom;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _SegmentControllerFactory = __webpack_require__(173);

var _SegmentControllerFactory2 = _interopRequireDefault(_SegmentControllerFactory);

var _DomHelper = __webpack_require__(45);

var _DomHelper2 = _interopRequireDefault(_DomHelper);

var _Cookie = __webpack_require__(25);

var _Cookie2 = _interopRequireDefault(_Cookie);

var _CardList = __webpack_require__(174);

var _CardList2 = _interopRequireDefault(_CardList);

var _SimulatorPPI = __webpack_require__(175);

var _SimulatorPPI2 = _interopRequireDefault(_SimulatorPPI);

var _Popin = __webpack_require__(84);

var _Popin2 = _interopRequireDefault(_Popin);

var _Glossary = __webpack_require__(177);

var _Glossary2 = _interopRequireDefault(_Glossary);

var _GlossaryTerms = __webpack_require__(178);

var _GlossaryTerms2 = _interopRequireDefault(_GlossaryTerms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SEGMENT_ATTR = {
    DEFAULT: "data-clientside-segments",
    BFM: "data-clientside-segments-bfm",
    PRIVATE_BANKING: "data-clientside-segments-bp",
    COOKIES: "data-clientside-cookies",
    COOKIES_EXCLUDE: "data-clientside-cookies-exclude"
};

exports.default = {
    initialize: function initialize() {
        var _this = this;

        var ATTR_CLIENT_ID = "data-clientside-id";
        var SEPARATOR_COMMA = ",";

        (0, _jquery2.default)("*[data-clientside-id]").each(function (index, element) {
            // only continues with executing the function if the FunctionMapper is really defined (which should), and if there
            // really is a function for this ID
            var functionIds = (0, _jquery2.default)(element).attr(ATTR_CLIENT_ID).split(SEPARATOR_COMMA);

            functionIds.forEach(function (functionId) {
                if (_this.has(functionId)) {
                    // calls the method passing the element, so the function can do whatever it need with it
                    _this[functionId](element);
                }
            });
        });
    },

    has: function has(methodName) {
        return !!this[methodName];
    },

    // Method that analyzes if the content should be or not visible, depending on the cookie segments (include and exclude cookies)
    analyzeCookiePersonalizationVisibility: function analyzeCookiePersonalizationVisibility(cookieSegments) {
        var cookiesToShow = cookieSegments.get();
        var cookiesToHide = cookieSegments.getToHide();

        var shouldBeVisible = false;
        // If there are no cookies to hide set, let's analyze the cookies to show
        if (!cookiesToHide) {
            shouldBeVisible = _Cookie2.default.analyze(cookiesToShow);
        } else if (!cookiesToShow) {
            // If there are no cookies to show set, let's analyze the cookies to hide
            shouldBeVisible = _Cookie2.default.analyzeHide(cookiesToHide);
        } else {
            // There are both cookies to show and to hide set, so let's analyze the cookies to hide
            shouldBeVisible = _Cookie2.default.analyzeShowAndHide(cookiesToShow, cookiesToHide);
        }

        return shouldBeVisible;
    },

    /**
     * Removes the Open New Account button if the client is authenticated or recognized
     */
    openNewAccountButton: function openNewAccountButton(element) {
        var clientSegment = (0, _SegmentControllerFactory2.default)(element, SEGMENT_ATTR.DEFAULT);

        if (clientSegment.isAnyActive()) {
            clientSegment.removeElement();
        }
    },

    /**
     * Sets the secure search results link if the user is authenticated
     */
    setSecureSearchResults: function setSecureSearchResults(element) {
        var clientSegment = (0, _SegmentControllerFactory2.default)(element, SEGMENT_ATTR.DEFAULT);

        if (clientSegment.isAnyActive()) {
            clientSegment.setAction("/secure/resultats-recherche");
        }
    },

    /**
     * Sets the Connected Header color for BFM, BP1 and BP2
     */
    setConnectedHeaderColor: function setConnectedHeaderColor(element) {
        var bfmSegments = (0, _SegmentControllerFactory2.default)(element, SEGMENT_ATTR.BFM);
        var bpSegments = (0, _SegmentControllerFactory2.default)(element, SEGMENT_ATTR.PRIVATE_BANKING);

        if (bfmSegments.isAnyActive()) {
            bfmSegments.setHeaderBrand();
        } else if (bpSegments.isAnyActive()) {
            bpSegments.setHeaderBrand();
        }
    },

    /**
     * Applies the cookie segmentation
     */
    applyCookieSegmentation: function applyCookieSegmentation(element) {
        var cookieSegments = (0, _SegmentControllerFactory2.default)(element, SEGMENT_ATTR.COOKIES, SEGMENT_ATTR.COOKIES_EXCLUDE);
        var shouldBeVisible = this.analyzeCookiePersonalizationVisibility(cookieSegments);

        if (shouldBeVisible) {
            cookieSegments.showElement();
        } else {
            cookieSegments.removeElement();
        }
    },

    /**
     * Applies the cookie segmentation for Cards
     */
    applyCardsCookieSegmentation: function applyCardsCookieSegmentation(element) {
        var cookieSegments = (0, _SegmentControllerFactory2.default)(element, SEGMENT_ATTR.COOKIES, SEGMENT_ATTR.COOKIES_EXCLUDE);
        var shouldBeVisible = this.analyzeCookiePersonalizationVisibility(cookieSegments);

        if (shouldBeVisible) {
            cookieSegments.showElement();
        } else {
            // if it's not meant to be shown, first analyzes if this is the last child: if it is, replaces its
            // content with a message; if it's not, removes it from the HTML
            var cardList = new _CardList2.default(element);

            if (cardList.hasExpectedChildrenIndex()) {
                cardList.showNoCardMessage();
                cookieSegments.showElement();
            } else {
                cookieSegments.removeElement();
            }
        }
    },

    /**
     * Calls the PPI Simulator
     */
    callPpiSimulator: function callPpiSimulator(element) {
        try {
            var simulatorPPI = new _SimulatorPPI2.default({
                element: element,
                sdcWrapper: "dpiWrapper",
                defaultRoute: "#dpi/simulationrapide",
                noRoute: true
            });

            if (simulatorPPI) {
                simulatorPPI.load();
            }
        } catch (errorMessage) {
            console.error(errorMessage);
        }
    },

    /**
     * Prestation Code
     * 2 cases basically usable by contributors
     * - getPrestCouranteTypeGestSousMandat
     * - getPrestCouranteTypeGestConseillee
     */
    getPrest: function getPrest(element) {
        var relatedMethod = element.getAttribute("data-clientside-method-name");
        var answer = element.getAttribute("data-clientside-answer");

        if (answer === null || answer === "" || relatedMethod === null || relatedMethod === "") {
            return false;
        }

        var answerCleaned = answer.trim().toLowerCase();

        // First case : getPrestCouranteTypeGestSousMandat
        if (relatedMethod === "getPrestCouranteTypeGestSousMandat" && typeof window.getPrestCouranteTypeGestSousMandat === "function") {
            var result = window.getPrestCouranteTypeGestSousMandat();
            generateAnchorsAttr(element, result, answerCleaned);
        }

        // Second case : getPrestCouranteTypeGestConseillee
        if (relatedMethod === "getPrestCouranteTypeGestConseillee" && typeof window.getPrestCouranteTypeGestConseillee === "function") {
            var result = window.getPrestCouranteTypeGestConseillee();
            generateAnchorsAttr(element, result, answerCleaned);
        }
    },

    /**
     * Show link in case its data-clientside-mandat attribute and the visited page hash are the same
     */
    showRequestedMandats: function showRequestedMandats(element) {
        var showElement = function showElement(element) {
            element.style.display = "";
        };
        var getMandatTypesAsArray = function getMandatTypesAsArray(requestedMandatTypes) {
            return requestedMandatTypes.split(/\s*,\s*/);
        };

        var requestedMandatType = window.location.hash.replace("#typeMandat=", "");

        if (!requestedMandatType) {
            showElement(element);
            return;
        }

        var mandatTypeAttribute = element.getAttribute("data-clientside-mandat");

        if (mandatTypeAttribute && getMandatTypesAsArray(mandatTypeAttribute).indexOf(requestedMandatType) >= 0) {
            showElement(element);
        }
    },

    /**
     * Show glossary terms
     */
    applyGlossaryTerms: function applyGlossaryTerms(element) {
        var POPIN_ID = "dcw_popin",
            POPIN_TITLE_ID = "dcw_popin-title",
            POPIN_DESCRIPTION_ID = "dcw_popin-desc";

        var popinContainer = document.getElementById(POPIN_ID);
        var titleElement = document.getElementById(POPIN_TITLE_ID);
        var descriptionElement = document.getElementById(POPIN_DESCRIPTION_ID);

        var popinInfoView = new _Popin2.default(popinContainer, titleElement, descriptionElement);

        _GlossaryTerms2.default.fetch(function (terms) {
            new _Glossary2.default(element, popinInfoView, terms);
        });
    }
};

/**
 *  This function generate anchors in all links inside of the element pass like paramater, depending of the results from external methods.
 *  The variable "answer" is coming from presentation properties
 *  The variable result is coming from the external method
 *  Params : element, result, answer
 */

function generateAnchorsAttr(element, result, answer) {
    // if the result from current method is defined and contains the expected answer
    if (result != undefined && result.typeGestion != undefined && result.typeGestion.trim().toLowerCase() === answer) {
        // begins to set the links (it sets all the links below the element)
        if (result.idPrest !== undefined && result.idPrest.toLowerCase() !== "impossible a definir") {
            var anchorChildren = element.getElementsByTagName("a");

            for (var i = 0, nbAnchors = anchorChildren.length; i < nbAnchors; i++) {
                var anchorElem = anchorChildren[i];
                var anchorElemHref = anchorElem.getAttribute("href");

                if (anchorElemHref !== undefined && anchorElemHref !== "") {
                    anchorElem.setAttribute("href", anchorElemHref + result.idPrest);
                }
            }
        }

        // shows the element
        _DomHelper2.default.unwrap(element);
    }
}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _DomHelper = __webpack_require__(45);

var _DomHelper2 = _interopRequireDefault(_DomHelper);

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clientSideSegments = {
    BFM: "data-clientside-segments-bfm",
    PRIVATE_BANKING: "data-clientside-segments-bp"
};

function SegmentControllerFactory(element, segmentName, segmentToHideName) {
    if (!element || !segmentName) return null;

    switch (segmentName) {
        case clientSideSegments.BFM:
            return new BfmSegmentController(element, clientSideSegments.BFM);
            break;
        case clientSideSegments.PRIVATE_BANKING:
            return new PrivateBankingSegmentController(element, clientSideSegments.PRIVATE_BANKING);
            break;
        default:
            return new SegmentController(element, segmentName, segmentToHideName);
            break;
    }
}

function SegmentController(element, segmentName, segmentToHideName) {
    if (!element || !segmentName) return null;

    this.element = element;
    this.segmentName = segmentName;
    this.segments = this._getSegments();

    if (typeof segmentToHideName !== "undefined") {
        this.segmentToHideName = segmentToHideName;
        this.segmentsToHide = this._getSegmentsToHide();
    }
}

SegmentController.prototype.setElement = function (element) {
    this.element = element;
};

SegmentController.prototype.setSegmentName = function (segmentName) {
    this.segmentName = segmentName;
};

SegmentController.prototype.removeElement = function () {
    (0, _jquery2.default)(this.element).remove();
};

SegmentController.prototype.showElement = function () {
    _DomHelper2.default.unwrap(this.element);
};

SegmentController.prototype.get = function () {
    return !!this.segments && this.segments || false;
};

SegmentController.prototype.getToHide = function () {
    return !!this.segmentsToHide && this.segmentsToHide || false;
};

SegmentController.prototype.isAnyActive = function () {
    if (!window.userSegments) {
        return false;
    }

    for (var i = 0; i < this.segments.length; i++) {
        if (window.userSegments.indexOf(this.segments[i]) >= 0) {
            return true;
        }
    }

    return false;
};

SegmentController.prototype._getSegments = function () {
    var segmentList = this._getSegmentListByName(this.segmentName);

    if (!segmentList) {
        return null;
    }

    return this._getSegmentsFromListSeparatedBy(segmentList, ",");
};

SegmentController.prototype._getSegmentsToHide = function () {
    var segmentList = this._getSegmentListByName(this.segmentToHideName);

    if (!segmentList) {
        return null;
    }

    return this._getSegmentsFromListSeparatedBy(segmentList, ",");
};

SegmentController.prototype._getSegmentListByName = function (name) {
    return this.element.getAttribute(name);
};

SegmentController.prototype._getSegmentsFromListSeparatedBy = function (segmentList, separator) {
    var indexOfEqual = segmentList.indexOf("=");
    var key = indexOfEqual >= 0 ? segmentList.substring(0, indexOfEqual) + '=' : '';
    var values = segmentList.substring(indexOfEqual + 1);

    return values.split(separator).map(function (singleValue) {
        return key + singleValue;
    });
};

SegmentController.prototype.setAction = function (action) {
    this.element.setAttribute("action", action);
};

function BfmSegmentController(element, segmentName) {
    SegmentController.call(this, element, segmentName);
}

BfmSegmentController.prototype = Object.create(SegmentController.prototype);
BfmSegmentController.prototype.constructor = BfmSegmentController;

BfmSegmentController.prototype.setHeaderBrand = function () {
    this.element.classList.add("dcw_header--bfm");
};

function PrivateBankingSegmentController(element, segmentName) {
    SegmentController.call(this, element, segmentName);
}

PrivateBankingSegmentController.prototype = Object.create(SegmentController.prototype);
PrivateBankingSegmentController.prototype.constructor = PrivateBankingSegmentController;

PrivateBankingSegmentController.prototype.setHeaderBrand = function () {
    this.element.classList.add("dcw_header--private");
};

exports.default = SegmentControllerFactory;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var MESSAGE_NO_CARD_DEFAULT = "Il n'y a plus de cartes à montrer.";
var ATTR_NO_CARD_MSG = "data-clientside-no-cards-message";
var ATTR_CHILDREN_INDEX = "data-clientside-children-number";

function Cardlist(element) {
    this.element = element;
}

Cardlist.prototype.showNoCardMessage = function () {
    this.element.children[0].innerHTML = buildHTMLTitle(getNoCardMessage.call(this));
};

Cardlist.prototype.hasExpectedChildrenIndex = function () {
    return this.element.parentNode.childElementCount === Number(getChildrenIndex.call(this));
};

function buildHTMLTitle(message) {
    return "<h3>" + message + "</h3>";
}

function getNoCardMessage() {
    return this.element.getAttribute(ATTR_NO_CARD_MSG) || MESSAGE_NO_CARD_DEFAULT;
}

function getChildrenIndex() {
    return this.element.getAttribute(ATTR_CHILDREN_INDEX);
}

exports.default = Cardlist;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Simulator = __webpack_require__(176);

var _Simulator2 = _interopRequireDefault(_Simulator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SIMULATOR = {
    ID_DEFAULT_CONTENT: "simulator_default",
    ID_DPI: "dpiWrapper",
    ID_MOSAIC_WRAPPER_SIMULATOR: "simulator_container"
};

function displayDefaultContent() {
    // append default content - DCW-2155
    var simulatorWrapperApi = document.getElementById(SIMULATOR.ID_DPI);
    var simulatorContainer = document.getElementById(SIMULATOR.ID_MOSAIC_WRAPPER_SIMULATOR);
    var defaultContent = document.getElementById(SIMULATOR.ID_DEFAULT_CONTENT);

    // hide container of simulator to avoid coming of simulator too late or the presence of the loader from API
    simulatorWrapperApi.classList.add('dcw_visually-hidden');

    // check if container exists
    if (!simulatorContainer) {
        throw new Error("SimulatorPPI - dpiAwtConfig is not defined && no container available");
    }

    // check if default content container exists
    if (!defaultContent) {
        throw new Error("SimulatorPPI - default content is not set");
    }

    // check if default content container has content
    if (!defaultContent.children) {
        throw new Error("SimulatorPPI - default content is empty");
    }

    // display default content
    simulatorContainer.appendChild(defaultContent.children[0]);
}

function SimulatorPPI(options) {
    if (!this._isDpiDefined()) {
        displayDefaultContent();
    }

    _Simulator2.default.call(this, options);
    this.integrationMode = this._getIntegrationMode();
}

SimulatorPPI.prototype = Object.create(_Simulator2.default.prototype);
SimulatorPPI.prototype.constructor = SimulatorPPI;

SimulatorPPI.prototype._getIntegrationMode = function () {
    var integrationModeValue = this.element.getAttribute("data-clientside-integration-mode");

    if (!integrationModeValue || integrationModeValue === "empty") {
        return "";
    } else {
        return integrationModeValue;
    }
};

SimulatorPPI.prototype.load = function () {
    if (!window.dpiAwtConfig) {
        return;
    }

    window.ppiSimulator = new window.dpiAwtConfig("dpi", null, this._buildOptions());

    var timeOutOn = setTimeout(function () {
        displayDefaultContent();
    }, 5000);

    window.ppiSimulator.load({}, function () {
        // if the call success, stop the timer
        clearTimeout(timeOutOn);
    });
};

SimulatorPPI.prototype._buildOptions = function () {
    this.options.integrationMode = this.integrationMode;
    return this.options;
};

SimulatorPPI.prototype._isDpiDefined = function () {
    return !!window.dpiAwtConfig;
};

exports.default = SimulatorPPI;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function Simulator(options) {
    this._checkOptions(options);
}

// abstract method to override
Simulator.prototype.load = function () {};

Simulator.prototype._checkOptions = function (options) {
    if (!options) {
        throw new Error("Simulator - missing constructor options parameter");
    }

    var expectedParameters = ["element", "sdcWrapper", "defaultRoute", "noRoute"];

    for (var i = 0; i < expectedParameters.length; i++) {
        if (!options[expectedParameters[i]]) {
            throw new Error("Simulator - missing options parameter:", expectedParameters[i]);
        }
    }

    this.element = options.element;
    this.options = {};
    this.options.sdcWrapper = options.sdcWrapper;
    this.options.defaultRoute = options.defaultRoute;
    this.options.noRoute = options.noRoute;
};

exports.default = Simulator;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var TERM_CLASS = "js-open-popin";

function GlossaryController(element, popinView, terms) {
    this.element = element;
    this.popinView = popinView;
    this.terms = terms;
    this.termModel = this.getTermModelFrom(terms);
    this.bindTermsClick();
    this.renderTermViews();
}

GlossaryController.prototype.bindTermsClick = function () {
    var self = this;

    this.element.addEventListener("click", function (event) {
        var element = event.target;

        if (element.classList.contains(TERM_CLASS)) {
            self.showPopinInfoFrom(element);
        }
    });
};

GlossaryController.prototype.showPopinInfoFrom = function (termElement) {
    var infos = this.getTermInfosFrom(termElement);
    this.popinView.callingElement = termElement;
    this.popinView.render(infos);
    this.popinView.show();
};

GlossaryController.prototype.renderTermViews = function () {
    for (var i = 0; i < this.terms.length; i++) {
        var currentTerm = this.terms[i];

        if (!currentTerm.term || !currentTerm.keyword || !currentTerm.definition) {
            continue;
        }
        // Explanation of the regular expression:
        // * Before we had (\b<word>\b), which would match the word with boundaries in the beginning and in the end.
        // This means that it would match the word if it was surrounded by spaces, or if it ended with punctuation (so,
        // basically wold match the word itself). This solution worked great, except when the word started or ended with
        // characters with accents: the \b only works with characters that match with \w, and characters with accents
        // don't match with it;
        // * To fix this problem, this is the new regular expression that we had to use:
        // (\s|^|[\00-\57]|[\72-\100]|[\133-\140|\173-\177])<word>(=?\s|$|[\00-\57]|[\72-\100]|[\133-\140|\173-\177])
        // This regular expression matches with the <word> if it begins with a space, or if it's the beginning of the
        // sentence, or if begins with any of the characters within those ranges (0 to 57, 72 to 100, 133 to 140 or 173 to 177),
        // and if it ends with a space, if it's the end of the sentence, or if it ends with any of the characters within
        // the same ranges. Those ranges are octal indexes of the ASCII table, and are basically punctuation points and
        // some special characters.
        var termToReplace = "(\\s|^|[\\00-\\57]|[\\72-\\100]|[\\133-\\140|\\173-\\177])" + currentTerm.keyword + "(=?\\s|$|[\\00-\\57]|[\\72-\\100]|[\\133-\\140|\\173-\\177])";
        var regex = new RegExp(termToReplace, "gi");
        var normalizedTerm = this.normalizeTerm(currentTerm.term);

        this.element.innerHTML = this.element.innerHTML.replace(regex, "$1" + glossaryTermTemplate(currentTerm.keyword, normalizedTerm) + "$2");
    }
};

GlossaryController.prototype.getTermInfosFrom = function (element) {
    return this.termModel[getTermNameFrom(element)];
};

GlossaryController.prototype.getTermModelFrom = function (terms) {
    var termModel = {};

    for (var i = 0; i < terms.length; i++) {
        var termKey = this.normalizeTerm(terms[i].term);
        termModel[termKey] = {
            keyword: terms[i].keyword,
            definition: terms[i].definition
        };
    }

    return termModel;
};

GlossaryController.prototype.normalizeTerm = function (term) {
    return term.replace(/ .,\/#!$%\^&\*;:{}=\-_`~()"']/g, "").toLowerCase();
};

function getTermNameFrom(element) {
    return element.getAttribute("data-term-key").toLowerCase();
}

function glossaryTermTemplate(termKeyword, normalizedTerm) {
    return "<span data-term-key='" + normalizedTerm + "' class='dcw_gsm_show-popin js-open-popin' readonly='true'>" + termKeyword + "</span>";
}

exports.default = GlossaryController;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GLOSSARY_TERMS_URL = "/cmscontents/glossaryterms";
var terms;

exports.default = {
    fetch: function fetch(callback) {
        if (terms) {
            return callback(terms);
        }
        var xhr = new XMLHttpRequest();

        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    var response = JSON.parse(xhr.response);
                    if (!response || !response.glossaryTerms) {
                        return;
                    }
                    terms = response.glossaryTerms;
                    callback(terms);
                } else {
                    console.error(xhr);
                }
            }
        };

        xhr.open("GET", GLOSSARY_TERMS_URL, true);
        xhr.send(null);
    }
};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.initCmsUtil = initCmsUtil;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

"use strict";

var CMS_UTIL = {
    SELECTOR_BREADCRUMB_CHANNEL_ID: '#auth-breadcrumb-channel-ids',
    CLIENT_PROSPECT: '0'
};

function initCmsUtil() {
    // Init cms Util
    if (!window.cmsUtil) window.cmsUtil = {};

    // global variable to know if we are in prospect context
    if (!(typeof userSegmentNames === "undefined" ? "undefined" : _typeof(userSegmentNames)) === "undefined" && userSegmentNames.indexOf(CMS_UTIL.CLIENT_PROSPECT) != -1) {
        window.cmsUtil.isProspect = true;
    } else {
        window.cmsUtil.isProspect = false;
    }

    // global variable to know id of current channels breadcrumb
    window.cmsUtil.currentChannelBreadcrumb = (0, _jquery2.default)(CMS_UTIL.SELECTOR_BREADCRUMB_CHANNEL_ID).val();

    // Init cms Text Constants
    if (!window.cmsConstantsLabel) window.cmsConstantsLabel = {};

    window.cmsConstantsLabel.DESKTOP_FOLD_THE_MENU = "Replier la navigation principale";
    window.cmsConstantsLabel.DESKTOP_UNFOLD_THE_MENU = "Déplier la navigation principale";
    window.cmsConstantsLabel.MOBILE_OPEN_THE_MENU = "Ouvrir le menu";
    window.cmsConstantsLabel.MOBILE_CLOSE_THE_MENU = "Fermer le menu";
}

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var queue = [];

var addToQueue = function addToQueue(method, params) {
    queue.push({
        func: method,
        data: params
    });
};

var executeQueuedFunctions = function executeQueuedFunctions() {
    if (queue.length) {
        for (var i = 0; i < queue.length; i++) {
            try {
                queue[i].func(queue[i].data);
            } catch (error) {
                console.error(error);
            }
        }

        queue = [];
    }
};

exports.executeQueuedFunctions = executeQueuedFunctions;
exports.addToQueue = addToQueue;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initCookieDisclaimer = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initCookieDisclaimer = function initCookieDisclaimer() {
    var dateNow = new Date();
    dateNow.setMonth(dateNow.getMonth() + 1);
    dateNow.setFullYear(dateNow.getFullYear() + 1);
    var CMS_COOKIE_USER_CONSENT = "user_consent";
    var CMS_SET_COOKIE_USER_CONSENT = "user_consent=true;path=/;expires=" + dateNow.toUTCString();

    var selectorDisclaimer = "#cookieDisclaimer";
    var cookieYetUpdated = false;

    // Function to get a cookie
    function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) {
            return parts.pop().split(";").shift();
        }
        return "";
    }

    var cookieUserContent = getCookie(CMS_COOKIE_USER_CONSENT);

    if (cookieUserContent == null || cookieUserContent === "") {
        (0, _jquery2.default)("#cookieDisclaimer").show();

        // remove disclaimer and add cookie if click on all btn or link of the current page

        (0, _jquery2.default)('a, #cookieDisclaimer button').on('click', function (e) {
            e.preventDefault();
            var href = (0, _jquery2.default)(this).attr("href");
            document.cookie = CMS_SET_COOKIE_USER_CONSENT;
            (0, _jquery2.default)(selectorDisclaimer).hide();

            if (href) {
                window.location = href;
            }
        });

        (0, _jquery2.default)(window).on('scroll', function () {
            if (cookieYetUpdated) {
                return;
            }

            var scrollPosition = (0, _jquery2.default)(this).scrollTop();
            if (scrollPosition >= 5) {
                document.cookie = CMS_SET_COOKIE_USER_CONSENT;
                (0, _jquery2.default)(selectorDisclaimer).hide();
                cookieYetUpdated = true;
            }
        });
    }
};

exports.initCookieDisclaimer = initCookieDisclaimer;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
				value: true
});
exports.initSearchContext = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _sinequa = __webpack_require__(183);

var _sinequa2 = _interopRequireDefault(_sinequa);

var _Cookie = __webpack_require__(25);

var _Cookie2 = _interopRequireDefault(_Cookie);

var _sobot = __webpack_require__(85);

var _sobot2 = _interopRequireDefault(_sobot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

"use strict";

var keyword;
var profilsToDeactivate;

// Dom Elements
var $contentZone = null;
var searchApp = null;
var sobotApp = null;

var activateSobot = true;

// Const
var SELECTOR_CONTENT_ZONE = "#dcw_results_content";
var SELECTOR_SEARCH_KEYWORD = "#search-keyword";
var CLASS_SEARCH_OUTPUT = "dcw_results_output";

var SEARCH = {
				MESSAGE_NO_RESULT: '0 r\xE9ponse  sur le site'
};

var COOKIE_PROFILE = "profilTiers";

/*
    Build dom if no query made (no ajax call to do)
 */
function buildEmptyQueryResult() {
				displayEmptySearch();
				displayContentZone();
}

function displayContentZone() {
				$contentZone.css('visibility', 'visible');
}

function displayEmptySearch() {
				// Display Gsa empty default text

				if ((0, _jquery2.default)("#id_results_output").length) {
								(0, _jquery2.default)("#id_results_output").empty();
								(0, _jquery2.default)("#id_results_output").removeClass().addClass(CLASS_SEARCH_OUTPUT).html(SEARCH.MESSAGE_NO_RESULT);
				}
				// For pages with old html :
				else {
												var pSearch = (0, _jquery2.default)('<p></p>').attr("class", CLASS_SEARCH_OUTPUT).append(document.createTextNode(SEARCH.MESSAGE_NO_RESULT));
												$contentZone.append(pSearch);
								}
}

function buildResultsPage() {
				// Build result of the search
				searchApp.buildSearchResults();
				displayContentZone();
}

function cleanKeyword(keyword) {
				// clean query string
				keyword = keyword.replace(/"([^"]+(?="))"/g, '$1').trim();

				if (keyword !== null && keyword !== undefined && keyword !== "") {
								keyword = atob(keyword);
				}

				return keyword;
}

function launchSobot(keyword) {
				sobotApp = new _sobot2.default(keyword);
				sobotApp.initSobot();
}

function checkIfDisabled() {
				if (window.cmsGlobals.chatbotConfig.disabled) {
								return false;
				} else {
								return true;
				}
}

function checkProfil() {
				// Keep list of profils to deactivate
				if (window.cmsGlobals.chatbotConfig.profilToDeactivate && window.cmsGlobals.chatbotConfig.profilToDeactivate != "") {
								profilsToDeactivate = window.cmsGlobals.chatbotConfig.profilToDeactivate;
				} else {
								return true;
				}

				var listOfProfiles = profilsToDeactivate.split(',');
				var profilT = _Cookie2.default.getByName(COOKIE_PROFILE);
				var profileDeactivated = false;

				if (profilT === "") {
								return true;
				} else {
								listOfProfiles.forEach(function (profilToDeactivate) {
												if (profilT.includes(profilToDeactivate)) {
																profileDeactivated = true;
												}
								});
				}

				if (profileDeactivated) {
								return false;
				} else {
								return true;
				}
}

var initSearchContext = function initSearchContext() {

				var hashValue = window.location.hash;
				var keyword = hashValue.indexOf("#keyword=") >= 0 ? hashValue.replace(/^#keyword=/, '') : undefined;

				//Sobot ?
				activateSobot = checkIfDisabled();
				if (activateSobot) {
								activateSobot = checkProfil();
				}

				// If on page resultats-recherche
				if (window.location.href.indexOf("resultats-recherche") >= 0) {

								window.EventBusCMS.addEventListener('buildSearch', function (event) {
												if (event.detail.isReady === 'search') {
																buildResultsPage();
												}
								});

								$contentZone = (0, _jquery2.default)(SELECTOR_CONTENT_ZONE);

								var keywordSoClean = "";
								if (keyword == null || keyword == undefined || keyword == "") {} else {

												var keywordClean = cleanKeyword(keyword); // Ascii
												var keywordlength = keywordClean.length - 1;
												keywordSoClean = keywordClean.substr(0, keywordlength); // without final character (b/p)
												if (keywordSoClean != "") {
																if (activateSobot) {
																				launchSobot(keywordSoClean);
																}

																searchApp = new _sinequa2.default($contentZone, keywordClean);

																/*/ Test 0 résultat
                var	origin = keywordClean.substr(keywordlength,1);
                if (origin=="0")
                	searchApp.callSearchApiTest0resultat();
                else */
																searchApp.callSearchApi();
												}
								}
								// manage empty query case : if no search done then show : 0 results
								if (keywordSoClean == "") {
												if (activateSobot) {
																launchSobot("");
												}
												buildEmptyQueryResult();
								}
				}
};

exports.initSearchContext = initSearchContext;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
				value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// constants for SINEQUE search
var MESSAGE_ERROR_FIRST_LINE = "La recherche sur le site est momentanément indisponible.",
    MESSAGE_ERROR_SECOND_LINE = "Nous vous invitons à renouveller votre recherche ultérieurement.",
    CLASS_SEARCH_OUTPUT = "dcw_results_output",
    LABEL_RESULTAT = " r\xE9sultat",
    LABEL_RESULTATS = " r\xE9sultats";

var Sinequa = function () {
				function Sinequa($contentZone, keyword) {
								_classCallCheck(this, Sinequa);

								this.container = $contentZone;
								this.itemslist = (0, _jquery2.default)('<ul></ul>');

								this.keyword = keyword;

								var origin = "";
								if (this.keyword == null || this.keyword == undefined || this.keyword == "") {
												this.keyword = "";
								} else {
												var keywordlength = this.keyword.length - 1;
												origin = this.keyword.substr(keywordlength, 1);
												this.keyword = this.keyword.substr(0, keywordlength);
								}

								this.keywordTms = this.formatTms(this.keyword);

								this.searchengin = "barre-page-de-recherche";
								if (origin == "b") {
												this.searchengin = "barre-de-recherche";
								} else if (origin == "p") {
												this.searchengin = "page-de-recherche";
								}

								// Keep global config
								this.nbResultsToDisplay = window.cmsGlobals.sinequaConfig.sinequaResultsToDisplay;
								// !!! Only for tests vf-kli !!!
								//this.nbResultsToDisplay=2;
								//if (origin == "0") this.nbResultsToDisplay=0;

								this.nbSponsorizedLinks = window.cmsGlobals.sinequaConfig.numSpLinks;
								this.numItem = window.cmsGlobals.sinequaConfig.numItem;

								this.results = null;
								this.links = null;
								this.nbResultsNatural = null;
								this.nbResultTotal = null;
								this.indexResult = 0;

								// keep possibility to switch xsearch / xrest API
								this.methodXsearch = window.cmsGlobals.sinequaConfig.methodXsearch;
								this.secureContext = false;
								if (tc_vars["user_is_logged"] === true) {
												this.secureContext = true;
								}
								// Keep right Url
								if (this.methodXsearch) {
												if (this.secureContext) {
																this.url = window.cmsGlobals.sinequaConfig.sinequaResultsXsearchSecure;
												} else {
																this.url = window.cmsGlobals.sinequaConfig.sinequaResultsXsearch;
												}
								} else {
												if (this.secureContext) {
																this.url = window.cmsGlobals.sinequaConfig.sinequaResultsSecure;
												} else {
																this.url = window.cmsGlobals.sinequaConfig.sinequaResults;
												}
								}
				}

				// tcod 2741


				_createClass(Sinequa, [{
								key: "formatTms",
								value: function formatTms(inputText) {
												if (inputText) {
																return inputText.replace(/[\s+]/g, '-').replace(/[éèê]/g, "e").replace(/[\u2018\u2019\u0027]/g, "-").replace(/à/g, "a").toLowerCase();
												}
												return "";
								}
				}, {
								key: "displayMessage",
								value: function displayMessage(pmessage, pclass) {
												if ((0, _jquery2.default)("#id_results_output").length) {
																(0, _jquery2.default)("#id_results_output").empty();
																(0, _jquery2.default)("#id_results_output").removeClass().addClass(pclass).html(pmessage);
												}
												// For pages with old html :
												else {
																				this.container.append("<p class=\"" + pclass + "\" role=\"status\">" + pmessage + "</p>");
																}
								}

								// BUILD

				}, {
								key: "manageSearchFail",
								value: function manageSearchFail() {
												this.displayMessage(MESSAGE_ERROR_FIRST_LINE + "<br/>" + MESSAGE_ERROR_SECOND_LINE, CLASS_SEARCH_OUTPUT);

												/*var p = $('<p role="status"></p>').attr("class", CLASS_SEARCH_OUTPUT);
            p.append(document.createTextNode(MESSAGE_ERROR_FIRST_LINE));
            p.append(document.createElement("br"));
            p.append(document.createTextNode(MESSAGE_ERROR_SECOND_LINE));
            this.container.append(p);*/
								}
				}, {
								key: "buildSearchParagraph",
								value: function buildSearchParagraph(infoToDisplay) {

												// tcod 2741 track on paragraphe
												var divWrapper = (0, _jquery2.default)('<li></li>').attr("class", "dcw_results_wrapper");

												var h2 = (0, _jquery2.default)('<h2></h2>');
												if (infoToDisplay.hasOwnProperty('aria-live')) h2.attr("aria-live", infoToDisplay['aria-live']);

												var alink = (0, _jquery2.default)('<a></a>').attr("class", "dcw_results_link").attr("href", infoToDisplay['currentUrl']);
												if (infoToDisplay.hasOwnProperty('bddfTms')) alink.attr("onclick", infoToDisplay['bddfTms']);
												alink.append((0, _jquery2.default)(infoToDisplay["currentTitle"]));
												h2.attr("class", "dcw_title").append(alink);
												divWrapper.append(h2);
												divWrapper.append((0, _jquery2.default)('<p>' + infoToDisplay["currentText"] + '</p>').attr("class", "dcw_results_desc"));
												var alink = (0, _jquery2.default)('<a></a>').attr("class", "dcw_results_hypertexte").attr("href", infoToDisplay['currentUrl']);
												if (infoToDisplay.hasOwnProperty('bddfTms')) alink.attr("onclick", infoToDisplay['bddfTms']);

												divWrapper.append(alink.append(document.createTextNode(infoToDisplay['currentUrl'].replace(window.location.origin, ""))));

												return divWrapper;
								}

								// Check if the nb of item is less than the nb of results configurated and then iterate

				}, {
								key: "displayResults",
								value: function displayResults() {
												var resultsToDisplay = this.nbResultsNatural > this.nbResultsToDisplay ? this.nbResultsToDisplay : this.nbResultsNatural;
												this.indexResult = resultsToDisplay;

												for (var i = 0; i < this.indexResult; i++) {
																var currentResponse = this.results[i];
																var infoToDisplay = this.prepareInfoToDisplay(currentResponse);
																this.itemslist.append(this.buildSearchParagraph(infoToDisplay));
												}
								}

								// Check if the nb of item is less than the nb of results configurated and then iterate

				}, {
								key: "displaySponsorizedLinks",
								value: function displaySponsorizedLinks() {
												var nbLinks = this.links.length;
												for (var i = 0; i < nbLinks; i++) {
																var currentLink = this.links[i];
																var infoToDisplay = [];

																if (!currentLink.Summary) return;

																// get current Elements
																// prevent % encoding issues (URI malformed)
																var currentText = currentLink.Summary;
																infoToDisplay['currentText'] = currentText;
																infoToDisplay['currentTitle'] = currentLink.Title.replace("<b>", "").replace("</b>", "").bold();
																infoToDisplay['currentUrl'] = currentLink.Url;

																this.itemslist.append(this.buildSearchParagraph(infoToDisplay));
												}
								}
				}, {
								key: "prepareInfoToDisplay",
								value: function prepareInfoToDisplay(currentResponse) {
												var infoToDisplay = [];
												var currentText,
												    currentUrl,
												    currentTitle = "";

												// get current Elements
												// prevent % encoding issues (URI malformed)
												if (this.methodXsearch) {

																if (!currentResponse.hasOwnProperty('HtmlSummary') || !currentResponse.hasOwnProperty('Url1') || !currentResponse.hasOwnProperty('Title')) {
																				return;
																}

																currentText = currentResponse.HtmlSummary;
																currentUrl = currentResponse.Url1;
																currentTitle = currentResponse.Title;
												} else {

																if (!currentResponse.hasOwnProperty('smallsummaryhtml') || !currentResponse.hasOwnProperty('resulturl') || !currentResponse.hasOwnProperty('title')) {
																				return;
																}
																currentText = currentResponse.smallsummaryhtml;
																currentUrl = currentResponse.resulturl;
																currentTitle = currentResponse.title;

																// 2741 Clic sur l'un des résultats
																// Propriété infoToDisplay['bddfTms']
																var search_engine_result_page = "1"; // no page management otherwise retrieve from response
																var bddfTms = "bddfTms.trackEvent(this,'internal_search_result_click',{" + "search_engine_name:'" + this.searchengin + "'," + "search_engine_keyword:'" + this.keywordTms + "'," + "search_engine_result_number:'" + this.nbResultsNatural.toString() + "'," + "search_engine_result_page:'" + search_engine_result_page + "'," + "search_engine_click_rank:'" + (currentResponse.docrank + 1).toString() + "'," + "search_engine_click_title:'" + this.formatTms(currentTitle) + "'," + "search_engine_click_uri:'" + this.formatTms(currentUrl) + "'})";
																infoToDisplay['bddfTms'] = bddfTms;
												}

												infoToDisplay['currentText'] = currentText;
												infoToDisplay['currentTitle'] = currentTitle.replace("<b>", "").replace("</b>", "").bold();
												infoToDisplay['currentUrl'] = currentUrl;

												return infoToDisplay;
								}

								//  Manage Btn to display more results

				}, {
								key: "displayMoreResults",
								value: function displayMoreResults() {
												var _self = this;
												var isLastIteration = false;
												var lastIndex;
												// 2741
												var link = (0, _jquery2.default)('<a></a>').attr("class", "dcw_btn dcw_btn--ghost-dark dcw_results_more").attr("onclick", "bddfTms.trackEvent(this, 'click', {event_name:'resultats-de-recherche::clic-sur-voir-plus-de-resultats'});").attr("tabindex", "0").attr("role", "button").attr("aria-label", "Voir plus de résultats (Chargement ci-dessous)").append(document.createTextNode("Voir plus de r\xE9sultats"));

												link.click(function () {

																link.remove();

																if (_self.indexResult + _self.nbResultsToDisplay > _self.nbResultTotal) {
																				isLastIteration = true;
																				lastIndex = _self.nbResultTotal;
																} else {
																				lastIndex = _self.indexResult + _self.nbResultsToDisplay;
																}

																for (var i = _self.indexResult; i < lastIndex; i++) {
																				var currentResponse = _self.results[i];
																				var infoToDisplay = _self.prepareInfoToDisplay(currentResponse);
																				//infoToDisplay['aria-live'] = "polite";

																				_self.itemslist.append(_self.buildSearchParagraph(infoToDisplay));
																}

																_self.indexResult = lastIndex;
																if (!isLastIteration) _self.displayMoreResults();
												});

												_self.container.append(link);
								}

								// BUILD DOM AFTER AJAX CALL

				}, {
								key: "buildSearchResults",
								value: function buildSearchResults() {
												var _self = this;
												if (this.results == null) {
																this.manageSearchFail();
												} else {
																if (this.nbResultTotal == null) {
																				this.nbResultTotal = 0;
																}

																// display number of results
																var responseWord = this.nbResultTotal <= 1 ? LABEL_RESULTAT : LABEL_RESULTATS;
																this.displayMessage(this.nbResultTotal + responseWord + " sur le site", "dcw_results_output");

																/*var p = $('<p role="status"></p>')
                    .attr("class","dcw_results_output")
                    .append(document.createTextNode(this.nbResultTotal + responseWord + " sur le site"));
                this.container.append(p);*/

																// Create List
																var nitems = 0;

																// Sponsored Links
																if (this.links != null) {
																				_self.itemslist.append(this.displaySponsorizedLinks());
																				nitems = this.links.length;
																}

																// Search results
																_self.itemslist.append(this.displayResults());
																nitems += this.results.length;

																if (nitems > 0) _self.container.append(_self.itemslist);

																// Display more
																if (this.nbResultTotal > this.nbResultsToDisplay) {
																				this.displayMoreResults();
																}
												}
								}
				}, {
								key: "callXAPIDone",
								value: function callXAPIDone(response, calltype) {}
				}, {
								key: "callXAPIFail",
								value: function callXAPIFail() {

												// tcod 2741 - chargement de la page - fail
												bddfTms.trackEvent(this, 'internal_search_result_display', {
																search_engine_name: this.searchengin,
																search_engine_keyword: this.keywordTms,
																search_engine_result_number: '0',
																search_engine_result_page: ''
												});

												window.EventBusCMS.dispatchEvent('buildSearch', { isReady: 'search' });
								}
				}, {
								key: "callXsearchAPI",
								value: function callXsearchAPI() {
												var _self = this;
												var settings = {
																"method": "POST",
																"async": true,
																"crossDomain": true,
																"url": _self.url,
																"headers": {
																				"Content-Type": "application/x-www-form-urlencoded",
																				"Cache-Control": "no-cache"
																},
																"data": {
																				"text": _self.keyword,
																				"questionlanguage": "fr",
																				"type": "json",
																				"skipCount": _self.numItem
																}
												};

												_jquery2.default.ajax(settings).done(function (response) {
																if (typeof response.Documents !== "undefined") {
																				_self.results = response.Documents;
																				_self.nbResultsNatural = response.DocumentCount;
																				// tcod 2741 - chargement de la page
																				var pcurrentPage = response.CurrentPage;
																				var currentPage = pcurrentPage.toString();
																				if (currentPage == '0') currentPage = '';
																				bddfTms.trackEvent(this, 'internal_search_result_display', {
																								search_engine_name: _self.searchengin,
																								search_engine_keyword: _self.keywordTms,
																								search_engine_result_number: _self.nbResultsNatural.toString(),
																								search_engine_result_page: currentPage
																				});
																}

																if (typeof response.Links !== "undefined") {
																				_self.links = response.Links;
																				_self.nbResultTotal = _self.nbResultsNatural + _self.links.length;
																}

																window.EventBusCMS.dispatchEvent('buildSearch', { isReady: 'search' });
												}).fail(function () {
																// tcod 2741 - chargement de la page - fail
																bddfTms.trackEvent(this, 'internal_search_result_display', {
																				search_engine_name: _self.searchengin,
																				search_engine_keyword: _self.keywordTms,
																				search_engine_result_number: '0',
																				search_engine_result_page: ''
																});

																window.EventBusCMS.dispatchEvent('buildSearch', { isReady: 'search' });
												});
								}
				}, {
								key: "callXrestAPI",
								value: function callXrestAPI() {

												var _self = this;
												var settings = {
																"method": "GET",
																"async": true,
																"crossDomain": true,
																"url": _self.url,
																"headers": {
																				"Cache-Control": "no-cache"
																},
																"data": {
																				"query.text": _self.keyword,
																				"query.questionlanguage": "fr",
																				"method": "search.profile",
																				"responsetype": "Searchresult"
																}
												};

												_jquery2.default.ajax(settings).done(function (response) {
																//_self.callXAPIDone(response, "rest");
																if (typeof response.Result !== "undefined") {
																				if (typeof response.Result.Docs !== "undefined") {
																								_self.results = response.Result.Docs;
																								_self.nbResultsNatural = response.DocumentCount;

																								// tcod 2741 - chargement de la page
																								var pcurrentPage = response.CurrentPage;
																								var currentPage = pcurrentPage.toString();
																								if (currentPage == '0') currentPage = '';
																								bddfTms.trackEvent(this, 'internal_search_result_display', {
																												search_engine_name: _self.searchengin,
																												search_engine_keyword: _self.keywordTms,

																												search_engine_result_number: _self.nbResultsNatural.toString(),
																												search_engine_result_page: currentPage
																								});
																				}

																				if (typeof response.Result.Links !== "undefined") {
																								_self.links = response.Result.Links;
																								_self.nbResultTotal = _self.nbResultsNatural + _self.links.length;
																				}
																}
																window.EventBusCMS.dispatchEvent('buildSearch', { isReady: 'search' });
												}).fail(function () {
																//_self.callXAPIFail();				
																// tcod 2741 - chargement de la page - fail
																bddfTms.trackEvent(this, 'internal_search_result_display', {
																				search_engine_name: _self.searchengin,
																				search_engine_keyword: _self.keywordTms,
																				search_engine_result_number: '0',
																				search_engine_result_page: ''
																});

																window.EventBusCMS.dispatchEvent('buildSearch', { isReady: 'search' });
												});
								}
				}, {
								key: "callSearchApi",
								value: function callSearchApi() {
												if (this.methodXsearch) this.callXsearchAPI();else this.callXrestAPI();
								}
								// ONLY FOR TEST - SIMULATE callX...
								/*var response = {
        	"ProcessingTime": " 9 ms",
        	"RowFetchTime": " 2 ms",
        	"DocumentCount": 3,
        	"TotalCount": 3,
        	"PageCount": 1,
        	"CurrentPage": 1,
        	"DocumentsPerPage": 200,
        	"DocumentsThisPage": 3,
        	"ProductTitle": "Sinequa Enterprise Search",
        	"Result": {
        		"queryid": "",
        		"resultid": "89286C8351874F1BA7DD47C58B2A29F9",
        		"Docs": [
        			{	"docid": "\/NGC-Source\/PRI-ANON-Collection\/|http:\/\/192.65.110.83:40700\/articles-actualites\/preparer-retraite-50-60-ans",
        				"collection": "\/NGC-Source\/PRI-ANON-Collection\/",
        				"company": "SOCIETE GENERALE;Soci\u00e9t\u00e9 G\u00e9n\u00e9rale;411,16,496,16,990,16,3435,16,7115,16,7217,16;18207,20,19352,20,41641,20,54541,20,66733,20,68482,20;CREDIT DU NORD;Cr\u00e9dit du Nord;330,14,877,14;17064,15,39838,15",
        				"docrank": 0,
        				"docformat": "htm",
        				"extracts": "Plus vous ferez {b}t\u00f4t{nb} cette d\u00e9marche et plus il vous sera possible de signaler rapidement aux organismes concern\u00e9s les \u00e9ventuels oublis, pour r\u00e9gularisation.;1878,155;52046,160;Ainsi, plus le demandeur s'y prend {b}t\u00f4t{nb}, moins le rachat de ses trimestres sera \u00e9lev\u00e9.;2463,85;52944,90",
        				"fileext": "htm",
        				"filename": "preparer-retraite-50-60-ans",
        				"flags": "h",
        				"fullsummaryhtml": "<b>t&#244;t <\/b>",
        				"geo": "AUVERGNE;Auvergne;378,8,941,8;17757,8,40877,8;RHONE-ALPES;Rh\u00f4ne-Alpes;387,11,950,11;17766,12,40886,12;ILE-DE-FRANCE;Ile-de-France;514,13,1008,13;19374,14,41663,14;CORSE;Corse;429,5;18229,5;MONACO;Monaco;979,6;41386,6",
        				"globalrelevance": 64,
        				"hashtml": true,
        				"index": "PRI_ANON_Index",
        				"indexationtime": "2023-10-06 00:07:14",
        				"internalglobalrelevance": 0.649915,
        				"imageurl": "images\/html.gif",
        				"languages": "fr",
        				"largesummaryhtml": "Plus vous ferez <b>t&#244;t <\/b>cette d&#233;marche et plus il vous sera possible de signaler rapidement aux organismes concern&#233;s les &#233;ventuels oublis, pour r&#233;gularisation.... Ainsi, plus le demandeur s&#39;y prend <b>t&#244;t<\/b>, moins le rachat de ses trimestres sera &#233;lev&#233;.",
        				"matchingpartnames": "text",
        				"matchlocations": "1894,3,2498,3;52062,4,52981,4",
        				"matchlocationsperterm": "tot;1894.3,2498.3;52062.4,52981.4",
        				"modified": "2023-10-06 00:07:14",
        				"source": "NGC-Source",
        				"version": "S0F37SW570I1pi72vRPTQA==",
        				"title": "Pr\u00e9parer sa retraite : que faut-il faire de 50 \u00e0 60 ans ? (\u00e2ge, revenus ...",
        				"treepath": "\/NGC-Source\/",
        				"size": 72951,
        				"smallsummaryhtml": "Plus vous ferez <b>t&#244;t <\/b>cette d&#233;marche et plus il vous sera possible ... organismes concern&#233;s les &#233;ventuels oublis, pour r&#233;gularisation.... Ainsi, plus le demandeur s&#39;y prend <b>t&#244;t<\/b>, moins le rachat de ses trimestres sera &#233;lev&#233;.",
        				"smallimageurl": "images\/html-small.gif",
        				"tinyimageurl": "images\/html-small-2.gif",
        				"resultid": "89286C8351874F1BA7DD47C58B2A29F9",
        				"resulturl": "\/articles-actualites\/preparer-retraite-50-60-ans",
        				"resulttitle": "Pr\u00e9parer sa retraite : que faut-il faire de 50 \u00e0 60 ans ? (\u00e2ge, revenus ...",
        				"urlcachehtmltext": "download\/htmltext\/%252FNGC-Source%252FPRI-ANON-Collection%252F%257Chttp%253A%252F%252F192.65.110.83%253A40700%252Farticles-actualites%252Fpreparer-retraite-50-60-ans\/file.htm",
        				"urlcachehtml": "download\/html\/%252FNGC-Source%252FPRI-ANON-Collection%252F%257Chttp%253A%252F%252F192.65.110.83%253A40700%252Farticles-actualites%252Fpreparer-retraite-50-60-ans\/file.htm",
        				"urldocresult": "docresult?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fpreparer-retraite-50-60-ans&docrank=0&resultid=89286C8351874F1BA7DD47C58B2A29F9",
        				"urldocresultontext": "docresult?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fpreparer-retraite-50-60-ans&docrank=0&resultid=89286C8351874F1BA7DD47C58B2A29F9&on=text",
        				"urldocresultleft": "docresultleft?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fpreparer-retraite-50-60-ans&docrank=0&resultid=89286C8351874F1BA7DD47C58B2A29F9",
        				"urldocresultvert": "docresultvert?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fpreparer-retraite-50-60-ans&docrank=0&resultid=89286C8351874F1BA7DD47C58B2A29F9",
        				"urldocresulthorz": "docresulthorz?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fpreparer-retraite-50-60-ans&docrank=0&resultid=89286C8351874F1BA7DD47C58B2A29F9",
        				"term": {
        					"term1": "tot;1894.3,2498.3;52062.4,52981.4",
        					"termsall": "tot;1894.3,2498.3;52062.4,52981.4"
        				}
        			},
        			{	"docid": "\/NGC-Source\/PRI-ANON-Collection\/|http:\/\/192.65.110.83:40700\/articles-actualites\/guide-quand-comment-constituer-faire-son-epargne",
        				"collection": "\/NGC-Source\/PRI-ANON-Collection\/",
        				"company": "SOCIETE GENERALE;Soci\u00e9t\u00e9 G\u00e9n\u00e9rale;65,16,417,16,502,16,996,16,2256,16,2328,16,3959,16,5207,16,5913,16,6015,16,6295,16;431,20,18228,20,19373,20,41662,20,52899,20,53109,20,56507,20,58796,20,66199,20,67948,20,72583,36;CREDIT DU NORD;Cr\u00e9dit du Nord;336,14,883,14;17085,15,39859,15",
        				"docrank": 1,
        				"docformat": "htm",
        				"extracts": "plus vous commencez \u00e0 \u00e9pargner {b}t\u00f4t{nb}, moins l'effort d'\u00e9pargne est important.;3521,75;55553,83;C'est pourquoi en ouvrant un contrat le plus {b}t\u00f4t{nb} possible, vous optimisez la fiscalit\u00e9 et confirmez l'int\u00e9r\u00eat de \u00ab prendre date \u00bb, m\u00eame avec un faible versement.;3757,161;55833,182",
        				"fileext": "htm",
        				"filename": "guide-quand-comment-constituer-faire-son-epargne",
        				"flags": "h",
        				"fullsummaryhtml": "<b>t&#244;t<\/b>",
        				"geo": "AUVERGNE;Auvergne;384,8,947,8;17778,8,40898,8;RHONE-ALPES;Rh\u00f4ne-Alpes;393,11,956,11;17787,12,40907,12;ILE-DE-FRANCE;Ile-de-France;520,13,1014,13;19395,14,41684,14;CORSE;Corse;435,5;18250,5;MONACO;Monaco;985,6;41407,6",
        				"globalrelevance": 64,
        				"hashtml": true,
        				"index": "PRI_ANON_Index",
        				"indexationtime": "2023-10-06 00:07:15",
        				"internalglobalrelevance": 0.646448,
        				"imageurl": "images\/html.gif",
        				"languages": "fr",
        				"largesummaryhtml": "plus vous commencez &#224; &#233;pargner <b>t&#244;t<\/b>, moins l&#39;effort d&#39;&#233;pargne est important.... C&#39;est pourquoi en ouvrant un contrat le plus <b>t&#244;t <\/b>possible, vous optimisez la fiscalit&#233; et confirmez l&#39;int&#233;r&#234;t de &#171; prendre date &#187;, m&#234;me avec un faible versement.",
        				"matchingpartnames": "text",
        				"matchlocations": "3552,3,3802,3;55586,4,55880,4",
        				"matchlocationsperterm": "tot;3552.3,3802.3;55586.4,55880.4",
        				"modified": "2023-10-06 00:07:15",
        				"source": "NGC-Source",
        				"version": "Ghem5Te123lNmVYCUWA9eQ==",
        				"title": "Guide de l'\u00e9pargne : quand et comment constituer son \u00e9pargne ? - Soci\u00e9t\u00e9 G\u00e9n\u00e9rale",
        				"treepath": "\/NGC-Source\/",
        				"size": 72417,
        				"smallsummaryhtml": "plus vous commencez &#224; &#233;pargner <b>t&#244;t<\/b>, moins l&#39;effort d&#39;&#233;pargne est important.... C&#39;est pourquoi en ouvrant un contrat le plus <b>t&#244;t <\/b>possible, vous optimisez la fiscalit&#233; et confirmez ... date &#187;, m&#234;me avec un faible versement.",
        				"smallimageurl": "images\/html-small.gif",
        				"tinyimageurl": "images\/html-small-2.gif",
        				"resultid": "89286C8351874F1BA7DD47C58B2A29F9",
        				"resulturl": "\/articles-actualites\/guide-quand-comment-constituer-faire-son-epargne",
        				"resulttitle": "Guide de l'\u00e9pargne : quand et comment constituer son \u00e9pargne ? - Soci\u00e9t\u00e9 G\u00e9n\u00e9rale",
        				"urlcachehtmltext": "download\/htmltext\/%252FNGC-Source%252FPRI-ANON-Collection%252F%257Chttp%253A%252F%252F192.65.110.83%253A40700%252Farticles-actualites%252Fguide-quand-comment-constituer-faire-son-epargne\/file.htm",
        				"urlcachehtml": "download\/html\/%252FNGC-Source%252FPRI-ANON-Collection%252F%257Chttp%253A%252F%252F192.65.110.83%253A40700%252Farticles-actualites%252Fguide-quand-comment-constituer-faire-son-epargne\/file.htm",
        				"urldocresult": "docresult?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fguide-quand-comment-constituer-faire-son-epargne&docrank=1&resultid=89286C8351874F1BA7DD47C58B2A29F9",
        				"urldocresultontext": "docresult?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fguide-quand-comment-constituer-faire-son-epargne&docrank=1&resultid=89286C8351874F1BA7DD47C58B2A29F9&on=text",
        				"urldocresultleft": "docresultleft?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fguide-quand-comment-constituer-faire-son-epargne&docrank=1&resultid=89286C8351874F1BA7DD47C58B2A29F9",
        				"urldocresultvert": "docresultvert?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fguide-quand-comment-constituer-faire-son-epargne&docrank=1&resultid=89286C8351874F1BA7DD47C58B2A29F9",
        				"urldocresulthorz": "docresulthorz?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fguide-quand-comment-constituer-faire-son-epargne&docrank=1&resultid=89286C8351874F1BA7DD47C58B2A29F9",
        				"term": {
        					"term1": "tot;3552.3,3802.3;55586.4,55880.4",
        					"termsall": "tot;3552.3,3802.3;55586.4,55880.4"
        				}
        			},
        			{	"docid": "\/NGC-Source\/PRI-ANON-Collection\/|http:\/\/192.65.110.83:40700\/articles-actualites\/quel-est-meilleur-placement-bancaire",
        				"collection": "\/NGC-Source\/PRI-ANON-Collection\/",
        				"company": "SOCIETE GENERALE;Soci\u00e9t\u00e9 G\u00e9n\u00e9rale;394,16,479,16,973,16,5765,16,5867,16;18162,20,19307,20,41596,20,64108,20,65857,20;CREDIT DU NORD;Cr\u00e9dit du Nord;313,14,860,14;17019,15,39793,15",
        				"docrank": 2,
        				"docformat": "htm",
        				"extracts": "Plus vous \u00e9pargnez {b}t\u00f4t{nb}, plus vous augmentez votre capacit\u00e9 d'emprunt le jour o\u00f9 vous avez besoin de souscrire un pr\u00eat immobilier.;2511,129;52879,136",
        				"fileext": "htm",
        				"filename": "quel-est-meilleur-placement-bancaire",
        				"flags": "h",
        				"fullsummaryhtml": "<b>t&#244;t<\/b>",
        				"geo": "AUVERGNE;Auvergne;361,8,924,8;17712,8,40832,8;RHONE-ALPES;Rh\u00f4ne-Alpes;370,11,933,11;17721,12,40841,12;ILE-DE-FRANCE;Ile-de-France;497,13,991,13;19329,14,41618,14;CORSE;Corse;412,5;18184,5;MONACO;Monaco;962,6;41341,6",
        				"globalrelevance": 61,
        				"hashtml": true,
        				"index": "PRI_ANON_Index",
        				"indexationtime": "2023-10-06 00:07:22",
        				"internalglobalrelevance": 0.619396,
        				"imageurl": "images\/html.gif",
        				"languages": "fr",
        				"largesummaryhtml": "Plus vous &#233;pargnez <b>t&#244;t<\/b>, plus vous augmentez votre capacit&#233; d&#39;emprunt le jour o&#249; vous avez besoin de souscrire un pr&#234;t immobilier.",
        				"matchingpartnames": "text",
        				"matchlocations": "2530,3;52899,4",
        				"matchlocationsperterm": "tot;2530.3;52899.4",
        				"modified": "2023-10-06 00:07:22",
        				"source": "NGC-Source",
        				"version": "LkQYszsKIgbbFOlAADJFGQ==",
        				"title": "Quel est le meilleur placement bancaire pour son \u00e9pargne ?",
        				"treepath": "\/NGC-Source\/",
        				"size": 70326,
        				"smallsummaryhtml": "Plus vous &#233;pargnez <b>t&#244;t<\/b>, plus vous augmentez votre capacit&#233; d&#39;emprunt le jour o&#249; vous avez besoin de souscrire un pr&#234;t immobilier.",
        				"smallimageurl": "images\/html-small.gif",
        				"tinyimageurl": "images\/html-small-2.gif",
        				"resultid": "89286C8351874F1BA7DD47C58B2A29F9",
        				"resulturl": "\/articles-actualites\/quel-est-meilleur-placement-bancaire",
        				"resulttitle": "Quel est le meilleur placement bancaire pour son \u00e9pargne ?",
        				"urlcachehtmltext": "download\/htmltext\/%252FNGC-Source%252FPRI-ANON-Collection%252F%257Chttp%253A%252F%252F192.65.110.83%253A40700%252Farticles-actualites%252Fquel-est-meilleur-placement-bancaire\/file.htm",
        				"urlcachehtml": "download\/html\/%252FNGC-Source%252FPRI-ANON-Collection%252F%257Chttp%253A%252F%252F192.65.110.83%253A40700%252Farticles-actualites%252Fquel-est-meilleur-placement-bancaire\/file.htm",
        				"urldocresult": "docresult?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fquel-est-meilleur-placement-bancaire&docrank=2&resultid=89286C8351874F1BA7DD47C58B2A29F9",
        				"urldocresultontext": "docresult?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fquel-est-meilleur-placement-bancaire&docrank=2&resultid=89286C8351874F1BA7DD47C58B2A29F9&on=text",
        				"urldocresultleft": "docresultleft?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fquel-est-meilleur-placement-bancaire&docrank=2&resultid=89286C8351874F1BA7DD47C58B2A29F9",
        				"urldocresultvert": "docresultvert?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fquel-est-meilleur-placement-bancaire&docrank=2&resultid=89286C8351874F1BA7DD47C58B2A29F9",
        				"urldocresulthorz": "docresulthorz?id=%2FNGC-Source%2FPRI-ANON-Collection%2F%7Chttp%3A%2F%2F192.65.110.83%3A40700%2Farticles-actualites%2Fquel-est-meilleur-placement-bancaire&docrank=2&resultid=89286C8351874F1BA7DD47C58B2A29F9",
        				"term": {
        					"term1": "tot;2530.3;52899.4",
        					"termsall": "tot;2530.3;52899.4"
        				}
        			}
        		],
        		"Boxes": [],
        		"Links": []
        	},
        	"methodresult": "ok"
        };
        		
        // Simulate 
        // - done
        this.callXAPIDone(response, "rest");
        // - fail
        //this.callXAPIFail();	       
          }
            callSearchApiTest0resultat() {
        
        // TEST 2741 - SIMULATE callX...
        var response = {
        	"ProcessingTime": " 4 ms",
        	"RowFetchTime": "0 ms",
        	"DocumentCount": 0,
        	"TotalCount": 0,
        	"PageCount": 0,
        	"CurrentPage": 0,
        	"DocumentsPerPage": 200,
        	"DocumentsThisPage": 0,
        	"ProductTitle": "Sinequa Enterprise Search",
        	"Result": {
        		"queryid": "",
        		"resultid": "4D1E0558F24A43B7ADE9BDB569B269FB",
        		"Docs": [],
        		"Boxes": [],
        		"Links": []
        	},
        	"methodresult": "ok"
        };
        
        // Simulate done
        this.callXAPIDone(response, "rest");      
          }
        */

				}]);

				return Sinequa;
}();

exports.default = Sinequa;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initPopinModal = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _Popin = __webpack_require__(84);

var _Popin2 = _interopRequireDefault(_Popin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// constants
var POPIN_LIGHT_CMS = {
    SELECTOR_POPIN_MODAL_OVERLAY: 'dcw_popin',
    SELECTOR_POPIN_MODAL_TITLE: 'dcw_popin-title',
    SELECTOR_POPIN_MODAL_TEXT: 'dcw_popin-desc',
    SELECTOR_BTN_POPIN_MODAL: '.js-openPopinModal',
    SELECTOR_TEXT_TO_DISPLAY: '.js-popinText'
};

/*
    Work with global Popinview.js

    Params :
    - Id of container
    - Id of title container
    - Id of description container
    - Infos with title & description

    Usefull to use it with others contexts
 */

function PopinLightCMS(popId, popTitleId, popDescrId, infos) {

    // get Element and return if doesn't exist
    this.root = document.getElementById(popId);
    if (!this.root) {
        return;
    }

    // get container Title & Text
    this.titleCont = document.getElementById(popTitleId);
    this.descrCont = document.getElementById(popDescrId);

    // get Data
    this.infos = infos;

    this.render();
}

PopinLightCMS.prototype.render = function () {

    this.popinInfoView = new _Popin2.default(this.root, this.titleCont, this.descrCont);

    this.popinInfoView.render(this.infos);
};

PopinLightCMS.prototype.show = function () {
    this.popinInfoView.show();
};

/*
    When a btn with the class js-popinText is clicked,
    we initialize modal popin light
 */
var initPopinModal = function initPopinModal() {
    var $btnPopin = (0, _jquery2.default)(POPIN_LIGHT_CMS.SELECTOR_BTN_POPIN_MODAL);

    if (!$btnPopin.length === 0) {
        return;
    }

    $btnPopin.click(function (e) {
        e.preventDefault();

        var $currenBtn = (0, _jquery2.default)(this);
        var infos = {
            keyword: $currenBtn.text(),
            definition: $currenBtn.next(POPIN_LIGHT_CMS.SELECTOR_TEXT_TO_DISPLAY).html()

            // Init each time because we could have several btns
        };var popinLight = new PopinLightCMS(POPIN_LIGHT_CMS.SELECTOR_POPIN_MODAL_OVERLAY, POPIN_LIGHT_CMS.SELECTOR_POPIN_MODAL_TITLE, POPIN_LIGHT_CMS.SELECTOR_POPIN_MODAL_TEXT, infos);

        if (popinLight) {
            popinLight.show();
        }
    });
};

exports.initPopinModal = initPopinModal;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filterListWem = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filterListWem = function filterListWem() {
    var filterCardPreSet = (0, _jquery2.default)('.js-filter-list-card');

    (0, _jquery2.default)(filterCardPreSet).each(function (i, elem) {
        var currentId = (0, _jquery2.default)(elem).attr("data-id");
        var currentFilterCardElms = (0, _jquery2.default)(".js-filter-list-card[data-id='" + currentId + "']");
        var cardToKeep = (0, _jquery2.default)(currentFilterCardElms).first();

        if ((0, _jquery2.default)(currentFilterCardElms).length > 1) {
            (0, _jquery2.default)(currentFilterCardElms).each(function (i, cardWithSameId) {
                if (i === 0) return;

                var currentCat = (0, _jquery2.default)(cardWithSameId).attr("data-category");
                var catAttr = (0, _jquery2.default)(cardToKeep).attr("data-category");

                // Take INT index of current category card
                var indexCat = currentCat.replace('category-', '');

                // Take order INT of the card in current category
                var currentCatOrder = (0, _jquery2.default)(cardWithSameId).attr('data-category_order_' + indexCat);

                // Add current category to the unique card
                catAttr += ' ';
                catAttr += currentCat;
                (0, _jquery2.default)(cardToKeep).attr("data-category", catAttr);
                (0, _jquery2.default)(cardToKeep).attr('data-category_order_' + indexCat, currentCatOrder);

                (0, _jquery2.default)(cardWithSameId).remove();
            });
        }

        (0, _jquery2.default)(cardToKeep).removeAttr('data-id');
    });
};

exports.filterListWem = filterListWem;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateBrsShortcuts = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

"use strict";

var myDataStructureShortcuts = new Array();

function callBrsService() {
    var req = new XMLHttpRequest();
    req.open("GET", window.location.origin + "/brs/cem/CemInfoServlet.xml?brs_profile=true");
    req.addEventListener("load", function () {
        if (req.status != 200 || req.responseXML == null || req.responseXML.getElementsByTagName("CodeRetourIb")[0] == 1) {
            console.error("error calling brs service : " + req.status + " " + req.statusText);
        } else {
            extractShortcutsFromRequest(req.responseXML);
            updateDomForBrsShortcuts();
        }
    });
    req.addEventListener("error", function () {
        console.error("Erreur réseau");
    });
    req.send(null);
}

function extractShortcutsFromRequest(root) {
    var lien = root.getElementsByTagName("LienRaccourcis")[0];
    myDataStructureShortcuts["NbElem"] = lien.getElementsByTagName("NbElem")[0].firstChild.nodeValue;
    myDataStructureShortcuts["IndicRaccourcis"] = root.getElementsByTagName("Raccourcis")[0];
    var raccInfo = myDataStructureShortcuts["IndicRaccourcis"];
    var nbElem = myDataStructureShortcuts["NbElem"];
    var j = 1;
    for (var i = 1; i <= nbElem && raccInfo; i++) {
        var info = raccInfo.childNodes[i - 1];
        if (info) {
            if (info.getElementsByTagName("Lib")[0].firstChild.nodeValue == decodeURI("Palmar%C3%A8s + fortes hausses Eurolist")) {
                myDataStructureShortcuts["RACC_Lib_fix"] = info.getElementsByTagName("Lib")[0].firstChild.nodeValue;
                myDataStructureShortcuts["RACC_Uri_fix"] = info.getElementsByTagName("Uri")[0].firstChild.nodeValue;
            } else {
                myDataStructureShortcuts["RACC_Lib_" + j] = info.getElementsByTagName("Lib")[0].firstChild.nodeValue;
                myDataStructureShortcuts["RACC_Uri_" + j] = info.getElementsByTagName("Uri")[0].firstChild.nodeValue;
                j++;
            }
        }
    }
}

function updateDomForBrsShortcuts() {
    if ((0, _jquery2.default)('#menuDynBlocCemNet2g-list').length) {
        var list = (0, _jquery2.default)('#menuDynBlocCemNet2g-list');
        list[0].appendChild(buildSeparatedShortcut());
        buildCustomShortcut(list);
        (0, _jquery2.default)('#menuDynBlocCemNet2g-ngim').css('visibility', 'visible');
    }
}

function buildSeparatedShortcut() {
    var liShortcut = document.createElement("li");
    liShortcut.setAttribute("class", "dcw_brs-shortcut_item is-separated");
    var href = document.createElement("a");
    href.setAttribute("href", myDataStructureShortcuts["RACC_Uri_fix"]);
    href.setAttribute("data-tms-click-type", "N");
    href.setAttribute("data-tms-element-label", myDataStructureShortcuts["RACC_Lib_fix"].replace(/\s+/g, '-').toLowerCase());
    href.setAttribute("data-tms-container-label", "brs-shortcuts");
    href.appendChild(document.createTextNode(myDataStructureShortcuts["RACC_Lib_fix"]));
    liShortcut.appendChild(href);
    return liShortcut;
}

function buildCustomShortcut(list) {
    for (var i = 1; i <= myDataStructureShortcuts["NbElem"]; i++) {
        var link = myDataStructureShortcuts["RACC_Uri_" + i];
        var label = myDataStructureShortcuts["RACC_Lib_" + i];
        if (link && label) {
            var liShortcut = document.createElement("li");
            if (i == 1) {
                liShortcut.setAttribute("class", "dcw_brs-shortcut_item is-current");
            } else {
                liShortcut.setAttribute("class", "dcw_brs-shortcut_item");
            }
            var href = document.createElement("a");
            href.setAttribute("href", link);
            href.setAttribute("data-tms-click-type", "N");
            href.setAttribute("data-tms-element-label", label.replace(/\s+/g, '-').toLowerCase());
            href.setAttribute("data-tms-container-label", "brs-shortcuts");
            href.appendChild(document.createTextNode(label));
            liShortcut.appendChild(href);
            list[0].getElementsByClassName("dcw_brs-shortcut_item is-separated")[0].parentNode.insertBefore(liShortcut, list[0].getElementsByClassName("dcw_brs-shortcut_item is-separated")[0]);
        }
    }
}

/* Call service to update shortcuts for BRS */
var updateBrsShortcuts = function updateBrsShortcuts() {
    if ((0, _jquery2.default)('#menuDynBlocCemNet2g-ngim').length) {
        callBrsService();
    }
};

exports.updateBrsShortcuts = updateBrsShortcuts;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.showFirstEligibleMessage = exports.bindCloseMessageEvent = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var closeMessage = function closeMessage(message, showNext) {
    message.remove();

    if (showNext) {
        var messageId = message.attr("data-id");
        var messagePublishDate = message.attr("data-publish-date");
        var messageEndDate = message.attr("data-end-date");

        window.localStorage.setItem("message_" + messageId + "_" + messagePublishDate, messageEndDate);
        cleanOldMessageEntries();
        showFirstEligibleMessage();
    }
};

var bindCloseMessageEvent = function bindCloseMessageEvent() {
    // close button on the service message from a list
    (0, _jquery2.default)(document).on('click', 'aside.service-message-list > div.dcw_alert-message_wrapper > button.dcw_alert-message_close-btn', function () {
        closeMessage((0, _jquery2.default)(this).parents("aside.dcw_alert-message"), true);
    });

    // close button on a unique service message
    (0, _jquery2.default)(document).on('click', 'aside.service-message-instance > div.dcw_alert-message_wrapper > button.dcw_alert-message_close-btn', function () {
        closeMessage((0, _jquery2.default)(this).parents("aside.dcw_alert-message"), false);
    });
};

var showFirstEligibleMessage = function showFirstEligibleMessage() {

    // Remove invalid messages (out of date or closed by user)
    (0, _jquery2.default)("aside.dcw_alert-message.service-message-list").each(function (index, element) {
        var message = (0, _jquery2.default)(element);

        // By default all message are not displayed
        // Check if currentTimeStamp is after messageStartDate and less than messageEndDate
        var messageok = false;
        var currentTimeStamp = Math.round(new Date().getTime());
        var messageStartDate = message.attr("data-start-date");
        var messageEndDate = message.attr("data-end-date");
        if (messageEndDate > currentTimeStamp && messageStartDate < currentTimeStamp) {
            // If there is no info regarding this message on the localStorage, then it means the user didn't close it yet
            var messageId = message.attr("data-id");
            var messagePublishDate = message.attr("data-publish-date");

            if (window.localStorage.getItem("message_" + messageId + "_" + messagePublishDate) == undefined) {
                messageok = true;
            }
        }
        if (!messageok) {
            message.remove();
        }
    });

    // Show first n messages
    (0, _jquery2.default)("aside.dcw_alert-message.service-message-list").each(function (index, element) {
        var message = (0, _jquery2.default)(element);

        // Show first n messages : 
        // if not displayed yet : unwrap and set as displayed
        // else leave as is.
        var messageItemsDisplayed = message.attr("itemsdisplayed");
        if (messageItemsDisplayed) {} else messageItemsDisplayed = 1;
        if (index < messageItemsDisplayed) {

            var margin_top = index > 0 ? "1rem" : "0";
            message.css("margin-top", margin_top);

            if (message.attr("displayed")) {} else {
                message.attr("displayed", "true");
                message.unwrap();
            }
        } else return false;
    });
};

var cleanOldMessageEntries = function cleanOldMessageEntries() {
    var localStorageKeys = Object.keys(window.localStorage);
    var currentDate = new Date().valueOf();
    var key;

    for (var i = 0; i < localStorageKeys.length; i++) {
        key = localStorageKeys[i];

        // if the key starts with "message_", then it's from our Service Messages implementation; and if its value (end date)
        // is lower then the current date, then it means the end date has expired, so the message is not in the HTML already,
        // so we can remove it from the localStorage
        if (key.startsWith("message_") && window.localStorage.getItem(key) < currentDate) {
            window.localStorage.removeItem(key);
        }
    }
};

exports.bindCloseMessageEvent = bindCloseMessageEvent;
exports.showFirstEligibleMessage = showFirstEligibleMessage;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.eventsHandler = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this file is meant to handle all the events for all the objects
var eventsHandler = function eventsHandler() {
    var $body = (0, _jquery2.default)('body');
    // click event on the logout button when attr eq value
    var classname = document.getElementsByClassName("js-lgc-logout");

    var unauthButton = function unauthButton() {
        var callbackUrl = this.getAttribute('data-cms-callback-url');
        logout(function () {
            window.sessionStorage.removeItem("alerting_counter");
            window.location.replace(callbackUrl);
        });
    };

    for (var i = 0; i < classname.length; i++) {
        classname[i].addEventListener('click', unauthButton, false);
    }

    // click event on the back button
    $body.on("click", "button.dcw_header-title_back, button.dcw_submenu-auth_back-btn", function () {
        window.history.back();
    });

    // click event on the open mobile contextual menu
    $body.on("click", ".dcw_contextual-menu-mobile_btn", function () {
        (0, _jquery2.default)(this).next(".dcw_contextual-menu-mobile_pane").addClass("is-open");
        (0, _jquery2.default)("main").addClass("is-blurred");
        (0, _jquery2.default)("body").css("overflow", "hidden");
    });

    // click event on the close mobile contextual menu
    $body.on("click", ".dcw_contextual-menu-mobile_close", function () {
        (0, _jquery2.default)("body").css("overflow", "");
        (0, _jquery2.default)("main").removeClass("is-blurred");
        (0, _jquery2.default)(this).parent().removeClass("is-open");
    });

    // click event on the close mobile contextual menu
    // A VERIFIER AVEC DAMIEN
    $body.on("click", ".dcw_contextual-menu-mobile_link", function () {
        (0, _jquery2.default)("body").css("overflow", "");
        (0, _jquery2.default)("main").removeClass("is-blurred");
        (0, _jquery2.default)(this).closest('.dcw_contextual-menu-mobile_pane').removeClass("is-open");
    });
};

exports.eventsHandler = eventsHandler;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.processLhsNotifications = processLhsNotifications;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _alerting = __webpack_require__(190);

var _alerting2 = _interopRequireDefault(_alerting);

var _gms = __webpack_require__(191);

var _gms2 = _interopRequireDefault(_gms);

var _popinProfile = __webpack_require__(192);

var _popinProfile2 = _interopRequireDefault(_popinProfile);

var _popinNavProPri = __webpack_require__(86);

var _popinNavProPri2 = _interopRequireDefault(_popinNavProPri);

var _notifBurger = __webpack_require__(193);

var _notifBurger2 = _interopRequireDefault(_notifBurger);

var _alerting_pro = __webpack_require__(194);

var _alerting_pro2 = _interopRequireDefault(_alerting_pro);

var _activation_ent = __webpack_require__(195);

var _activation_ent2 = _interopRequireDefault(_activation_ent);

var _market = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

"use strict";

// Apps
var popinProfileApp,
    popinNavProPriApp,
    mobileNotifBurger,
    gmsApp = null;

// for Alerting & GMS
var SELECTOR = {
    ID_ALERTING_COUNTER: "js-counter-alerting",
    ID_GMS_COUNTER: "js-counter-gms"
};

var UTIL = {
    MOBILE_BREAKPOINT: 768

    /*
        Global function to update Notifications of alerting and GMS
     */
};function processLhsNotifications() {

    mobileNotifBurger = new _notifBurger2.default();

    // default PRI
    switch (_market.MARKET.CODE) {
        case 2:
            // init Notif of alerting PRO
            if (window.cmsGlobals.alertingProConfig.activate) {
                new _alerting_pro2.default();
            }
            break;
        case 3:
            // init Notif of alerting
            if (window.cmsGlobals.alertingProConfig.activate) {
                new _alerting_pro2.default();
            }
            // init Activation Counter
            if (window.cmsGlobals.activationEntConfig.activate && (0, _jquery2.default)("li[data-channelid='c4dc0026fc78d610VgnVCM100000da4658c0RCRD'] a").length) {
                new _activation_ent2.default();
            }
            break;
        default:
            // init Notif of alerting
            var selectorIdCounter = document.getElementById(SELECTOR.ID_ALERTING_COUNTER);
            if (window.cmsGlobals.alertingConfig.activate && selectorIdCounter !== null) {
                new _alerting2.default();
            }

            // init Activation Tel
            if (window.cmsGlobals.popinProfileConfig.activate) {
                popinProfileApp = new _popinProfile2.default();
                popinProfileApp.initPopinProfile();
            }
            break;
    }

    if (_market.MARKET.CODE === 1 || _market.MARKET.CODE === 2) {
        popinNavProPriApp = new _popinNavProPri2.default();
        popinNavProPriApp.initPopinNavProPri();
    }

    // init Notif of gms
    if (window.cmsGlobals.gmsConfig.activate) {
        var selectorGMSCounter = document.getElementById(SELECTOR.ID_GMS_COUNTER);
        if (_market.MARKET.CODE === 1) {
            if (selectorGMSCounter !== null) {
                gmsApp = new _gms2.default();
            }
        } else {
            gmsApp = new _gms2.default();
        }
    }
}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _popin = __webpack_require__(48);

var _popin2 = _interopRequireDefault(_popin);

var _counter = __webpack_require__(26);

var _counter2 = _interopRequireDefault(_counter);

var _SessionStoragePop = __webpack_require__(15);

var _SessionStoragePop2 = _interopRequireDefault(_SessionStoragePop);

var _methodUtils = __webpack_require__(20);

var _methodUtils2 = _interopRequireDefault(_methodUtils);

var _market = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// constants for Gsa search
var ALERTING_TEXT = {
    SEE_DETAIL: 'Voir le détail',
    SEE_ALERTS: 'Voir les notifications'
};

var ALERTING_DEFAULT_VALUES = {
    URL_SIGNATURE: "/com/icd-web/alerting/fil-alertes.html",
    URL_SERVICE: "/icd/alerting/data/nouvellesalertes.json",
    SESSION_KEY: "alerting_counter",
    MOBILE_BREAKPOINT: 768,
    CURRENT_APP: "alerting",
    PRIORITY_MOBILE: 2
};

var ALERTING_SELECTOR = {
    ID_ZONE: "#js-container-alerting-zone",
    ID_COUNTER: '#js-counter-alerting',
    ID_COUNTER_MOBILE: '#js-counter-alerting-mobile'
};

var AlertingApp = function () {
    function AlertingApp() {
        _classCallCheck(this, AlertingApp);

        var _self = this;

        _self.dataResponse = {};

        // init default values
        _self.urlService = ALERTING_DEFAULT_VALUES.URL_SERVICE;
        _self.sessionKey = ALERTING_DEFAULT_VALUES.SESSION_KEY;
        _self.needToDisplayPopinByDefault = false;
        _self.currentApp = ALERTING_DEFAULT_VALUES.CURRENT_APP;

        // init from conf
        _self.initPropertiesFromConf();

        // init Session storage popin Obj
        _self.sessionStoragePop = new _SessionStoragePop2.default(_self.sessionKey, _self.intervalTime);

        // init Util Method
        _self.util = new _methodUtils2.default();

        // Init Popin & counter
        _self.popin = new _popin2.default(ALERTING_SELECTOR.ID_ZONE, _self.currentApp, _self.priorityMobile, false);

        // Same counter Mobile / Desktop
        _self.counter = new _counter2.default(ALERTING_SELECTOR.ID_COUNTER);
        if (_market.MARKET.CODE === 1) {
            _self.counterMobile = new _counter2.default(ALERTING_SELECTOR.ID_COUNTER_MOBILE);
        }

        _self.isInRefreshingMode = true;

        // init alerting Interval
        _self.refreshIntervalId = _self.launchTimer(_self.sessionStoragePop.getJsonObjectFromSession(), function () {
            if (_self.isInRefreshingMode) _self.updateNotification();
        }, _self.intervalTime);

        _self.updateNotification();

        // Event when first element closed
        window.EventBusCMS.addEventListener('popinGenericEventOnClose', function (event) {
            if (event.detail.currentApp === _self.currentApp) {
                _self.updateSessionStorageOnClick();
            }
        });
    }

    _createClass(AlertingApp, [{
        key: 'initPropertiesFromConf',
        value: function initPropertiesFromConf() {
            this.urlDetail = window.cmsGlobals.alertingConfig.urlAlertDetail;
            this.urlGlobal = window.cmsGlobals.alertingConfig.urlAlerts;
            this.intervalTime = window.cmsGlobals.alertingConfig.alertingIntervalTime;

            if (window.cmsGlobals.alertingConfig.urlAlertingSignature) {
                this.urlAlertingSignature = window.cmsGlobals.alertingConfig.urlAlertingSignature;
            } else {
                this.urlAlertingSignature = ALERTING_DEFAULT_VALUES.URL_SIGNATURE;
            }

            // Init default priority popin on mobile
            this.priorityMobile = ALERTING_DEFAULT_VALUES.PRIORITY_MOBILE;
        }
    }, {
        key: 'launchTimer',
        value: function launchTimer(data, appliFunction, time) {
            if (data !== null) {
                setTimeout(appliFunction, new Date(data.expirationDate).getTime() - new Date().getTime());
            }
            return this.util.updateApplicationNotificationEvery(appliFunction, 60000 * time);
        }

        /**
         * Update Session Storage with popin data
         */

    }, {
        key: 'updateSessionStorage',
        value: function updateSessionStorage() {
            var _self = this;

            if (_self.dataResponse) {
                _self.dataResponse.closed = false;
                _self.sessionStoragePop.updateSessionStorage(_self.dataResponse);
            }
        }
    }, {
        key: 'updateNotification',
        value: function updateNotification() {
            var _self = this;

            // If we are on current page alerting, we only display counter
            // else we display counter and popin
            if (_self.urlAlertingSignature.indexOf(window.location.pathname) !== -1) {
                _self.needToDisplayPopin = false;
                _self.sessionStoragePop.resetCounterInSession();
                _self.dataResponse = _self.sessionStoragePop.getJsonObjectFromSession();

                _self.updateDOM();
            } else {
                _self.needToDisplayPopin = true;
                _self.dataResponse = _self.sessionStoragePop.getJsonObjectFromSession();
                if (_self.dataResponse == null) {
                    _self.callAlertingService();
                } else {
                    if ((new Date(_self.dataResponse.expirationDate).getTime() - new Date().getTime()) / 60000 > 0) {
                        _self.updateDOM();
                    } else {
                        _self.callAlertingService();
                    }
                }
            }
        }

        /**
         * Call the service exposed by Alerting in order to recover the notification numbers
         */

    }, {
        key: 'callAlertingService',
        value: function callAlertingService() {
            var _self = this;

            _jquery2.default.ajax({
                url: _self.urlService,
                method: "GET",
                swmIntercept: false,
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                beforeSend: function beforeSend(request) {
                    request.setRequestHeader("x-no-session-postpone", "true");
                },
                success: function success(response) {
                    if (response && response.commun.statut.toLowerCase() === "ok") {
                        _self.dataResponse = {};
                        _self.dataResponse.counterVal = response.donnees.compteur, _self.dataResponse.dateMessage = response.donnees.message.date;
                        _self.dataResponse.message = response.donnees.message.libelleCta;
                        _self.dataResponse.idAlerte = response.donnees.message.idAlerte;

                        if (_self.dataResponse.counterVal !== null && _self.dataResponse.counterVal !== undefined) {

                            if (_self.dataResponse.counterVal !== "0" && _self.dataResponse.counterVal !== 0) {
                                var data = _self.sessionStoragePop.getJsonObjectFromSession();

                                // If data & popin has been closed, popin need to be displayed only if new notification come
                                if (data !== null && data.closed) {
                                    if (_self.dataResponse.counterVal !== data.counterVal) {
                                        _self.needToDisplayPopin = true;
                                    }
                                    // if we have response but not initial data in session, display the popin
                                } else if (data == null) {
                                    _self.needToDisplayPopin = true;
                                }
                            }

                            _self.updateSessionStorage();
                            _self.updateDOM();
                        }
                    } else {
                        _self.isInRefreshingMode = false;
                        window.sessionStorage.removeItem(_self.sessionKey);
                    }
                },
                error: function error() {
                    _self.isInRefreshingMode = false;
                    window.sessionStorage.removeItem(_self.sessionKey);
                    console.error("Erreur réseau");
                }
            });
        }

        /**
         * Update the html for both counter and infobulle
         */

    }, {
        key: 'updateDOM',
        value: function updateDOM() {
            var _self = this;

            // Update Counter
            _self.counter.updateHtml(_self.util.getNotificationCounterToShow(_self.dataResponse.counterVal));
            if (_market.MARKET.CODE === 1) {
                _self.counterMobile.updateHtml(_self.util.getNotificationCounterToShow(_self.dataResponse.counterVal));
            }

            // Update popin if message is present
            if (_self.dataResponse.message !== null && _self.needToDisplayPopin) {
                this.updatePopinHtml();
            }
        }

        /**
         * Update HTML Popin
         */

    }, {
        key: 'updatePopinHtml',
        value: function updatePopinHtml() {
            var _self = this;
            var popinPreviouslyOpen = _self.popin.isOpen;

            _self.popin.hide();
            _self.preparePopinData();

            // on mobile, only activate
            if ((0, _jquery2.default)(window).width() < ALERTING_DEFAULT_VALUES.MOBILE_BREAKPOINT) {
                if (popinPreviouslyOpen) {
                    _self.popin.show();
                } else {
                    _self.popin.activate();
                }
            } else {
                _self.popin.show();
            }
        }

        /**
         * Update Session on click
         */

    }, {
        key: 'updateSessionStorageOnClick',
        value: function updateSessionStorageOnClick() {
            var _self = this;
            var info = _self.sessionStoragePop.getJsonObjectFromSession();
            var remainingTime = (new Date(info.expirationDate).getTime() - new Date().getTime()) / 60000;

            // put new interval time
            _self.sessionStoragePop.setIntervalTime(remainingTime);

            // update counter info in session on click
            _self.sessionStoragePop.updateCounterAlone(info.counterVal, true);
        }

        /**
         * Update notification infobulle
         */

    }, {
        key: 'preparePopinData',
        value: function preparePopinData() {
            var _self = this;
            var data = {};

            if (_self.dataResponse.dateMessage !== null) {
                data.headLine = _self.dataResponse.dateMessage;
            }

            if (_self.dataResponse.message !== null) {
                data.description = _self.dataResponse.message;
            }

            if (_self.dataResponse.counterVal == "1" || _self.dataResponse.counterVal == 1) {
                var href = _self.urlDetail + _self.dataResponse.idAlerte;
                data.href = href;
                data.textLink = ALERTING_TEXT.SEE_DETAIL;
            } else {
                var href = _self.urlGlobal;
                data.href = href;
                data.textLink = ALERTING_TEXT.SEE_ALERTS;
            }

            _self.popin.updatePopinData(data);
        }
    }]);

    return AlertingApp;
}();

exports.default = AlertingApp;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _counter = __webpack_require__(26);

var _counter2 = _interopRequireDefault(_counter);

var _SessionStoragePop = __webpack_require__(15);

var _SessionStoragePop2 = _interopRequireDefault(_SessionStoragePop);

var _methodUtils = __webpack_require__(20);

var _methodUtils2 = _interopRequireDefault(_methodUtils);

var _market = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
// gms - default value
var gmsIntervalTime = 5;
var refreshGmsIntervalId;*/

// selector: "#dcw-gms-zone"


var GMS_DEFAULT_VALUES = {
    URL_SIGNATURE: "/icd/mcd/index-authsec.html",
    URL_NEW_SERVICE: "/icd/mcd/data/nb-messages-authsec.json?b64e200_isRead=false",
    URL_SERVICE: "/gms/gmsInfoServlet",
    SESSION_KEY: "gms_counter",
    MOBILE_BREAKPOINT: 768
};

var GMS_SELECTOR = {
    ID_COUNTER: '#js-counter-gms',
    ID_COUNTER_MOBILE: '#js-counter-gms-mobile'
};

var GmsApp = function () {
    function GmsApp() {
        _classCallCheck(this, GmsApp);

        var _self = this;

        _self.counterEmpty = true;

        // init default values
        _self.urlService = GMS_DEFAULT_VALUES.URL_NEW_SERVICE;
        _self.sessionKey = GMS_DEFAULT_VALUES.SESSION_KEY;

        // init from conf
        _self.initPropertiesFromConf();

        // init Session storage popin Obj
        _self.sessionStoragePop = new _SessionStoragePop2.default(_self.sessionKey, _self.intervalTime);

        // init Util Method
        _self.util = new _methodUtils2.default();

        // Init Popin & counter
        _self.counter = new _counter2.default(GMS_SELECTOR.ID_COUNTER);
        if (_market.MARKET.CODE === 1) {
            _self.counterMobile = new _counter2.default(GMS_SELECTOR.ID_COUNTER_MOBILE);
        }

        _self.isInRefreshingMode = true;

        _self.refreshIntervalId = _self.launchTimer(_self.sessionStoragePop.getJsonObjectFromSession(), function () {
            if (_self.isInRefreshingMode) _self.updateNotification();
        }, _self.intervalTime);

        _self.updateNotification();
    }

    _createClass(GmsApp, [{
        key: 'initPropertiesFromConf',
        value: function initPropertiesFromConf() {
            this.intervalTime = window.cmsGlobals.gmsConfig.gmsIntervalTime;

            if (window.cmsGlobals.gmsConfig.urlGmsSignature) {
                this.urlGMSSignature = window.cmsGlobals.gmsConfig.urlGmsSignature;
            } else {
                this.urlGMSSignature = GMS_DEFAULT_VALUES.URL_SIGNATURE;
            }
        }
    }, {
        key: 'launchTimer',
        value: function launchTimer(data, appliFunction, time) {
            if (data !== null) {
                setTimeout(appliFunction, new Date(data.expirationDate).getTime() - new Date().getTime());
            }
            return this.util.updateApplicationNotificationEvery(appliFunction, 60000 * time);
        }

        /**
         * Get the value from the session storage, if no value, call Alerting service
         */

    }, {
        key: 'updateNotification',
        value: function updateNotification() {
            var _self = this;
            if (_self.urlGMSSignature.indexOf(window.location.pathname) !== -1) {
                _self.sessionStoragePop.resetCounterInSession();
                _self.updateDOM();
            } else {
                _self.dataResponse = _self.sessionStoragePop.getJsonObjectFromSession();

                if (!_self.dataResponse) {
                    _self.callGmsService();
                } else {
                    if ((new Date(_self.dataResponse.expirationDate).getTime() - new Date().getTime()) / 60000 > 0) {
                        _self.updateDOM();
                    } else {
                        _self.callGmsService();
                    }
                }
            }
        }

        /**
         * Call the service exposed by GMS in order to recover the notification numbers
         */

    }, {
        key: 'callGmsService',
        value: function callGmsService() {
            var _self = this;

            _jquery2.default.ajax({
                url: _self.urlService,
                method: "GET",
                swmIntercept: false,
                contentType: "application/xml; charset=utf-8",
                dataType: 'json',
                beforeSend: function beforeSend(request) {
                    request.setRequestHeader("x-no-session-postpone", "true");
                },
                success: function success(response) {
                    if (response && response.total) {
                        var counter = response.total;

                        // check if counter is well a number
                        if (isNaN(counter)) {
                            _self.sessionStoragePop.removeKey();
                            console.error("Counter not on right format");
                        } else {
                            _self.sessionStoragePop.updateCounterAlone(counter, false);
                            _self.updateDOM();
                        }
                    } else {
                        _self.isInRefreshingMode = false;
                        _self.sessionStoragePop.removeKey();
                        console.error("Pas de messages");
                    }
                },
                error: function error() {
                    _self.isInRefreshingMode = false;
                    _self.sessionStoragePop.removeKey();
                    console.error("Erreur réseau");
                }
            });
        }

        /**
         * Call the service exposed by GMS in order to recover the notification numbers
         */

    }, {
        key: 'callOldGmsService',
        value: function callOldGmsService() {
            var _self = this;

            _jquery2.default.ajax({
                url: _self.urlService,
                method: "GET",
                swmIntercept: false,
                contentType: "application/xml; charset=utf-8",
                dataType: 'xml',
                beforeSend: function beforeSend(request) {
                    request.setRequestHeader("x-no-session-postpone", "true");
                },
                success: function success(response) {
                    if (response == undefined || response.firstChild == null || response.firstChild == undefined || response.getElementsByTagName("NbMessage") == null || response.getElementsByTagName("NbMessage")[0].firstChild == null) {
                        clearInterval(_self.intervalTime);
                        _self.sessionStoragePop.removeKey();
                        console.error("Pas de messages");
                    } else {
                        var counter = response.getElementsByTagName("NbMessage")[0].firstChild.nodeValue;

                        // check if counter is well a number
                        if (isNaN(counter)) {
                            _self.sessionStoragePop.removeKey();
                            console.error("Counter not on right format");
                        } else {
                            _self.sessionStoragePop.updateCounterAlone(counter, false);
                            _self.updateDOM();
                        }
                    }
                },
                error: function error() {
                    clearInterval(_self.intervalTime);
                    _self.sessionStoragePop.removeKey();
                    console.error("Erreur réseau");
                }
            });
        }

        /**
         * Update the html for both counter and infobulle
         */

    }, {
        key: 'updateDOM',
        value: function updateDOM() {
            var _self = this;
            var data = _self.sessionStoragePop.getJsonObjectFromSession();

            // Update Counter
            _self.counter.updateHtml(_self.util.getNotificationCounterToShow(data.counterVal));
            if (_market.MARKET.CODE === 1) {
                _self.counterMobile.updateHtml(_self.util.getNotificationCounterToShow(data.counterVal));
            }
        }
    }]);

    return GmsApp;
}();

exports.default = GmsApp;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _popin = __webpack_require__(48);

var _popin2 = _interopRequireDefault(_popin);

var _SessionStoragePop = __webpack_require__(15);

var _SessionStoragePop2 = _interopRequireDefault(_SessionStoragePop);

var _methodUtils = __webpack_require__(20);

var _methodUtils2 = _interopRequireDefault(_methodUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var POPIN_PROFILE_DEFAULT_VALUES = {
    MOBILE_BREAKPOINT: 768,
    ACTIV_TEL_HREF_DETAIL: "/csa/csa_activation_tel.html",
    ACTIV_TEL_TEXT_SEE_DETAIL: "Activer mon numéro de téléphone",
    ACTIV_TEL_TEXT_HEADLINE: "Sécurité",
    ACTIV_TEL_TEXT_DESCRIPTION: "Vous avez dû recevoir votre code d'activation par courrier postal. Vous pouvez désormais finaliser l'enregistrement de votre numéro de téléphone.",
    ACTIV_TEL_TEXT_DESCRIPTION_MOBILE: "Vous avez dû recevoir votre code d'activation par courrier postal. Rendez-vous dans votre espace client Internet pour finaliser l'enregistrement de votre numéro de téléphone.",
    RESET_PASSWORD_HREF_DETAIL: "/swm/swm-changemdp.html#etape1",
    RESET_PASSWORD_TEXT_SEE_DETAIL: "Changer le code secret",
    RESET_PASSWORD_TEXT_HEADLINE: "Sécurité",
    SESSION_STORAGE_POPIN_ACTIVATED_TEL_CLOSED: "popin_activate_tel_closed",
    COOKIE_PASSWORD: "nbjexp",
    COOKIE_ACTIVATE_TEL: "CAMPAIGNS",
    VALUE_TO_CHECK_ACTIVATE_TEL_O: "O:ACT",
    VALUE_TO_CHECK_ACTIVATE_TEL_B: "B:ACT",
    PASSWORD_APP: "password",
    DTS_APP: "dts",
    PRIORITY_MOBILE: 1
};

var POPIN_PROFILE_SELECTOR = {
    ID_ZONE: "#js-profil-zone",
    ID_LOGIN_MENU_PROFILE: "js-desktop-profil"
};

var PopinProfileApp = function () {
    function PopinProfileApp() {
        _classCallCheck(this, PopinProfileApp);

        var _self = this;

        // init default values
        _self.sessionKey = POPIN_PROFILE_DEFAULT_VALUES.SESSION_STORAGE_POPIN_ACTIVATED_TEL_CLOSED;
        _self.initPropertiesFromConf();
        _self.initMobileContext();

        // init Util Method
        _self.util = new _methodUtils2.default();
        // Init session storage with custom key
        _self.sessionStoragePop = new _SessionStoragePop2.default(_self.sessionKey);
        // Do not display popin if yet closed during session
        // So do not check the cookie in this context
        if (_self.sessionStoragePop.getJsonObjectFromSession()) {
            _self.needToDisplayActivateTel = false;
        } else {
            _self.needToDisplayActivateTel = _self.checkCookieCampaign();
        }

        _self.popin = new _popin2.default(POPIN_PROFILE_SELECTOR.ID_ZONE, _self.needToDisplayActivateTel ? POPIN_PROFILE_DEFAULT_VALUES.DTS_APP : POPIN_PROFILE_DEFAULT_VALUES.PASSWORD_APP, _self.priorityMobile, true);

        // No popin password in mobile context
        if (_self.onMobile) {
            _self.needToDisplayResetPassword = false;
        } else {
            _self.needToDisplayResetPassword = true;
        }

        // get Cookie for password popin context
        _self.cookieResetPassword = _self.util.getCookie(POPIN_PROFILE_DEFAULT_VALUES.COOKIE_PASSWORD);

        // Event when first element closed
        window.EventBusCMS.addEventListener('popinEvent', function (event) {
            if (event.detail.firstLvlClosed && event.detail.currentApp === POPIN_PROFILE_DEFAULT_VALUES.DTS_APP) {
                _self.sessionStoragePop.addSimpleBooleanInSessionStorage();
                _self.initPopinResetPassword();
            }
        });
    }

    _createClass(PopinProfileApp, [{
        key: 'initMobileContext',
        value: function initMobileContext() {
            // Init Mobile context
            this.onMobile = false;
            if ((0, _jquery2.default)(window).width() < POPIN_PROFILE_DEFAULT_VALUES.MOBILE_BREAKPOINT) {
                this.onMobile = true;
            }
        }
    }, {
        key: 'initPropertiesFromConf',
        value: function initPropertiesFromConf() {
            // Init default URL for phone activation
            if (window.cmsGlobals.popinProfileConfig.url_detail_activ_tel) {
                this.urlDetailActivateTel = window.cmsGlobals.popinProfileConfig.url_detail_activ_tel;
            } else {
                this.urlDetailActivateTel = POPIN_PROFILE_DEFAULT_VALUES.ACTIV_TEL_HREF_DETAIL;
            }

            // Init default priority popin on mobile
            this.priorityMobile = POPIN_PROFILE_DEFAULT_VALUES.PRIORITY_MOBILE;

            // Init default URL for password
            if (window.cmsGlobals.popinProfileConfig.url_detail_reset_password) {
                this.urlDetailResetPassword = window.cmsGlobals.popinProfileConfig.url_detail_reset_password;
            } else {
                this.urlDetailResetPassword = POPIN_PROFILE_DEFAULT_VALUES.RESET_PASSWORD_HREF_DETAIL;
            }
        }
    }, {
        key: 'checkCookieCampaign',
        value: function checkCookieCampaign() {
            var _self = this;

            var currentValue = _self.util.getCookie(POPIN_PROFILE_DEFAULT_VALUES.COOKIE_ACTIVATE_TEL);
            if (!currentValue) {
                return false;
            }

            try {
                var currentValDecode = JSON.parse(decodeURI(currentValue));
                if (!currentValDecode.DTS) {
                    return false;
                }

                if (currentValDecode.DTS === POPIN_PROFILE_DEFAULT_VALUES.VALUE_TO_CHECK_ACTIVATE_TEL_O || currentValDecode.DTS === POPIN_PROFILE_DEFAULT_VALUES.VALUE_TO_CHECK_ACTIVATE_TEL_B) {
                    return true;
                }
            } catch (e) {
                return false;
            }
        }

        /**
         * init activation tel
         */

    }, {
        key: 'initPopinProfile',
        value: function initPopinProfile() {
            if (this.needToDisplayActivateTel) {
                this.initPopinActivationTel();
            } else if (this.needToDisplayResetPassword) {
                this.initPopinResetPassword();
            } else if ((0, _jquery2.default)(window).width() < POPIN_PROFILE_DEFAULT_VALUES.MOBILE_BREAKPOINT) {
                // if no popin - display following popin on mobile
                this.popin.displayNextPopin();
            }
        }

        /**
         * init activation tel
         */

    }, {
        key: 'initPopinActivationTel',
        value: function initPopinActivationTel() {
            var data = {};
            var _self = this;
            _self.popin.hide();

            data.headLine = POPIN_PROFILE_DEFAULT_VALUES.ACTIV_TEL_TEXT_HEADLINE;

            if (_self.onMobile) {
                data.description = POPIN_PROFILE_DEFAULT_VALUES.ACTIV_TEL_TEXT_DESCRIPTION_MOBILE;
            } else {
                data.description = POPIN_PROFILE_DEFAULT_VALUES.ACTIV_TEL_TEXT_DESCRIPTION;
            }

            if (_self.onMobile) {
                data.hideLink = true;
            } else {
                data.textLink = POPIN_PROFILE_DEFAULT_VALUES.ACTIV_TEL_TEXT_SEE_DETAIL;
                data.href = _self.urlDetailActivateTel;
            }

            _self.popin.updatePopinData(data);
            _self.popin.show();
        }

        /**
         * Update popin reset password
         */

    }, {
        key: 'initPopinResetPassword',
        value: function initPopinResetPassword() {
            var _self = this;
            _self.popin.hide();

            if (_self.needToDisplayResetPassword) {
                if (_self.cookieResetPassword === "" || Number(_self.cookieResetPassword) > 30) return;
                _self.updatePopinPassword(_self.cookieResetPassword);
                _self.popin.show();
            }
        }

        /**
         * Update notification infobulle
         */

    }, {
        key: 'updatePopinPassword',
        value: function updatePopinPassword(nbDays) {
            var _self = this;
            var data = {};
            var dayWord = nbDays === "1" ? "jour" : "jours";

            data.href = _self.urlDetailResetPassword;
            data.headLine = POPIN_PROFILE_DEFAULT_VALUES.RESET_PASSWORD_TEXT_HEADLINE;
            data.description = "Vous n'avez pas modifié votre code secret depuis plus d'un an. Il vous reste " + nbDays + " " + dayWord + " pour le modifier.";
            data.textLink = POPIN_PROFILE_DEFAULT_VALUES.RESET_PASSWORD_TEXT_SEE_DETAIL;

            this.popin.updatePopinData(data);
        }
    }]);

    return PopinProfileApp;
}();

exports.default = PopinProfileApp;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SELECTOR = {
    BURGER_MENU_NOTIFICATION: '.js-header-burger-notif'
};

var CLASS = {
    IS_ACTIVE: 'is-active'
};

var MobileNotifBurger = function () {
    function MobileNotifBurger() {
        _classCallCheck(this, MobileNotifBurger);

        var _self = this;
        _self.$notifBurger = (0, _jquery2.default)(SELECTOR.BURGER_MENU_NOTIFICATION);
        _self.isActive = false;

        window.EventBusCMS.addEventListener('toggleBurgerMobileNotif', function (event) {
            if (event.detail.state === 'active' && !_self.isActive) {
                _self.activateBurgerMobileNotif();
            }

            if (event.detail.state === 'unactive' && _self.isActive) {
                _self.deactivateNotifBurger();
            }
        });
    }

    /**
     * Activate Notif Burger
     */


    _createClass(MobileNotifBurger, [{
        key: 'activateBurgerMobileNotif',
        value: function activateBurgerMobileNotif() {
            this.$notifBurger.addClass(CLASS.IS_ACTIVE);
            this.isActive = true;
        }

        /**
         * Deactivate Notif Burger
         */

    }, {
        key: 'deactivateNotifBurger',
        value: function deactivateNotifBurger() {
            this.$notifBurger.removeClass(CLASS.IS_ACTIVE);
            this.isActive = false;
        }
    }]);

    return MobileNotifBurger;
}();

exports.default = MobileNotifBurger;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _counter = __webpack_require__(26);

var _counter2 = _interopRequireDefault(_counter);

var _SessionStoragePop = __webpack_require__(15);

var _SessionStoragePop2 = _interopRequireDefault(_SessionStoragePop);

var _methodUtils = __webpack_require__(20);

var _methodUtils2 = _interopRequireDefault(_methodUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ALERT_PRO_DEFAULT_VALUES = {
    URL_SERVICE: "/icd/ape/data/alertes-compteur.json",
    URL_SIGNATURE: "/com/icd-web/alerting/fil-alertes.html",
    SESSION_KEY: "alert_pro_counter",
    MOBILE_BREAKPOINT: 768
};

var ALERT_PRO_SELECTOR = {
    ID_COUNTER: '#js-link-alert-counter',
    DATA_CHANNEL_ALERTING_PRO: "li[data-channelid='c30c27583a2dc610VgnVCM100000da4658c0RCRD'] a",
    DATA_CHANNEL_ALERTING_ENT: "li[data-channelid='9587227b02e6d610VgnVCM100000da4658c0RCRD'] a"
};

var AlertingProApp = function () {
    function AlertingProApp() {
        _classCallCheck(this, AlertingProApp);

        var _self = this;

        _self.counterEmpty = true;

        // init default values
        _self.urlService = ALERT_PRO_DEFAULT_VALUES.URL_SERVICE;
        _self.sessionKey = ALERT_PRO_DEFAULT_VALUES.SESSION_KEY;

        // init from conf
        _self.initPropertiesFromConf();

        // init Session storage popin Obj
        _self.sessionStoragePop = new _SessionStoragePop2.default(_self.sessionKey, _self.intervalTime);

        // init Util Method
        _self.util = new _methodUtils2.default();

        // Custom channel ID
        if ((0, _jquery2.default)(ALERT_PRO_SELECTOR.DATA_CHANNEL_ALERTING_PRO).length) {
            _self.counterSelector = ALERT_PRO_SELECTOR.DATA_CHANNEL_ALERTING_PRO;
        } else if ((0, _jquery2.default)(ALERT_PRO_SELECTOR.DATA_CHANNEL_ALERTING_ENT).length) {
            _self.counterSelector = ALERT_PRO_SELECTOR.DATA_CHANNEL_ALERTING_ENT;
        } else {
            _self.urlService = null;
        }

        // Init Popin & counter
        _self.counter = new _counter2.default(_self.counterSelector);

        _self.isInRefreshingMode = true;

        _self.refreshIntervalId = _self.launchTimer(_self.sessionStoragePop.getJsonObjectFromSession(), function () {
            if (_self.isInRefreshingMode) _self.updateNotification();
        }, _self.intervalTime);

        _self.updateNotification();
    }

    _createClass(AlertingProApp, [{
        key: 'initPropertiesFromConf',
        value: function initPropertiesFromConf() {
            this.intervalTime = window.cmsGlobals.alertingProConfig.intervalTime;
            if (window.cmsGlobals.alertingProConfig.urlAlertingSignature) {
                this.urlAlertingProSignature = window.cmsGlobals.alertingProConfig.urlAlertingSignature;
            } else {
                this.urlAlertingProSignature = ALERT_PRO_DEFAULT_VALUES.URL_SIGNATURE;
            }
        }
    }, {
        key: 'launchTimer',
        value: function launchTimer(data, appliFunction, time) {
            if (data !== null) {
                setTimeout(appliFunction, new Date(data.expirationDate).getTime() - new Date().getTime());
            }
            return this.util.updateApplicationNotificationEvery(appliFunction, 60000 * time);
        }

        /**
         * Get the value from the session storage, if no value, call Alerting service
         */

    }, {
        key: 'updateNotification',
        value: function updateNotification() {
            var _self = this;
            if (_self.urlAlertingProSignature.indexOf(window.location.pathname) !== -1) {
                _self.sessionStoragePop.resetCounterInSession();
                _self.updateDOM();
            } else {
                _self.dataResponse = _self.sessionStoragePop.getJsonObjectFromSession();

                if (!_self.dataResponse) {
                    _self.callAlertingProService();
                } else {
                    if ((new Date(_self.dataResponse.expirationDate).getTime() - new Date().getTime()) / 60000 > 0) {
                        _self.updateDOM();
                    } else {
                        _self.callAlertingProService();
                    }
                }
            }
        }

        /**
         * Call the service exposed by Alerting in order to recover the notification numbers
         */

    }, {
        key: 'callAlertingProService',
        value: function callAlertingProService() {
            var _self = this;

            if (_self.urlService != null) {
                _jquery2.default.ajax({
                    url: _self.urlService,
                    method: "GET",
                    swmIntercept: false,
                    contentType: "application/xml; charset=utf-8",
                    dataType: 'json',
                    beforeSend: function beforeSend(request) {
                        request.setRequestHeader("x-no-session-postpone", "true");
                    },
                    success: function success(response) {
                        if (response && response.commun.statut.toLowerCase() === "ok") {
                            _self.dataResponse = {};
                            _self.dataResponse.counterVal = response.donnees.compteur;

                            if (_self.dataResponse.counterVal !== null && _self.dataResponse.counterVal !== 0) {
                                _self.sessionStoragePop.updateCounterAlone(_self.dataResponse.counterVal, false);
                                _self.updateDOM();
                            }
                        } else {
                            _self.isInRefreshingMode = false;
                            _self.sessionStoragePop.removeKey();
                        }
                    },
                    error: function error() {
                        _self.isInRefreshingMode = false;
                        _self.sessionStoragePop.removeKey();
                        console.error("Erreur réseau");
                    }
                });
            } else {
                _self.isInRefreshingMode = false;
                _self.sessionStoragePop.removeKey();
            }
        }

        /**
         * Update the html for both counter and infobulle
         */

    }, {
        key: 'updateDOM',
        value: function updateDOM() {
            var _self = this;
            var data = _self.sessionStoragePop.getJsonObjectFromSession();

            // Update Counter
            _self.counter.updateHtml(_self.util.getNotificationCounterToShow(data.counterVal));
        }
    }]);

    return AlertingProApp;
}();

exports.default = AlertingProApp;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _counter = __webpack_require__(26);

var _counter2 = _interopRequireDefault(_counter);

var _SessionStoragePop = __webpack_require__(15);

var _SessionStoragePop2 = _interopRequireDefault(_SessionStoragePop);

var _methodUtils = __webpack_require__(20);

var _methodUtils2 = _interopRequireDefault(_methodUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ACTIVATION_ENT_DEFAULT_VALUES = {
    URL_SERVICE: "/gax-web/gax/gax-pending-activation-requests-count.html",
    URL_SIGNATURE: "/com/icd-web/alerting/fil-alertes.html",
    SESSION_KEY: "ent_activation_counter",
    MOBILE_BREAKPOINT: 768
};

var ACTIVATION_ENT_SELECTOR = {
    ID_COUNTER: '#js-link-ent-activation',
    DATA_CHANNEL_ACTIVATION_ENT: "li[data-channelid='c4dc0026fc78d610VgnVCM100000da4658c0RCRD'] a"
};

var ActivationEnt = function () {
    function ActivationEnt() {
        _classCallCheck(this, ActivationEnt);

        var _self = this;

        _self.counterEmpty = true;

        // init default values
        _self.urlService = ACTIVATION_ENT_DEFAULT_VALUES.URL_SERVICE;
        _self.sessionKey = ACTIVATION_ENT_DEFAULT_VALUES.SESSION_KEY;

        // init from conf
        _self.initPropertiesFromConf();

        // init Session storage popin Obj
        _self.sessionStoragePop = new _SessionStoragePop2.default(_self.sessionKey, _self.intervalTime);

        // init Util Method
        _self.util = new _methodUtils2.default();

        // Custom channel ID
        _self.counterSelector = ACTIVATION_ENT_SELECTOR.DATA_CHANNEL_ACTIVATION_ENT;

        _self.isInRefreshingMode = true;

        _self.refreshIntervalId = _self.launchTimer(_self.sessionStoragePop.getJsonObjectFromSession(), function () {
            if (_self.isInRefreshingMode) _self.updateNotification();
        }, _self.intervalTime);

        _self.waitUntil(function () {
            return (0, _jquery2.default)(_self.counterSelector).length > 0;
        }, function () {
            // Init & counter
            _self.counter = new _counter2.default(_self.counterSelector);
            _self.updateNotification();
        }, 50, 20);
    }

    _createClass(ActivationEnt, [{
        key: 'initPropertiesFromConf',
        value: function initPropertiesFromConf() {
            this.intervalTime = window.cmsGlobals.activationEntConfig.intervalTime;
            if (window.cmsGlobals.activationEntConfig.urlActivationEntSignature) {
                this.urlActivationEntSignature = window.cmsGlobals.activationEntConfig.urlActivationEntSignature;
            } else {
                this.urlActivationEntSignature = ACTIVATION_ENT_DEFAULT_VALUES.URL_SIGNATURE;
            }
        }
    }, {
        key: 'launchTimer',
        value: function launchTimer(data, appliFunction, time) {
            if (data !== null) {
                setTimeout(appliFunction, new Date(data.expirationDate).getTime() - new Date().getTime());
            }
            return this.util.updateApplicationNotificationEvery(appliFunction, 60000 * time);
        }

        /**
         * Get the value from the session storage, if no value, call Alerting service
         */

    }, {
        key: 'updateNotification',
        value: function updateNotification() {
            var _self = this;
            if (_self.urlActivationEntSignature.indexOf(window.location.pathname) !== -1) {
                _self.sessionStoragePop.resetCounterInSession();
                _self.updateDOM();
            } else {
                _self.dataResponse = _self.sessionStoragePop.getJsonObjectFromSession();

                if (!_self.dataResponse) {
                    _self.callActivationEntService();
                } else {
                    // if interval expired, call service, else take the counter value in session
                    if ((new Date(_self.dataResponse.expirationDate).getTime() - new Date().getTime()) / 60000 > 0) {
                        _self.updateDOM();
                    } else {
                        _self.callActivationEntService();
                    }
                }
            }
        }

        /**
         * Call the service exposed by Alerting in order to recover the notification numbers
         */

    }, {
        key: 'callActivationEntService',
        value: function callActivationEntService() {
            var _self = this;

            _jquery2.default.ajax({
                url: _self.urlService,
                method: "GET",
                swmIntercept: false,
                contentType: "application/xml; charset=utf-8",
                dataType: 'xml',
                beforeSend: function beforeSend(request) {
                    request.setRequestHeader("x-no-session-postpone", "true");
                },
                success: function success(response) {
                    if (response == undefined || response.firstChild == null || response.firstChild == undefined || response.getElementsByTagName("nbDemActivAttente") == null || response.getElementsByTagName("nbDemActivAttente")[0].firstChild == null) {

                        clearInterval(_self.intervalTime);
                        _self.sessionStoragePop.removeKey();

                        console.error("Pas de messages");
                    } else {
                        var counter = response.getElementsByTagName("nbDemActivAttente")[0].firstChild.nodeValue;

                        // check if counter is well a number
                        if (isNaN(counter)) {
                            _self.sessionStoragePop.removeKey();
                            console.error("Counter not on right format");
                        } else {
                            _self.sessionStoragePop.updateCounterAlone(counter, false);
                            _self.updateDOM();
                        }
                    }
                },
                error: function error() {
                    _self.isInRefreshingMode = false;
                    _self.sessionStoragePop.removeKey();
                    console.error("Erreur réseau");
                }
            });
        }
    }, {
        key: 'waitUntil',
        value: function waitUntil(isready, success, count, interval) {
            var _self = this;
            if (count === undefined) {
                count = 20;
            }
            if (interval === undefined) {
                interval = 20;
            }
            if (isready()) {
                success();
                return;
            }
            // The call back isn't ready. We need to wait for it
            setTimeout(function () {
                if (count) {
                    // Try again
                    _self.waitUntil(isready, count - 1, interval);
                }
            }, interval);
        }

        /**
         * Update the html for both counter and infobulle
         */

    }, {
        key: 'updateDOM',
        value: function updateDOM() {
            var _self = this;
            var data = _self.sessionStoragePop.getJsonObjectFromSession();

            // Update Counter
            _self.counter.updateHtml(_self.util.getNotificationCounterToShow(data.counterVal));
        }
    }]);

    return ActivationEnt;
}();

exports.default = ActivationEnt;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.processLoginBoxMenu = processLoginBoxMenu;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

"use strict";

var LOGIN_BOX_MENU = {
    IS_ACTIVE: 'is-active',
    SELECTOR_ITEM_MENU: '.dcw_login_notif',
    SELECTOR_JS_RELATED_MENU: '.JS--relatedLinkedList',
    SELECTOR_CONTAINER_HEADER: '.dcw_main-nav_list',
    SELECTOR_SUBMENU_ITEM: '.js-submenu_item',
    SELECTOR_SUBMENU_MARKER: '.js-marker',
    PROP_DATA_CHANNEL_ID: 'data-channelid',
    INITIAL_2NDMARKER_POS: 0,
    SELECTOR_REFERENCE_ELT: ".js-ref_elt"
};

// default values
var $container = null;
var $menuToDisplay = null;
var $jsRelatedMenus = null;
var $subMenuBarItemActive = null;
var currentPageIsActive = false;

function processLoginBoxMenu() {
    if (window.cmsUtil.currentChannelBreadcrumb != undefined) {
        $jsRelatedMenus = (0, _jquery2.default)(LOGIN_BOX_MENU.SELECTOR_JS_RELATED_MENU);
        $container = (0, _jquery2.default)(LOGIN_BOX_MENU.SELECTOR_CONTAINER_HEADER);
        var channels = window.cmsUtil.currentChannelBreadcrumb.split(",");

        // channels.length-1 to remove home channel
        for (var i = 0; i < channels.length - 1; i++) {
            var currentChannelIdFromBreadcrumb = channels[i];

            // Check first level of Login box menu
            processActiveItems(currentChannelIdFromBreadcrumb);

            if (currentPageIsActive) {
                break;
            }

            // Check second level of Login box menu
            processActiveSubMenuItems(currentChannelIdFromBreadcrumb);
        }

        // check if external URL match in case of only transactional
        if (!currentPageIsActive) {
            processActiveItemsIfExternalLink();
        }

        if (currentPageIsActive) {
            $menuToDisplay.removeClass(LOGIN_BOX_MENU.CLASS_IS_HIDDEN);
            //initMarker();
        } else {
            $jsRelatedMenus.remove();
        }
    }
}

/**
 * highlight corresponding icon and generate related menu
 */
function processActiveItems(currentChannelIdFromBreadcrumb) {
    var $item = (0, _jquery2.default)(LOGIN_BOX_MENU.SELECTOR_ITEM_MENU + "[" + LOGIN_BOX_MENU.PROP_DATA_CHANNEL_ID + "=" + currentChannelIdFromBreadcrumb + "]");

    if ($item.length) {
        $item.addClass(LOGIN_BOX_MENU.IS_ACTIVE);
        if ($item.next(LOGIN_BOX_MENU.SELECTOR_JS_RELATED_MENU).length) {
            $menuToDisplay = (0, _jquery2.default)($item.next(LOGIN_BOX_MENU.SELECTOR_JS_RELATED_MENU).html());

            // display related Menu
            $menuToDisplay.prependTo($container);
            currentPageIsActive = true;
        }
    }
}

/**
 * highlight corresponding icon checking the path (for external app context, if no channel link from the CMS)
 */
function processActiveItemsIfExternalLink() {
    var path = window.location.pathname;
    path = path.replace(/\/$/, "");
    path = decodeURIComponent(path);

    (0, _jquery2.default)(LOGIN_BOX_MENU.SELECTOR_ITEM_MENU).each(function () {
        var $this = (0, _jquery2.default)(this);
        var href = $this.attr("href").replace(/\/$/, "");
        href = href.replace(/#.*$/, "");

        if (href != undefined && href === path.substring(0, href.length)) {
            $this.addClass(LOGIN_BOX_MENU.IS_ACTIVE);
            currentPageIsActive = true;

            if ($this.next(LOGIN_BOX_MENU.SELECTOR_JS_RELATED_MENU).length) {
                $menuToDisplay = (0, _jquery2.default)($this.next(LOGIN_BOX_MENU.SELECTOR_JS_RELATED_MENU).html());
                $menuToDisplay.prependTo($container);
            }
        }
    });
}

/**
 * highlight corresponding icon and corresponding menu item of submenu
 */
function processActiveSubMenuItems(currentChannelIdFromBreadcrumb) {
    $jsRelatedMenus.each(function () {
        var $currentRelatedMenu = (0, _jquery2.default)(this);
        var activeLink = $currentRelatedMenu.find(LOGIN_BOX_MENU.SELECTOR_SUBMENU_ITEM + " " + LOGIN_BOX_MENU.SELECTOR_REFERENCE_ELT + "[" + LOGIN_BOX_MENU.PROP_DATA_CHANNEL_ID + "=" + currentChannelIdFromBreadcrumb + "]");

        if (activeLink.length) {
            $subMenuBarItemActive = activeLink.parents(LOGIN_BOX_MENU.SELECTOR_SUBMENU_ITEM);

            // skip it if no subMenu Item
            if (!$subMenuBarItemActive.length) {
                return true;
            }

            // add class on current Menu Element
            $subMenuBarItemActive.addClass(LOGIN_BOX_MENU.IS_ACTIVE);

            // get global menu to display
            $menuToDisplay = $currentRelatedMenu.children();

            if (!$menuToDisplay.length) {
                return;
            }

            // Add class to current section in login box menu
            if ($currentRelatedMenu.prev(LOGIN_BOX_MENU.SELECTOR_ITEM_MENU).length) {
                $currentRelatedMenu.prev(LOGIN_BOX_MENU.SELECTOR_ITEM_MENU).addClass(LOGIN_BOX_MENU.IS_ACTIVE);
            }

            // display related Menu
            $menuToDisplay.prependTo((0, _jquery2.default)(LOGIN_BOX_MENU.SELECTOR_CONTAINER_HEADER));
            currentPageIsActive = true;

            // break the current loop
            return false;
        }
    });
}

/**
 * init javascript marker and translate it to the right position
 */
function initMarker() {
    var $currentMarker = $menuToDisplay.find(LOGIN_BOX_MENU.SELECTOR_SUBMENU_MARKER);

    if (!$subMenuBarItemActive.length || !$currentMarker.length) {
        return false;
    }

    var positionActiveItem = $subMenuBarItemActive.position();
    if (positionActiveItem) {
        $currentMarker.css('transform', 'translateX(' + positionActiveItem.left + 'px) scaleX(1)');
    }
}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initLastConnectionMessage = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _name = __webpack_require__(27);

var _market = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initLastConnectionMessage = function initLastConnectionMessage() {

	var COOKIE_LAST_CONNECTION = "lastDate";
	var COOKIE_LAST_MEDIA = "lastMedia";
	//const MESSAGE_DURATION = 5000;

	// Cookie functions
	function getCookie(name) {
		var value = "; " + document.cookie;
		var parts = value.split("; " + name + "=");
		if (parts.length == 2) return parts.pop().split(";").shift();
		return "";
	}
	function deleteCookie(name) {
		document.cookie = name + '=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	}

	// Load cookies 
	var cookieLastConnection = getCookie(COOKIE_LAST_CONNECTION);
	var cookieLastMedia = getCookie(COOKIE_LAST_MEDIA);

	// Show banner (if cookie && bannercomponent on page)
	(0, _jquery2.default)("#lastConnectionMessage").attr("aria-hidden", "true");
	if (cookieLastConnection && cookieLastConnection.length >= 12) {

		// Banner management
		if ((0, _jquery2.default)("#lastConnectionBanner").length > 0) {

			// Message
			var message = 'Derni\xE8re connexion ';

			// - Date
			var year = cookieLastConnection.substring(0, 4);
			var month = cookieLastConnection.substring(4, 6);
			var day = cookieLastConnection.substring(6, 8);
			var hour = cookieLastConnection.substring(8, 10);
			var minute = cookieLastConnection.substring(10, 12);
			var lastConnection = day + '/' + month + '/' + year + ' \xE0 ' + hour + 'h' + minute;

			// - Média
			var media;
			switch (cookieLastMedia) {
				case 'WAP':
					media = 'sur Services Mobiles';
					break;
				case 'VOC':
					media = 'au 3933';
					break;
				default:
					media = 'par Internet';
			}
			message = message + (media + ' le ' + lastConnection);

			// - Client name
			var clientName = (0, _name.updateLoginBoxNamesLhs)();
			if (_market.MARKET.CODE === 1) message = 'Bonjour ' + clientName + ' ! ' + message + '.';

			(0, _jquery2.default)("#lastConnectionMessage").text(message);
			(0, _jquery2.default)("#lastConnectionMessage").attr("aria-hidden", "false");

			(0, _jquery2.default)("#lastConnectionBanner").show();

			// Delete cookie once shown not to display it again during the session
			// Auto hide after 5 seconds : setTimeout(function () { $("#lastConnectionBanner").hide(); }, MESSAGE_DURATION);
			deleteCookie(COOKIE_LAST_CONNECTION);

			// Button close click event : Hide the messagebanner 
			(0, _jquery2.default)('#lastConnectionBanner div button').on('click', function (e) {
				e.preventDefault();
				(0, _jquery2.default)("#lastConnectionBanner").hide();
			});
		}
	}
};

exports.initLastConnectionMessage = initLastConnectionMessage;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.processFirstLevelConnected = processFirstLevelConnected;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

"use strict";

var FIRST_LEVEL_MENU = {
    IS_ACTIVE: 'is-active',
    SELECTOR_JS_RELATED_MENU: '.JS--firstLevelConnectedList',
    SELECTOR_ITEM_MENU: '.dcw_first-level_hidden',
    SELECTOR_CONTAINER_HEADER: '.dcw_main-nav_list',
    SELECTOR_SUBMENU_ITEM: '.js-submenu_item',
    SELECTOR_SUBMENU_MARKER: '.js-marker',
    PROP_DATA_CHANNEL_ID: 'data-channelid',
    SELECTOR_PAGE_TITLE: '.dcw_submenu-auth_wrap-title',
    INITIAL_2NDMARKER_POS: 0
};

// default values
var $container = null;
var $menuToDisplay = null;
var $jsRelatedMenus = null;
var currentPageIsActive = false;

function processFirstLevelConnected() {
    if (window.cmsUtil.currentChannelBreadcrumb != undefined) {
        $jsRelatedMenus = (0, _jquery2.default)(FIRST_LEVEL_MENU.SELECTOR_JS_RELATED_MENU);
        $container = (0, _jquery2.default)(FIRST_LEVEL_MENU.SELECTOR_CONTAINER_HEADER);
        var channels = window.cmsUtil.currentChannelBreadcrumb.split(",");

        // channels.length-1 to remove home channel
        for (var i = 0; i < channels.length - 1; i++) {
            var currentChannelIdFromBreadcrumb = channels[i];
            processActiveItemsForFirstLevel(currentChannelIdFromBreadcrumb);
            if (currentPageIsActive) {
                break;
            }
        }
        if (currentPageIsActive) {
            $menuToDisplay.removeClass(FIRST_LEVEL_MENU.CLASS_IS_HIDDEN);
            //initMarker();
        } else {
            $jsRelatedMenus.remove();
        }
    }
}

/**
 * Generate menu associated to the current page for the connected part
 */
function processActiveItemsForFirstLevel(currentChannelIdFromBreadcrumb) {
    var $item = (0, _jquery2.default)(FIRST_LEVEL_MENU.SELECTOR_ITEM_MENU + "[" + FIRST_LEVEL_MENU.PROP_DATA_CHANNEL_ID + "=" + currentChannelIdFromBreadcrumb + "]");

    if ($item.length) {
        $item.addClass(FIRST_LEVEL_MENU.IS_ACTIVE);
        if ($item.find(FIRST_LEVEL_MENU.SELECTOR_JS_RELATED_MENU).length) {
            $menuToDisplay = (0, _jquery2.default)($item.find(FIRST_LEVEL_MENU.SELECTOR_JS_RELATED_MENU).html());

            // display related Menu
            $menuToDisplay.prependTo($container);
            currentPageIsActive = true;
            (0, _jquery2.default)(FIRST_LEVEL_MENU.SELECTOR_PAGE_TITLE).remove();
        }
    }
}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateDescription = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateDescription = function updateDescription() {
    var scriptTag = document.getElementById("sas_user_info");
    if (scriptTag) {
        var auth = checkAuth(scriptTag);
        if (auth && (0, _jquery2.default)("p.dcw_banner-heading_text").data("cms-description") != null) {
            (0, _jquery2.default)("p").remove(".dcw_banner-heading_text[data-cms-description='unauth']");
        } else if ((0, _jquery2.default)("p.dcw_banner-heading_text").data("cms-description") != null) {
            (0, _jquery2.default)("p").remove(".dcw_banner-heading_text[data-cms-description='auth']");
        }
    } else {
        if ((0, _jquery2.default)("p.dcw_banner-heading_text").data("cms-description") != null) {
            (0, _jquery2.default)("p").remove(".dcw_banner-heading_text[data-cms-description='auth']");
        }
    }
};

function checkAuth(scriptTag) {
    try {
        var userInfos = JSON.parse(scriptTag.innerHTML.trim());
        if (userInfos && userInfos["IdStat"] != null) {
            return true;
        } else {
            console.error("Impossible de récupérer les informations utilisateur");
            return false;
        }
    } catch (e) {
        console.error("Impossible de récupérer les informations utilisateur");
        return false;
    }
}

exports.updateDescription = updateDescription;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setHtmlAccessibility = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setHtmlAccessibility = function setHtmlAccessibility() {
    /*
        set attribute value to html tag
     */
    (0, _jquery2.default)('html').attr('lang', 'FR');
};

exports.setHtmlAccessibility = setHtmlAccessibility;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initInteract = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _Cookie = __webpack_require__(25);

var _Cookie2 = _interopRequireDefault(_Cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COOKIE_PROFILE = "profilTiers";

function waitUntil(isready, success, error, count, interval) {
    if (count === undefined) count = 300;
    if (interval === undefined) interval = 20;
    if (isready()) {
        success();
        return;
    }
    // The call back isn't ready. We need to wait for it
    setTimeout(function () {
        // We have run out of retries
        if (!count) {
            if (error !== undefined) error();
        }
        // Try again    
        else waitUntil(isready, success, error, count - 1, interval);
    }, interval);
}

// Same as checkProfil() in search.js
// Returns if profil is ok
function checkProfil() {

    // return ok if no profils desactivated
    var profilsToDeactivate = window.cmsGlobals.chatbotConfig.profilToDeactivate;
    if (profilsToDeactivate && profilsToDeactivate != "") {} else return true;

    // return ok if not connected (no profile)
    var profilT = _Cookie2.default.getByName(COOKIE_PROFILE);
    if (profilT === "") return true;

    // Profile desactived ?
    var listOfProfiles = profilsToDeactivate.split(',');
    var profileOk = true;
    listOfProfiles.forEach(function (profilToDeactivate) {
        if (profilT.includes(profilToDeactivate)) profileOk = false;
    });
    return profileOk;
}

var initInteract = function initInteract() {

    // Check condition interact checkbox :
    // Cancel if deactivated
    if (document.getElementById('sticky_hideContact')) return;

    // Vars
    var pageType = "DEFAULT",
        pageParcours = "DEFAULT",
        pageCategory = "";
    if (window.cmsAPI.breakpoint.getCurrentContext() === 'mobile') {
        // manage Interact / contextual menu
        waitUntil(
        // isready ?
        function () {
            return (0, _jquery2.default)('#interact-fab').length > 0;
        },
        // success
        function () {
            window.cmsAPI.fab.register({ name: "contextual", domId: "contextual-fab" });
        },
        // error (do nothing)
        function () {},
        // retrial count and timeout
        300, 20);
    }
    /* // 3264 commented out :
       if (document.getElementById('sticky_pageType'))
           pageType = document.getElementById('sticky_pageType').getAttribute('data-value');
       if (document.getElementById('sticky_pageParcours'))
           pageParcours = document.getElementById('sticky_pageParcours').getAttribute('data-value');
       if (document.getElementById('sticky_pageCategorie'))
           pageCategory = document.getElementById('sticky_pageCategorie').getAttribute('data-value');
    
       //  Set detfault pageType when global chatbox activated
       if ((window.cmsGlobals.interactConfig.activateGlobalChatbot)
           && (pageType === "")
           && (pageParcours === "")) {
           pageType = "DEFAULT";
       }*/

    // Init
    if (typeof window.sdcInteract !== "undefined" && typeof window.sdcInteract.api !== "undefined") {
        window.sdcInteract.api.init({ parcours: pageParcours, categorie: pageCategory, pageType: pageType });
    }

    // Handle clicks (when document loaded)
    (0, _jquery2.default)(document).on('click', '.interactAction', function (event) {
        event.stopPropagation();
        var currentInteractAction = (0, _jquery2.default)(this).data('cms-param');
        if (typeof window.sdcInteract !== 'undefined') {
            window.sdcInteract.api.openFeatureStickyPanel({ feature: currentInteractAction });
        }
    });

    // ** SOBOT ***

    // Check conditions :
    // - Globally disabled ?
    if (window.cmsGlobals.chatbotConfig.disabled) return true;
    // - Interact api loaded ?
    if (typeof sdcInteract == "undefined" || typeof sdcInteract.api == "undefined") return true;
    // - Chatbot checkbox activated ?
    if (document.getElementById('chatbot_activated') == null) return true;

    // Check profil
    if (!checkProfil()) return true; //was _self. in sobot.js

    // Load Sobot Api
    _jquery2.default.getScript("/icd/static/pch-front/public/pch-lanceur.js", function (data, textStatus, jqxhr) {
        var result = jqxhr.status;
    });
    // -> charge : /icd/static/pch-front-js/3.0.11-V3-RC3/awtPchBuilder.js
};

exports.initInteract = initInteract;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initJauge = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Constants
var selectorError = '.erreurJauge',
    selectorActivationMsg = '.activationMsg',
    selectorGlobalSection = '.tableau_main',
    selectorJaugeContainer = '.jaugeContainer',
    selectorJaugeMaster = '.jaugemaster',
    selectorStaticContext = "#jauge-static-context",
    attrStaticContext = "data-file-context",
    selectorLoaderTdb = '#loader_tdb',
    selectorImg = "#tdb_image",
    selectorErrorIndispo = '.erreurIndispo',
    MIN_INDEX = 0,
    MAX_INDEX = 100,
    PATH_IMG = '/Resources/img/jauges/jauge_tdb_',
    MOBILE_BREAKPOINT = 768;

//Elements Jquery
var $errorMsg = null,
    $errorMsgIndispo = null,
    $jaugeMaster = null,
    $jaugeContainer = null,
    $loaderTdb = null,
    $img = null,
    $globalSection = null,
    $activationMsg = null,
    $staticContext = null;

/*
    Show a message when it's the first time that the Jauge is shown to a user
 */

/* 2747 - COMMENT FIRST ACCESS JAUGE PARCOURS

SESSION_FIST_TIME = "jauge_first_time",
isFirstAccesFlag = false;
selectorFirst = '.sansJaugeFirst',
selectorFirst2 = '.sansJaugeFirst2',
$firstMsg = null,
$firstMsg2 = null,

function showFirstTime(){
    $jaugeContainer.hide();
    $loaderTdb.hide();
    $firstMsg.show();
    window.localStorage.setItem(SESSION_FIST_TIME, "true");
}
*/

/*
    Show active jauge
 */
function showJaugeActive(index) {
    var type = '';
    var nb = Math.ceil(index * 43 / 100);
    if (index >= 1 && index <= 30) {
        type = 'orange_';
    }

    $img.removeAttr('src').attr('src', $staticContext + PATH_IMG + type + nb + '.png');

    $jaugeMaster.show();
}

/*
    Show section of inactive jauge
 */
function showJaugeInactive() {
    $activationMsg.show();
}

/*
    Show error Msg when service aren't unable
 */
function showError() {
    $errorMsg.show();
    $errorMsgIndispo.show();
    $jaugeContainer.show();
}

/*
    Display jauge with data
 */
function displayJauge(index) {
    if (index >= MIN_INDEX && index <= MAX_INDEX) {
        showJaugeActive(index);
    } else {
        showJaugeInactive();
    }
    $jaugeContainer.show();
}

function errorOccurred(responseJSON) {
    return responseJSON == undefined || responseJSON.commun == undefined || responseJSON.commun.statut == undefined;
}

function getJaugeInfo() {
    //var url  = $staticContext + '/Resources/Configuration/jauge_info.json';
    //var responseJSON = JSON.parse(responseJSONString);

    var contentType = 'multipart/form-data';
    var url = '/abm/restit/perso/meteo2.json';

    // remove loader after delay
    $loaderTdb.delay(3000).hide(0);

    _jquery2.default.ajax({
        url: url,
        contentType: contentType,
        success: function success(responseJSON) {
            $loaderTdb.hide();

            // If basic variables from response are wrong or status is nok
            if (errorOccurred(responseJSON) || responseJSON.commun.statut == "nok") {
                $globalSection.hide();
                return;
            }

            // if we have a raison with no personnalisation, display the corresponding msg
            if (typeof responseJSON.commun.raison !== "undefined" && (responseJSON.commun.raison == "pas_perso" || responseJSON.commun.raison == "aucune_perso")) {
                showJaugeInactive();

                // if it should work but we don't have any data, display an error
            } else if (responseJSON.donnees == undefined || responseJSON.donnees.indexCav == undefined) {
                showError();

                // then display the jauge
            } else {
                displayJauge(responseJSON.donnees.indexCav);
            }
        },
        error: function error() {
            $loaderTdb.hide();
            $globalSection.hide();
        }
    });
}

var initJauge = function initJauge() {
    if ((0, _jquery2.default)(window).width() > MOBILE_BREAKPOINT) {
        return;
    }

    $loaderTdb = (0, _jquery2.default)(selectorLoaderTdb);
    $loaderTdb.show();
    $jaugeContainer = (0, _jquery2.default)(selectorJaugeContainer);
    $jaugeMaster = (0, _jquery2.default)(selectorJaugeMaster);
    $img = (0, _jquery2.default)(selectorImg);
    $globalSection = (0, _jquery2.default)(selectorGlobalSection);
    $activationMsg = (0, _jquery2.default)(selectorActivationMsg);

    $errorMsg = (0, _jquery2.default)(selectorError);
    $errorMsgIndispo = (0, _jquery2.default)(selectorErrorIndispo);

    // get path context of img
    $staticContext = (0, _jquery2.default)(selectorStaticContext).attr(attrStaticContext);

    getJaugeInfo();
};

exports.initJauge = initJauge;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.bourseLeftMenuActiveItems = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bourseLeftMenuActiveItems = function bourseLeftMenuActiveItems() {
	// sets the 'is-current' classes
	var currentChannelBreadcrumb = (0, _jquery2.default)("#bourse-breadcrumb-channel-ids").val();
	if (currentChannelBreadcrumb != undefined) {
		var channels = currentChannelBreadcrumb.split(",");
		// channels.length-1 because I don't care about the home channel
		for (var i = 0; i < channels.length - 1; i++) {
			var ch = channels[i];
			var $item = (0, _jquery2.default)("li.dcw_menu-brs_item a[data-channelid=" + ch + "]");

			if ($item.length) {
				var $liItem = $item.parent(".dcw_menu-brs_item");
				if ($liItem.hasClass("dcw_menu-brs_menu-item")) {
					// it's a level 2 item
					$liItem.addClass("is-current");
					$liItem.attr("aria-current", "true");
				} else {
					// it's a level 3 item
					$liItem.parents('li').addClass("is-current");
					$liItem.addClass("is-active");
					var $buttonItem = $liItem.parent(".dcw_menu-brs_list").siblings("button.js-menu-brs_toggle");
					$buttonItem.addClass("is-open");
				}

				break;
			}
		}
	}
};

exports.bourseLeftMenuActiveItems = bourseLeftMenuActiveItems;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initSimulator = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initSimulator = function initSimulator() {
    /*
        Tenso Simulator
        If div with specific ID is present, initialize the corresponding simulator.
        Get the type from data-attribute "simulator_type"
        Get the context env from init-config.js
        By default, "simulator_content_default" is used for the ID of default content wrapper (corresponding to the DV simulator wrapper).
        Time out max is the acceptable time to display simulator or default content
     */
    if ((0, _jquery2.default)('#simulator_tenso').length > 0) {
        var currentType = (0, _jquery2.default)('#simulator_tenso').data("simulator_type");

        new Vue({
            render: function render(h) {
                return h(TensoSimulator.TensoSimulator, {
                    props: {
                        tool: currentType,
                        env: window.cmsGlobals.simulatorConfig.current_env,
                        id_content_default: 'simulator_content_default',
                        time_out_max: window.cmsGlobals.simulatorConfig.time_out
                    }
                });
            }
        }).$mount('#simulator_tenso');
    }

    /*
        Bind the Btn simulator Action to pass extra information if existing.
     */
    (0, _jquery2.default)(document).on('click', '.simulatorAction', function (event) {
        event.stopPropagation();
        var href = (0, _jquery2.default)(this).attr('href');
        var currentSimulatorAction = (0, _jquery2.default)(this).data('simulator-param');

        if (currentSimulatorAction !== null && currentSimulatorAction !== "") {
            href += "?" + currentSimulatorAction;
        }

        (0, _jquery2.default)(this).attr("href", href);
    });
};

exports.initSimulator = initSimulator;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contextualMenuCleanup = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contextualMenuCleanup = function contextualMenuCleanup() {
    // cleanups for the mobile contextual menu
    var $mobileContextualMenus = (0, _jquery2.default)('.dcw_contextual-menu-mobile_list.contextualMenu');
    $mobileContextualMenus.each(function (index, contextualMenu) {
        var $contextualMenu = (0, _jquery2.default)(contextualMenu);

        // we will check only the links that don't have the 'js--hasContext' class, because:
        // 1. if this method is called before the contextualMenu(), then we will remove the showing links exceeding the limit
        // 2. if this method is called after the contextualMenu(), no link will have the class 'js--hasContext'
        // This is to ensure that, if this method gets called twice (one before and another after the call of contextualMenu()),
        // this won't remove too much links, leaving us with less then the maximum
        var $links = $contextualMenu.children('li:visible');
        var plusButton = (0, _jquery2.default)(".dcw_contextual-menu-mobile_btn");

        if ($links.length === 0) {
            // if we don't have any link, we will hide the opening button
            plusButton.addClass("dcw_visually-hidden");
        } else {
            // if we have some link, we will make sure the opening button will be shown
            plusButton.removeClass("dcw_visually-hidden");

            // if we have more than 7 links, then we need to add a special class
            if ($links.length > 7) {
                $contextualMenu.closest(".dcw_contextual-menu-mobile").addClass("dcw_contextual-menu-mobile--large");
            } else {
                $contextualMenu.closest(".dcw_contextual-menu-mobile").removeClass("dcw_contextual-menu-mobile--large");
            }

            // 10 is the maximum: if we have more than 10 links, we will remove the rest
            $links.each(function (i, link) {
                if (i < 10) {
                    (0, _jquery2.default)(link).show();
                } else {
                    (0, _jquery2.default)(link).hide();
                }
            });
        }
    });

    // cleanups for the right column contextual menu
    var $desktopContextualMenus = (0, _jquery2.default)('.dcw_contextual-menu_wrapper.contextualMenu');
    $desktopContextualMenus.each(function (index, contextualMenu) {
        var $contextualMenu = (0, _jquery2.default)(contextualMenu);
        var $links = $contextualMenu.children('li:visible');
        var $contextualMenuWrapper = $contextualMenu.closest(".rightColumnContextualMenuWrapper");

        if ($links.length === 0) {
            // if we don't have any link, we will hide the component
            $contextualMenuWrapper.addClass("dcw_visually-hidden");
        } else {
            // if we have some link, we will make sure the opening button will be shown
            $contextualMenuWrapper.removeClass("dcw_visually-hidden");
        }
    });
};

exports.contextualMenuCleanup = contextualMenuCleanup;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initCardSubscription = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initCardSubscription = function initCardSubscription() {
    /*
        If a card subscription button is present on the DOM, we initialise and bind the click
        to that button in order to be redirected to the subscription pages
     */
    (0, _jquery2.default)(document).on('click', '.dcw_cta--red--rounded', function (event) {
        event.stopPropagation();
        var href = (0, _jquery2.default)(this).children().attr('href');
        var cardReference = (0, _jquery2.default)('.dcw_cta--red--rounded').children().data("card-reference");
        if (cardReference !== null && cardReference !== "") {
            href += cardReference;
        }
        (0, _jquery2.default)(this).children().attr("href", href);
    });
};

exports.initCardSubscription = initCardSubscription;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initSupervision = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _name = __webpack_require__(27);

var _market = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initSupervision = function initSupervision() {

    var dataUser = document.getElementById("sas_user_info");

    if (dataUser) {
        var dataHtml = dataUser.innerHTML;
        var supervisionStatut = JSON.parse(dataHtml);

        var clientName = (0, _name.updateLoginBoxNamesLhs)();
        var message;

        message = 'Vous supervisez le client:  ' + clientName + '.';
        (0, _jquery2.default)("#supervisionMessage").text(message);

        if (supervisionStatut["user-info-sup"] == 'true') {
            (0, _jquery2.default)("#supervision").show();
        } else {
            console.error("Impossible de récupérer l'information de supervision");
        }

        // pass the secure zone
        //$('#supervision div button').on('click', function(e) {
        (0, _jquery2.default)('#byPassButton').on('click', function (e) {
            e.preventDefault();
            _jquery2.default.ajax({
                url: "/sec/sup-clear-all-ZS.json",
                method: "GET",
                swmIntercept: false,
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function success(response) {
                    if (response.commun.statut === "ok") {
                        /*// Avant :
                                          if(MARKET.CODE === 1) {
                                              window.location.href = "/icd/cbo/index-authsec.html#cbo/";
                                          } else { // if(MARKET.CODE === 3)
                                              //if(window.location.href === "/icd-web/syd-front/index-comptes.html#etape1")
                                              window.location.href = "/icd-web/syd-front/index-comptes.html#comptes";
                        }*/

                        // TCOD-2948
                        var newlocation = _market.MARKET.CODE === 1 ? "/icd/cbo/index-authsec.html#cbo/" : "/icd-web/syd-front/index-comptes.html#comptes";
                        //Si l'on est déjà sur la page alors forcer le rafraîchissement
                        if (window.location.href.indexOf(newlocation) >= 0) window.location.reload(true);else window.location.href = newlocation;
                    }
                },
                error: function error() {
                    console.log("Erreur ByPass zone de securité");
                }
            });
        });

        // On click close button : position fixed -> relative
        (0, _jquery2.default)('#Supervision_Close_Btn').on('click', function (e) {
            e.preventDefault();
            (0, _jquery2.default)('#supervision').addClass("dcw_Relative");
            // Hide itself
            (0, _jquery2.default)("#Supervision_Close_Btn").hide();
        });
    }
};

exports.initSupervision = initSupervision;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initPopinLogin = undefined;

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR_POPIN = '.js--popinLogin',
    SELECTOR_POPIN_CLOSE = '.js--popinLoginClose',
    SELECTOR_BTN = '.js-btn-popin';

function displayContainers($popinLogin, $popinLoginModal, $popinBtnClose) {
    $popinLogin.show();
    $popinLoginModal.show();
    $popinBtnClose.focus();
}

function hideContainers($popinBtn, $popinLogin, $popinLoginModal) {
    $popinBtn.focus();
    $popinLogin.hide();
    $popinLoginModal.hide();
}

function bindEvent($popinBtn, $popinLogin, $popinLoginModal, $popinBtnClose) {

    $popinBtn.on('click', function (e) {
        e.preventDefault();

        if ($popinLogin.css('display') === 'none') {
            displayContainers($popinLogin, $popinLoginModal, $popinBtnClose);
        } else {
            hideContainers($popinBtn, $popinLogin, $popinLoginModal);
        }
    });

    (0, _jquery2.default)(SELECTOR_POPIN_CLOSE).on('click', function (e) {
        hideContainers($popinBtn, $popinLogin, $popinLoginModal);
    });

    $popinLogin.on('click', function (e) {
        hideContainers($popinBtn, $popinLogin, $popinLoginModal);
    });

    //- Keydown TAB : stoppropagation(), go next focusable item in modal
    $popinLogin.on("keydown", function (e) {

        if (e.keyCode === 9) {
            e.stopPropagation();e.preventDefault();

            var focusableElements = $popinLogin.find('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'); //.filter(':visible')
            var currentIndex = focusableElements.index(document.activeElement);
            var newIndex = 0;
            if (e.shiftKey) newIndex = currentIndex - 1 + focusableElements.length;else newIndex = currentIndex + 1;
            newIndex = newIndex % focusableElements.length;
            focusableElements.eq(newIndex).focus();
        }
    });

    //- Keyup ESC : stoppropagation(), hide()
    $popinLogin.on("keyup", function (e) {

        if (e.keyCode === 27) {
            e.stopPropagation();e.preventDefault();
            hideContainers($popinBtn, $popinLogin, $popinLoginModal);
        }
    });
}

var initPopinLogin = function initPopinLogin() {
    if ((0, _jquery2.default)(SELECTOR_POPIN).length && (0, _jquery2.default)(SELECTOR_BTN).length) {
        var $popinLogin = (0, _jquery2.default)(SELECTOR_POPIN);
        var $popinLoginModal = $popinLogin.children(":first");

        var $popinBtn = (0, _jquery2.default)(SELECTOR_BTN);
        var $popinBtnClose = (0, _jquery2.default)(SELECTOR_POPIN_CLOSE);

        $popinLogin.appendTo(document.body);

        bindEvent($popinBtn, $popinLogin, $popinLoginModal, $popinBtnClose);
    }
};

exports.initPopinLogin = initPopinLogin;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initNavpropri = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

var _popinNavProPri = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECTOR_POPIN = 'js--popinNavpropri',
    SELECTOR_POPIN_MODAL = 'js--popinNavpropri-modal',
    SELECTOR_POPIN_CLOSE = 'js--popinNavpropriClose';
var initNavpropri = function initNavpropri(market) {
    var navproplinks = document.getElementsByClassName("js-navpropri");
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = navproplinks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var navproplink = _step.value;

            if (window.cmsGlobals.navpropri.hidden === false) {

                navproplink.onclick = function (e) {
                    //e.preventDefault();
                    if (market === 1) {
                        window.bddfTms.trackEvent(this, 'click_menu', { event_name: 'navigation-connectee::acces-espace-professionnels' });
                    } else {
                        window.bddfTms.trackEvent(this, 'click_menu', { event_name: 'navigation-connectee::acces-espace-particulier' });
                    }

                    if (checkSupervision()) {
                        if (document.getElementsByClassName(SELECTOR_POPIN)[0] !== undefined) {
                            var $popinNavpropri = document.getElementsByClassName(SELECTOR_POPIN)[0];
                            var $popinNavpropriModal = document.getElementsByClassName(SELECTOR_POPIN_MODAL)[0];
                            document.getElementsByClassName(SELECTOR_POPIN_CLOSE)[0].onclick = function (e) {
                                hideContainers($popinNavpropri, $popinNavpropriModal);
                            };

                            //$popinNavpropri.appendTo(document.body);

                            bindEvent(navproplink, $popinNavpropri, $popinNavpropriModal);
                            return false;
                        } else {
                            return false;
                        }
                    }
                    if (window.cmsGlobals.navpropri.disabled) {
                        if (window.cmsGlobals.navpropri.urlDisable !== "") {
                            window.location.href = window.cmsGlobals.navpropri.urlDisable;
                            window.EventBusCMS.dispatchEvent('buildSearch', { isReady: 'navpropri' });
                            return false;
                        } else {
                            return false;
                        }
                    }

                    var settings = {
                        "async": false,
                        "url": window.cmsGlobals.navpropri.urlServiceSas,
                        "method": "GET",
                        "dataType": 'json'
                    };

                    _jquery2.default.ajax(settings).done(function (response) {
                        if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) !== undefined) {
                            var statusnav;

                            if (response.commun.statut === "ok") {
                                statusnav = getStatus(response, market);
                            }

                            if (response.commun.statut === 'ok' && statusnav === 'nok') {
                                window.location.href = window.cmsGlobals.navpropri.urlSasKO;
                            } else if (response.commun.statut === 'ok' && statusnav === 'consent_await') {
                                // Dans le cas ou PRI est notre point d'origine
                                if (market === 1 && (sasJs === undefined || sasJs["user-auth-origin"] === undefined || sasJs["user-auth-origin"] !== "PRO")) {
                                    window.location.href = window.cmsGlobals.navpropri.urlNonEligible;
                                } else {
                                    window.location.href = window.cmsGlobals.navpropri.urlConsentAwait;
                                }
                            } else if (response.commun.statut === 'ok' && statusnav === 'consent_refused') {
                                // Dans le cas ou PRI est notre point d'origine
                                if (market === 1 && (sasJs === undefined || sasJs["user-auth-origin"] === undefined || sasJs["user-auth-origin"] !== "PRO")) {
                                    window.location.href = window.cmsGlobals.navpropri.urlNonEligible;
                                } else {
                                    window.location.href = window.cmsGlobals.navpropri.urlConsentementKO;
                                }
                            } else if (response.commun.statut === 'ok' && statusnav === 'non_eligible') {
                                window.location.href = window.cmsGlobals.navpropri.urlNonEligible;
                            } else if (response.commun.statut === 'ok' && statusnav === 'ok') {
                                //on supprime le flag de la popin navpropri de la session avant de la fermer
                                window.sessionStorage.removeItem(_popinNavProPri.POPIN_PROFILE_DEFAULT_VALUES.SESSION_STORAGE_POPIN_ACTIVATED);
                                closeSessionAndSetUrl(response, market);
                            } else {
                                if (response.commun.raison !== "niv_auth_insuff") {
                                    window.location.href = window.cmsGlobals.navpropri.urlSasKO;
                                } else {
                                    window.location.reload();
                                }
                            }
                        } else {
                            window.location.href = window.cmsGlobals.navpropri.urlSasKO;
                        }
                        window.EventBusCMS.dispatchEvent('buildSearch', { isReady: 'navpropri' });
                    }).fail(function () {
                        window.location.href = window.cmsGlobals.navpropri.urlSasKO;
                        window.EventBusCMS.dispatchEvent('buildSearch', { isReady: 'navpropri' });
                    });
                };
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    function closeSessionAndSetUrl(responseSAS, market) {
        var settingsDeco = {
            "async": false,
            "url": window.cmsGlobals.navpropri.urlCloseSession,
            "method": "GET",
            "dataType": 'json'
        };
        _jquery2.default.ajax(settingsDeco).done(function () {
            var tokennav = getToken(responseSAS, market);

            var nameToken;
            if (market === 1) {
                nameToken = "ktoken_navpripro";
            } else {
                nameToken = "ktoken_navpropri";
            }

            var hiddenForm = (0, _jquery2.default)('<form action="' + window.cmsGlobals.navpropri.urlConsentementOK + '" method="POST" style="display:none;"></form>').appendTo(document.body);

            (0, _jquery2.default)('<input type="hidden" />').attr({
                name: nameToken,
                value: tokennav
            }).appendTo(hiddenForm);

            hiddenForm.submit();
            hiddenForm.remove();
        }).fail(function () {});
    }

    function getToken(response, market) {
        if (market === 1) {
            return response.donnees.navpripro.token;
        } else {
            return response.donnees.navpropri.token;
        }
    }
    function getStatus(response, market) {
        if (market === 1) {
            return response.donnees.navpripro.status;
        } else {
            return response.donnees.navpropri.status;
        }
    }

    function checkSupervision() {
        if (sasJs !== undefined && sasJs["user-info-sup"] !== undefined && sasJs["user-info-sup"] === "true") {
            return true;
        } else {
            return false;
        }
    }

    function displayContainers($popinLogin, $popinNavpropriModal) {
        $popinLogin.style.display = 'block';
        $popinNavpropriModal.style.display = 'block';
    }

    function hideContainers($popinLogin, $popinNavpropriModal) {
        $popinLogin.style.display = 'none';
        $popinNavpropriModal.style.display = 'none';
    }

    function bindEvent($popinBtn, $popinLogin, $popinNavpropriModal) {
        if ($popinLogin.style.display === 'none') {
            displayContainers($popinLogin, $popinNavpropriModal);
        } else {
            hideContainers($popinLogin, $popinNavpropriModal);
        }
    }
};

exports.initNavpropri = initNavpropri;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var checkCookieICDSwitch = function checkCookieICDSwitch(type_cookie) {
    var firstFilter = document.cookie.split("ICD_SWITCH=");

    if (firstFilter.length > 1) {
        var buildNode = function buildNode(elt) {
            elt = elt.trim();
            if (subStringToCheck.includes(elt) || subStringToCheck.includes(elt.toUpperCase())) {
                var element = document.createElement("p");
                element.id = "icd_switch" + elt;
                element.style.color = "red";
                element.style.padding = "3px";
                element.style.fontWeight = 'bold';
                element.appendChild(document.createTextNode(elt));
                document.getElementsByClassName("rsp_header__wrapper-nav")[0].insertBefore(element, document.getElementsByClassName("rsp_nav")[1]);
            }
        };

        var secondFilter = firstFilter[1].split(";");
        var subStringToCheck = secondFilter[0];

        var listeValueToCheck = null;
        if (type_cookie === "YOGA") {
            listeValueToCheck = window.cmsGlobals.checkCookieYogaConfig.valueToCheck;
        }

        if (type_cookie === "CMS_TECH") {
            listeValueToCheck = window.cmsGlobals.checkCookieCMSTechConfig.valueToCheck;
        }

        if (listeValueToCheck != null) {
            listeValueToCheck.split(",").forEach(buildNode);
        }
    }
};

exports.checkCookieICDSwitch = checkCookieICDSwitch;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["contextualMenuCMS"] = __webpack_require__(212);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(0);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// check is JS--hasContext
// Si non, afficher
// Si Oui, awt appelle contextualMenu ou event

var contextualMenu = function contextualMenu(contextualMenuData) {
    try {
        // if the DOM is not ready, then saves the requested data on the queue, to be executed later
        if (contextualMenuData != null) {
            var keysToCheck = Object.keys(contextualMenuData);
            var $contextualMenus = (0, _jquery2.default)('.contextualMenu');

            $contextualMenus.each(function (index, contextualMenu) {
                var $contextualMenu = (0, _jquery2.default)(contextualMenu);
                var $links = $contextualMenu.children('li');

                $links.each(function (i, link) {
                    var $link = (0, _jquery2.default)(link);

                    if ($link.hasClass("js--hasContext")) {
                        // if the link has context, we will check if we show it or remove it
                        var isValid = false;
                        var linkIdContext = $link.attr('data-idaction');

                        for (var j = 0; j < keysToCheck.length && !isValid; j++) {
                            if (linkIdContext == keysToCheck[j]) {
                                var $anchor = $link.children('a').first();
                                $anchor.attr("href", contextualMenuData[linkIdContext]);
                                isValid = true;
                            }
                        }
                        if (isValid) {
                            $link.show();
                        } else {
                            $link.hide();
                        }
                    } else {
                        // this is for the case when we are in mobile and links that exceed the limit of 10 are hidden:
                        // when we call the contextual menu function again, they must be shownm and hidden below if needed
                        // (if they exceed the limit of 10)
                        $link.show();
                    }
                });

                // if it's the mobile contextual menu, let's do the cleanups for mobile
                if ($contextualMenu.hasClass("dcw_contextual-menu-mobile_list")) {
                    // we will check only the links that don't have the 'js--hasContext' class, because:
                    // 1. if this method is called before the contextualMenu(), then we will remove the showing links exceeding the limit
                    // 2. if this method is called after the contextualMenu(), no link will have the class 'js--hasContext'
                    // This is to ensure that, if this method gets called twice (one before and another after the call of contextualMenu()),
                    // this won't remove too much links, leaving us with less then the maximum
                    $links = $contextualMenu.children('li:visible');
                    var plusButton = (0, _jquery2.default)(".dcw_contextual-menu-mobile_btn");

                    if ($links.length === 0) {
                        // if we don't have any link, we will hide the opening button
                        plusButton.addClass("dcw_visually-hidden");
                    } else {
                        // if we have some link, we will make sure the opening button will be shown
                        plusButton.removeClass("dcw_visually-hidden");

                        // if we have more than 7 links, then we need to add a special class
                        if ($links.length > 7) {
                            $contextualMenu.closest(".dcw_contextual-menu-mobile").addClass("dcw_contextual-menu-mobile--large");
                        } else {
                            $contextualMenu.closest(".dcw_contextual-menu-mobile").removeClass("dcw_contextual-menu-mobile--large");
                        }

                        // 10 is the maximum: if we have more than 10 links, we will remove the rest
                        $links.each(function (i, link) {
                            if (i < 10) {
                                (0, _jquery2.default)(link).show();
                            } else {
                                (0, _jquery2.default)(link).hide();
                            }
                        });
                    }
                } else if ($contextualMenu.hasClass("dcw_contextual-menu_wrapper")) {
                    // if it's the right column desktop contextual menu, let's do the cleanups for that

                    $links = $contextualMenu.children('li:visible');
                    var $contextualMenuWrapper = $contextualMenu.closest(".rightColumnContextualMenuWrapper");

                    if ($links.length === 0) {
                        // if we don't have any link, we will hide the component
                        $contextualMenuWrapper.addClass("dcw_visually-hidden");
                    } else {
                        // if we have some link, we will make sure the opening button will be shown
                        $contextualMenuWrapper.removeClass("dcw_visually-hidden");
                    }
                }
            });
        }

        return true;
    } catch (error) {
        return false;
    }
};

module.exports = contextualMenu;

/***/ })
],[87]);


// WEBPACK FOOTER //
// index.min.js